<template>
  <div style="position: relative" class="report-editor">
    <div class="spreadSheetEditor">
      <kendo-spreadsheet
        ref="reportEditor"
        :toolbar="{
          home: false,
          insert: false,
          data: false,
        }"
        :rows="maxControlRow"
        :columns="maxControlColumn"
        :header-height="5"
        :header-width="5"
        class="spreadsheet"
        v-on:keydown.tab.native="onTabFired"
        v-on:keydown.enter.native="onEnterFired"
        v-on:keydown.up.native="moveActiveField('up')"
        v-on:keydown.down.native="moveActiveField('down')"
        v-on:keydown.left.native="moveActiveField('left')"
        v-on:keydown.right.native="moveActiveField('right')"
        v-on:removeSheet="onRemoveSheet"
        v-on:insertSheet="onInsertSheet"
        v-on:renameSheet="onRenameSheet"
        v-on:change="onChange"
        v-on:select="onSelect"
        v-on:selectsheet="onSpreadSheetSelectSheet"
      />
      <div class="float-button">
        <slot name="float-button"></slot>
      </div>
      <div
        style="
          position: fixed;
          bottom: 32px;
          right: 40px;
          font-size: 12px;
          z-index: 1;
        "
      >
        {{ statisticsString }}
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      ref="dialog__wrapper"
      id="data-selector"
      key="data-selector"
      :close-on-click-modal="false"
      :visible.sync="listViewVisiable"
      @closed="
        () => {
          if ($refs.listViewDataTable) {
            $refs.listViewDataTable.listViewData = [];
          }
        }
      "
      title="选择数据"
      style="min-width: 70%"
      height="calc(100vh - 100px)"
      width="900px"
      append-to-body
    >
      <ListView
        ref="listViewDataTable"
        v-if="listViewVisiable"
        :listViewInfo="listViewInfo"
        :cache="specCache.ListView"
        @WriteListSpecSelectedData="WriteListSpecSelectedData"
        @WriteListCleanFillRange="WriteListCleanFillRange"
      ></ListView>
      <div
        class="line"
        v-elDragWidth:false="$refs.dialog__wrapper"
        @changeDone="() => {}"
      ></div>
    </el-dialog>
    <PrintPreview ref="printPreview"> </PrintPreview>
    <iframe
      name="pdfDirectViewer"
      ref="pdfDirectViewer"
      style="display: none"
      :src="printFullUrl"
      height="0px"
      width="0px"
    />
    <attachContext
      :options="attachContext"
      :id="`attachContextMenu-${templateId}-${formEditStatus}`"
      ref="attachContextMenu"
      @optionClicked="attachContextnClicked"
      @showFileSelector="showFileSelector"
    >
    </attachContext>
    <attach-preview
      v-show="attachViewerVisible"
      ref="attachPreview"
      :previewAttachId="previewAttachId"
    ></attach-preview>
    <a ref="downloadObj"></a>
    <a ref="labelPrint"></a>
    <input
      ref="fileInput"
      id="fileInput"
      name="fileInput"
      type="file"
      @change="onSelectedFile"
      multiple="multiple"
      style="display: none"
      :accept="reviceFileAccept"
    />
    <div id="printFrame"></div>
    <ImageViewer
      ref="imageViewer"
      @refreshView="refreshView"
      :previewType="
        formEditStatus === 11 ||
        formEditStatus === 20 ||
        formEditStatus === 31 ||
        formEditStatus === 41 ||
        formEditStatus === 50 ||
        formEditStatus === 51
          ? 'check'
          : 'edit'
      "
    />
    <AttachViewer
      ref="attachViewer"
      @refreshView="refreshView"
      @supplyAttachFile="supplyAttachFile"
      :previewType="
        formEditStatus === 11 ||
        formEditStatus === 20 ||
        formEditStatus === 31 ||
        formEditStatus === 41 ||
        formEditStatus === 50 ||
        formEditStatus === 51
          ? 'check'
          : 'edit'
      "
    />
    <mail
      ref="mail"
      @SendMailByStep="SendMailByStep"
      @ExportPDFFile="ExportPDFFile"
      @ExportExcelFile="ExportExcelFile"
    />
    <signature
      ref="signature"
      @handleSaveSignature="handleSaveSignature"
      @handleDefault="handleDefaultSignature"
    />
    <Location ref="location" @handleSaveLocation="handleSaveLocation" />
    <baidu-map
      class="hidden_map"
      :ak="ak"
      @ready="mapReadyHandler"
      v-if="initMap"
    />
  </div>
</template>

<script>
import { downloadFile as downloadExcel } from '@/utils'
import zango from '@/mixins/zango.js'
import Vue from 'vue'
import $ from 'jquery'
import kendo from '@progress/kendo-ui'
import { mapGetters } from 'vuex'
import './cultures/kendo.culture.zh-CHS.js'
import './messages/kendo.messages.zh-CN.js'
import './style/all.css'
// icon文件
import '@/assets/workfine-icon/iconfont.css'
// 评分样式文件
import './style/rate.scss'
// 日期选择器
import './js/laydate.all.js'
import './style/laydate/laydate.css'
// 下拉选择器
import './js/dropDown.js'
import './style/dropDown.css'
// 级联选择器
import './js/cascader.js'
import './style/cascader.css'
import alasql from 'alasql'
import attachContext from './AttachContext/index.vue'
import ImageViewer from '@/components/ImageViewer/index.vue'
import AttachViewer from '@/components/AttachViewer/index.vue'
import PrintPreview from './PrintPreview/index.vue'
import ListView from './ListView/index.vue'
import AttachPreview from './AttachPreview/index.vue'
import Mail from './../Mail'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import StatisticsWorker from './js/statistics.worker.js'
import {
  getFormData,
  addNewForm,
  modifyForm,
  getReportTicket,
  dropReportTicket,
  GetTemplateJsonFile,
  getConnectInfo,
  getLinkInfo,
  getActionParams,
  reportOperation,
  GetTemplateConnectInfo,
  getBarCodeFormData,
  getProcedureResult,
  getCurrentLabel,
  getTemplateMailContent,
  prevdependence,
  postdependence,
  exportReport
} from '@/api/form.js'
import {
  getComboOutput,
  getSerialOutput,
  getCascaderSpecsOutput,
  getSelectorSpecsOutput,
  getSystemVariables
} from '@/api/dataSpec.js'
import {
  getQueryFormulaOutput
} from '@/api/queryFormula.js'
import {
  getWriteFromulaResult
} from '@/api/writeFormula.js'
import {
  getWorkFlowActivitys,
  getWorkFlowTargets
} from '@/api/workFlow'
import {
  Spreadsheet,
  SpreadsheetSheet,
  SpreadsheetInstaller
} from '@progress/kendo-spreadsheet-vue-wrapper'
import { updateEmptyFile, identifyFiles, downloadFile } from '@/api/largeFile.js'
import print from './js/print.js'
import largeFile from './js/largeFile.js'
import formatConverter from './js/formatConverter.js'
import extendFunctions from './js/extend.js'
import extendSpreadFunctions from './js/extendSpreadFunction.js'
import barCode from './js/barCode.js'
import { Loading } from 'element-ui'
import Signature from '@/components/Signature/index.vue'
import Location from './Location/index.vue'
import uploadConfirm from './uploadConfirm'
import { getFonts } from '@/api/form.js'
Vue.use(SpreadsheetInstaller)
Vue.use(uploadConfirm)
export default {
  name: 'ReportEditor',
  mixins: [zango],
  components: {
    Mail,
    Spreadsheet,
    SpreadsheetSheet,
    PrintPreview,
    attachContext,
    ListView,
    AttachPreview,
    ImageViewer,
    AttachViewer,
    Signature,
    Location,
    BaiduMap
  },
  data() {
    return {
      // 计算模式
      formulaMode: 1,
      uploadWarning: localStorage.uploadWarning && localStorage.uploadWarning !== 'undefined' ? +localStorage.uploadWarning : 1,
      // 模板编号
      templateId: 0,
      // 单据编号
      recordId: 0,
      // 当前模式
      // 0=新建单据，发起流程
      // 1=修改单据，办理流程
      // 2=查看单据，查看流程
      editModel: 0,
      // 零值是否显示
      zeroModel: false,
      // 主表编号
      masterTableId: 0,
      // 该用户对于模板的高级控制权限
      templateRole: undefined,
      // 模板高级控制选项
      advancedProperty: {
        // 显示零值
        showZero: true,
        // 调试模式，所有单元格都不锁定
        adminModel: false,
        // 非定义区域无法选中
        lockUndefinedArea: true
      },
      // 关联填报来源单据相关信息
      connectReport: {
      },
      // 合并单元格列表
      mergeFields: {},
      // 用户打印单据的权限
      printRole: false,
      // 用户导出单据的权限
      outputRole: false,
      // 启用右下角数据统计
      dataStatistics: true,
      // 数据统计子功能
      statisticsItems: {
        average: true,
        count: true,
        numberCount: true,
        minimum: true,
        maximum: true,
        summation: true
      },
      // 数据统计的内容
      statisticsString: '',
      // 统计数据用Worker
      statisticsWorker: null,
      // 被设置条件格式的字段列表
      // 存储字段ID，条件格式信息，原始格式
      conditionalList: {},
      conditionInfos: {},
      conditionDictionary: {},
      conditionTriggerList: [],
      cacheTableData: undefined,
      // 条件格式相关单元格的默认格式
      fieldDefaultStyle: {},
      // 是否暂停条件格式运算
      conditionPause: false,
      // 是否处于工作流相关状态
      workFlowModel: false,
      // 流程ID
      workFlowId: 0,
      // 流程步骤ID
      workFlowActivityId: 0,
      // 流程步骤信息
      workFlowActivityInfo: null,
      // SpreadSheet数据处理行列设置
      // 默认给5000行
      maxControlRow: 50000,
      maxControlColumn: 1500,
      // 当前最大使用行
      maxUsedRow: {},
      // 当前最大使用列
      maxUsedColumn: {},
      // 行列默认宽高
      defaultRowHeight: {},
      // spreadsheet控件
      spreadSheet: undefined,
      // 数据表
      dataSheets: undefined,
      // 工作表列表
      sheetList: undefined,
      // 模板属性
      templateAttribute: undefined,
      // 取数公式
      queryFormulaInfos: undefined,
      // 动态样式
      formatFormulaInfos: undefined,
      // 公式自动执行字典
      formulaDictionary: {},
      // 动态样式自动执行字典
      formatFormulaDictionary: {},
      // 字段ID=>数据表ID对照表
      id2DataSheets: {},
      // ID=>属性对照表
      id2Info: {},
      // 别名=>字段ID对照表
      name2IdInfo: {},
      // 字段ID=>别名对照表
      id2NameInfo: {},
      // 右键菜单
      cellContext: undefined,
      // 白名单
      whiteList: undefined,
      attachWhiteList: {},
      // 编辑状态
      editStatus: undefined,
      // 编辑锁
      editTicket: undefined,
      // 历史记录单据交叉表原记录行数
      extendTableRowsCount: {},
      // 数据规范
      specificationList: {
        System: [],
        Serial: [],
        DropDown: [],
        ListView: []
      },
      specCache: {
        DropDown: {},
        ListView: {},
        Cascader: {}
      },
      modifyIndexObj: [],
      listViewParams: undefined,
      // 列表规范信息集合
      listViewInfos: [],
      // 列表规范信息
      listViewInfo: {},
      // 列表规范界面可见情况
      listViewVisiable: false,
      // 列表规范宽度
      listViewWidth: '50%',
      // 扩展表默认行数Json
      dataSheetDefaultLines: {},
      R1C1: /^R([1-9]\d*)C([1-9]\d*)$/,
      A1: /^([A-Z]+)(\d+)$/,
      // 导出的pdf文件URL对象地址
      fullUrl: '',
      // PDF预览界面是否显示
      pdfPreviewVisible: false,
      // PDF预览界面状态
      pdfPreviewModel: 'print',
      // PDF预览属性
      pdfViewerProperty: undefined,
      // 打印用的iframe地址
      printFullUrl: '',
      // 附件更多菜单的按钮内容
      attachContext: [
        {
          name: this.$t('report.upload'),
          slug: 'upload',
          selectFile: true,
          visiable: true
        },
        {
          name: this.$t('report.preview'),
          slug: 'view',
          visiable: true
        },
        {
          name: this.$t('report.download'),
          slug: 'download',
          visiable: true
        },
        {
          name: this.$t('report.modify'),
          slug: 'modify',
          selectFile: true,
          visiable: true
        },
        {
          name: this.$t('report.delete'),
          slug: 'delete',
          visiable: true
        }
      ],
      // 上传文件类型
      reviceFileAccept: '*',
      // 附件图片下拉按钮是否显示
      attachContextVisiable: false,
      // 附件图片的预览界面
      attachViewerVisible: false,
      // 预览附件图片ID
      previewAttachId: 0,
      // 附件图片上传大小限制，单位B
      attachLimitedSize: 52428800,
      dialogModel: false,
      // 关联填报属性
      connectInfos: [],
      // 超链接属性
      linkInfos: [],
      // 自定义按钮参数集合
      actionParamList: {},
      // 自定义按钮按钮列表
      actionButtonList: null,
      // 当前活动sheet页
      activeSheet: null,
      // 记录每个标签页滚动条当前位置
      sheetVerScrollPosition: {},
      sheetHorScrollPosition: {},
      cascaderData: [],
      barCodeBindingInfo: [],
      // 展现单元格样式信息
      dataStyle: {
        '0': '#',
        '1': '',
        '2': 'yyyy-mm-dd',
        '3': 'yyyy-mm-dd '
      },
      showFormulaLoading: false,
      printProperty: {},
      // PDF默认预览属性
      defaultPrintProperty: {
        name: '',
        printType: 0,
        enable: true,
        printExtTitle: false, // 标题是否跨页
        titleCount: 1, // 标题行数
        linkDataTable: null, // 需要打印的扩展表
        linkFilter: '', // 逐行打印时的筛选条件
        linkTransFilter: '', // 逐行打印时的筛选条件
        itemMargin: 0,
        linkNodes: [],
        handleFormula: [], // 穿插的取数公式
        paperOption: {
          author: this.$store.getters.OEMInfo.ProductShortName,
          creator: this.$store.getters.OEMInfo.ProductShortName,
          emptyCells: true, // 属性意义未知，默认给True
          fitWidth: true, // 按列缩放
          guideColor: '#aaa', // 框线颜色
          guidelines: false, // 打印框线
          hCenter: true, // 水平居中
          vCenter: true, // 垂直居中
          headerRows: null, // 页眉行
          landscape: true, // 纸张方向，true=横向，false=纵向
          margin: 'Normal', // 页边距
          customMargin: { // 自定义页边距
            top: 10,
            bottom: 10,
            left: 10,
            right: 10
          },
          maxEmpty: 0.2, // 属性意义未知
          paperSize: 'A4', // 纸张大小
          customPaperSize: {
            height: 297,
            width: 210
          },
          printCount: 1, // 打印数量
          scale: 1 // 缩放，受fitWidth影响
        }
      },
      subTotal: {
        tableId: 490,
        classifies: [{
          fieldId: 2940,
          sort: null,
          seq: 1,
          aggregate: [{
            id: 2941,
            type: 1,
            seq: 1
          }, {
            id: 2943,
            type: 0,
            seq: 3
          }]
        }, {
          fieldId: 2941,
          sort: null,
          seq: 2,
          aggregate: [{
            id: 2942,
            type: 1,
            seq: 2
          }, {
            id: 2943,
            type: 0,
            seq: 3
          }]
        }, {
          fieldId: 2942,
          sort: null,
          seq: 3,
          aggregate: [{
            id: 2943,
            type: 0,
            seq: 3
          }]
        }]
      },
      tableClassifyInfo: {},
      uploadFileList: [],
      conditionTriggerInfo: null,
      // conditionRecord
      conditionRevertValues: [],
      mailAttachFile: null,
      mailInfo: [],
      mailContent: {},
      mailSendList: [],
      // initSelection: false,
      handleChangeEvent: null,
      fieldbuttonInfos: [],
      resultRowCount: -1,
      uploadingFile: false,
      correntSelection: false,
      scrollerParam: {
        top: 0,
        left: 0
      },
      signatureCell: null,
      currentLocation: null,
      BMap: undefined,
      myLocation: null,
      initMap: false,
      controlRoleDictionary: {},
      controlRoles: [],
      renderCount: 0,
      temporaryId: undefined,
      requiredTableList: [],
      systemValue: {
        ID: 0,
        r1: 0,
        r5: 0,
        r6: 0,
        r7: '1900-1-1',
        r8: null,
        r10: null,
        r11: false,
        r12: null,
        r13: 0,
        r14: 0,
        r15: null
      },
      joinStrList: [{
        value: 2,
        label: ','
      }, {
        value: 4,
        label: ';'
      }, {
        value: 8,
        label: '.'
      }, {
        value: 16,
        label: ' '
      }, {
        value: 32,
        label: '+'
      }, {
        value: 64,
        label: '/'
      }, {
        value: 128,
        label: '\r\n'
      }],
      extendDataCollection: {},
      paginationItems: [],
      currentExtendTable: null
    }
  },
  computed: {
    ...mapGetters(['connectInfo', 'ak', 'storeTemporaryId', 'copyCreateRID', 'lastTab', 'fontList'])
  },
  watch: {
    formEditStatus() {
      this.changeActionButtons()
    }
  },
  props: {
    connectProps: {},
    formEditStatus: Number,
    // 取数公式执行队列
    queryFormulaIds: Array,
    useRouter: {
      type: Boolean,
      default: true
    },
    workflowTaskId: String
  },
  mounted() {
    var fillInfo = localStorage.getItem('fillInfo')
    if (fillInfo) {
      fillInfo = JSON.parse(fillInfo)
      this.fillScheme = fillInfo.Scheme || null
    }
    // 初始化引入的js文件
    // 引入本地化文件
    kendo.culture('zh-CHS')
    // 初始化SpreadSheet
    console.time('初始化SpreadSheet')
    this.spreadSheet = this.$refs.reportEditor.kendoWidget()
    this.spreadSheet._view.reportEditor = this
    this.spreadSheet._workbook.reportEditor = this
    // 调整默认行高为24
    this.spreadSheet.options.rowHeight = 24
    var fontList = ['微软雅黑', '等线', '幼圆', '隶书', '仿宋', '宋体', '黑体', '楷体']
    var fontFile = {
      '微软雅黑': {
        normal: 'MSYH.ttf',
        bold: 'MSYHBD.ttf'
      },
      '等线': {
        normal: 'DENG.ttf',
        bold: 'DENGBD.ttf'
      },
      '幼圆': {
        normal: 'SIMYOU.ttf'
      },
      '隶书': {
        normal: 'SIMLI.ttf'
      },
      '仿宋': {
        normal: 'SIMFANG.ttf'
      },
      '宋体': {
        normal: 'SIMSUN.ttf'
      },
      '楷体': {
        normal: 'SIMKAI.ttf'
      },
      '黑体': {
        normal: 'SIMHEI.ttf'
      }
    }
    getFonts().then(response => {
      response.data.forEach(font => {
        if (fontList.indexOf(font.name) < 0) {
          fontList.push(font.name)
        }
      })
      this.$emit('setFontList', fontList)
      const defaultFont = ['微软雅黑', '等线', '幼圆', '隶书', '仿宋', '宋体', '黑体', '楷体']
      var defineFonts = {}
      fontList.forEach(fontName => {
        if (defaultFont.indexOf(fontName) >= 0) {
          // 默认字体
          defineFonts[fontName] = './static/fonts/' + fontFile[fontName].normal
          defineFonts[fontName + '|italic'] = './static/fonts/' + (fontFile[fontName].italic || fontFile[fontName].normal)
          defineFonts[fontName + '|bold'] = './static/fonts/' + (fontFile[fontName].bold || fontFile[fontName].normal)
          defineFonts[fontName + '|bold|italic'] = './static/fonts/' + (fontFile[fontName].bold_italic || fontFile[fontName].normal)
        } else {
          // 自定义字体
          const fontProperty = response.data.find(item => item.name === fontName)
          if (fontProperty) {
            const normal = fontProperty.normal ? process.env.BASE_API + '/fonts/1/download?type=0&name=' + fontName : './static/fonts/SIMFANG.ttf'
            defineFonts[fontName] = normal
            defineFonts[fontName + '|italic'] = fontProperty.italics ? process.env.BASE_API + '/fonts/1/download?type=2&name=' + fontName : normal
            defineFonts[fontName + '|bold'] = fontProperty.bold ? process.env.BASE_API + '/fonts/1/download?type=1&name=' + fontName : normal
            defineFonts[fontName + '|boldItalic'] = fontProperty.boldItalics ? process.env.BASE_API + '/fonts/1/download?type=3&name=' + fontName : normal
          }
        }
      })
      kendo.pdf.defineFont(defineFonts)
    })
    // 扩展自定义函数
    extendSpreadFunctions.defineFunctions(kendo)
    var alasql_charindex = (str1, str2) => {
      if (str1 === undefined || str2 === undefined || str1 === null || str2 === null) {
        return 0
      }
      return (str2 + '').indexOf(str1 + '') + 1
    }
    alasql.fn.charindex = alasql_charindex
    alasql.fn.CharIndex = alasql_charindex
    alasql.fn.Charindex = alasql_charindex
    alasql.fn.CHARINDEX = alasql_charindex
    alasql.aggr.pjoin = function(value, accumulator, stage) {
      if (stage === 1) {
        // first call of aggregator - for first line
        var newAccumulator = value
        return newAccumulator
      } else if (stage === 2) {
        // for every line in the group
        accumulator = accumulator + value
        return accumulator
      } else if (stage === 3) {
        // Post production - please nota that value Will be undefined
        return accumulator
      }
    }
    // 给表格区域绑定focus和blur事件
    $('.k-spreadsheet-clipboard').bind('focus', function() {
      // console.log("focus")
      $('.k-spreadsheet-selection').removeClass('k-selection-blur')
    })
    $('.k-spreadsheet-clipboard').bind('blur', function() {
      // console.log("blur")
      $('.k-spreadsheet-selection').addClass('k-selection-blur')
    })
    // 修改默认字体为微软雅黑
    this.spreadSheet.options.defaultCellStyle.fontFamily = '微软雅黑'
    this.spreadSheet.options.defaultCellStyle.showZero = this.advancedProperty.showZero
    // 修改默认所有单元格换行
    console.timeEnd('初始化SpreadSheet')
    // 为超链接初始化VM对象
    // getVMObject(this)
  },
  methods: {
    // *********************
    // ***SpreadSheet动作***
    // *********************
    // 删除sheet时拦截
    onRemoveSheet: function(e) {
      e._defaultPrevented = true
      this.$message({
        message: this.$t('report.illegalOperation'),
        type: 'warning'
      })
    },
    // 插入sheet时拦截
    onInsertSheet: function(e) {
      e._defaultPrevented = true
      this.$message({
        message: this.$t('report.illegalOperation'),
        type: 'warning'
      })
    },
    // 重命名sheet时拦截
    onRenameSheet: function(e) {
      e._defaultPrevented = true
      this.$message({
        message: this.$t('report.illegalOperation'),
        type: 'warning'
      })
    },
    // 单元格变动时触发
    onChange: async function(e) {
      console.time('onChange')
      try {
        if (e.range._ref.bottomRight.row === Infinity || e.range._ref.bottomRight.col === Infinity) {
          return
        }
      } catch (ex) {
        console.error(ex)
      }
      this.spreadSheet.activeSheet().range(e.range)._manualAdjustRowHeight()
      e.range._ref.sheet = e.range._sheet._name()
      this.handleChangeEvent = e
      await this.RangeValueChanged(formatConverter.ConvertAllFormat2Json(e.range._ref, this), e.sourceCondition)
      // 条件验证错误提示
      if (this.conditionTriggerInfo) {
        switch (this.conditionTriggerInfo.alertType) {
          case 1:
            extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
            break
          case 2:
            extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
            break
        }
        this.conditionTriggerInfo = null
      }
      console.timeEnd('onChange')
    },
    onRender: function() {
      console.warn(`===========render_${++this.renderCount}_${new Date().toISOString()}===========`)
    },
    onSpreadSheetSelectSheet(arg) {
      switch (arg.type) {
        case 'dblClick':
          if (arg.message !== 'no_message') {
            extendFunctions.errorMessage(arg.message)
          }
          // console.log('fired')
          break
        default:
          if (this.activeSheet) {
            this.sheetVerScrollPosition[this.activeSheet] = this.spreadSheet.element[0].children[2].children[1].scrollTop
            this.sheetHorScrollPosition[this.activeSheet] = this.spreadSheet.element[0].children[2].children[1].scrollLeft
          }
          this.activeSheet = arg.sheet._sheetName
          if (this.sheetVerScrollPosition[this.activeSheet]) {
            this.spreadSheet.element[0].children[2].children[1].scrollTop = this.sheetVerScrollPosition[this.activeSheet]
          } else {
            this.spreadSheet.element[0].children[2].children[1].scrollTop = 0
          }
          if (this.sheetHorScrollPosition[this.activeSheet]) {
            this.spreadSheet.element[0].children[2].children[1].scrollLeft = this.sheetHorScrollPosition[this.activeSheet]
          } else {
            this.spreadSheet.element[0].children[2].children[1].scrollLeft = 0
          }
          break
      }
    },
    // 为点击到的带超链接单元格的超链接绑定click事件
    onSelect(e) {
      // if (this.initSelection) {
      //   return
      // }
      // 用户可选中区域控制
      if (this.correntSelection) {
        return
      }
      if (!e) {
        e = { range: this.spreadSheet.activeSheet().selection() }
      }
      if (e.range && (e.range.switch() || e.range.rate() || e.range.selector() || e.range.progress() || e.range.imageGroup() ||
        e.range.attachGroup() || (e.range.location() && !e.range.location().property.manualName))) {
        if (e.preventDefault) { e.preventDefault() }
      }
      var range, rangeItem
      var cellInTableNameRanges = []
      if (e.range._ref.length) {
        for (range of e.range._ref.refs) {
          cellInTableNameRanges.push(this.GetRangeInSelectableRange(formatConverter.ConvertAllFormat2Json(
            range, this), this.spreadSheet.activeSheet()._sheetName, true))
        }
      } else {
        cellInTableNameRanges.push(this.GetRangeInSelectableRange(formatConverter.ConvertAllFormat2Json(
          e.range._ref, this), this.spreadSheet.activeSheet()._sheetName, true))
      }
      if (this.advancedProperty.lockUndefinedArea) {
        for (rangeItem of cellInTableNameRanges) {
          if (rangeItem === undefined) {
            if (e.preventDefault) {
              e.preventDefault()
            }
            return
          }
          if (rangeItem && rangeItem.name.substring(0, 1) !== '_') {
            if (e.preventDefault) {
              e.preventDefault()
            }
            return
          }
        }
      }
      // 选中区域统计
      if (this.dataStatistics && this.statisticsWorker) {
        var selectionValues = []
        e.range.forEachCell(function(row, col, cell) {
          if ((!cell.hidden) && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            selectionValues.push(cell.value)
          }
        })
        if (selectionValues.length > 1) {
          this.statisticsWorker.postMessage({
            dataArray: selectionValues,
            statisticsOption: {
              itemOption: this.statisticsItems
            }
          })
        } else {
          this.statisticsString = ''
        }
      }
      var cellInNameRanges = this.getSelectionNameRange(e.range)
      if (cellInNameRanges.length === 0) {
        return
      }
      if (cellInNameRanges.length > 1) {
        cellInNameRanges.sort(extendFunctions.sortBy('name'))
        const len = cellInNameRanges.length
        for (var i = len - 1; i >= 0; i--) {
          if (i - 1 >= 0) {
            if (cellInNameRanges[i].name === cellInNameRanges[i - 1].name) {
              cellInNameRanges.splice(i, 1)
            }
          }
        }
      }
      // 确定当前选中的扩展表
      const fieldInfo = this.name2IdInfo[cellInNameRanges[0].name]
      if (fieldInfo) {
        const dataSheetInfo = this.dataSheets[fieldInfo.owner]
        if (dataSheetInfo.type === 1) {
          this.currentExtendTable = +dataSheetInfo.id
        } else {
          this.currentExtendTable = null
        }
      } else {
        this.currentExtendTable = null
      }
      this.refreshParent()
      // 清除关联填报按钮
      // 根据选择内容生成关联填报按钮
      var buttonsInfo = []
      if (this.connectInfos) {
        // 对参数作处理，返回按钮信息
        // 排除选中了多个区域的情况
        if (!(e.range._ref instanceof kendo.spreadsheet.UnionRef)) {
          this.connectInfos.forEach(info => {
            info.class = 'connect'
            // 判断选中区域是否包含指定内容
            var fieldId
            for (rangeItem of cellInNameRanges) {
              fieldId = this.name2IdInfo[rangeItem.name].id
              info.sourceType = this.dataSheets[this.id2DataSheets[fieldId]].type
              // 排除选中了多行的情况
              if (this.dataSheets[this.id2DataSheets[fieldId]].extType === 1) {
                if (e.range._ref instanceof kendo.spreadsheet.RangeRef) {
                  if (e.range._ref.bottomRight.row - e.range._ref.topLeft.row !== 0) {
                    break
                  }
                }
                // 合并单元格处理
                // debugger
                if (rangeItem.mergedInfo) {
                  if (rangeItem.mergedInfo.bottomRight.row - rangeItem.mergedInfo.topLeft.row !== 0) {
                    break
                  }
                }
              } else if (this.dataSheets[this.id2DataSheets[fieldId]].extType === 2) {
                if (e.range._ref instanceof kendo.spreadsheet.RangeRef) {
                  if (e.range._ref.bottomRight.col - e.range._ref.topLeft.col !== 0) {
                    break
                  }
                }
                if (rangeItem.mergedInfo) {
                  if (rangeItem.mergedInfo.bottomRight.col - rangeItem.mergedInfo.topLeft.col !== 0) {
                    break
                  }
                }
              }
              if ((info.type & 0x00000002) === 0x00000002) {
                // 数据表级
                if (this.id2DataSheets[fieldId] === info.fromSheet.toString()) {
                  buttonsInfo.push(info)
                  break
                }
              } else if ((info.type & 0x00000004) === 0x00000004) {
                // 字段级
                if (info.fieldList.indexOf(fieldId.toString()) > -1) {
                  buttonsInfo.push(info)
                  break
                }
              }
            }
          })
        }
      }
      var linksInfo = []
      if (this.connectInfos) {
        // 对参数作处理，返回按钮信息
        // debugger
        // 排除选中了多个区域的情况
        // debugger
        if (!(e.range._ref instanceof kendo.spreadsheet.UnionRef)) {
          this.linkInfos.forEach(info => {
            // 判断选中区域是否包含指定内容
            var fieldId
            for (rangeItem of cellInNameRanges) {
              fieldId = this.name2IdInfo[rangeItem.name].id
              // 排除选中了多行的情况
              if (this.dataSheets[this.id2DataSheets[fieldId]].extType === 1) {
                if (e.range._ref instanceof kendo.spreadsheet.RangeRef) {
                  if (e.range._ref.bottomRight.row - e.range._ref.topLeft.row !== 0) {
                    break
                  }
                }
                // 合并单元格处理
                // debugger
                if (rangeItem.mergedInfo) {
                  if (rangeItem.mergedInfo.bottomRight.row - rangeItem.mergedInfo.topLeft.row !== 0) {
                    break
                  }
                }
              } else if (this.dataSheets[this.id2DataSheets[fieldId]].extType === 2) {
                if (e.range._ref instanceof kendo.spreadsheet.RangeRef) {
                  if (e.range._ref.bottomRight.col - e.range._ref.topLeft.col !== 0) {
                    break
                  }
                }
                if (rangeItem.mergedInfo) {
                  if (rangeItem.mergedInfo.bottomRight.col - rangeItem.mergedInfo.topLeft.col !== 0) {
                    break
                  }
                }
              }
              if (info.fromField.indexOf(fieldId.toString()) > -1) {
                info.class = 'link'
                info.sourceType = this.dataSheets[this.id2DataSheets[fieldId]].type
                linksInfo.push(info)
                break
              }
            }
          })
        }
      }
      // 生成超链接和关联填报按钮
      this.$emit('buildFieldButtons', buttonsInfo.concat(linksInfo))
    },

    getSelectionNameRange(range) {
      var cellInNameRanges = []
      if (range._ref instanceof kendo.spreadsheet.UnionRef) {
        for (range of range._ref.refs) {
          cellInNameRanges.push(this.GetRangeInNameRange(formatConverter.ConvertAllFormat2Json(
            range, this), this.spreadSheet.activeSheet()._sheetName, true))
        }
      } else if (range._ref instanceof kendo.spreadsheet.RangeRef) {
        // 将range打散
        for (var row = range._ref.topLeft.row; row <= range._ref.bottomRight.row; row++) {
          for (var col = range._ref.topLeft.col; col <= range._ref.bottomRight.col; col++) {
            cellInNameRanges.push(this.GetRangeInNameRange(formatConverter.ConvertAllFormat2Json(
              {
                topLeft: {
                  row: row,
                  col: col
                },
                bottomRight: {
                  row: row,
                  col: col
                }
              }, this), this.spreadSheet.activeSheet()._sheetName, true))
            if (cellInNameRanges[cellInNameRanges.length - 1]) {
              this.spreadSheet.activeSheet().forEachMergedCell(
                new kendo.spreadsheet.CellRef(row, col, 0), merged => {
                  cellInNameRanges[cellInNameRanges.length - 1].mergedInfo = merged
                }
              )
            }
          }
        }
      } else if (range._ref instanceof kendo.spreadsheet.CellRef) {
        cellInNameRanges.push(this.GetRangeInNameRange(formatConverter.ConvertAllFormat2Json(
          range._ref, this), this.spreadSheet.activeSheet()._sheetName, true))
        if (cellInNameRanges[cellInNameRanges.length - 1]) {
          this.spreadSheet.activeSheet().forEachMergedCell(
            range._ref, merged => {
              cellInNameRanges[cellInNameRanges.length - 1].mergedInfo = merged
            }
          )
        }
      }
      cellInNameRanges = extendFunctions.ArrayDistinct(cellInNameRanges)
      for (var rangeItem of cellInNameRanges) {
        if (rangeItem === undefined || !this.name2IdInfo[rangeItem.name]) {
          return []
        }
      }
      return cellInNameRanges
    },

    onTabFired(e) {
      console.log(e)
      if (e) {
        e.preventDefault()
        if (e.shiftKey) {
          this.moveActiveField('left')
        } else {
          this.moveActiveField('right')
        }
      }
    },

    // 用户点击tab时触发该方法
    // onTabFired(e, rangeJson, length) {
    //   if (e) {
    //     e.preventDefault()
    //     if (e.shiftKey) {
    //       this.moveActiveField('left')
    //     }else{
    //       this.moveActiveField('right')
    //     }
    //   }
    //   return
    //   // 判断未定义字段的空模板
    //   if (JSON.stringify(this.name2IdInfo) === '{}') {
    //     return
    //   }
    //   this.spreadSheet._controller.deactivateEditor()
    //   var nameRange
    //   if (e) {
    //     // TODO:按shift+tab实现反向tab
    //     e.preventDefault()
    //     if (e.shiftKey) {
    //       return
    //     }
    //     var activeSheetHasNames = false
    //     for (nameRange in this.spreadSheet._workbook._names) {
    //       if (this.spreadSheet._workbook._names[nameRange].value.sheet === this.spreadSheet.activeSheet()._name()) {
    //         activeSheetHasNames = true
    //         break
    //       }
    //     }
    //     if (!activeSheetHasNames) {
    //       return
    //     }
    //   }
    //   // 循环超过10次，则返回到首行
    //   if (length >= 10) {
    //     rangeJson.topLeft.row = 1
    //     rangeJson.bottomRight.row = 1
    //     this.onTabFired(undefined, rangeJson)
    //     return
    //   }
    //   length = length ? length + 1 : 1
    //   // 获取当前活动区域开始，到最后一列的range
    //   var focusedRow = rangeJson || formatConverter.ConvertAllFormat2Json(this.spreadSheet.activeSheet().activeCell(), this)
    //   // 当前行行高为0，则跳过
    //   if (this.spreadSheet.activeSheet()._rows.hidden(focusedRow.topLeft.row - 1)) {
    //     focusedRow.topLeft.row += 1
    //     focusedRow.bottomRight.row += 1
    //     this.onTabFired(undefined, focusedRow, length)
    //     return
    //   }
    //   focusedRow.bottomRight.col = this.maxControlColumn
    //   focusedRow.workSheet = this.spreadSheet.activeSheet()._name()
    //   var fieldsList = []
    //   var tempNameRange
    //   // 获取当前活动区域开始，到最后一列的所有别名字段
    //   for (nameRange in this.spreadSheet._workbook._names) {
    //     if (nameRange.substring(0, 1) !== '_') {
    //       continue
    //     }
    //     if (nameRange.substring(0, 3) === '_mt') {
    //       continue
    //     }
    //     tempNameRange = this.spreadSheet._workbook._names[nameRange].value
    //     tempNameRange = formatConverter.ConvertAllFormat2Json(tempNameRange, this)
    //     if (tempNameRange === undefined) {
    //       continue
    //     }

    //     if (this.RangeOverlaped(focusedRow, [tempNameRange])) {
    //       tempNameRange.name = nameRange
    //       fieldsList.push(tempNameRange)
    //     }
    //   }
    //   if (fieldsList.length > 0) {
    //     // 按照列序进行升序排列
    //     fieldsList.sort((nameRange1, nameRange2) => {
    //       var val1 = nameRange1.topLeft.col
    //       var val2 = nameRange2.topLeft.col
    //       if (val1 < val2) {
    //         return -1
    //       } else if (val1 > val2) {
    //         return 1
    //       } else {
    //         return 0
    //       }
    //     })
    //     var nextField
    //     if (!e) {
    //       // 如果是第一次在该行找，则直接返回第一个
    //       nextField = fieldsList[0]
    //     } else {
    //       // 如果不是第一次找，则返回第二个
    //       if (fieldsList.length > 1) {
    //         nextField = fieldsList[1]
    //       } else {
    //         focusedRow.topLeft.row += 1
    //         focusedRow.bottomRight.row += 1
    //         focusedRow.topLeft.col = 1
    //         this.onTabFired(undefined, focusedRow, length)
    //         return
    //       }
    //     }
    //     nextField.topLeft.row = focusedRow.topLeft.row
    //     nextField.bottomRight.row = focusedRow.bottomRight.row
    //     this.spreadSheet.activeSheet().range(formatConverter.ConvertJsonToRange(nextField)).select()
    //     return
    //   }
    //   focusedRow.topLeft.row += 1
    //   focusedRow.bottomRight.row += 1
    //   this.onTabFired(undefined, focusedRow, length)
    // },

    onEnterFired(e) {
      console.log(e)
      if (e) {
        e.preventDefault()
        if (this.templateAttribute.enterOption) {
          if (e.shiftKey) {
            this.moveActiveField('left')
          } else {
            this.moveActiveField('right')
          }
        } else {
          if (e.shiftKey) {
            this.moveActiveField('up')
          } else {
            this.moveActiveField('down')
          }
        }
      }
    },

    moveActiveField(direction, currentCell, fieldInfoList) {
      // 重试10次
      console.time('跳转定义字段')
      var i, fieldInfoMark
      var CellRef = kendo.spreadsheet.CellRef
      var activeSheet = this.spreadSheet.activeSheet()
      var activeCell = currentCell || this.spreadSheet.activeSheet().selection()._ref
      if (activeCell instanceof kendo.spreadsheet.UnionRef) {
        activeCell = activeCell.refs[0]
      }
      if (activeCell instanceof kendo.spreadsheet.RangeRef) {
        var currentRow = activeCell.topLeft.row
        var currentCol = activeCell.topLeft.col
        var fieldInfoListTemp
        if (fieldInfoList) {
          fieldInfoMark = true
        } else {
          fieldInfoList = []
          fieldInfoListTemp = extendFunctions.deepCopy(activeSheet._properties.get('fieldInfo').values())
          if (!fieldInfoListTemp || !fieldInfoListTemp.length) {
            // 未定义字段
            return
          } else {
            fieldInfoListTemp.forEach(item => {
              if (item.end - item.start > 0) {
                for (var i = 1; i <= item.end - item.start; i++) {
                  fieldInfoList.push({
                    start: item.start + i,
                    end: item.start + i,
                    value: item.value
                  })
                }
                item.end = item.start
              }
              fieldInfoList.push({
                start: item.start,
                end: item.start,
                value: item.value
              })
            })
          }
        }
        var getRowCol = (index) => {
          switch (direction) {
            // 还原单元格
            case 'up':
            case 'down':
              return new CellRef(index % this.maxControlRow, parseInt(index / this.maxControlRow))
            case 'left':
            case 'right':
              return new CellRef(parseInt(index / this.maxControlColumn), index % this.maxControlColumn)
            default:
              return new CellRef(0, 0)
          }
        }
        var nextCellIndex, currentIndex
        var shiftLength = 2
        if (!activeSheet.range(activeCell).fieldInfo()) {
          shiftLength = 1
        }
        var propertyName = 'start'
        switch (direction) {
          case 'up':
          case 'down':
            currentIndex = currentRow + this.maxControlRow * currentCol
            fieldInfoList.sort(extendFunctions.sortBy('start'))
            break
          case 'left':
          case 'right':
            propertyName = 'rowStart'
            currentIndex = currentCol + this.maxControlColumn * currentRow
            if (!fieldInfoMark) {
              console.time('初始化rowStart')
              fieldInfoList.forEach(item => {
                var row = item.start % this.maxControlRow
                var col = parseInt(item.start / this.maxControlRow)
                item.rowStart = col + row * this.maxControlColumn
              })
              fieldInfoList.sort(extendFunctions.sortBy('rowStart'))
            }
            console.timeEnd('初始化rowStart')
            break
        }
        // property方法
        for (i = 0; i < fieldInfoList.length; i++) {
          var nextCellIndexTemp
          if (fieldInfoList[i][propertyName] > currentIndex) {
            if (direction === 'up' || direction === 'left') {
              if (i - shiftLength < 0) {
                nextCellIndexTemp = fieldInfoList[fieldInfoList.length - 1][propertyName]
              } else {
                nextCellIndexTemp = fieldInfoList[i - shiftLength][propertyName]
              }
            } else if (direction === 'down' || direction === 'right') {
              nextCellIndexTemp = fieldInfoList[i][propertyName]
            }
          }
          var rowColInfo = getRowCol(nextCellIndexTemp)
          if (activeSheet.rowHeight(rowColInfo.row) && activeSheet.columnWidth(rowColInfo.col)) {
            nextCellIndex = nextCellIndexTemp
            break
          }
        }
        if (!nextCellIndex) {
          switch (direction) {
            case 'up':
            case 'left':
              nextCellIndex = fieldInfoList[fieldInfoList.length - shiftLength][propertyName]
              break
            case 'down':
            case 'right':
              nextCellIndex = fieldInfoList[0][propertyName]
              break
          }
        }
        var nextCell = getRowCol(nextCellIndex)
        var nextRange = activeSheet.range(nextCell.row, nextCell.col)
        if (nextRange && (nextRange.switch() || nextRange.rate() || nextRange.selector() || nextRange.progress() || nextRange.imageGroup() ||
          nextRange.attachGroup() || (nextRange.location() && !nextRange.location().property.manualName))) {
          this.moveActiveField(direction, nextRange._ref, fieldInfoList)
        }
        nextRange.select()
      } else {
        console.error('活动单元格格式错误')
      }
      console.timeEnd('跳转定义字段')
    },

    // *********************
    // ********Model********
    // *********************
    // dataSheets主循环方法
    // 生成别名=>ID对照表、生成白名单、生成数据规范信息
    DataSheetsLoop: async function(fieldDataSpecInfos) {
      this.whiteList = {}
      this.attachWhiteList = {}
      this.name2IdInfo = {}
      this.id2NameInfo = {}
      this.id2DataSheets = {}
      if (fieldDataSpecInfos) {
        this.specificationList = {
          System: [],
          Serial: [],
          DropDown: [],
          ListView: [],
          Switch: [],
          DateTime: [],
          Selector: [],
          Progress: [],
          Rate: [],
          Cascader: [],
          Location: []
        }
      }
      this.requiredTableList = []
      var dataSheetRangeJson, i
      this.mergeFields = {}
      console.time('流程处理')
      // ==============流程处理=================
      // 整理流程隐藏和不可编辑字段
      if (this.workFlowModel && this.workFlowActivityInfo) {
        var item
        if (this.workFlowActivityInfo.operAreaType === 24) {
          this.workFlowActivityInfo.operAreaArray = []
          for (item of this.workFlowActivityInfo.operArea) {
            this.workFlowActivityInfo.operAreaArray.push(item.id)
          }
        } else if (this.workFlowActivityInfo.operAreaType === 25) {
          this.workFlowActivityInfo.operAreaArray = []
        }
        if (this.workFlowActivityInfo.viewAreaType === 24) {
          this.workFlowActivityInfo.hideAreaArray = []
          for (item of this.workFlowActivityInfo.viewArea) {
            this.workFlowActivityInfo.hideAreaArray.push(item.id)
          }
        }
      }
      // ==============流程处理=================
      console.timeEnd('流程处理')
      // ===============白名单==================
      for (i = 0; i < this.spreadSheet.sheets().length; i++) {
        this.whiteList[this.spreadSheet.sheets()[i]._sheetName] = []
        this.attachWhiteList[this.spreadSheet.sheets()[i]._sheetName] = []
      }
      this.paginationItems = []
      // this.unreachableTable=[]
      // ================白名单================
      for (var dataSheetId in this.dataSheets) {
        console.time(`数据表${dataSheetId}循环`)
        var dataSheetInfo = this.dataSheets[dataSheetId]
        if (dataSheetInfo.validateOption) {
          this.requiredTableList.push(+dataSheetId)
        }
        if (dataSheetInfo.isPaging && this.templateAttribute.type === 1 && dataSheetInfo.type === 1) {
          // if(dataSheetInfo.type===1){
          this.paginationItems.push({
            id: +dataSheetId,
            sheet: dataSheetInfo.sheetName,
            totalRecord: 0,
            totalPage: 0,
            step: dataSheetInfo.pageSize || 10,
            currentPage: 0
          })
          if (!this.currentExtendTable) {
            this.currentExtendTable = +dataSheetId
          }
          this.extendDataCollection[dataSheetId] = []
        }
        // this.unreachableTable.push(+dataSheetId)
        // ================默认行数================
        if (dataSheetInfo.type !== 0) {
          this.name2IdInfo[dataSheetInfo.areaAlias.toLowerCase()] = dataSheetInfo
          this.id2NameInfo[dataSheetId] = dataSheetInfo.areaAlias.toLowerCase()
          // this.id2Info[dataSheetId] = dataSheetInfo
          dataSheetRangeJson = this.GetNameRangeJson(dataSheetInfo.areaAlias)
          switch (dataSheetInfo.extType) {
            case 1:
              this.dataSheetDefaultLines[dataSheetId] = dataSheetRangeJson.bottomRight.row - dataSheetRangeJson.topLeft.row + 1
              this.defaultRowHeight[dataSheetId] = { row: this.spreadSheet.sheetByName(dataSheetInfo.sheetName).rowHeight(dataSheetRangeJson.topLeft.row - 1) }
              break
            case 2:
              this.dataSheetDefaultLines[dataSheetId] = dataSheetRangeJson.bottomRight.col - dataSheetRangeJson.topLeft.col + 1
              this.defaultRowHeight[dataSheetId] = { col: this.spreadSheet.sheetByName(dataSheetInfo.sheetName).columnWidth(dataSheetRangeJson.topLeft.col - 1) }
              break
            // 交叉表处理
            case 3:
              this.dataSheetDefaultLines[dataSheetId] = {
                row: dataSheetRangeJson.bottomRight.row - dataSheetRangeJson.topLeft.row + 1,
                col: dataSheetRangeJson.bottomRight.col - dataSheetRangeJson.topLeft.col + 1
              }
              var dataRangeJson = this.GetNameRangeJson(dataSheetInfo.children.find(item => item.extType === 3).areaAlias)
              this.defaultRowHeight[dataSheetId] = { row: this.spreadSheet.sheetByName(dataSheetInfo.sheetName).rowHeight(dataRangeJson.topLeft.row - 1) }
              this.defaultRowHeight[dataSheetId].col = this.spreadSheet.sheetByName(dataSheetInfo.sheetName).columnWidth(dataRangeJson.topLeft.col - 1)
              break
          }
          // 应用间隔色
          if (dataSheetInfo.intervalActive) {
            this.SetIntervalColor(dataSheetId)
          }
        } else {
          // 主表情况下
          this.masterTableId = dataSheetId
        }
        // ================默认行数================
        // 开始字段属性循环
        for (var fieldId in dataSheetInfo.fields) {
          console.time(`字段${fieldId}循环`)
          var fieldInfo = dataSheetInfo.fields[fieldId]
          var fieldRange = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(
            formatConverter.ConvertJsonToRange(this.GetNameRangeJson(fieldInfo.areaAlias)))
          // 根据流程判断
          // if (this.workFlowModel && this.workFlowActivityInfo) {
          //   if(this.unreachableTable.indexOf(+dataSheetId)>=0&&this.workFlowActivityInfo.operAreaType!==25){
          //     if(this.workFlowActivityInfo.operAreaType===24&&this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId)>=0){
          //       this.unreachableTable.pop()
          //     }
          //   }
          // }
          // if(this.unreachableTable.indexOf(+dataSheetId)>=0&&this.workFlowActivityInfo.operAreaType!==25){
          //   if(this.workFlowActivityInfo.operAreaType===24&&this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId)>=0){
          //     this.unreachableTable.pop()
          //   }
          // }
          if (fieldInfo.autoMerge > 0) {
            if (!this.mergeFields[dataSheetId]) {
              this.mergeFields[dataSheetId] = []
            }
            this.mergeFields[dataSheetId].push(fieldInfo)
          }
          // ================对照表================
          this.id2DataSheets[fieldId] = dataSheetId
          this.name2IdInfo[fieldInfo.areaAlias.toLowerCase()] = fieldInfo
          this.id2NameInfo[fieldId] = fieldInfo.areaAlias.toLowerCase()
          this.id2Info[fieldId] = fieldInfo
          // ================对照表================
          // ==============图片附件=================
          if (fieldInfo.baseType === 6) {
            this.setFieldAttachGroup(this.spreadSheet.sheetByName(fieldInfo.sheetName), this.GetNameRangeJson(fieldInfo.areaAlias, true))
          } else if (fieldInfo.baseType === 5) {
            this.setFieldImageGroup(this.spreadSheet.sheetByName(fieldInfo.sheetName), this.GetNameRangeJson(fieldInfo.areaAlias, true), undefined, fieldInfo.dataOption)
          }
          // ==============图片附件=================
          // ================白名单================
          var specCreatable = true
          // 控制自动编号和系统变量
          var specCreatable2 = true
          // 图片附件不允许可编辑
          // 流程可编辑字段判断
          if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.operAreaType) {
            switch (this.workFlowActivityInfo.operAreaType) {
              case 24:
                if (this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId) > -1) {
                  if (fieldInfo.editable) {
                    if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                      this.whiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                    } else {
                      this.attachWhiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                    }
                  }
                } else {
                  specCreatable = false
                  specCreatable2 = false
                }
                break
              case 23:
                if (fieldInfo.editable) {
                  if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                    this.whiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                  } else {
                    this.attachWhiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                  }
                }
                break
              case 25:
                specCreatable = false
                specCreatable2 = false
                break
            }
          } else {
            if (!(this.templateRole.disableField && this.templateRole.disableField.indexOf(+fieldId) > -1)) {
              if (fieldInfo.editable) {
                if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                  this.whiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                } else {
                  this.attachWhiteList[fieldInfo.sheetName].push(fieldInfo.areaAlias)
                }
              }
            } else {
              specCreatable = false
            }
          }
          // 流程隐藏字段判断
          // 隐藏字段默认不可编辑，从白名单移除
          if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.viewAreaType) {
            switch (this.workFlowActivityInfo.viewAreaType) {
              case 24:
                if (this.workFlowActivityInfo.hideAreaArray.indexOf(+fieldId) > -1) {
                  fieldRange.color('rgba(0,0,0,0)')
                  fieldRange.hidden(true)
                  if (this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias) >= 0) {
                    this.whiteList[fieldInfo.sheetName].splice(this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias), 1)
                  }
                }
                break
              case 23:
                fieldRange.color('rgba(0,0,0,0)')
                fieldRange.hidden(true)
                if (this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias) >= 0) {
                  this.whiteList[fieldInfo.sheetName].splice(this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias), 1)
                }
                break
              case 25:
                break
            }
          }
          if (this.templateRole.hiddenField && this.templateRole.hiddenField.indexOf(+fieldId) > -1) {
            fieldRange.color('rgba(0,0,0,0)')
            fieldRange.hidden(true)
            if (this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias) >= 0) {
              this.whiteList[fieldInfo.sheetName].splice(this.whiteList[fieldInfo.sheetName].indexOf(fieldInfo.areaAlias), 1)
            }
          }
          // ===============白名单==================
          // ==============数据规范=================
          if (fieldDataSpecInfos && fieldDataSpecInfos[fieldId] && fieldDataSpecInfos[fieldId].length) {
            var dataSpecInfo = fieldDataSpecInfos[fieldId][0]
            if (dataSpecInfo.specType === 5) {
              this.specificationList.Switch.push({
                fieldId: +fieldId,
                sheetName: fieldInfo.sheetName,
                areaAlias: fieldInfo.areaAlias,
                type: dataSheetInfo.type,
                extType: dataSheetInfo.extType,
                specId: dataSpecInfo.specId,
                openValue: dataSpecInfo.openValue,
                closeValue: dataSpecInfo.closeValue,
                defaultValue: dataSpecInfo.default ? dataSpecInfo.openValue : dataSpecInfo.closeValue,
                showLabel: dataSpecInfo.showLabel,
                theme: dataSpecInfo.theme || 0,
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 9) {
              this.specificationList.Rate.push({
                fieldId: +fieldId,
                sheetName: fieldInfo.sheetName,
                areaAlias: fieldInfo.areaAlias,
                shape: dataSpecInfo.specId,
                display: JSON.parse(dataSpecInfo.display),
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 7) {
              this.specificationList.Selector.push({
                fieldId: +fieldId,
                sheetName: fieldInfo.sheetName,
                areaAlias: fieldInfo.areaAlias,
                specId: dataSpecInfo.specId,
                single: dataSpecInfo.single,
                source: dataSpecInfo.source,
                values: dataSpecInfo.values,
                theme: dataSpecInfo.theme,
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 8) {
              this.specificationList.Progress.push({
                fieldId: +fieldId,
                sheetName: fieldInfo.sheetName,
                areaAlias: fieldInfo.areaAlias,
                type: dataSpecInfo.bartype,
                display: JSON.parse(dataSpecInfo.display),
                enable: specCreatable
              })
            }
            // 不受权限控制，受白名单控制
            if (specCreatable2) {
              if (dataSpecInfo.specType === 0) {
                this.specificationList.System.push({
                  sheetName: fieldInfo.sheetName,
                  fieldId: +fieldId,
                  dataSheetId: dataSheetId,
                  areaAlias: fieldInfo.areaAlias,
                  specId: dataSpecInfo.specId,
                  value: dataSpecInfo.value,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType
                })
              } else if (dataSpecInfo.specType === 4) {
                this.specificationList.Serial.push({
                  sheetName: fieldInfo.sheetName,
                  areaAlias: fieldInfo.areaAlias,
                  dataSheetId: dataSheetId,
                  fieldId: fieldId,
                  specId: dataSpecInfo.specId,
                  single: dataSpecInfo.single,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType
                })
              }
            }
            // 数据规范初始化
            if (specCreatable) {
              if (dataSpecInfo.specType === 1) {
                // debugger
                this.specificationList.DropDown.push({
                  fieldId: +fieldId,
                  sheetName: fieldInfo.sheetName,
                  areaAlias: fieldInfo.areaAlias,
                  specId: dataSpecInfo.specId,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType,
                  fieldType: dataSpecInfo.baseType,
                  source: dataSpecInfo.source,
                  single: dataSpecInfo.single,
                  values: dataSpecInfo.values,
                  params: dataSpecInfo.params,
                  search: dataSpecInfo.search,
                  cache: dataSpecInfo.cache
                })
              } else if (dataSpecInfo.specType === 2) {
                // debugger
                var level2ColumnId = {}
                if (dataSpecInfo.subtype === 0) {
                  dataSpecInfo.columns.forEach(column => {
                    if (column.level !== null && column.level >= 0) {
                      level2ColumnId[column.level] = column.id
                    }
                  })
                }
                this.specificationList.Cascader.push({
                  fieldId: +fieldId,
                  sheetName: fieldInfo.sheetName,
                  areaAlias: fieldInfo.areaAlias,
                  cascaderId: dataSpecInfo.specId,
                  sourceType: dataSpecInfo.subtype,
                  allowMiddle: dataSpecInfo.midenable,
                  columns: dataSpecInfo.columns,
                  mapping: dataSpecInfo.mapping,
                  params: dataSpecInfo.params,
                  level2ColumnId: level2ColumnId,
                  cache: dataSpecInfo.cache
                })
              } else if (dataSpecInfo.specType === 3) {
                fieldDataSpecInfos[fieldId].forEach(info => {
                  this.specificationList.ListView.push({
                    fieldId: +fieldId,
                    dataSheetId: +dataSheetId,
                    sheetName: fieldInfo.sheetName,
                    areaAlias: fieldInfo.areaAlias,
                    type: dataSheetInfo.type,
                    extType: dataSheetInfo.extType,
                    specId: info.specId,
                    single: info.single,
                    distinct: info.distinct,
                    oneRow: info.oneRow,
                    mapping: info.mapping,
                    columns: info.columns,
                    params: info.params,
                    unique: info.unique,
                    conditionParam: info.conditionParam,
                    condition: info.condition,
                    cache: dataSpecInfo.cache,
                    failtext: dataSpecInfo.failtext
                  })
                })
              } else if (dataSpecInfo.specType === 6) {
                this.specificationList.DateTime.push({
                  fieldId: +fieldId,
                  sheetName: fieldInfo.sheetName,
                  areaAlias: fieldInfo.areaAlias,
                  type: dataSpecInfo.specId,
                  single: dataSpecInfo.single,
                  mapping: dataSpecInfo.mapping
                })
              } else if (dataSpecInfo.specType === 10) {
                this.specificationList.Location.push({
                  fieldId: +fieldId,
                  sheetName: fieldInfo.sheetName,
                  areaAlias: fieldInfo.areaAlias,
                  type: dataSpecInfo.specId,
                  property: JSON.parse(dataSpecInfo.display)
                })
              }
            }
          }
          console.timeEnd(`字段${fieldId}循环`)
          // }
          // 由于开关有显示作用，所以必须初始化，通过白名单控制是否可编辑
          // ==============数据规范=================
        }
        console.timeEnd(`数据表${dataSheetId}循环`)
      }
      this.refreshParent()
    },

    // 给定义的单元格补充字段属性
    setCellFieldInfo(version) {
      console.time('补充设置单元格字段属性')
      var sheetsList = {}
      var fieldRange
      this.spreadSheet.sheets().forEach(sheet => {
        sheetsList[sheet._sheetName] = sheet
        sheet.range('A1:ET200').fieldInfo(null)
        sheet.range('A1:ET200').isLink(false)
      })
      var range, fieldInfo
      for (var tableId in this.dataSheets) {
        if (this.dataSheets[tableId].type === 0) {
          for (var sheetName in sheetsList) {
            var fields = this.dataSheets[tableId].children.filter(field => field.sheetName === sheetName)
            if (fields.length) {
              sheetsList[sheetName].batch(() => {
                fields.forEach(field => {
                  range = formatConverter.convertA1ToJson(field.fieldRange)
                  fieldRange = sheetsList[sheetName].range(formatConverter.ConvertJsonToA1({
                    row: range.topLeft.row,
                    col: range.topLeft.col
                  }))
                  fieldRange.fieldInfo(field.id)
                  fieldRange.isLink(field.dataType === 107)
                })
              })
            }
          }
        } else {
          var that = this
          this.spreadSheet.sheetByName(this.dataSheets[tableId].sheetName).batch(() => {
            for (fieldInfo of that.dataSheets[tableId].children) {
              range = formatConverter.convertA1ToJson(fieldInfo.fieldRange)
              switch (that.dataSheets[tableId].extType) {
                case 1:
                  fieldRange = sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: range.topLeft.row,
                      col: range.topLeft.col
                    },
                    bottomRight: {
                      row: range.bottomRight.row,
                      col: range.topLeft.col
                    }
                  }))
                  fieldRange.fieldInfo(fieldInfo.id)
                  fieldRange.isLink(fieldInfo.dataType === 107)
                  break
                case 2:
                  fieldRange = sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: range.topLeft.row,
                      col: range.topLeft.col
                    },
                    bottomRight: {
                      row: range.topLeft.row,
                      col: range.bottomRight.col
                    }
                  }))
                  fieldRange.fieldInfo(fieldInfo.id)
                  fieldRange.isLink(fieldInfo.dataType === 107)
                  break
                case 3:
                  switch (fieldInfo.extType) {
                    case 1:
                      fieldRange = sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.bottomRight.row,
                          col: range.topLeft.col
                        }
                      }))
                      fieldRange.fieldInfo(fieldInfo.id)
                      fieldRange.isLink(fieldInfo.dataType === 107)
                      break
                    case 2:
                      fieldRange = sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.topLeft.row,
                          col: range.bottomRight.col
                        }
                      }))
                      fieldRange.fieldInfo(fieldInfo.id)
                      fieldRange.isLink(fieldInfo.dataType === 107)
                      break
                    case 3:
                      fieldRange = sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.bottomRight.row,
                          col: range.bottomRight.col
                        }
                      }))
                      fieldRange.fieldInfo(fieldInfo.id)
                      fieldRange.isLink(fieldInfo.dataType === 107)
                      break
                  }
                  break
              }
            }
          })
        }
      }
      console.timeEnd('补充设置单元格字段属性')
    },

    // 获取有效控制区域
    GetValuableControlRange: function() {
      var maxRow = 0
      var maxColumn = 0
      var nameRangeValue
      for (var nameRange in this.spreadSheet._workbook._names) {
        if (nameRange.substring(0, 1) !== '_') {
          continue
        }
        nameRangeValue = formatConverter.ConvertAllFormat2Json(this.spreadSheet._workbook._names[nameRange].value, this)
        if (nameRangeValue.bottomRight.row > maxRow) {
          maxRow = nameRangeValue.bottomRight.row
        }
        if (nameRangeValue.bottomRight.col > maxColumn) {
          maxColumn = nameRangeValue.bottomRight.col
        }
      }
      return {
        topLeft: {
          row: 1,
          col: 1
        },
        bottomRight: {
          row: maxRow + 10,
          col: maxColumn + 5
        }
      }
    },

    // *********************
    // ***spreadSheet控制***
    // *********************
    // 注册右键菜单
    RegistSheetContextMenu: function() {
      const that = this
      that.cellContext = that.spreadSheet.cellContextMenu()
      that.cellContext.bind('open', function(e) {
        if (e.item.length === undefined) {
          return
        }
        // const clickNameRange = that.GetActiveNameRange()
        var clickFieldInfo = that.spreadSheet.activeSheet().selection().fieldInfo()
        if (!clickFieldInfo) {
          e._defaultPrevented = true
          return
        }
        const fieldInfo = that.id2Info[clickFieldInfo]
        // const rangeId = that.name2IdInfo[clickNameRange.name].id
        switch (that.formEditStatus) {
          case 11:
          case 20:
          case 31:
          case 41:
            e._defaultPrevented = true
            return
        }
        var contextJson = []
        var cellContextItems, contextIndex
        var dataSheetInfo = that.dataSheets[fieldInfo.owner]
        that.cellContext.remove('.k-item.k-state-default')
        // 判断选择区域是不是扩展表
        if (dataSheetInfo !== undefined && dataSheetInfo.type >= 1 && !that.tableClassifyInfo[dataSheetInfo.id]) {
          if (!that.RangeInclude(formatConverter.ConvertAllFormat2Json(that.spreadSheet.activeSheet().selection()._ref, that),
            that.GetNameRangeJson(that.dataSheets[that.id2DataSheets[fieldInfo.id]].areaAlias))) {
            e._defaultPrevented = true
            return
          }
          switch (dataSheetInfo.extType) {
            case 1:
              if (that.templateAttribute !== {}) {
                if (that.templateAttribute.addRow) {
                  contextJson.push({ text: that.$t('report.addRow'), items: [{ text: '1' + that.$t('report.row') }, { text: '5' + that.$t('report.row') }, { text: '20' + that.$t('report.row') }, { text: that.$t('report.customRows') }] })
                }
                if (that.templateAttribute.delRow) {
                  contextJson.push({ text: that.$t('report.deleteRow') })
                }
              }
              break
            case 2:
              if (that.templateAttribute !== {}) {
                if (that.templateAttribute.addRow) {
                  contextJson.push({ text: that.$t('report.addColumn'), items: [{ text: '1' + that.$t('report.column') }, { text: '5' + that.$t('report.column') }, { text: '20' + that.$t('report.column') }, { text: that.$t('report.customColumns') }] })
                }
                if (that.templateAttribute.delRow) {
                  contextJson.push({ text: that.$t('report.deleteColumn') })
                }
              }
              break
            case 3:
              if (that.templateAttribute !== {}) {
                if (fieldInfo.extType === 1) {
                  if (that.templateAttribute.addRow) {
                    contextJson.push({ text: that.$t('report.addRow'), items: [{ text: '1' + that.$t('report.row') }, { text: '5' + that.$t('report.row') }, { text: '20' + that.$t('report.row') }, { text: that.$t('report.customRows') }] })
                  }
                  if (that.templateAttribute.delRow) {
                    contextJson.push({ text: that.$t('report.deleteRow') })
                  }
                } else if (fieldInfo.extType === 2) {
                  if (that.templateAttribute.addRow) {
                    contextJson.push({ text: that.$t('report.addColumn'), items: [{ text: '1' + that.$t('report.column') }, { text: '5' + that.$t('report.column') }, { text: '20' + that.$t('report.column') }, { text: that.$t('report.customColumns') }] })
                  }
                  if (that.templateAttribute.delRow) {
                    contextJson.push({ text: that.$t('report.deleteColumn') })
                  }
                }
              }
              break
          }
        }
        // 判断是否含有列表规范
        if ((that.specificationList.ListView.find(listViewInfo => {
          return listViewInfo.fieldId === +fieldInfo.id
        }) && !that.spreadSheet.activeSheet().selection().roleLocked()) || that.spreadSheet.activeSheet().selection().cascader()) {
          if (contextJson.length > 0) {
            contextJson.push({ text: that.$t('report.delimiter') })
          }
          contextJson.push({ text: that.$t('report.clearFill') })
        }
        // 判断是否含有关联填报
        var fieldConnectInfos = that.connectInfos.filter(connectInfo => {
          if (connectInfo.fromSheet === null) {
            return true
          } else if (connectInfo.fieldList) {
            return connectInfo.fieldList.filter(fieldId => { return +fieldId === +fieldInfo.id }).length > 0
          } else {
            return false
          }
        })
        if (fieldConnectInfos.length > 0) {
          if (contextJson.length > 0) {
            contextJson.push({ text: that.$t('report.delimiter') })
          }
          fieldConnectInfos.forEach(info => {
            contextJson.push({ text: info.alias })
          })
        }

        // 判断是否含有超链接
        var fieldLinkInfos = that.linkInfos.filter(linkInfo => {
          if (linkInfo.fromSheet === null) {
            return true
          } else if (linkInfo.fromField) {
            return linkInfo.fromField.split(',').filter(fieldId => { return +fieldId === +fieldInfo.id }).length > 0
          } else {
            return false
          }
        })
        if (fieldLinkInfos.length > 0) {
          if (contextJson.length > 0) {
            contextJson.push({ text: that.$t('report.delimiter') })
          }
          fieldLinkInfos.forEach(info => {
            contextJson.push({ text: info.alias })
          })
        }
        if (contextJson.length > 0) {
          that.cellContext.append(contextJson)
          cellContextItems = that.spreadSheet.cellContextMenu().element[0].children
          for (contextIndex in contextJson) {
            if (contextJson[contextIndex].text === that.$t('report.delimiter')) {
              cellContextItems[contextIndex].className = 'k-separator k-item k-state-default'
              cellContextItems[contextIndex].innerHTML = ''
            }
          }
        } else {
          e._defaultPrevented = true
        }
      })
      // 绑定命令
      that.cellContext.unbind('select')
      that.cellContext.bind('select', function(e) {
        // 获取当前活动sheet
        console.log('触发选择')
        const activatedSheet = that.spreadSheet.activeSheet()
        var activeRange = formatConverter.ConvertAllFormat2Json(that.spreadSheet.activeSheet().selection()._ref, that)
        activeRange.workSheet = activatedSheet.name()
        // console.log(e)
        var selectLabel = e.item.children[0].innerText.replace(/[\r\n]/g, '')
        switch (selectLabel) {
          case '1' + that.$t('report.row'):
            that.InsertRowColumn(activeRange, 'row', 1)
            break
          case '5' + that.$t('report.row'):
            that.InsertRowColumn(activeRange, 'row', 5)
            break
          case '20' + that.$t('report.row'):
            that.ChangeFunctionLoadingStatus(true)
            that.InsertRowColumn(activeRange, 'row', 20)
            that.ChangeFunctionLoadingStatus(false)
            break
          case that.$t('report.customRows'):
            that.$prompt(that.$t('report.extendRow'), that.$t('status.prompt'), {
              confirmButtonText: that.$t('buttons.determine'),
              cancelButtonText: that.$t('buttons.cancel'),
              inputPattern: /^[1-9]\d*$/,
              inputErrorMessage: that.$t('report.integer')
            }).then(({ value }) => {
              that.ChangeFunctionLoadingStatus(true)
              that.InsertRowColumn(activeRange, 'row', parseInt(value))
              that.ChangeFunctionLoadingStatus(false)
            })
            break
          case that.$t('report.deleteRow'):
            that.DeleteRowColumn(activeRange, 'row')
            break
          case '1' + that.$t('report.column'):
            that.InsertRowColumn(activeRange, 'column', 1)
            break
          case '5' + that.$t('report.column'):
            that.InsertRowColumn(activeRange, 'column', 5)
            break
          case '20' + that.$t('report.column'):
            that.ChangeFunctionLoadingStatus(true)
            that.InsertRowColumn(activeRange, 'column', 20)
            that.ChangeFunctionLoadingStatus(false)
            break
          case that.$t('report.customColumns'):
            that.$prompt(that.$t('report.extendColumn'), that.$t('status.prompt'), {
              confirmButtonText: that.$t('buttons.determine'),
              cancelButtonText: that.$t('buttons.cancel'),
              inputPattern: /^[1-9]\d*$/,
              inputErrorMessage: that.$t('report.integer')
            }).then(({ value }) => {
              that.ChangeFunctionLoadingStatus(true)
              that.InsertRowColumn(activeRange, 'column', parseInt(value))
              that.ChangeFunctionLoadingStatus(false)
            })
            break
          case that.$t('report.deleteColumn'):
            that.DeleteRowColumn(activeRange, 'column')
            break
          case that.$t('report.clearFill'):
            if (that.spreadSheet.activeSheet().selection().cascader()) {
              that.cleanCascaderMappingData(that.spreadSheet.activeSheet().selection().fieldInfo(), activeRange)
            } else {
              var listView = that.SelectCurrentListView(that.spreadSheet.activeSheet().selection().listView(), activeRange)
              if (listView) {
                that.WriteListCleanFillRange(listView, activeRange)
              }
            }
            break
          case that.$t('report.addRow'):
          case that.$t('report.addColumn'):
            break
          default:
            var selectedConnect = that.connectInfos.find(info => { return info.alias === selectLabel })
            if (selectedConnect) {
              that.$emit('connectLinkHandler', that.connectInfos.filter(info => { return info.id === selectedConnect.id }))
            } else {
              selectedConnect = that.linkInfos.find(info => { return info.alias === selectLabel })
              that.$emit('connectLinkHandler', that.linkInfos.filter(info => { return info.id === selectedConnect.id }))
            }
            break
        }
      })
    },

    // 移除行头列标右键菜单
    RemoveContextMenu: function() {
      var rowContext = this.spreadSheet.rowHeaderContextMenu()
      rowContext.bind('open', function(e) {
        e._defaultPrevented = true
      })
      var colContext = this.spreadSheet.colHeaderContextMenu()
      colContext.bind('open', function(e) {
        e._defaultPrevented = true
      })
    },

    // 扩展行，在选择区域的下面插入行
    // type=row/column
    InsertRowColumn: function(selectedRange, type, count, withoutFormula, ignorePagination, skipRecalc) {
      const that = this
      if (count <= 0) {
        return
      }
      console.log(`扩展${count}行`)
      console.time('扩展行/列')
      this.spreadSheet._workbook.ignoreClipbord = true
      var sheet, dealRange, startIndex, i, controlRoleList, tableRange, controlRoleListForTable
      if (selectedRange.workSheet) {
        sheet = that.spreadSheet.sheetByName(selectedRange.workSheet)
      } else {
        sheet = that.spreadSheet.activeSheet()
        selectedRange.workSheet = that.spreadSheet.activeSheet().name()
      }
      // const clickNameRange = that.GetCellInNameRange(selectedRange, selectedRange.workSheet)
      // var dataSheetId = this.id2DataSheets[this.name2IdInfo[clickNameRange.name].id]
      var fieldRange = this.spreadSheet.sheetByName(sheet).range(formatConverter.ConvertJsonToRange(selectedRange))
      if (!fieldRange) {
        extendFunctions.errorMessage(that.$t('status.error'), that.$t('report.rowError'))
        this.spreadSheet._workbook.ignoreClipbord = false
        return
      }
      var fieldInfo = this.id2Info[fieldRange.fieldInfo()]
      // 判断是否为分页扩展表
      var dataSheetId = fieldInfo.owner
      const paginationInfo = this.paginationItems.find(item => item.id === +dataSheetId)
      var insertRow, insertRowCount, insertCol, insertColCount
      if (paginationInfo && !ignorePagination) {
        // 分页扩展行
        if (!this.extendDataCollection[dataSheetId]) {
          this.extendDataCollection[dataSheetId] = []
        }
        // 开始插入
        for (i = 0; i < count; i++) {
          this.extendDataCollection[dataSheetId].push([])
        }
        // 更新总行数
        this.RefreshPaginationInfo(dataSheetId)
      } else {
        var clickNameRange = this.GetNameRangeJson(fieldInfo.areaAlias)
        switch (type) {
          case 'row':
          {
            var insertRowShift = false
            insertRow = selectedRange.bottomRight.row
            insertRowCount = count === undefined ? selectedRange.bottomRight.row - selectedRange.topLeft.row + 1 : count
            // 判断insertRow是不是最后一行，是则上移一行
            if (insertRow >= clickNameRange.bottomRight.row) {
              insertRow = insertRow - 1
              insertRowShift = true
            }
            // var currentRowHeight = sheet.rowHeight(insertRow - 1)
            // var currentRowHeight = insertRowShift ? sheet.rowHeight(insertRow) : sheet.rowHeight(insertRow - 1)
            // 解锁单元格
            // that.UnLockProtectedRanges(that.spreadSheet.activeSheet().name())
            sheet.batch(function() {
              // 找出哪些列需要合并单元格
              console.time('找出要合并的单元格')
              var mergedList = that.GetMergedCellsList(selectedRange.workSheet)
              // console.log(mergedList)
              if (mergedList.length > 0) {
                for (i = mergedList.length - 1; i >= 0; i--) {
                  if (mergedList[i].topLeft.row !== insertRow) {
                    mergedList.splice(i, 1)
                  }
                }
              }
              console.timeEnd('找出要合并的单元格')
              console.time('找出被利用的最大列')
              var maxUsedColumn = 0
              var nameInfo
              for (var _name in this._workbook._names) {
                nameInfo = this._workbook._names[_name]
                if (_name.indexOf('_mt') >= 0 || _name.indexOf('_sf') >= 0 || _name.indexOf('_ct') >= 0) {
                  if (nameInfo.value instanceof kendo.spreadsheet.CellRef) {
                    maxUsedColumn = nameInfo.value.col > maxUsedColumn ? nameInfo.value.col : maxUsedColumn
                  } else if (nameInfo.value instanceof kendo.spreadsheet.RangeRef) {
                    maxUsedColumn = nameInfo.value.bottomRight.col > maxUsedColumn ? nameInfo.value.bottomRight.col : maxUsedColumn
                  }
                }
              }
              maxUsedColumn = (maxUsedColumn += 5) <= that.maxControlColumn - 1 ? maxUsedColumn + 5 : that.maxControlColumn
              console.timeEnd('找出被利用的最大列')
              var lastRowData = []
              if (insertRowShift) {
                console.time('记录下最后一行的公式和值')
                for (i = 0; i < maxUsedColumn; i++) {
                  var cellRange = {}
                  var cellObj = sheet.range(formatConverter.ConvertJsonToA1({ row: insertRow + 1, col: i + 1 }))
                  if (cellObj.formula()) {
                    cellRange.formula = cellObj.formula()
                  }
                  if (cellObj.value()) {
                    cellRange['value'] = cellObj.value()
                  }
                  if (cellObj.imageGroup()) {
                    cellRange['imageGroup'] = extendFunctions.deepCopy(cellObj.imageGroup())
                  }
                  if (cellObj.attachGroup()) {
                    cellRange['attachGroup'] = extendFunctions.deepCopy(cellObj.attachGroup())
                  }
                  if (cellObj.attachEnable()) {
                    cellRange['attachEnable'] = cellObj.attachEnable()
                  }
                  if (cellObj.hidden()) {
                    cellRange['hidden'] = cellObj.hidden()
                  }
                  if (cellObj.customButtons()) {
                    cellRange['customButtons'] = cellObj.customButtons()
                  }
                  if (cellObj.conditionStyle()) {
                    cellRange['conditionStyle'] = cellObj.conditionStyle()
                  }
                  if (cellObj.classify()) {
                    cellRange['classify'] = cellObj.classify()
                  }
                  if (cellObj.background()) {
                    cellRange['background'] = cellObj.background()
                  }
                  if (cellObj.fieldInfo()) {
                    cellRange['fieldInfo'] = cellObj.fieldInfo()
                  }
                  cellRange['showController'] = cellObj.showController()
                  if (JSON.stringify(cellRange) !== '{}') {
                    cellRange.range = cellObj
                    lastRowData.push(cellRange)
                  }
                }
                console.timeEnd('记录下最后一行的值')
              }
              // 根据count插入空白行
              console.time('插入行')
              // 插入行
              try {
                sheet.insertRow(insertRow, insertRowCount)
              } catch (exception) {
                extendFunctions.errorMessage(that.$t('report.insertRowError'), exception)
              }
              console.timeEnd('插入行')
              console.time('设置行高')
              // insertRow插入位置
              for (i = 0; i < insertRowCount; i++) {
                // 行高控制
                sheet.rowHeight(insertRow + i, that.defaultRowHeight[dataSheetId] ? (that.defaultRowHeight[dataSheetId].row) : 28)
                // 合并单元格处理
                for (var mergedInfo of mergedList) {
                  mergedInfo.topLeft.row = mergedInfo.bottomRight.row = insertRow + i + 1
                  sheet.range(formatConverter.ConvertJsonToRange(mergedInfo)).merge()
                }
              }
              console.timeEnd('设置行高')
              // 使用AutoFill功能进行整行内容复制
              const originRange = {
                topLeft: {
                  row: selectedRange.bottomRight.row - (insertRowShift ? 1 : 0),
                  col: 1
                },
                bottomRight: {
                  row: selectedRange.bottomRight.row - (insertRowShift ? 1 : 0),
                  col: maxUsedColumn
                }
              }
              // console.log(originRange)
              const operatingRange = {
                topLeft: {
                  row: selectedRange.bottomRight.row + 1 - (insertRowShift ? 1 : 0),
                  col: 1
                },
                bottomRight: {
                  row: selectedRange.bottomRight.row + insertRowCount,
                  col: maxUsedColumn
                }
              }
              // 由于AutoFill不能清除边框，需要手动处理一次
              dealRange = formatConverter.ConvertJsonToRange(operatingRange)
              sheet.range(dealRange).borderLeft(null)
              sheet.range(dealRange).borderRight(null)
              sheet.range(dealRange).borderTop(null)
              console.time('复制格式')
              console.warn('性能损耗点：复制格式')
              that.spreadSheet._workbook.execute({
                command: 'AutoFillCommand',
                options: {
                  skipCheck: true,
                  direction: 'ver',
                  disableUndoStack: true,
                  disableRangeEnable: true,
                  fillModel: 'format',
                  origin: sheet.range(formatConverter.ConvertJsonToRange(originRange)),
                  operatingRange: sheet.range(formatConverter.ConvertJsonToRange(operatingRange))
                }
              })
              console.timeEnd('复制格式')
              var tempRange = extendFunctions.deepCopy(operatingRange)
              sheet.range(formatConverter.ConvertJsonToRange(tempRange)).showController(false)
              if (insertRowShift) {
                originRange.topLeft.row += 1
                originRange.bottomRight.row += 1
                operatingRange.topLeft.row += 1
              }
              // 清空不带公式的单元格内容，并且将有公式的内容填充
              console.time('复制公式')
              console.warn('性能损耗点：复制公式')
              var dealOriginRange
              for (var j = originRange.topLeft.col; j <= originRange.bottomRight.col; j++) {
                dealRange = {
                  topLeft: {
                    row: operatingRange.topLeft.row,
                    col: j
                  },
                  bottomRight: {
                    row: operatingRange.bottomRight.row,
                    col: j
                  }
                }
                dealOriginRange = {
                  topLeft: {
                    row: originRange.topLeft.row,
                    col: j
                  },
                  bottomRight: {
                    row: originRange.bottomRight.row,
                    col: j
                  }
                }
                if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).formula() === null) {
                  if (withoutFormula) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).formula(null)
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).classify(null)
                  }
                  sheet.range(formatConverter.ConvertJsonToRange(dealRange)).values(null)
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).imageGroup()) {
                    that.setFieldImageGroup(sheet, formatConverter.ConvertJsonToRange(dealRange))
                  }
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).sign()) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).sign(true)
                  }
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).attachGroup()) {
                    that.setFieldAttachGroup(sheet, formatConverter.ConvertJsonToRange(dealRange))
                  }
                } else {
                  if (withoutFormula) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).formula(null)
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).classify(null)
                  } else {
                    that.spreadSheet._workbook.execute({
                      command: 'AutoFillCommand',
                      options: {
                        disableUndoStack: true,
                        disableRangeEnable: true,
                        fillModel: 'formula',
                        origin: sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)),
                        operatingRange: sheet.range(formatConverter.ConvertJsonToRange(dealRange))
                      }
                    })
                  }
                }
              }
              console.timeEnd('复制公式')
              if (insertRowShift) {
                // 将最后一行的值回写过去
                console.time('回写最后一行记录的值')
                lastRowData.forEach(cellRange => {
                  if (!cellRange.formula) {
                    cellRange.range.value(cellRange.value)
                  }
                  cellRange.range.imageGroup(cellRange.imageGroup || null)
                  cellRange.range.attachGroup(cellRange.attachGroup || null)
                  cellRange.range.attachEnable(cellRange.attachEnable || null)
                  cellRange.range.hidden(cellRange.hidden || null)
                  cellRange.range.customButtons(cellRange.customButtons || null)
                  cellRange.range.conditionStyle(cellRange.conditionStyle || null)
                  cellRange.range.fieldInfo(cellRange.fieldInfo || null)
                  cellRange.range.classify(cellRange.classify || null)
                  cellRange.range.background(cellRange.background || null)
                  cellRange.range.showController(cellRange.showController)
                })
                console.timeEnd('回写最后一行记录的值')
              }
              // 判断是否在filter范围内
              if (sheet._filter !== null) {
                var filterRange = formatConverter.ConvertAllFormat2Json(sheet._filter.ref, this)
                if (filterRange.topLeft.row < selectedRange.topLeft.row &&
                    filterRange.bottomRight.row >= selectedRange.topLeft.row) {
                  filterRange.bottomRight.row = filterRange.bottomRight.row + insertRowCount
                  sheet.range(formatConverter.ConvertJsonToRange(filterRange)).filter(true)
                }
              }
              // 对扩展行进行操作约束计算
              controlRoleList = that.controlRoleDictionary[dataSheetId]
              controlRoleListForTable = that.controlRoleDictionary['extendTableCalc']
              if (controlRoleList && controlRoleList.length || (controlRoleListForTable && controlRoleListForTable.length)) {
                tableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
                startIndex = selectedRange.topLeft.row - tableRange.topLeft.row + 1
                if (insertRowShift) {
                  startIndex -= 1
                  insertRowCount += 1
                }
                if (controlRoleList && controlRoleList.length) {
                  for (i = startIndex; i < startIndex + insertRowCount; i++) {
                    that.controlRoleHelper(controlRoleList, {
                      top: i,
                      length: 1
                    })
                  }
                }
                if (controlRoleListForTable && controlRoleListForTable.length) {
                  for (i = startIndex; i < startIndex + insertRowCount; i++) {
                    that.controlRoleHelper(controlRoleListForTable)
                  }
                }
              }
            }, {recalc: !skipRecalc})
            console.info('batch处理完毕！')
            this.maxUsedRow[sheet.name()] += count
            if (that.formulaMode) {
              that.spreadSheet._workbook.updateFormulaTarget()
            }
            break
          }
          case 'column':
          {
            var insertColShift = false
            insertCol = selectedRange.bottomRight.col
            insertColCount = count === undefined ? selectedRange.bottomRight.col - selectedRange.topLeft.col + 1 : count
            // 判断insertCol是不是最后一列，是则左移一列
            if (insertCol >= clickNameRange.bottomRight.col) {
              insertCol = insertCol - 1
              insertColShift = true
            }
            // var currentcolumnWidth = sheet.columnWidth(insertCol - 1)
            // var currentcolumnWidth = insertColShift ? sheet.columnWidth(insertCol) : sheet.columnWidth(insertCol - 1)
            // 解锁单元格
            // that.UnLockProtectedRanges(that.spreadSheet.activeSheet().name())
            sheet.batch(function() {
              // 找出哪些列需要合并单元格
              console.time('找出要合并的单元格')
              var mergedList = that.GetMergedCellsList(selectedRange.workSheet)
              if (mergedList.length > 0) {
                for (var i = mergedList.length - 1; i >= 0; i--) {
                  if (mergedList[i].topLeft.col !== insertCol) {
                    mergedList.splice(i, 1)
                  }
                }
              }
              console.timeEnd('找出要合并的单元格')
              console.time('找出被利用的最大行')
              var maxUsedRow = 0
              var nameInfo
              for (var _name in this._workbook._names) {
                nameInfo = this._workbook._names[_name]
                if (_name.indexOf('_mt') >= 0 || _name.indexOf('_sf') >= 0 || _name.indexOf('_ct') >= 0) {
                  if (nameInfo.value instanceof kendo.spreadsheet.CellRef) {
                    maxUsedRow = nameInfo.value.row > maxUsedRow ? nameInfo.value.row : maxUsedRow
                  } else if (nameInfo.value instanceof kendo.spreadsheet.RangeRef) {
                    maxUsedRow = nameInfo.value.bottomRight.row > maxUsedRow ? nameInfo.value.bottomRight.row : maxUsedRow
                  }
                }
              }
              maxUsedRow = (maxUsedRow += 15) <= that.maxControlRow - 1 ? maxUsedRow + 15 : that.maxControlRow
              console.timeEnd('找出被利用的最大行')
              var lastRowData = []
              if (insertColShift) {
                console.time('记录下最后一列的公式和值')
                for (i = 0; i < maxUsedRow; i++) {
                  var cellRange = {}
                  var cellObj = sheet.range(formatConverter.ConvertJsonToA1({ row: i + 1, col: insertCol + 1 }))
                  if (cellObj.formula()) {
                    cellRange.formula = cellObj.formula()
                  } else if (cellObj.value()) {
                    cellRange['value'] = cellObj.value()
                  }
                  if (cellObj.imageGroup()) {
                    cellRange['imageGroup'] = extendFunctions.deepCopy(cellObj.imageGroup())
                  }
                  if (cellObj.attachGroup()) {
                    cellRange['attachGroup'] = extendFunctions.deepCopy(cellObj.attachGroup())
                  }
                  if (cellObj.attachEnable()) {
                    cellRange['attachEnable'] = cellObj.attachEnable()
                  }
                  if (cellObj.hidden()) {
                    cellRange['hidden'] = cellObj.hidden()
                  }
                  if (cellObj.customButtons()) {
                    cellRange['customButtons'] = cellObj.customButtons()
                  }
                  if (cellObj.conditionStyle()) {
                    cellRange['conditionStyle'] = cellObj.conditionStyle()
                  }
                  if (cellObj.fieldInfo()) {
                    cellRange['fieldInfo'] = cellObj.fieldInfo()
                  }
                  if (cellObj.classify()) {
                    cellRange['classify'] = cellObj.classify()
                  }
                  if (cellObj.background()) {
                    cellRange['background'] = cellObj.background()
                  }
                  if (cellObj.borderRight()) {
                    cellRange['borderRight'] = cellObj.borderRight()
                  }
                  if (JSON.stringify(cellRange) !== '{}') {
                    cellRange.range = cellObj
                    lastRowData.push(cellRange)
                  }
                }
                console.timeEnd('记录下最后一列的公式和值')
              }
              // 根据count插入空白列
              console.time('插入列')
              // 插入列
              try {
                sheet.insertColumn(insertCol, insertColCount)
              } catch (exception) {
                extendFunctions.errorMessage(that.$t('report.insertColumnError'), exception)
              }
              console.timeEnd('插入列')
              console.time('设置列宽')
              // insertCol插入位置
              for (i = 0; i < insertColCount; i++) {
                // 行高控制
                sheet.columnWidth(insertCol + i, that.defaultRowHeight[dataSheetId] ? (that.defaultRowHeight[dataSheetId].col) : 64)
                // 合并单元格处理
                for (var mergedInfo of mergedList) {
                  mergedInfo.topLeft.col = mergedInfo.bottomRight.col = insertCol + i + 1
                  sheet.range(formatConverter.ConvertJsonToRange(mergedInfo)).merge()
                }
              }
              console.timeEnd('设置列宽')
              // 使用AutoFill功能进行整行内容复制
              const originRange = {
                topLeft: {
                  row: 1,
                  col: selectedRange.bottomRight.col - (insertColShift ? 1 : 0)
                },
                bottomRight: {
                  row: maxUsedRow,
                  col: selectedRange.bottomRight.col - (insertColShift ? 1 : 0)
                }
              }
              // console.log(originRange)
              const operatingRange = {
                topLeft: {
                  row: 1,
                  col: selectedRange.bottomRight.col + 1 - (insertColShift ? 1 : 0)
                },
                bottomRight: {
                  row: maxUsedRow,
                  col: selectedRange.bottomRight.col + insertColCount
                }
              }
              // 由于AutoFill不能清除边框，需要手动处理一次
              dealRange = formatConverter.ConvertJsonToRange(operatingRange)
              sheet.range(dealRange).borderLeft(null)
              // sheet.range(dealRange).borderRight(null)
              sheet.range(dealRange).borderTop(null)
              sheet.range(dealRange).borderBottom(null)
              console.time('复制格式')
              that.spreadSheet._workbook.execute({
                command: 'AutoFillCommand',
                options: {
                  disableUndoStack: true,
                  disableRangeEnable: true,
                  fillModel: 'format_col',
                  origin: sheet.range(formatConverter.ConvertJsonToRange(originRange)),
                  operatingRange: sheet.range(formatConverter.ConvertJsonToRange(operatingRange))
                }
              })
              console.timeEnd('复制格式')
              if (insertColShift) {
                originRange.topLeft.col += 1
                originRange.bottomRight.col += 1
                operatingRange.topLeft.col += 1
              }
              // 清空不带公式的单元格内容，并且将有公式的内容填充
              console.time('复制公式')
              var dealRange, dealOriginRange
              for (var j = originRange.topLeft.row; j <= originRange.bottomRight.row; j++) {
                dealRange = {
                  topLeft: {
                    row: j,
                    col: operatingRange.topLeft.col
                  },
                  bottomRight: {
                    row: j,
                    col: operatingRange.bottomRight.col
                  }
                }
                dealOriginRange = {
                  topLeft: {
                    row: j,
                    col: originRange.topLeft.col
                  },
                  bottomRight: {
                    row: j,
                    col: originRange.bottomRight.col
                  }
                }
                if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).formula() === null) {
                  if (withoutFormula) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).formula(null)
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).classify(null)
                  }
                  sheet.range(formatConverter.ConvertJsonToRange(dealRange)).values([])
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).imageGroup()) {
                    that.setFieldImageGroup(sheet, formatConverter.ConvertJsonToRange(dealRange))
                  }
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).sign()) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).sign(true)
                  }
                  if (sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)).attachGroup()) {
                    that.setFieldAttachGroup(sheet, formatConverter.ConvertJsonToRange(dealRange))
                  }
                } else {
                  if (withoutFormula) {
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).formula(null)
                    sheet.range(formatConverter.ConvertJsonToRange(dealRange)).classify(null)
                  } else {
                    that.spreadSheet._workbook.execute({
                      command: 'AutoFillCommand',
                      options: {
                        disableUndoStack: true,
                        disableRangeEnable: true,
                        fillModel: 'formula_col',
                        origin: sheet.range(formatConverter.ConvertJsonToRange(dealOriginRange)),
                        operatingRange: sheet.range(formatConverter.ConvertJsonToRange(dealRange))
                      }
                    })
                  }
                }
              }
              console.timeEnd('复制公式')
              if (insertColShift) {
                // 将最后一列的值回写过去
                console.time('回写最后一列记录的值')
                lastRowData.forEach(cellRange => {
                  if (cellRange.formula) {
                    cellRange.range.formula(cellRange.formula)
                  } else if (cellRange.value) {
                    cellRange.range.value(cellRange.value)
                  }
                  cellRange.range.imageGroup(cellRange.imageGroup || null)
                  cellRange.range.attachGroup(cellRange.attachGroup || null)
                  cellRange.range.attachEnable(cellRange.attachEnable || null)
                  cellRange.range.hidden(cellRange.hidden || null)
                  cellRange.range.customButtons(cellRange.customButtons || null)
                  cellRange.range.conditionStyle(cellRange.conditionStyle || null)
                  cellRange.range.fieldInfo(cellRange.fieldInfo || null)
                  cellRange.range.classify(cellRange.classify || null)
                  cellRange.range.background(cellRange.background || null)
                  cellRange.range.borderRight(cellRange.borderRight || null)
                })
                console.timeEnd('回写最后一列记录的值')
              }
              // 判断是否在filter范围内
              if (sheet._filter !== null) {
                var filterRange = formatConverter.ConvertAllFormat2Json(sheet._filter.ref, that)
                if (filterRange.topLeft.col < selectedRange.topLeft.col &&
                    filterRange.bottomRight.col >= selectedRange.topLeft.col) {
                  filterRange.bottomRight.col = filterRange.bottomRight.col + insertColCount
                  sheet.range(formatConverter.ConvertJsonToRange(filterRange)).filter(true)
                }
              }
              // 对扩展行进行操作约束计算
              controlRoleList = that.controlRoleDictionary[dataSheetId]
              controlRoleListForTable = that.controlRoleDictionary['extendTableCalc']
              if (controlRoleList && controlRoleList.length || (controlRoleListForTable && controlRoleListForTable.length)) {
                tableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
                startIndex = selectedRange.topLeft.row - tableRange.topLeft.row + 1
                if (insertColShift) {
                  startIndex -= 1
                  insertColCount += 1
                }
                if (controlRoleList && controlRoleList.length) {
                  for (i = startIndex; i < startIndex + insertColCount; i++) {
                    that.controlRoleHelper(controlRoleList, {
                      top: i,
                      length: 1
                    })
                  }
                }
                if (controlRoleListForTable && controlRoleListForTable.length) {
                  for (i = startIndex; i < startIndex + insertColCount; i++) {
                    that.controlRoleHelper(controlRoleListForTable)
                  }
                }
              }
            })
            that.maxUsedColumn[sheet.name()] += count
            if (that.formulaMode) {
              that.spreadSheet._workbook.updateFormulaTarget()
            }
            break
          }
        }
        // var extendTableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
        // // 给予颜色
        // console.time('默认纯色')
        // if (!this.dataSheets[dataSheetId].intervalColor) { that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).background('white') }
        // console.timeEnd('默认纯色')
        // console.time('默认边框')
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).borderLeft({ size: 1, color: 'black' })
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).borderRight({ size: 1, color: 'black' })
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).borderTop({ size: 1, color: 'black' })
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).borderBottom({ size: 1, color: 'black' })
        // console.timeEnd('默认边框')
        // console.time('文本水平居中')
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).verticalAlign('center')
        // console.timeEnd('文本水平居中')
        // console.time('文本垂直居左')
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).textAlign('left')
        // console.timeEnd('文本垂直居左')
        // console.time('移除所有格式')
        // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(extendTableRange)).format('#')
        // console.timeEnd('移除所有格式')
        // that.dataSheets[dataSheetId].children.forEach((fieldInfo) => {
        //   var dealRangeJson, fieldRangeJson
        //   switch (fieldInfo.baseType) {
        //     case 4:
        //       // 日期转换为XXXX-XX-XX
        //       dealRangeJson = extendFunctions.deepCopy(extendTableRange)
        //       fieldRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
        //       switch (type) {
        //         case 'row':
        //           dealRangeJson.topLeft.col = fieldRangeJson.topLeft.col
        //           dealRangeJson.bottomRight.col = fieldRangeJson.bottomRight.col
        //           break
        //         case 'col':
        //           dealRangeJson.topLeft.col = fieldRangeJson.topLeft.col
        //           dealRangeJson.bottomRight.col = fieldRangeJson.bottomRight.col
        //           break
        //       }
        //       that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(dealRangeJson)).format('yyyy-m-d')
        //       break
        //     case 3:
        //       // 数值垂直居右
        //       dealRangeJson = extendFunctions.deepCopy(extendTableRange)
        //       fieldRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
        //       switch (type) {
        //         case 'row':
        //           dealRangeJson.topLeft.col = fieldRangeJson.topLeft.col
        //           dealRangeJson.bottomRight.col = fieldRangeJson.bottomRight.col
        //           break
        //         case 'col':
        //           dealRangeJson.topLeft.col = fieldRangeJson.topLeft.col
        //           dealRangeJson.bottomRight.col = fieldRangeJson.bottomRight.col
        //           break
        //       }
        //       that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(dealRangeJson)).textAlign('right')
        //       // that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(dealRangeJson)).format('[>=0]0.00;[<0]-0.00')
        //       break
        //     case 1:
        //     case 5:
        //     case 6:
        //     default:
        //       // 字符串不作处理图片不作处理附件不作处理
        //       break
        //   }
        // })
        // 刷新间隔色
        // if (this.dataSheets[dataSheetId].intervalActive) { this.SetIntervalColor(dataSheetId, type === 'row' ? selectedRange.topLeft.row : selectedRange.topLeft.col, count) }
        this.CalcSetScroller(dataSheetId, type)
        console.timeEnd('扩展行/列')
        console.warn(this.spreadSheet.activeSheet()._properties.get('fieldInfo').values())
      }
    },

    // 间隔色
    SetIntervalColor: function(dataSheetId) {
      // 给指定区域设置间隔色属性
      var handleRange = this.spreadSheet._workbook._names[this.dataSheets[dataSheetId].areaAlias.toLowerCase()].value
      var direction = this.dataSheets[dataSheetId].extType === 1 ? 'row' : 'col'
      var benchmarkPlace
      if (direction === 'row') {
        benchmarkPlace = handleRange.topLeft.row
      } else {
        benchmarkPlace = handleRange.topLeft.col
      }
      var that = this
      this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).batch(() => {
        that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(handleRange.toString()).interval({
          direction: direction,
          model: benchmarkPlace % 2 ? 1 : -1, // 1=奇数行，2=偶数行
          color: that.dataSheets[dataSheetId].intervalColor || '#D4EBFE'
        })
      })
    },

    // 删除行/列
    DeleteRowColumn: function(selectedRange, type, withoutControlRole, ignoreStep, ignorePagination) {
      const that = this
      console.time('删除行/列')
      const sheet = selectedRange.workSheet ? that.spreadSheet.sheetByName(selectedRange.workSheet) : that.spreadSheet.activeSheet()
      var fieldRange = this.spreadSheet.sheetByName(sheet).range(formatConverter.ConvertJsonToRange(selectedRange))
      if (!fieldRange) {
        extendFunctions.errorMessage(that.$t('status.error'), that.$t('report.rowError'))
        this.spreadSheet._workbook.ignoreClipbord = false
        return
      }
      var fieldInfo = this.id2Info[fieldRange.fieldInfo()]
      var handleTableId = fieldInfo.owner
      const paginationInfo = this.paginationItems.find(item => item.id === +handleTableId)
      var deleteRow, deleteRowCount, deleteColumn, deleteColumnCount
      if (paginationInfo && !ignorePagination) {
        // 分页扩展行
        if (!this.extendDataCollection[handleTableId]) {
          this.extendDataCollection[handleTableId] = []
        }
        const editTable = this.extendDataCollection[handleTableId]
        switch (type) {
          case 'row':
            // 从第几行开始删除
            deleteRow = selectedRange.topLeft.row - fieldRange._ref.topLeft.row + 1 + (ignoreStep ? 0 : paginationInfo.currentPage * paginationInfo.step)
            // 共删除多少行
            deleteRowCount = selectedRange.bottomRight.row - selectedRange.topLeft.row + 1
            break
          case 'column':
            // 在第几列进行插入
            deleteRow = selectedRange.bottomRight.col - fieldRange._ref.topLeft.col + 1 + (ignoreStep ? 0 : paginationInfo.currentPage * paginationInfo.step)
            // 共插入多少列
            deleteRowCount = selectedRange.bottomRight.col - selectedRange.topLeft.col + 1
            break
        }
        if (editTable.length - deleteRow < deleteRowCount) {
          deleteRowCount = editTable.length - deleteRow
        }
        // 开始删除
        if (deleteRowCount) {
          editTable.splice(deleteRow, deleteRowCount)
        }
        // 更新总行数
        this.RefreshPaginationInfo(handleTableId)
      } else {
        var tableRange = this.GetNameRangeJson(this.dataSheets[handleTableId].areaAlias)
        var modifyRange
        switch (type) {
          case 'row':
          {
            const dataSheetRowsInfo = that.GetDataSheetUsedRowInfo(handleTableId)
            deleteRowCount = selectedRange.bottomRight.row - selectedRange.topLeft.row + 1
            deleteRow = selectedRange.topLeft.row
            var startIndex, i, controlRoleList, message
            if (!withoutControlRole && this.controlRoleDictionary && this.controlRoleDictionary[handleTableId]) {
              controlRoleList = this.controlRoleDictionary[handleTableId].filter(roleId => {
                const currentRole = this.controlRoles.find(role => role.id === roleId)
                return currentRole && (currentRole.operation & 1) === 1
              })
              if (controlRoleList && controlRoleList.length) {
                startIndex = selectedRange.topLeft.row - tableRange.topLeft.row
                for (i = startIndex; i < startIndex + deleteRowCount; i++) {
                  message = this.controlRoleHelper(controlRoleList, {
                    top: i,
                    length: 1
                  })
                  if (message === 'no_message') {
                    extendFunctions.errorMessage(that.$('report.cannotDelete'))
                    return
                  } else if (message) {
                    extendFunctions.errorMessage(message)
                    return
                  }
                }
              }
              controlRoleList = this.controlRoleDictionary['extendTableCalc']
              if (controlRoleList && controlRoleList.length) {
                startIndex = selectedRange.topLeft.row - tableRange.topLeft.row
                for (i = startIndex; i < startIndex + deleteRowCount; i++) {
                  message = this.controlRoleHelper(controlRoleList)
                  if (message === 'no_message') {
                    extendFunctions.errorMessage(that.$('report.cannotDelete'))
                    return
                  } else if (message) {
                    extendFunctions.errorMessage(message)
                    return
                  }
                }
              }
            }
            const leftRows = dataSheetRowsInfo.usedRangeJson.bottomRight.row - dataSheetRowsInfo.usedRangeJson.topLeft.row - deleteRowCount + 1
            if (leftRows < 2) {
              // 仅删除数据
              modifyRange = sheet.range(formatConverter.ConvertJsonToRange({
                topLeft: {
                  row: selectedRange.topLeft.row,
                  col: dataSheetRowsInfo.usedRangeJson.topLeft.col
                },
                bottomRight: {
                  row: selectedRange.bottomRight.row,
                  col: dataSheetRowsInfo.usedRangeJson.bottomRight.col
                }
              }))
              sheet.batch(function() {
                modifyRange.forEachCell((row, col, cell) => {
                  if (!cell.formula) {
                    var range = sheet.range(formatConverter.ConvertJsonToA1({
                      row: row + 1,
                      col: col + 1
                    }))
                    range.value(null)
                    if (range.attachGroup()) {
                      that.setFieldAttachGroup(sheet, range._ref.toString())
                    }
                    if (range.imageGroup()) {
                      that.setFieldImageGroup(sheet, range._ref.toString())
                    }
                  }
                })
              })
              // 继续删除多出来的行
              if (deleteRowCount + leftRows <= 2) {
                return
              }
              deleteRowCount -= 2 - leftRows
              selectedRange.topLeft.row += 2 - leftRows
              fieldRange = this.spreadSheet.sheetByName(sheet).range(formatConverter.ConvertJsonToRange(selectedRange))
              if (!fieldRange) {
                this.spreadSheet._workbook.ignoreClipbord = false
                return
              }
            }
            sheet.batch(function() {
              sheet.deleteRow(deleteRow - 1, deleteRowCount)
              if (sheet._filter !== null) {
                var filterRange = formatConverter.ConvertAllFormat2Json(sheet._filter.ref, that)
                if (filterRange.topLeft.row < selectedRange.topLeft.row &&
                    filterRange.bottomRight.row >= selectedRange.topLeft.row) {
                  filterRange.bottomRight.row = filterRange.bottomRight.row - deleteRowCount
                  sheet.range(formatConverter.ConvertJsonToRange(filterRange)).filter(true)
                }
              }
            })
            this.maxUsedRow[sheet.name()] -= deleteRowCount
            break
          }
          case 'column':
          {
            const dataSheetColumnsInfo = that.GetDataSheetUsedRowInfo(handleTableId)
            deleteColumnCount = selectedRange.bottomRight.col - selectedRange.topLeft.col + 1
            const leftCols = dataSheetColumnsInfo.usedRangeJson.bottomRight.col - dataSheetColumnsInfo.usedRangeJson.topLeft.col - deleteColumnCount + 1
            if (leftCols < 2) {
              // 仅删除数据
              modifyRange = sheet.range(formatConverter.ConvertJsonToRange({
                topLeft: {
                  row: dataSheetColumnsInfo.usedRangeJson.topLeft.row,
                  col: selectedRange.topLeft.col
                },
                bottomRight: {
                  row: dataSheetColumnsInfo.usedRangeJson.bottomRight.row,
                  col: selectedRange.bottomRight.col
                }
              }))
              sheet.batch(function() {
                modifyRange.forEachCell((row, col, cell) => {
                  if (!cell.formula) {
                    sheet.range(formatConverter.ConvertJsonToA1({
                      row: row + 1,
                      col: col + 1
                    })).value(null)
                  }
                })
              })
              // 继续删除多出来的列
              if (deleteColumnCount + leftCols <= 2) {
                return
              }
              deleteColumnCount -= 2 - leftCols
              selectedRange.topLeft.col += 2 - leftCols
              fieldRange = this.spreadSheet.sheetByName(sheet).range(formatConverter.ConvertJsonToRange(selectedRange))
              if (!fieldRange) {
                this.spreadSheet._workbook.ignoreClipbord = false
                return
              }
            }
            deleteColumn = selectedRange.topLeft.col
            sheet.batch(function() {
              sheet.deleteColumn(deleteColumn - 1, deleteColumnCount)
              if (sheet._filter !== null) {
                var filterRange = formatConverter.ConvertAllFormat2Json(sheet._filter.ref, that)
                if (filterRange.topLeft.col < selectedRange.topLeft.col &&
                    filterRange.bottomRight.col >= selectedRange.topLeft.col) {
                  filterRange.bottomRight.col = filterRange.bottomRight.col - deleteColumnCount
                  sheet.range(formatConverter.ConvertJsonToRange(filterRange)).filter(true)
                }
              }
            })
            this.maxUsedColumn[sheet.name()] -= deleteColumnCount
            break
          }
        }
      }
      console.timeEnd('删除行/列')
    },

    // 计算并判断是否显示滚动条
    CalcSetScroller: function(dataSheetId, direction) {
      return
      // var dataSheetInfo = this.dataSheets[dataSheetId]
      // if (dataSheetInfo.type === 0) {
      //   return
      // }
      // switch (direction) {
      //   case 'row':
      //     if (this.spreadSheet._view.scroller.style.overflowY === 'auto') { return }
      //     break
      //   case 'column':
      //     if (this.spreadSheet._view.scroller.style.overflowX === 'auto') { return }
      //     break
      // }
      // var dataSheetRange = this.GetNameRangeJson(dataSheetInfo.areaAlias)
      // switch (direction) {
      //   case 'row':
      //     if (dataSheetRange.bottomRight.row - dataSheetRange.topLeft.row >= 40) {
      //       this.spreadSheet._view.scroller.style.overflowY = 'auto'
      //     }
      //     break
      //   case 'column':
      //     if (dataSheetRange.bottomRight.col - dataSheetRange.topLeft.col >= 30) {
      //       this.spreadSheet._view.scroller.style.overflowX = 'auto'
      //     }
      //     break
      // }
    },

    // 锁定所有单元格
    LockProtectedRanges: function(sheetName) {
      const that = this
      if (that.advancedProperty.adminModel) {
        return
      }
      console.time('锁定单元格')
      for (var i = 0; i < that.sheetList.length; i++) {
        if (sheetName !== undefined) {
          if (that.sheetList[i].name() !== sheetName) {
            continue
          }
        }
        that.sheetList[i].batch(function() {
          // console.time('整表锁定')
          const valueableRange = that.sheetList[i].range(formatConverter.ConvertJsonToRange({
            topLeft: {
              row: 0,
              col: 0
            },
            bottomRight: {
              row: that.maxControlRow,
              col: that.maxControlColumn
            }
          }))
          // const valueableRange = that.sheetList[i].range(formatConverter.ConvertJsonToRange(that.GetValuableControlRange()))
          valueableRange.locked(true)
          valueableRange.attachEnable(false)
          // console.timeEnd('整表锁定')
        }, { layout: true })
      }
      console.timeEnd('锁定单元格')
    },

    // 解锁白名单字段
    UnLockWhiteListRanges: function(sheetName) {
      const that = this
      console.time('解锁白名单')
      for (var i = 0; i < that.sheetList.length; i++) {
        if (sheetName !== undefined) {
          if (that.sheetList[i].name() !== sheetName) {
            continue
          }
        }
        var j
        that.sheetList[i].batch(function() {
          for (j = 0; j < that.whiteList[that.sheetList[i]._sheetName].length; j++) {
            const valueableRange = that.sheetList[i].range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(that.whiteList[that.sheetList[i]._sheetName][j])))
            valueableRange.locked(false)
          }
          for (j = 0; j < that.attachWhiteList[that.sheetList[i]._sheetName].length; j++) {
            const valueableRange = that.sheetList[i].range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(that.attachWhiteList[that.sheetList[i]._sheetName][j])))
            valueableRange.attachEnable(true)
          }
        }, { layout: true })
      }
      console.timeEnd('解锁白名单')
    },

    // 解锁所有单元格
    UnLockProtectedRanges: function(sheetName) {
      const that = this
      console.time('解锁单元格')
      for (var i = 0; i < that.sheetList.length; i++) {
        if (sheetName !== undefined) {
          if (that.sheetList[i].name() !== sheetName) {
            continue
          }
        }
        that.sheetList[i].batch(function() {
          const valuableRange = formatConverter.ConvertJsonToRange(that.GetValuableControlRange())
          that.sheetList[i].range(valuableRange).enable(true)
        }, { layout: true })
      }
      console.timeEnd('解锁单元格')
    },

    // 获取数据表在this.spreadSheet对应区域中的起始行，最后一行及已使用行数
    // 该行公式列不参与空行判断
    GetDataSheetUsedRowInfo: function(dataSheetId) {
      if (this.dataSheets[dataSheetId].type === 0) {
        return undefined
      }
      const dataRangeJson = this.GetNameRangeJson(this.dataSheets[dataSheetId].areaAlias)
      var usedRowColumnInfo = {
        usedRangeJson: dataRangeJson,
        usedRowColumnCount: 0
      }
      const dataInSheet = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(dataRangeJson)).values(undefined, false)
      // 交叉表处理
      if (this.dataSheets[dataSheetId].extType === 3) {
        let usedRow = 0
        let usedCol = 0
        dataInSheet.forEach((row, rowIndex) => {
          row.forEach((cell, colIndex) => {
            if (cell) {
              usedRow = rowIndex
              usedCol = colIndex > usedCol ? colIndex : usedCol
            }
          })
        })
        usedRowColumnInfo.matrix = {
          usedRow: usedRow + 1,
          usedCol: usedCol + 1
        }
      }
      var compareRangeJson, cellMergeInfo
      console.time('按数据行判断空行')
      for (var j = 0; j < dataInSheet[0].length; j++) {
        const handleRange = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).range(
          formatConverter.ConvertJsonToA1({ row: dataRangeJson.topLeft.row, col: dataRangeJson.topLeft.col + j }))
        const firstRowRangeJson = new kendo.spreadsheet.RangeRef({
          row: dataRangeJson.topLeft.row - 1,
          col: dataRangeJson.topLeft.col + j - 1
        }, {
          row: dataRangeJson.topLeft.row - 1,
          col: dataRangeJson.topLeft.col + j - 1
        })
        cellMergeInfo = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName)._getMergedCells(firstRowRangeJson)
        if (!handleRange.switch() && !handleRange.formula()) {
          for (var i = dataInSheet.length - 1; i >= 0; i--) {
            compareRangeJson = new kendo.spreadsheet.RangeRef({
              row: dataRangeJson.topLeft.row + i - 1,
              col: dataRangeJson.topLeft.col + j - 1
            }, {
              row: dataRangeJson.topLeft.row + i - 1,
              col: dataRangeJson.topLeft.col + j - 1
            })
            if (cellMergeInfo.hasMerged) {
              for (var cell in cellMergeInfo.primary) {
                compareRangeJson = cellMergeInfo.primary[cell]
              }
            }
            // 解决合并单元格的问题
            if (((dataInSheet[i][j]) || compareRangeJson.topLeft.row !== compareRangeJson.bottomRight.row) &&
            usedRowColumnInfo.usedRowColumnCount < i + 1) {
              usedRowColumnInfo.usedRowColumnCount = i + 1
              break
            }
          }
        }
      }
      console.timeEnd('按数据行判断空行')
      return usedRowColumnInfo
    },

    // 获取数据表在this.spreadSheet对应区域中的起始列，最后一列及已使用列数
    GetDataSheetUsedColumnInfo: function(dataSheetId) {
      if (this.dataSheets[dataSheetId].type === 0) {
        return undefined
      }
      const dataRangeJson = this.GetNameRangeJson(this.dataSheets[dataSheetId].areaAlias)
      // const dataInSheet = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).range(
      //   formatConverter.ConvertJsonToRange(dataRangeJson)).values()
      var usedRowColumnInfo = {
        usedRangeJson: dataRangeJson,
        usedRowColumnCount: 0
      }
      const dataInSheet = formatConverter.TransArray(this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(dataRangeJson)).values(undefined, false))
      var compareRangeJson, cellMergeInfo
      for (var j = dataInSheet.length - 1; j >= 0; j--) {
        var handleRange = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).range(
          formatConverter.ConvertJsonToA1({ row: dataRangeJson.topLeft.row + j, col: dataRangeJson.topLeft.col }))
        if (!handleRange.formula() && !handleRange.switch()) {
          for (var i = 0; i < dataInSheet[0].length; i++) {
            compareRangeJson = new kendo.spreadsheet.RangeRef({
              row: dataRangeJson.topLeft.row + i - 1,
              col: dataRangeJson.topLeft.col + j - 1
            }, {
              row: dataRangeJson.topLeft.row + i - 1,
              col: dataRangeJson.topLeft.col + j - 1
            })
            cellMergeInfo = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName)._getMergedCells(compareRangeJson)
            if (cellMergeInfo.hasMerged) {
              for (var cell in cellMergeInfo.primary) {
                compareRangeJson = cellMergeInfo.primary[cell]
              }
            }
            // 解决合并单元格的问题
            if (dataInSheet[j][i] || compareRangeJson.topLeft.col !== compareRangeJson.bottomRight.col) {
              usedRowColumnInfo.usedRowColumnCount = j + 1
              // return usedRowColumnInfo
              break
            }
          }
        }
      }
      // debugger
      return usedRowColumnInfo
    },

    // 获取交叉表数据表在this.spreadSheet对应区域中的起始信息，结束信息及已使用信息
    GetMatrixUsedInfo: function(dataSheetId) {
      if (this.dataSheets[dataSheetId].type === 0) {
        return undefined
      }
      var handleDataRange, handleDataString
      const tableInSheet = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName)
      const dataRangeJson = this.GetNameRangeJson(this.dataSheets[dataSheetId].areaAlias)
      var usedRowColumnInfo = {
        usedRangeJson: this.GetNameRangeJson(this.dataSheets[dataSheetId].children.filter(fieldInfo => { return fieldInfo.extType === 3 })[0].areaAlias),
        dataRangeJson: dataRangeJson,
        usedRowColumnCount: {
          row: 0,
          col: 0
        },
        centerUsedCount: {
          row: 0,
          col: 0
        }
      }
      var dataInSheet, cellMergeInfo, i, j, cell, tempValue
      // 分开取最大利用行和列
      var centerAreaRange = usedRowColumnInfo.usedRangeJson
      var leftAreaRange = {
        topLeft: {
          row: centerAreaRange.topLeft.row,
          col: dataRangeJson.topLeft.col
        },
        bottomRight: {
          row: centerAreaRange.bottomRight.row,
          col: centerAreaRange.topLeft.col - 1
        }
      }
      var topAreaRange = {
        topLeft: {
          row: dataRangeJson.topLeft.row,
          col: centerAreaRange.topLeft.col
        },
        bottomRight: {
          row: centerAreaRange.topLeft.row - 1,
          col: centerAreaRange.bottomRight.col
        }
      }
      dataInSheet = tableInSheet.range(formatConverter.ConvertJsonToRange(centerAreaRange)).values(undefined, false)
      handleDataString = ''
      for (i = dataInSheet.length - 1; i >= 0; i--) {
        for (j = dataInSheet[i].length - 1; j >= 0; j--) {
          if (!tableInSheet.range(
            formatConverter.ConvertJsonToA1({ row: centerAreaRange.topLeft.row + i, col: centerAreaRange.topLeft.col + j })).formula()) {
            if (dataInSheet[i][j] !== 0 && dataInSheet[i][j] !== null && dataInSheet[i][j] !== '') {
              handleDataString += dataInSheet[i][j]
            }
          }
        }
        if (handleDataString) {
          usedRowColumnInfo.centerUsedCount.row = i + 1
          break
        }
      }
      handleDataString = ''
      for (j = dataInSheet[0].length - 1; j >= 0; j--) {
        for (i = dataInSheet.length - 1; i >= 0; i--) {
          if (!tableInSheet.range(
            formatConverter.ConvertJsonToA1({ row: centerAreaRange.topLeft.row + i, col: centerAreaRange.topLeft.col + j })).formula()) {
            if (dataInSheet[i][j] !== 0 && dataInSheet[i][j] !== null && dataInSheet[i][j] !== '') {
              handleDataString += dataInSheet[i][j]
            }
          }
        }
        if (handleDataString) {
          usedRowColumnInfo.centerUsedCount.col = j + 1
          break
        }
      }
      for (i = leftAreaRange.bottomRight.row; i >= leftAreaRange.topLeft.row; i--) {
        handleDataRange = {
          topLeft: {
            row: i,
            col: leftAreaRange.topLeft.col
          },
          bottomRight: {
            row: i,
            col: leftAreaRange.bottomRight.col
          }
        }
        dataInSheet = tableInSheet.range(formatConverter.ConvertJsonToRange(handleDataRange)).values(undefined, false)[0]
        handleDataString = ''
        for (j = leftAreaRange.bottomRight.col; j >= leftAreaRange.topLeft.col; j--) {
          if (!tableInSheet.range(formatConverter.ConvertJsonToA1({ row: leftAreaRange.topLeft.row, col: j })).formula()) {
            cellMergeInfo = tableInSheet._getMergedCells(new kendo.spreadsheet.RangeRef({
              row: i - 1,
              col: j - 1
            }, {
              row: i - 1,
              col: j - 1
            }))
            tempValue = dataInSheet[j - leftAreaRange.topLeft.col]
            if (cellMergeInfo.hasMerged) {
              for (cell in cellMergeInfo.primary) {
                tempValue = tableInSheet.range(cellMergeInfo.primary[cell].toString()).value()
              }
            }
            if (tempValue) {
              handleDataString += tempValue
            }
          }
        }
        if (handleDataString) {
          usedRowColumnInfo.usedRowColumnCount.row = i - leftAreaRange.topLeft.row + 1
          break
        }
      }
      for (i = topAreaRange.bottomRight.col; i >= topAreaRange.topLeft.col; i--) {
        handleDataRange = {
          topLeft: {
            row: topAreaRange.topLeft.row,
            col: i
          },
          bottomRight: {
            row: topAreaRange.bottomRight.row,
            col: i
          }
        }
        dataInSheet = tableInSheet.range(formatConverter.ConvertJsonToRange(handleDataRange)).values(undefined, false)
        handleDataString = ''
        for (j = topAreaRange.bottomRight.row; j >= topAreaRange.topLeft.row; j--) {
          if (!tableInSheet.range(formatConverter.ConvertJsonToA1({ row: j, col: topAreaRange.topLeft.col })).formula()) {
            cellMergeInfo = tableInSheet._getMergedCells(new kendo.spreadsheet.RangeRef({
              row: j - 1,
              col: i - 1
            }, {
              row: j - 1,
              col: i - 1
            }))
            tempValue = dataInSheet[j - topAreaRange.topLeft.row][0]
            if (cellMergeInfo.hasMerged) {
              for (cell in cellMergeInfo.primary) {
                tempValue = tableInSheet.range(cellMergeInfo.primary[cell].toString()).value()
              }
            }
            if (tempValue) {
              handleDataString += tempValue
            }
          }
        }
        if (handleDataString) {
          usedRowColumnInfo.usedRowColumnCount.col = i - topAreaRange.topLeft.col + 1
          break
        }
      }
      console.log(usedRowColumnInfo)
      return usedRowColumnInfo
    },

    translateExcelFormula(formula, row, col) {
      if (formula) {
        var replaceRange = (list, type) => {
          if (fieldList && fieldList.length) {
            fieldList = extendFunctions.ArrayDistinct(fieldList)
            fieldList.forEach(matchItem => {
              // 匹配替换
              var dataSheetName = type ? matchItem.split('.')[1] : matchItem.split('.')[0]
              var fieldName = type ? matchItem.split('.')[2] : matchItem.split('.')[1]
              var fieldNameRange, dataSheetType, fieldSheet
              for (var id in this.dataSheets) {
                if (dataSheetName === `[${this.dataSheets[id].name}]`) {
                  var findResult = this.dataSheets[id].children.find(fieldInfo => fieldName === `[${fieldInfo.name}]`)
                  if (findResult) {
                    fieldNameRange = findResult.areaAlias.toLowerCase()
                    dataSheetType = this.dataSheets[id].type
                    fieldSheet = findResult.sheetName
                    break
                  }
                } else {
                  continue
                }
              }
              if (fieldNameRange) {
                var fieldRange = this.spreadSheet._workbook._names[fieldNameRange].value.toString()
                if (!dataSheetType && fieldRange.indexOf(':') >= 0) {
                  fieldRange = fieldRange.split(':')[0]
                } else {
                  // 扩展表
                  var fieldRangeJson = formatConverter.convertA1ToJson(fieldRange, fieldSheet)
                  if (row !== undefined) {
                    fieldRangeJson.topLeft.row = row
                    fieldRangeJson.bottomRight.row = row
                  } else if (col !== undefined) {
                    fieldRangeJson.topLeft.col = col
                    fieldRangeJson.bottomRight.col = col
                  }
                  fieldRange = formatConverter.ConvertJsonToRange(fieldRangeJson)
                }
                matchItem = matchItem.replace(/\[/g, '\\[').replace(/\]/g, '\\]').replace(/\./g, '\\.')
                formula = formula.replace(new RegExp(matchItem, 'g'), fieldSheet + '!' + fieldRange)
              }
            })
          }
        }
        // RegExp替换字段内容
        var fieldList = formula.match(/本报表\.\[.*?\]\.\[.*?\]/g)
        replaceRange(fieldList, 1)
        fieldList = formula.match(/\[.*?\]\.\[.*?\]/g)
        replaceRange(fieldList)
        return formula
      } else {
        return null
      }
    },

    // 根据字段ID向主表字段填值
    InsertMasterFieldValue: function(masterTableId, fieldValueArray, ignoreQueryFormula, specialFilling, ignoreCondition) {
      console.time('主表数据整理')
      // 速度优化，按sheet整理字段列表，再循环sheet进行batch
      var insertDataBySheet = {}
      var that = this
      var fieldId, fieldInfo, sheetName
      if (!masterTableId) {
        masterTableId = this.masterTableId
      }
      for (fieldId in fieldValueArray[0]) {
        fieldInfo = this.dataSheets[masterTableId].fields[fieldId]
        if (fieldInfo === undefined) {
          continue
        }
        if (insertDataBySheet[fieldInfo.sheetName] === undefined) {
          insertDataBySheet[fieldInfo.sheetName] = []
        }
        var insertValue = formatConverter.SetValidValue(this.dataSheets[masterTableId].fields[fieldId].baseType, fieldValueArray[0][fieldId], this)
        if (specialFilling && specialFilling[fieldId] && specialFilling[fieldId] === 3) {
          // 追加填充
          var oldValue = this.GetDataFromMasterTable(fieldId)
          switch (this.dataSheets[masterTableId].fields[fieldId].baseType) {
            case 5:
            case 6:
              if (oldValue && insertValue) {
                oldValue = JSON.parse(insertValue)
                insertValue = JSON.parse(insertValue)
                if (insertValue.data && insertValue.data.length) {
                  if (!oldValue.data) {
                    oldValue.data = []
                  }
                  insertValue.data.forEach(item => {
                    oldValue.data.push(item)
                  })
                  insertValue = JSON.stringify(oldValue)
                }
              }
              break
            default:
              insertValue = oldValue + insertValue
              break
          }
        }
        insertDataBySheet[fieldInfo.sheetName].push({
          fieldId: fieldId,
          range: formatConverter.ConvertJsonToRange(this.GetNameRangeJson(fieldInfo.areaAlias)),
          rangeJson: this.GetNameRangeJson(fieldInfo.areaAlias),
          value: insertValue
        })
      }
      console.timeEnd('主表数据整理')
      console.time('主表填值过程')
      var fieldRange, sheet
      for (sheetName in insertDataBySheet) {
        sheet = this.spreadSheet.sheetByName(sheetName)
        sheet.batch(function() {
          for (var insertData of insertDataBySheet[sheetName]) {
            fieldId = insertData.fieldId
            fieldRange = insertData.range
            var val = insertData.value
            switch (that.id2Info[fieldId].baseType) {
              case 5:
                that.setFieldImageGroup(sheet, fieldRange, val)
                break
              case 6:
                that.setFieldAttachGroup(sheet, fieldRange, val)
                break
              default:
                // 单元格有公式则不继续填值
                if (specialFilling && specialFilling[fieldId] && specialFilling[fieldId] === 2) {
                  // 填入Excel公式
                  sheet.range(fieldRange).formula(that.translateExcelFormula(val))
                } else {
                  // 其他填入
                  if (sheet.range(fieldRange).formula() !== null) {
                    continue
                  }
                  if (sheet.range(fieldRange).format() !== '@' &&
                    !isNaN(val) &&
                    val !== null) {
                    // 判断单元格格式为null并且填入值为数字
                    sheet.range(fieldRange).value(parseFloat(val))
                  } else {
                    // 写入值
                    sheet.range(fieldRange).value(val)
                  }
                }
                // 调整行高
                sheet.range(fieldRange)._manualAdjustRowHeight()
                break
            }
          }
        })
      }
      console.timeEnd('主表填值过程')
      console.time('依次触发取数公式')
      var changedFieldIdList = []
      for (sheetName in insertDataBySheet) {
        for (var insertData in insertDataBySheet[sheetName]) {
          changedFieldIdList.push(insertDataBySheet[sheetName][insertData].fieldId)
        }
      }
      this.FieldsValueChanged(changedFieldIdList, null, ignoreQueryFormula, ignoreCondition)
      console.timeEnd('依次触发取数公式')
    },

    // 向扩展表填值
    InsertData2ExtendTable: function(dataSheetId, usedRowColumnCount, insertData, ignoreQueryFormula, specialFilling, ignoreCondition, ignorePagination, ignoreStep) {
      console.time('向扩展表中填值')
      const that = this
      const paginationInfo = this.paginationItems.find(item => item.id === +dataSheetId)
      var handleSheet = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName)
      var fieldRange, insertRangeJson, fieldId
      if (paginationInfo && !ignorePagination) {
        // 分页时处理
        if (!this.extendDataCollection[dataSheetId]) {
          this.extendDataCollection[dataSheetId] = []
        }
        const editTableData = this.extendDataCollection[dataSheetId]
        insertData.forEach((data, index) => {
          var rowIndex = (usedRowColumnCount || 0) + index + (ignoreStep ? 0 : paginationInfo.step * paginationInfo.currentPage)
          if (!editTableData[rowIndex]) {
            editTableData[rowIndex] = {}
          }
          for (fieldId in data) {
            if (!that.id2Info[fieldId]) {
              continue
            }
            editTableData[rowIndex][fieldId] = data[fieldId]
          }
        })
        this.RefreshExtendTable(dataSheetId, true)
      } else {
        // 不分页时的处理
        // debugger
        if (insertData && insertData.length === 0) {
          return
        }
        if (that.dataSheets[dataSheetId] === undefined) {
          return
        } else if (that.dataSheets[dataSheetId].type === 1 && insertData instanceof Array && insertData.length > 0) {
          var insertColumnValues
          // 按列/行进行插入
          handleSheet.batch(function() {
            var handleExtentTable = that.dataSheets[dataSheetId].areaAlias
            var i, firstCellJson
            var changedFieldIdList = []
            for (fieldId in insertData[0]) {
              console.time('单列赋值')
              if (!that.id2Info[fieldId]) {
                continue
              }
              if (that.id2Info[fieldId].baseType === 5 || that.id2Info[fieldId].baseType === 6) {
                // 特殊单元格处理部分
                switch (that.dataSheets[dataSheetId].extType) {
                  case 1:
                    // 向下扩展
                    insertRangeJson = that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias)
                    insertRangeJson.topLeft.row = insertRangeJson.topLeft.row + usedRowColumnCount
                    insertRangeJson.bottomRight.row = insertRangeJson.topLeft.row + insertData.length - 1
                    firstCellJson = {
                      topLeft: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      },
                      bottomRight: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      }
                    }
                    for (i = 0; i < insertData.length; i++) {
                      var dealRange = handleSheet
                        .range(formatConverter.ConvertJsonToRange({
                          topLeft: {
                            row: firstCellJson.topLeft.row + i,
                            col: firstCellJson.topLeft.col
                          },
                          bottomRight: {
                            row: firstCellJson.topLeft.row + i,
                            col: firstCellJson.bottomRight.col
                          }
                        }))
                      switch (that.id2Info[fieldId].baseType) {
                        case 5:
                          that.setFieldImageGroup(handleSheet, dealRange._ref.toString(), insertData[i][fieldId])
                          break
                        case 6:
                          that.setFieldAttachGroup(handleSheet, dealRange._ref.toString(), insertData[i][fieldId])
                          break
                      }
                    }
                    break
                  case 2:
                    // 向右扩展
                    insertRangeJson = that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias)
                    insertRangeJson.topLeft.col = insertRangeJson.topLeft.col + usedRowColumnCount
                    insertRangeJson.bottomRight.col = insertRangeJson.topLeft.col + insertData.length - 1
                    firstCellJson = {
                      topLeft: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      },
                      bottomRight: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      }
                    }
                    for (i = 0; i < insertData.length; i++) {
                      var dealRange2 = handleSheet
                        .range(formatConverter.ConvertJsonToRange({
                          topLeft: {
                            row: firstCellJson.topLeft.row,
                            col: firstCellJson.topLeft.col + i
                          },
                          bottomRight: {
                            row: firstCellJson.topLeft.row,
                            col: firstCellJson.bottomRight.col + i
                          }
                        }))
                      switch (that.id2Info[fieldId].baseType) {
                        case 5:
                          that.setFieldImageGroup(handleSheet, dealRange2._ref.toString(), insertData[i][fieldId])
                          break
                        case 6:
                          that.setFieldAttachGroup(handleSheet, dealRange2._ref.toString(), insertData[i][fieldId])
                          break
                      }
                    }
                    break
                }
              } else {
                insertColumnValues = []
                // extendTableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
                switch (that.dataSheets[dataSheetId].extType) {
                  case 1:
                    // 向下扩展
                    for (i = 0; i < insertData.length; i++) {
                      insertColumnValues.push([formatConverter.SetValidValue(that.dataSheets[dataSheetId].fields[fieldId].baseType, insertData[i][fieldId], that)])
                    }
                    insertRangeJson = that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias)
                    insertRangeJson.topLeft.row = insertRangeJson.topLeft.row + usedRowColumnCount
                    insertRangeJson.bottomRight.row = insertRangeJson.topLeft.row + insertData.length - 1
                    // rowRange = {
                    //   topLeft: {
                    //     row: insertRangeJson.topLeft.row,
                    //     col: extendTableRange.topLeft.col
                    //   },
                    //   bottomRight: {
                    //     row: insertRangeJson.bottomRight.row,
                    //     col: extendTableRange.bottomRight.col
                    //   }
                    // }
                    break
                  case 2:
                    // 向右扩展
                    insertColumnValues.push([])
                    for (i = 0; i < insertData.length; i++) {
                      insertColumnValues[0].push(formatConverter.SetValidValue(that.dataSheets[dataSheetId].fields[fieldId].baseType, insertData[i][fieldId], that))
                    }
                    insertRangeJson = that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias)
                    insertRangeJson.topLeft.col = insertRangeJson.topLeft.col + usedRowColumnCount
                    insertRangeJson.bottomRight.col = insertRangeJson.topLeft.col + insertData.length - 1
                    break
                }
                firstCellJson = {
                  topLeft: {
                    row: insertRangeJson.topLeft.row,
                    col: insertRangeJson.topLeft.col
                  },
                  bottomRight: {
                    row: insertRangeJson.topLeft.row,
                    col: insertRangeJson.topLeft.col
                  }
                }
                if (specialFilling && specialFilling[fieldId] && specialFilling[fieldId] === 2) {
                  console.time('单列填excel公式')
                  var fieldRangeRef
                  var insertVal = (val) => {
                    fieldRange = formatConverter.ConvertJsonToRange(firstCellJson)
                    fieldRangeRef = handleSheet.range(fieldRange)
                    if (val) {
                      fieldRangeRef.formula(that.translateExcelFormula(val, firstCellJson.topLeft.row))
                    }
                  }
                  switch (that.dataSheets[dataSheetId].extType) {
                    case 1:
                      insertColumnValues.forEach(val => {
                        insertVal(val[0])
                        firstCellJson.topLeft.row += 1
                        firstCellJson.bottomRight.row += 1
                      })
                      break
                    case 2:
                      insertColumnValues[0].forEach(val => {
                        insertVal(val)
                        firstCellJson.topLeft.col += 1
                        firstCellJson.bottomRight.col += 1
                      })
                      break
                  }
                  console.timeEnd('单列填excel公式')
                } else {
                  fieldRange = formatConverter.ConvertJsonToRange(firstCellJson)
                  if (handleSheet.range(fieldRange).formula() !== null) {
                    continue
                  }
                  fieldRange = formatConverter.ConvertJsonToRange(insertRangeJson)
                  // 一次6个有值单元格耗时1.5ms
                  handleSheet.range(fieldRange).values(insertColumnValues)
                  handleSheet.range(fieldRange).showController(true)
                }
                changedFieldIdList.push(fieldId)
                console.timeEnd('单列赋值')
              }
            }
            if (changedFieldIdList.length > 0) {
              that.FieldsValueChanged(changedFieldIdList, {
                top: usedRowColumnCount,
                length: insertData.length
              }, ignoreQueryFormula, ignoreCondition)
            }
            handleExtentTable = formatConverter.ConvertJsonToRange(that.GetNameRangeJson(handleExtentTable))
            // FIXME:低于500行才进行行高计算
            if (insertColumnValues && insertColumnValues.length <= 500) {
              console.time('重算行高')
              console.warn('性能损耗点')
              handleSheet.range(handleExtentTable)._manualAdjustRowHeight()
              console.timeEnd('重算行高')
            }
            // extendTableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
            // // 给予间隔色
            // console.time('默认纯色')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).background('white')
            // console.timeEnd('默认纯色')
            // console.time('默认边框')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderLeft({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderRight({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderTop({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderBottom({ size: 1, color: 'black' })
            // console.timeEnd('默认边框')
            // console.time('文本垂直居左')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).verticalAlign('center')
            // console.timeEnd('文本垂直居左')
            // console.time('文本水平居中')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).verticalAlign('center')
            // console.timeEnd('文本水平居中')
          })
        } else if (that.dataSheets[dataSheetId].type === 2 && insertData instanceof Array && insertData.length > 0) {
          // 交叉表
          // 按列/行进行插入
          // 自动执行公式处理
          var insertRangeValues, insertRangeValueObj
          handleSheet.batch(() => {
            var handleMatrixTable = that.dataSheets[dataSheetId].areaAlias
            var firstCellJson, dealRange2
            for (var fieldId in insertData[0]) {
              var fieldInfo = that.dataSheets[dataSheetId].fields[fieldId]
              if (!fieldInfo) {
                continue
              }
              insertRangeValues = []
              insertRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
              switch (fieldInfo.extType) {
                case 1:
                  if (insertData[0].row === undefined) {
                    insertData.forEach((row, index) => {
                      row.row = index
                    })
                  }
                  // distinct修改原因？？？
                  insertRangeValueObj = alasql(`SELECT DISTINCT [${fieldInfo.id}],[row] FROM ? ORDER BY [row]`, [insertData])
                  insertRangeValueObj.forEach(valueObj => {
                    insertRangeValues.push([formatConverter.SetValidValue(fieldInfo.baseType, valueObj[fieldInfo.id], that)])
                  })
                  if (that.id2Info[fieldId].baseType === 5 || that.id2Info[fieldId].baseType === 6) {
                    firstCellJson = {
                      topLeft: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      },
                      bottomRight: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      }
                    }
                    for (i = 0; i < insertRangeValueObj.length; i++) {
                      dealRange2 = handleSheet
                        .range(formatConverter.ConvertJsonToRange({
                          topLeft: {
                            row: firstCellJson.topLeft.row + i,
                            col: firstCellJson.topLeft.col
                          },
                          bottomRight: {
                            row: firstCellJson.topLeft.row + i,
                            col: firstCellJson.bottomRight.col
                          }
                        }))
                      switch (that.id2Info[fieldId].baseType) {
                        case 5:
                          that.setFieldImageGroup(handleSheet, dealRange2._ref.toString(), insertRangeValues[i][0])
                          break
                        case 6:
                          that.setFieldAttachGroup(handleSheet, dealRange2._ref.toString(), insertRangeValues[i][0])
                          break
                      }
                    }
                    continue
                  }
                  insertRangeJson.topLeft.row = insertRangeJson.topLeft.row + usedRowColumnCount.row
                  insertRangeJson.bottomRight.row = insertRangeJson.topLeft.row + insertRangeValueObj.length - 1
                  break
                case 2:
                  if (insertData[0].col === undefined) {
                    insertData.forEach((col, index) => {
                      col.col = index
                    })
                  }
                  insertRangeValueObj = alasql(`SELECT DISTINCT [${fieldInfo.id}],[col] FROM ? ORDER BY [col]`, [insertData])
                  insertRangeValueObj.forEach(valueObj => {
                    insertRangeValues.push(formatConverter.SetValidValue(fieldInfo.baseType, valueObj[fieldInfo.id], that))
                  })
                  if (that.id2Info[fieldId].baseType === 5 || that.id2Info[fieldId].baseType === 6) {
                    firstCellJson = {
                      topLeft: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      },
                      bottomRight: {
                        row: insertRangeJson.topLeft.row,
                        col: insertRangeJson.topLeft.col
                      }
                    }
                    for (i = 0; i < insertRangeValueObj.length; i++) {
                      dealRange2 = handleSheet
                        .range(formatConverter.ConvertJsonToRange({
                          topLeft: {
                            row: firstCellJson.topLeft.row,
                            col: firstCellJson.topLeft.col + i
                          },
                          bottomRight: {
                            row: firstCellJson.topLeft.row,
                            col: firstCellJson.bottomRight.col + i
                          }
                        }))
                      switch (that.id2Info[fieldId].baseType) {
                        case 5:
                          that.setFieldImageGroup(handleSheet, dealRange2._ref.toString(), insertRangeValues[i])
                          break
                        case 6:
                          that.setFieldAttachGroup(handleSheet, dealRange2._ref.toString(), insertRangeValues[i])
                          break
                      }
                    }
                    continue
                  }
                  insertRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
                  insertRangeJson.topLeft.col += usedRowColumnCount.col
                  insertRangeJson.bottomRight.col += insertRangeValueObj.length - 1
                  insertRangeValues = [insertRangeValues]
                  break
                case 3:
                  var maxRow = alasql(`SELECT max([row]) as [row] FROM ? `, [insertData])[0].row || 0
                  var maxCol = alasql(`SELECT max([col]) as [col] FROM ? `, [insertData])[0].col || 0
                  for (var i = usedRowColumnCount.row; i <= maxRow; i++) {
                    insertRangeValues.push([])
                    for (var j = usedRowColumnCount.col; j <= maxCol; j++) {
                      insertRangeValues[i - usedRowColumnCount.row].push(null)
                    }
                  }
                  insertRangeValueObj = alasql(`SELECT DISTINCT [${fieldInfo.id}],[row],[col] FROM ? ORDER BY [row],[col]`, [insertData])
                  insertRangeValueObj.forEach(valueObj => {
                    insertRangeValues[valueObj.row ? valueObj.row - usedRowColumnCount.row : 0][valueObj.col ? valueObj.col - usedRowColumnCount.col : 0] =
                      formatConverter.SetValidValue(fieldInfo.baseType, valueObj[fieldInfo.id], that)
                  })
                  insertRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
                  insertRangeJson.topLeft.row += usedRowColumnCount.row
                  insertRangeJson.topLeft.col += usedRowColumnCount.col
                  insertRangeJson.bottomRight.row = insertRangeJson.topLeft.row + insertRangeValues.length - 1
                  insertRangeJson.bottomRight.col = insertRangeJson.topLeft.col + insertRangeValues[0].length - 1
                  break
              }
              fieldRange = formatConverter.ConvertJsonToRange(insertRangeJson)
              // 一次6个有值单元格耗时1.5ms
              handleSheet.range(fieldRange).values(insertRangeValues)
              if (ignoreQueryFormula !== true) {
                that.RangeValueChanged(insertRangeJson)
              }
            }
            handleSheet.range(
              formatConverter.ConvertJsonToRange(that.GetNameRangeJson(handleMatrixTable)))._manualAdjustRowHeight()
            // var extendTableRange = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
            // // 给予间隔色
            // console.time('默认纯色')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).background('white')
            // console.timeEnd('默认纯色')
            // console.time('默认边框')
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderLeft({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderRight({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderTop({ size: 1, color: 'black' })
            // handleSheet.range(formatConverter.ConvertJsonToRange(extendTableRange)).borderBottom({ size: 1, color: 'black' })
            // console.timeEnd('默认边框')
          })
        }
      }
      console.timeEnd('向扩展表中填值')
    },

    // 刷新扩展表数据
    RefreshExtendTable(dataSheetId, reset) {
      // 检查是否执行
      const info = this.paginationItems.find(item => item.id === +dataSheetId)
      if (!info) { return }
      // 准备数据，更新参数
      const data = []
      info.totalRecord = this.extendDataCollection[dataSheetId].length || 0
      if (this.extendDataCollection[dataSheetId]) {
        info.totalPage = parseInt(info.totalRecord / info.step) + (info.totalRecord % info.step ? 1 : 0)
        if (info.currentPage >= info.totalPage) {
          info.currentPage = 0
        }
        if (reset) { info.currentPage = 0 }
        var startLine = info.currentPage * info.step
        var endLine = startLine + (info.currentPage === info.totalPage - 1 ? ((info.totalRecord % info.step) || (info.totalRecord ? info.step : 0)) : info.step)
        for (var i = startLine; i < endLine; i++) {
          data.push(this.extendDataCollection[dataSheetId][i])
        }
      }
      // 清空表单数据
      this.MergeSameField(dataSheetId, true)
      this.CleanDataSheetAreaData(dataSheetId, null, true)
      // 检查表单行数
      this.CheckAndExtendRows(dataSheetId, info.step, null, null, null, true, true)
      // 插入数据
      this.InsertData2ExtendTable(dataSheetId, 0, data, true, null, null, true)
      this.MergeSameField(dataSheetId)
      this.currentExtendTable = +dataSheetId
    },

    RefreshPaginationInfo(dataSheetId) {
      const paginationInfo = this.paginationItems.find(item => item.id === +dataSheetId)
      if (!paginationInfo) { return }
      paginationInfo.totalRecord = this.extendDataCollection[dataSheetId] || 0
    },

    // 主表取值
    GetDataFromMasterTable: function(fieldId, dateFormat) {
      var fieldInfo
      if (fieldId) {
        fieldInfo = this.dataSheets[this.id2DataSheets[fieldId]].fields[fieldId]
        var that = this
        var fieldValue
        var handleRange = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(that.GetNameRangeJson(fieldInfo.areaAlias)))
        // 判断字段是否有公式，有公式则将它算出来
        if (fieldInfo.baseType === 5) {
          fieldValue = extendFunctions.deepCopy(handleRange.imageGroup() || { url: null, data: [] })
          if (fieldValue instanceof Object) {
            delete fieldValue.url
            delete fieldValue.blankUrl
            fieldValue.data.forEach(data => {
              delete data.src
              delete data.thumbnail
              delete data.newFile
            })
          }
          return formatConverter.GetValidValue(fieldValue, fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale, dateFormat)
        } else if (fieldInfo.baseType === 6) {
          fieldValue = extendFunctions.deepCopy(handleRange.attachGroup() || { url: null, data: [] })
          if (fieldValue instanceof Object) {
            delete fieldValue.url
            delete fieldValue.blankUrl
            fieldValue.data.forEach(data => {
              delete data.newFile
            })
          }
          return formatConverter.GetValidValue(fieldValue, fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale, dateFormat)
        } else {
          fieldValue = handleRange.values()[0][0]
          return formatConverter.GetValidValue(fieldValue, fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale, dateFormat)
        }
      } else {
        var dataValues = [{}]
        // 主表取值
        for (fieldInfo of this.dataSheets[this.masterTableId].children) {
          dataValues[0][fieldInfo.id] = this.GetDataFromMasterTable(fieldInfo.id)
          // var dealRange = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter
          //   .ConvertJsonToRange(this.GetNameRangeJson(fieldInfo.areaAlias)))
        }
        return dataValues
      }
    },

    // 扩展表取值
    // 以行为单位进行输出，指定了数据所在行列的话，则取指定行列的值
    // fieldList为需要取值的列表，不指定则取所有列
    // allowBlankRow为判断是否需要去除空行
    GetDataFromExtendTable: function(dataSheetId, dataRowColInfo, fieldList, allowBlankRow, disableMerge, dateFormat, displayOut) {
      var fieldRange, rangeValues, i, j, fieldValue, fieldId
      const paginationInfo = this.paginationItems.find(item => item.id === +dataSheetId)
      var valueJson = []
      const that = this
      if (this.tableClassifyInfo[dataSheetId]) { this.cancelClassify(dataSheetId) }
      const getValueSheet = this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName)
      // if (!disableMerge) { this.MergeSameField(dataSheetId, true) }
      function specialFieldValue(sheetName, rowIndex, colIndex, fieldRange, direction, baseType) {
        var dealRange = that.spreadSheet.sheetByName(sheetName).range(formatConverter.ConvertJsonToRange({
          topLeft: {
            row: fieldRange.topLeft.row + (direction === 1 || direction === 3 ? rowIndex : 0),
            col: fieldRange.topLeft.col + (direction === 2 || direction === 3 ? colIndex : 0)
          },
          bottomRight: {
            row: fieldRange.topLeft.row + (direction === 1 || direction === 3 ? rowIndex : 0),
            col: fieldRange.topLeft.col + (direction === 2 || direction === 3 ? colIndex : 0)
          }
        }))
        if (baseType === 5) {
          fieldValue = extendFunctions.deepCopy(dealRange.imageGroup() || { url: null, data: [] })
          delete fieldValue.url
          delete fieldValue.blankUrl
          fieldValue.data.forEach(data => {
            delete data.src
            delete data.thumbnail
            delete data.newFile
          })
          return fieldValue
        } else if (baseType === 6) {
          fieldValue = extendFunctions.deepCopy(dealRange.attachGroup() || { url: null, data: [] })
          delete fieldValue.blankUrl
          fieldValue.data.forEach(data => {
            delete data.newFile
          })
          return fieldValue
        } else {
          return ''
        }
      }
      if (paginationInfo && this.dataSheets[dataSheetId].extType < 3) {
        for (i = (dataRowColInfo ? dataRowColInfo.top : 0); i < (dataRowColInfo ? (dataRowColInfo.length + dataRowColInfo.top) : paginationInfo.totalRecord); i++) {
          var rowData = {}
          if (!fieldList) {
            rowData = extendFunctions.deepCopy(this.extendDataCollection[dataSheetId][i + paginationInfo.currentPage * paginationInfo.step] || [])
          } else {
            for (fieldId of fieldList) {
              if (this.extendDataCollection[dataSheetId][i + paginationInfo.currentPage * paginationInfo.step]) {
                rowData[fieldId] = this.extendDataCollection[dataSheetId][i + paginationInfo.currentPage * paginationInfo.step][fieldId] || formatConverter.GetValidNullValue(this.id2Info[fieldId].baseType)
              } else {
                rowData[fieldId] = formatConverter.GetValidNullValue(this.id2Info[fieldId].baseType)
              }
            }
          }
          valueJson.push(rowData)
        }
      } else {
        switch (this.dataSheets[dataSheetId].extType) {
          case 1:
            // 向下扩展
            for (fieldId in this.dataSheets[dataSheetId].fields) {
              if (fieldList) {
                if (fieldList.indexOf(+fieldId) < 0) {
                  continue
                }
              }
              fieldRange = this.GetNameRangeJson(this.dataSheets[dataSheetId].fields[fieldId].areaAlias)
              if (dataRowColInfo) {
                fieldRange.topLeft.row += dataRowColInfo.top
                fieldRange.bottomRight.row = fieldRange.topLeft.row + dataRowColInfo.length - 1
              }
              if (displayOut) {
                rangeValues = []
                for (var x = fieldRange.topLeft.row; x <= fieldRange.bottomRight.row; x++) {
                  var rowArray = []
                  for (var y = fieldRange.topLeft.col; y <= fieldRange.bottomRight.col; y++) {
                    const cell = getValueSheet.range(formatConverter.ConvertJsonToA1({
                      row: x,
                      col: y
                    }))
                    if (!cell.formula()) {
                      rowArray.push(cell.input())
                    } else {
                      rowArray.push(cell.value())
                    }
                  }
                  rangeValues.push(rowArray)
                }
              } else {
                rangeValues = getValueSheet.range(formatConverter.ConvertJsonToRange(fieldRange)).values()
              }
              if (valueJson.length === 0) {
                for (i = 0; i < rangeValues.length; i++) {
                  valueJson.push({})
                }
              }
              for (i = 0; i < rangeValues.length; i++) {
                // 特殊类型取特殊值
                if (this.id2Info[fieldId]) {
                  switch (this.id2Info[fieldId].baseType) {
                    case 5:
                    case 6:
                      valueJson[i][fieldId] = formatConverter.GetValidValue(
                        specialFieldValue(this.dataSheets[dataSheetId].sheetName, i, 0, fieldRange, 1, this.id2Info[fieldId].baseType), this.id2Info[fieldId].baseType)
                      break
                    default:
                      if (displayOut) {
                        valueJson[i][fieldId] = rangeValues[i][0]
                      } else {
                        valueJson[i][fieldId] = formatConverter.GetValidValue(rangeValues[i][0], this.id2Info[fieldId].baseType,
                          this.id2Info[fieldId].fieldLength, this.id2Info[fieldId].scale, dateFormat)
                        break
                      }
                  }
                }
              }
            }
            valueJson.forEach((row, index) => {
              row.index = index
            })
            break
          case 2:
            // 向右扩展
            for (fieldId in this.dataSheets[dataSheetId].fields) {
              if (fieldList) {
                if (fieldList.indexOf(fieldId) >= 0) {
                  continue
                }
              }
              fieldRange = this.GetNameRangeJson(this.dataSheets[dataSheetId].fields[fieldId].areaAlias)
              // dataRowColInfo为该行在字段中第几行
              if (dataRowColInfo) {
                fieldRange.topLeft.col += dataRowColInfo.top
                fieldRange.bottomRight.col = fieldRange.topLeft.col + dataRowColInfo.length - 1
              }
              rangeValues = getValueSheet.range(formatConverter.ConvertJsonToRange(fieldRange)).values()[0]
              for (i = 0; i < rangeValues.length; i++) {
                if (valueJson.length < rangeValues.length) {
                  valueJson.push({})
                }
                // 特殊类型取特殊值
                if (this.id2Info[fieldId]) {
                  switch (this.id2Info[fieldId].baseType) {
                    case 5:
                    case 6:
                      valueJson[i][fieldId] = formatConverter.GetValidValue(
                        specialFieldValue(this.dataSheets[dataSheetId].sheetName, 0, i, fieldRange, 2, this.id2Info[fieldId].baseType), this.id2Info[fieldId].baseType)
                      break
                    default:
                      valueJson[i][fieldId] = formatConverter.GetValidValue(rangeValues[i], this.id2Info[fieldId].baseType,
                        this.id2Info[fieldId].fieldLength, this.id2Info[fieldId].scale, dateFormat)
                      break
                  }
                }
              }
            }
            valueJson.forEach((row, index) => {
              row.index = index
            })
            break
          case 3:
            // 交叉扩展
            // dataRowColInfo={
            //   top:x,
            //   left:x,
            //   length:{
            //      row:x,
            //      col:x
            //    }
            // }
            // dataRowColInfo为该单元格在sheet中第几行列
            var valueCollection = {
              left: [],
              top: [],
              data: []
            }
            if (!dataRowColInfo) {
              var usedInfo = this.GetMatrixUsedInfo(dataSheetId)
              dataRowColInfo = {
                top: 0,
                left: 0,
                length: {
                  row: usedInfo.usedRowColumnCount.row > usedInfo.centerUsedCount.row ? usedInfo.usedRowColumnCount.row : usedInfo.centerUsedCount.row,
                  col: usedInfo.usedRowColumnCount.col > usedInfo.centerUsedCount.col ? usedInfo.usedRowColumnCount.col : usedInfo.centerUsedCount.col
                }
              }
            }
            var valueTemp, dealRecord
            for (var fieldInfo of this.dataSheets[dataSheetId].children) {
              if (fieldList && fieldList.indexOf(+fieldInfo.id) < 0) {
                continue
              }
              fieldRange = this.GetNameRangeJson(fieldInfo.areaAlias)
              switch (fieldInfo.extType) {
                case 1:
                  // 左侧，向下扩展
                  if (dataRowColInfo) {
                    if (dataRowColInfo.top < 0 || dataRowColInfo.length.row <= 0) {
                      continue
                    }
                    fieldRange.topLeft.row += dataRowColInfo.top
                    fieldRange.bottomRight.row = fieldRange.topLeft.row + dataRowColInfo.length.row - 1
                  }
                  rangeValues = getValueSheet.range(formatConverter.ConvertJsonToRange(fieldRange)).values()
                  for (i = 0; i < rangeValues.length; i++) {
                    if (!valueCollection.left.find(valueObj => { return valueObj.row === i })) {
                      valueCollection.left.push({ row: i })
                    }
                    dealRecord = valueCollection.left.find(valueObj => { return valueObj.row === i })
                    // 特殊类型取特殊值
                    switch (fieldInfo.baseType) {
                      case 5:
                      case 6:
                        dealRecord[fieldInfo.id] = formatConverter.GetValidValue(
                          specialFieldValue(this.dataSheets[dataSheetId].sheetName, i, 0, fieldRange, 1, fieldInfo.baseType), this.id2Info[fieldInfo.id].baseType)
                        break
                      default:
                        valueTemp = formatConverter.GetValidValue(rangeValues[i][0], fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale)
                        dealRecord[fieldInfo.id] = valueTemp
                        break
                    }
                  }
                  break
                case 2:
                  // 上方，向右扩展
                  if (dataRowColInfo) {
                    if (dataRowColInfo.left < 0 || dataRowColInfo.length.col <= 0) {
                      continue
                    }
                    fieldRange.topLeft.col += dataRowColInfo.left
                    fieldRange.bottomRight.col = fieldRange.topLeft.col + dataRowColInfo.length.col - 1
                  }
                  rangeValues = getValueSheet.range(formatConverter.ConvertJsonToRange(fieldRange)).values()[0]
                  for (i = 0; i < rangeValues.length; i++) {
                    if (!valueCollection.top.filter(valueObj => { return valueObj.col === i }).length) {
                      valueCollection.top.push({ col: i })
                    }
                    dealRecord = valueCollection.top.find(valueObj => { return valueObj.col === i })
                    // 特殊类型取特殊值
                    switch (fieldInfo.baseType) {
                      case 5:
                      case 6:
                        dealRecord[fieldInfo.id] = formatConverter.GetValidValue(
                          specialFieldValue(this.dataSheets[dataSheetId].sheetName, i, 0, fieldRange, 2, fieldInfo.baseType), this.id2Info[fieldInfo.id].baseType)
                        break
                      default:
                        valueTemp = formatConverter.GetValidValue(rangeValues[i], fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale)
                        dealRecord[fieldInfo.id] = valueTemp
                        break
                    }
                  }
                  break
                case 3:
                  // 数据字段，向右下角扩展
                  if (dataRowColInfo) {
                    if (dataRowColInfo.left < 0 || dataRowColInfo.top < 0 || dataRowColInfo.length.row <= 0 || dataRowColInfo.length.col <= 0) {
                      continue
                    }
                    fieldRange.topLeft.row += dataRowColInfo.top
                    fieldRange.topLeft.col += dataRowColInfo.left
                    fieldRange.bottomRight.row = fieldRange.topLeft.row + dataRowColInfo.length.row - 1
                    fieldRange.bottomRight.col = fieldRange.topLeft.col + dataRowColInfo.length.col - 1
                  }
                  rangeValues = getValueSheet.range(formatConverter.ConvertJsonToRange(fieldRange)).values()
                  var dataIndex = 0
                  for (i = 0; i < rangeValues.length; i++) {
                    for (j = 0; j < rangeValues[i].length; j++) {
                      if (!valueCollection.data.filter(valueObj => { return valueObj.index === dataIndex }).length) {
                        valueCollection.data.push({ index: dataIndex, row: i, col: j })
                      }
                      dealRecord = valueCollection.data.find(valueObj => { return valueObj.index === dataIndex })
                      // 特殊类型取特殊值
                      switch (fieldInfo.baseType) {
                        case 5:
                        case 6:
                          dealRecord[fieldInfo.id] = formatConverter.GetValidValue(
                            specialFieldValue(this.dataSheets[dataSheetId].sheetName, i, j, fieldRange, 3, fieldInfo.baseType), this.id2Info[fieldInfo.id].baseType)
                          break
                        default:
                          valueTemp = formatConverter.GetValidValue(rangeValues[i][j], fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale)
                          dealRecord[fieldInfo.id] = valueTemp
                          break
                      }
                      dataIndex += 1
                    }
                  }
                  // dataFieldId = fieldInfo.id
                  break
              }
            }
            // var dataIndex = 0
            if (valueCollection.data.length) {
              valueJson = alasql('SELECT * FROM ? rowColCollection LEFT JOIN ? dataArray ON rowColCollection.[row]=dataArray.[row] AND rowColCollection.[col]=dataArray.[col]',
                [(alasql('SELECT * FROM ? leftArray INNER JOIN ? topArray',
                  [valueCollection.left, valueCollection.top])), valueCollection.data])
              //   valueJson = alasql('SELECT * FROM ? rowColCollection LEFT JOIN ? dataArray ON rowColCollection.[row]=dataArray.[row] AND rowColCollection.[col]=dataArray.[col]' +
              // ' LEFT JOIN ? leftArray ON rowColCollection.[row]=leftArray.[row] LEFT JOIN ? topArray ON rowColCollection.[col]=topArray.[col] ',
              // [alasql('SELECT dataArray.[row],dataArray.[col] FROM ? dataArray UNION SELECT leftArray.[row],0 FROM ? leftArray UNION SELECT 0,topArray.[col] FROM ? topArray',
              //   [valueCollection.data, valueCollection.left, valueCollection.top]), valueCollection.data, valueCollection.left, valueCollection.top])
            } else {
              if (valueCollection.left.length && valueCollection.top.length) {
                valueJson = alasql('SELECT * FROM ? leftArray,? topArray', [valueCollection.left, valueCollection.top])
                // console.log(valueJson)
              } else if (valueCollection.left.length) {
                valueJson = valueCollection.left
              } else if (valueCollection.top.length) {
                valueJson = valueCollection.top
              } else {
                valueJson = []
              }
            }
            break
        }
      }
      // if (!disableMerge) { this.MergeSameField(dataSheetId) }
      // 删除空行
      if (allowBlankRow) {
        return valueJson
      }
      var recordWithData = false
      var len = valueJson.length
      for (i = len - 1; i >= 0; i--) {
        recordWithData = false
        for (fieldId in valueJson[i]) {
          if ((!this.id2Info[fieldId]) || fieldId === 'index') {
            continue
          }
          try {
            if (this.id2Info[fieldId].specType === 5 && this.specificationList.Switch.find(item => item.fieldId === +fieldId).defaultValue === valueJson[i][fieldId]) {
              continue
            }
          } catch (ex) {
            continue
          }
          if (valueJson[i][fieldId] !== '' && valueJson[i][fieldId] !== null && valueJson[i][fieldId] !== 0) {
            recordWithData = true
            break
          }
        }
        if (!recordWithData) {
          valueJson.splice(i, 1)
        }
      }
      return valueJson
    },

    // 清空数据表所在数据区域所有数据
    // TODO:分页改造
    CleanDataSheetAreaData: function(dataSheetId, triggerInfo, ignorePagination) {
      const that = this
      if (that.dataSheets[dataSheetId].type === 0) {
        extendFunctions.errorMessage(that.$t('report.mainTableNotClear'), that.$t('report.mainTableNotClear'))
        return
      }
      var sheetName, fieldRange, fieldJson, fieldInfo, i
      const paginationInfo = this.paginationItems.find(item => item.id === +dataSheetId)
      if (paginationInfo && !ignorePagination) {
        this.extendDataCollection[dataSheetId] = []
      } else {
        // 扩展表
        sheetName = that.dataSheets[dataSheetId].sheetName
        var sheet = that.spreadSheet.sheetByName(sheetName)
        sheet.batch(function() {
          for (var fieldId in that.dataSheets[dataSheetId].fields) {
            // 取列/行别名所在区域
            fieldInfo = that.dataSheets[dataSheetId].fields[fieldId]
            fieldJson = that.GetNameRangeJson(fieldInfo.areaAlias)
            if (triggerInfo) {
              switch (this.dataSheets[dataSheetId].extType) {
                case 1:
                  fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length - 1
                  fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                  break
                case 2:
                  fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.top + triggerInfo.length - 1
                  fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.top
                  break
                case 3:
                  switch (fieldInfo.extType) {
                    case 1:
                      fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                      fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                      break
                    case 2:
                      fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                      fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                      break
                    case 3:
                      fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                      fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                      fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                      fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                      break
                  }
                  break
              }
            }
            fieldRange = formatConverter.ConvertJsonToRange(fieldJson)
            var fieldObj = sheet.range(fieldRange)
            fieldObj.values(null)
            if (fieldObj.attachGroup()) {
              that.setFieldAttachGroup(sheet, fieldObj._ref.toString())
            }
            if (fieldObj.imageGroup()) {
              that.setFieldImageGroup(sheet, fieldObj._ref.toString())
            }
            fieldObj.customButtons(null)
            // fieldObj._manualAdjustRowHeight()
          }
          var sheetJson = that.GetNameRangeJson(that.dataSheets[dataSheetId].areaAlias)
          if (that.dataSheets[dataSheetId].extType === 1) {
            for (i = sheetJson.topLeft.row - 1; i <= sheetJson.bottomRight.row - 1; i++) {
              sheet.rowHeight(i, parseInt(that.defaultRowHeight[dataSheetId].row))
            }
          } else if (that.dataSheets[dataSheetId].extType === 2) {
            for (i = sheetJson.topLeft.col - 1; i <= sheetJson.bottomRight.col - 1; i++) {
              sheet.columnWidth(i, parseInt(that.defaultRowHeight[dataSheetId].col))
            }
          }
        }, {recalc: false})
      }
    },

    // 扩展表无数据时隐藏整行控件
    handleRowObjectHide(dataSheet, fieldRange) {
      if (dataSheet.type === 1) {
        const sheet = this.spreadSheet.sheetByName(dataSheet.sheetName)
        const tableRange = this.GetNameRangeJson(dataSheet.areaAlias)
        let dataRowColInfo
        let range, hasValue
        if (dataSheet.extType === 1) {
          if (fieldRange) {
            dataRowColInfo = {
              top: fieldRange._ref.topLeft.row - tableRange.topLeft.row + 1,
              length: fieldRange._ref.bottomRight.row - fieldRange._ref.topLeft.row + 1
            }
          } else {
            fieldRange = sheet.range(formatConverter.ConvertJsonToRange(tableRange))
          }
          const data = this.GetDataFromExtendTable(dataSheet.id, dataRowColInfo, undefined, true)
          const rowRange = {
            topLeft: {
              row: fieldRange._ref.topLeft.row + 1,
              col: tableRange.topLeft.col
            },
            bottomRight: {
              row: fieldRange._ref.topLeft.row + 1,
              col: tableRange.bottomRight.col
            }
          }
          sheet.batch(() => {
            const hasValueArray = []
            data.forEach((row, index) => {
              hasValueArray.push(false)
              for (const fieldId in row) {
                if (row[fieldId] && fieldId !== 'index') {
                  try {
                    if (!(this.id2Info[fieldId].specType === 5 && this.specificationList.Switch.find(item => item.fieldId === +fieldId).defaultValue === row[fieldId])) {
                      hasValueArray[index] = true
                    }
                  } catch (ex) {
                    console.error(ex)
                  }
                  break
                }
              }
            })
            var lastStatus = null
            hasValueArray.forEach((status, index) => {
              if (lastStatus === null) {
                lastStatus = status
              } else {
                if (lastStatus !== status) {
                  range = sheet.range(formatConverter.ConvertJsonToRange(rowRange))
                  range.showController(lastStatus)
                  rowRange.topLeft.row = fieldRange._ref.topLeft.row + 1 + index
                }
                rowRange.bottomRight.row++
              }
              if (index === hasValueArray.length - 1) {
                range = sheet.range(formatConverter.ConvertJsonToRange(rowRange))
                range.showController(status)
              }
              lastStatus = status
            })
          }, {recalc: false})
        } else if (dataSheet.extType === 2) {
          if (fieldRange) {
            dataRowColInfo = {
              top: fieldRange._ref.topLeft.col - tableRange.topLeft.col + 1,
              length: fieldRange._ref.bottomRight.col - fieldRange._ref.topLeft.col + 1
            }
          } else {
            fieldRange = sheet.range(formatConverter.ConvertJsonToRange(tableRange))
          }
          const data = this.GetDataFromExtendTable(dataSheet.id, dataRowColInfo, undefined, true)
          const colRange = {
            topLeft: {
              row: tableRange.topLeft.row,
              col: fieldRange._ref.topLeft.col + 1
            },
            bottomRight: {
              row: tableRange.bottomRight.row,
              col: fieldRange._ref.topLeft.col + 1
            }
          }
          sheet.batch(() => {
            data.forEach((row) => {
              // debugger
              hasValue = false
              for (const fieldId in row) {
                if (row[fieldId] && fieldId !== 'index') {
                  try {
                    if (this.id2Info[fieldId].specType === 5 && this.specificationList.Switch.find(item => item.fieldId === +fieldId).defaultValue === row[fieldId]) {
                      continue
                    }
                  } catch (ex) {
                    continue
                  }
                  hasValue = true
                  break
                }
              }
              range = sheet.range(formatConverter.ConvertJsonToRange(colRange))
              if (hasValue) {
                range.showController(true)
              } else {
                range.showController(false)
              }
              colRange.topLeft.col++
              colRange.bottomRight.col++
            })
          }, {recalc: false})
        }
      }
    },

    // 单元格change事件处理
    // 主要用于触发自动执行的取数公式
    RangeValueChanged: async function(changedRange, fieldInfo) {
      console.time('单元格值触发改变')
      var fieldRange = this.spreadSheet.sheetByName(changedRange.workSheet).range(formatConverter.ConvertJsonToRange(changedRange))
      if (fieldRange) {
        var queryFormulaList = []
        var formatFormulaList = []
        var conditionList = []
        var controlRoleList = []
        fieldInfo = fieldRange.fieldInfo() ? this.id2Info[fieldRange.fieldInfo()] : {}
        console.time('遍历')
        fieldRange.forEachCell((row, col, cell) => {
          if (!cell.fieldInfo) {
            return
          }
          // 判断该字段是否包涵自动执行的取数公式
          queryFormulaList = queryFormulaList.concat(extendFunctions.deepCopy(this.formulaDictionary[cell.fieldInfo]) || [])
          formatFormulaList = formatFormulaList.concat(extendFunctions.deepCopy(this.formatFormulaDictionary[cell.fieldInfo]) || [])
          conditionList = formatFormulaList.concat(extendFunctions.deepCopy(this.conditionDictionary[cell.fieldInfo]) || [])
          controlRoleList = formatFormulaList.concat(extendFunctions.deepCopy(this.controlRoleDictionary[cell.fieldInfo]) || [])
        })
        this.handleRowObjectHide(this.dataSheets[fieldInfo.owner], fieldRange)
        console.timeEnd('遍历')
        queryFormulaList = extendFunctions.ArrayDistinct(queryFormulaList)
        formatFormulaList = extendFunctions.ArrayDistinct(formatFormulaList)
        conditionList = extendFunctions.ArrayDistinct(conditionList)
        controlRoleList = extendFunctions.ArrayDistinct(controlRoleList)
        if (queryFormulaList.length || formatFormulaList.length || conditionList.length || controlRoleList.length) {
          switch (this.dataSheets[fieldInfo.owner].type) {
            case 0:
              // 主表直接执行公式
              this.showFormulaLoading = true
              if (queryFormulaList && queryFormulaList.length) {
                await this.QueryFormulaHelper(queryFormulaList, undefined, undefined, undefined, true)
              }
              if (conditionList && conditionList.length) { // && +sourceCondition !== +fieldInfo.id
                await this.ConditionHelper(conditionList)
              }
              if (formatFormulaList && formatFormulaList.length) {
                await this.FormatFormulaHelper(formatFormulaList)
              }
              if (controlRoleList && controlRoleList.length) {
                this.controlRoleHelper(controlRoleList)
              }
              break
            case 1:
            case 2:
              // 扩展表则需要根据数据表扩展方向，使用不同的策略进行按行列提取
              // 获取触发区域的起始和截止行（相对于第一行的距离，起始行为0）
              fieldRange = this.GetNameRangeJson(fieldInfo.areaAlias)
              var triggerInfo
              switch (this.dataSheets[fieldInfo.owner].extType) {
                case 1:
                  // 向下扩展
                  triggerInfo = {
                    top: changedRange.topLeft.row - fieldRange.topLeft.row,
                    length: changedRange.bottomRight.row - changedRange.topLeft.row + 1
                  }
                  break
                case 2:
                  // 向右扩展
                  triggerInfo = {
                    top: changedRange.topLeft.col - fieldRange.topLeft.col,
                    length: changedRange.bottomRight.col - changedRange.topLeft.col + 1
                  }
                  break
                case 3:
                  // 交叉扩展
                  // 上方和左侧区域的取值处理
                  switch (fieldInfo.extType) {
                    case 1:
                      triggerInfo = {
                        top: changedRange.topLeft.row - fieldRange.topLeft.row,
                        left: -1,
                        length: {
                          row: changedRange.bottomRight.row - changedRange.topLeft.row + 1,
                          col: -1
                        }
                      }
                      break
                    case 2:
                      triggerInfo = {
                        top: -1,
                        left: changedRange.topLeft.col - fieldRange.topLeft.col,
                        length: {
                          row: -1,
                          col: changedRange.bottomRight.col - changedRange.topLeft.col + 1
                        }
                      }
                      break
                    case 3:
                      triggerInfo = {
                        top: changedRange.topLeft.row - fieldRange.topLeft.row,
                        left: changedRange.topLeft.col - fieldRange.topLeft.col,
                        length: {
                          row: changedRange.bottomRight.row - changedRange.topLeft.row + 1,
                          col: changedRange.bottomRight.col - changedRange.topLeft.col + 1
                        }
                      }
                      break
                  }
                  break
              }
              this.showFormulaLoading = true
              if (queryFormulaList.length) {
                await this.QueryFormulaHelper(queryFormulaList, triggerInfo, undefined, fieldInfo.owner, true)
              }
              if (conditionList.length) {
                await this.ConditionHelper(conditionList, triggerInfo)
              }
              if (formatFormulaList.length) {
                await this.FormatFormulaHelper(formatFormulaList, triggerInfo, undefined, fieldInfo.owner)
              }
              if (controlRoleList.length) {
                this.controlRoleHelper(controlRoleList, triggerInfo)
              }
              break
          }
        }
      }
      console.timeEnd('单元格值触发改变')
      return true
    },

    // 字段change事件处理
    // 主要用于触发自动执行的取数公式
    FieldsValueChanged: function(changedFields, triggerInfo, ignoreQueryFormula, ignoreCondition) {
      // console.log(triggerInfo)
      console.time('单元格值触发改变')
      // 找出changedRange与哪些字段区域重叠
      if (changedFields instanceof Array && changedFields.length > 0) {
        // 覆盖内容去重
        changedFields = extendFunctions.ArrayDistinct(changedFields)
        // 循环判断覆盖区域类型，并按不同策略执行取数公式
        var queryFormulaList = []
        var formatFormulaList = []
        var conditionList = []
        var controlRoleList = []
        for (var fieldId of changedFields) {
          // 判断该字段是否包涵自动执行的取数公式/动态样式/条件格式
          if (!ignoreQueryFormula) {
            queryFormulaList = this.formulaDictionary[fieldId] ? this.formulaDictionary[fieldId].concat(queryFormulaList) : queryFormulaList
          }
          if (!ignoreCondition) {
            conditionList = this.conditionDictionary[fieldId] ? this.conditionDictionary[fieldId].concat(conditionList) : conditionList
          }
          formatFormulaList = this.formatFormulaDictionary[fieldId] ? this.formatFormulaDictionary[fieldId].concat(formatFormulaList) : formatFormulaList
          controlRoleList = this.controlRoleDictionary[fieldId] ? this.controlRoleDictionary[fieldId].concat(controlRoleList) : controlRoleList
        }
        var changedFieldInfo = this.id2Info[changedFields[0]]
        if (conditionList.length > 0) {
          if (this.dataSheets[changedFieldInfo.owner].type === 0) {
            // 主表直接执行公式
            this.showFormulaLoading = true
            this.ConditionHelper(conditionList)
          } else {
            // 扩展表则需要根据数据表扩展方向，使用不同的策略进行按行列提取
            this.showFormulaLoading = true
            this.ConditionHelper(conditionList, triggerInfo)
          }
        }
        // if (this.conditionTriggerInfo) {
        //   switch (this.conditionTriggerInfo.alertType) {
        //     case 1:
        //       extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
        //       break
        //     case 2:
        //       extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
        //       break
        //   }
        //   this.conditionTriggerInfo = null
        // }
        if (queryFormulaList.length > 0) {
          if (this.dataSheets[changedFieldInfo.owner].type === 0) {
            // 主表直接执行公式
            this.showFormulaLoading = true
            this.QueryFormulaHelper(queryFormulaList)
          } else {
            // 扩展表则需要根据数据表扩展方向，使用不同的策略进行按行列提取
            this.showFormulaLoading = true
            this.QueryFormulaHelper(queryFormulaList, triggerInfo, undefined, changedFieldInfo.owner)
          }
        }
        if (formatFormulaList.length > 0) {
          if (this.dataSheets[changedFieldInfo.owner].type === 0) {
            // 主表直接执行公式
            this.showFormulaLoading = true
            this.FormatFormulaHelper(formatFormulaList)
          } else {
            // 扩展表则需要根据数据表扩展方向，使用不同的策略进行按行列提取
            this.showFormulaLoading = true
            this.FormatFormulaHelper(formatFormulaList, triggerInfo, undefined, changedFieldInfo.owner)
          }
        }
        if (controlRoleList.length > 0) {
          if (this.dataSheets[changedFieldInfo.owner].type === 0) {
            // 主表直接执行公式
            this.showFormulaLoading = true
            this.controlRoleHelper(controlRoleList)
          } else {
            // 扩展表则需要根据数据表扩展方向，使用不同的策略进行按行列提取
            this.controlRoleHelper(controlRoleList, triggerInfo)
          }
        }
        if (this.dataSheets[changedFieldInfo.owner].type > 0) {
          var handleRange = this.GetNameRangeJson(changedFieldInfo.areaAlias)
          if (this.dataSheets[changedFieldInfo.owner].extType === 1) {
            handleRange.topLeft.row = handleRange.topLeft.row + triggerInfo.top
            handleRange.bottomRight.row = handleRange.topLeft.row + triggerInfo.length - 1
          } else {
            handleRange.topLeft.col = handleRange.topLeft.col + triggerInfo.top
            handleRange.bottomRight.col = handleRange.topLeft.col + triggerInfo.length - 1
          }
          var fieldRange = this.spreadSheet.sheetByName(this.dataSheets[changedFieldInfo.owner].sheetName).range(formatConverter.ConvertJsonToRange(handleRange))
          this.handleRowObjectHide(this.dataSheets[changedFieldInfo.owner], fieldRange)
        }
      }
      console.timeEnd('单元格值触发改变')
    },

    // 判断扩展表当前行数是否够用并扩展
    // dataRowCount=数据行列数
    CheckAndExtendRows: function(targetTableId, dataRowCount, triggerInfo, position, usedRangeInfo, ignorePagination, skipRecalc) {
      // 判断剩余行/列数够不够填充，不够则扩展行/列
      console.time('判断剩余空白行数是否够用并扩展')
      var insertRows = 0
      var insertColumns = 0
      var usedRowInfo, usedColumnInfo
      const paginationInfo = this.paginationItems.find(item => item.id === +targetTableId)
      if (paginationInfo && !ignorePagination) {
        switch (this.dataSheets[targetTableId].extType) {
          case 1:
            // 向下扩展
            insertRows = dataRowCount
            if (triggerInfo) {
              if (triggerInfo.length < dataRowCount) {
                insertRows = dataRowCount - triggerInfo.length
              }
            }
            usedRowInfo = this.GetDataSheetUsedRowInfo(targetTableId)
            this.InsertRowColumn({
              topLeft: {
                row: usedRowInfo.usedRangeJson.bottomRight.row,
                col: usedRowInfo.usedRangeJson.topLeft.col
              },
              bottomRight: {
                row: usedRowInfo.usedRangeJson.bottomRight.row,
                col: usedRowInfo.usedRangeJson.bottomRight.col
              },
              workSheet: this.dataSheets[targetTableId].sheetName
            }, 'row', insertRows, false, undefined, skipRecalc)
            break
          case 2:
            // 向右扩展
            insertColumns = dataRowCount
            if (triggerInfo) {
              if (triggerInfo.length < dataRowCount) {
                insertColumns = dataRowCount - triggerInfo.length
              }
            }
            usedColumnInfo = this.GetDataSheetUsedColumnInfo(targetTableId)
            this.InsertRowColumn({
              topLeft: {
                row: usedColumnInfo.usedRangeJson.topLeft.row,
                col: usedColumnInfo.usedRangeJson.bottomRight.col
              },
              bottomRight: {
                row: usedColumnInfo.usedRangeJson.bottomRight.row,
                col: usedColumnInfo.usedRangeJson.bottomRight.col
              },
              workSheet: this.dataSheets[targetTableId].sheetName
            }, 'column', insertColumns, false, undefined, skipRecalc)
            break
        }
      } else {
        switch (this.dataSheets[targetTableId].extType) {
          case 1:
            // 向下扩展
            // 找到数据表在this.spreadSheet对应区域中总行数及已经使用的行数
            usedRowInfo = this.GetDataSheetUsedRowInfo(targetTableId)
            if (triggerInfo) {
              if (triggerInfo.length < dataRowCount) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedRowInfo.usedRangeJson.topLeft.row + triggerInfo.top,
                    col: usedRowInfo.usedRangeJson.topLeft.col
                  },
                  bottomRight: {
                    row: usedRowInfo.usedRangeJson.topLeft.row + triggerInfo.top,
                    col: usedRowInfo.usedRangeJson.bottomRight.col
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'row', dataRowCount - triggerInfo.length, null, true, skipRecalc)
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return triggerInfo.top
            } else {
              const unUsedRowCount = usedRowInfo.usedRangeJson.bottomRight.row - usedRowInfo.usedRangeJson.topLeft.row + 1 - usedRowInfo.usedRowColumnCount
              if (unUsedRowCount < dataRowCount) {
                insertRows = dataRowCount - unUsedRowCount
              }
              if (insertRows > 0) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedRowInfo.usedRangeJson.bottomRight.row,
                    col: usedRowInfo.usedRangeJson.topLeft.col
                  },
                  bottomRight: {
                    row: usedRowInfo.usedRangeJson.bottomRight.row,
                    col: usedRowInfo.usedRangeJson.bottomRight.col
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'row', insertRows, null, true, skipRecalc)
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return usedRowInfo.usedRowColumnCount
            }
          case 2:
            // 向右扩展
            // 找到数据表在this.spreadSheet对应区域中总列数及已经使用的列数
            usedColumnInfo = this.GetDataSheetUsedColumnInfo(targetTableId)
            if (triggerInfo) {
              if (triggerInfo.length < dataRowCount) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedColumnInfo.usedRangeJson.topLeft.row,
                    col: usedColumnInfo.usedRangeJson.bottomRight.col + triggerInfo.top
                  },
                  bottomRight: {
                    row: usedColumnInfo.usedRangeJson.bottomRight.row,
                    col: usedColumnInfo.usedRangeJson.bottomRight.col + triggerInfo.top
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'column', dataRowCount - triggerInfo.length, null, true, skipRecalc)
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return triggerInfo.top
            } else {
              const unUsedColumnCount = usedColumnInfo.usedRangeJson.bottomRight.col - usedColumnInfo.usedRangeJson.topLeft.col + 1 - usedColumnInfo.usedRowColumnCount
              if (unUsedColumnCount < dataRowCount) {
                insertColumns = dataRowCount - unUsedColumnCount
              }
              if (insertColumns > 0) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedColumnInfo.usedRangeJson.topLeft.row,
                    col: usedColumnInfo.usedRangeJson.bottomRight.col
                  },
                  bottomRight: {
                    row: usedColumnInfo.usedRangeJson.bottomRight.row,
                    col: usedColumnInfo.usedRangeJson.bottomRight.col
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'column', insertColumns, null, true, skipRecalc)
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return usedColumnInfo.usedRowColumnCount
            }
          case 3:
            // debugger
            // 交叉扩展
            // 找到数据表在this.spreadSheet对应区域中总行数及已经使用的行数
            usedRangeInfo = usedRangeInfo || this.GetMatrixUsedInfo(targetTableId)
            if (triggerInfo) {
              if (triggerInfo.length.row < dataRowCount.row) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedRangeInfo.usedRangeJson.topLeft.row + triggerInfo.top,
                    col: usedRangeInfo.usedRangeJson.topLeft.col
                  },
                  bottomRight: {
                    row: usedRangeInfo.usedRangeJson.topLeft.row + triggerInfo.top,
                    col: usedRangeInfo.usedRangeJson.bottomRight.col
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'row', dataRowCount.row - triggerInfo.length.row, undefined, undefined, skipRecalc)
              }
              if (triggerInfo.length.col < dataRowCount.col) {
                this.InsertRowColumn({
                  topLeft: {
                    row: usedRangeInfo.usedRangeJson.topLeft.row,
                    col: usedRangeInfo.usedRangeJson.topLeft.col + triggerInfo.left
                  },
                  bottomRight: {
                    row: usedRangeInfo.usedRangeJson.topLeft.row,
                    col: usedRangeInfo.usedRangeJson.bottomRight.col + triggerInfo.left
                  },
                  workSheet: this.dataSheets[targetTableId].sheetName
                }, 'column', dataRowCount.col - triggerInfo.length.col)
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return triggerInfo.top
            } else {
              if (position !== 'top') {
                var unUsedRowCount
                switch (position) {
                  case 'data':
                    unUsedRowCount = usedRangeInfo.dataRangeJson.bottomRight.row - usedRangeInfo.dataRangeJson.topLeft.row + 1 - usedRangeInfo.centerUsedCount.row
                    break
                  default:
                    unUsedRowCount = usedRangeInfo.usedRangeJson.bottomRight.row - usedRangeInfo.usedRangeJson.topLeft.row + 1 - usedRangeInfo.usedRowColumnCount.row
                    break
                }
                if (unUsedRowCount < dataRowCount.row) {
                  insertRows = dataRowCount.row - unUsedRowCount
                }
                if (insertRows > 0) {
                  this.InsertRowColumn({
                    topLeft: {
                      row: usedRangeInfo.usedRangeJson.bottomRight.row,
                      col: usedRangeInfo.usedRangeJson.topLeft.col
                    },
                    bottomRight: {
                      row: usedRangeInfo.usedRangeJson.bottomRight.row,
                      col: usedRangeInfo.usedRangeJson.bottomRight.col
                    },
                    workSheet: this.dataSheets[targetTableId].sheetName
                  }, 'row', insertRows, undefined, undefined, skipRecalc)
                }
              }
              if (position !== 'left') {
                var unUsedColCount
                switch (position) {
                  case 'data':
                    unUsedColCount = usedRangeInfo.dataRangeJson.bottomRight.col - usedRangeInfo.dataRangeJson.topLeft.col + 1 - usedRangeInfo.centerUsedCount.col
                    break
                  default:
                    unUsedColCount = usedRangeInfo.usedRangeJson.bottomRight.col - usedRangeInfo.usedRangeJson.topLeft.col + 1 - usedRangeInfo.usedRowColumnCount.col
                    break
                }
                if (unUsedColCount < dataRowCount.col) {
                  insertColumns = dataRowCount.col - unUsedColCount
                }
                if (insertColumns > 0) {
                  this.InsertRowColumn({
                    topLeft: {
                      row: usedRangeInfo.usedRangeJson.topLeft.row,
                      col: usedRangeInfo.usedRangeJson.bottomRight.col
                    },
                    bottomRight: {
                      row: usedRangeInfo.usedRangeJson.bottomRight.row,
                      col: usedRangeInfo.usedRangeJson.bottomRight.col
                    },
                    workSheet: this.dataSheets[targetTableId].sheetName
                  }, 'column', insertColumns, undefined, undefined, skipRecalc)
                }
              }
              console.timeEnd('判断剩余空白行数是否够用并扩展')
              return {
                usedRowColumnCount: usedRangeInfo.usedRowColumnCount,
                centerUsedCount: usedRangeInfo.centerUsedCount
              }
            }
        }
      }
    },

    // *********************
    // ******数据表处理******
    // *********************
    // 判断数据表完整性,true=完整,false=不完整
    dataSheetsIntegralityCheck: function() {
      var checkResult = true
      for (var tableId in this.dataSheets) {
        if (this.dataSheets[tableId].extType !== 1) {
          var tableRange = this.GetNameRangeJson(this.dataSheets[tableId].areaAlias)
          if (JSON.stringify(tableRange) === '{}') {
            extendFunctions.errorMessage(this.$t('report.dataSheet') + this.dataSheets[tableId].name + '，' + this.$t('report.alias') + this.dataSheets[tableId].areaAlias + this.$t('report.notInTemp'))
            checkResult = false
          }
        }
        for (var fieldId in this.dataSheets[tableId].fields) {
          var fieldRange = this.GetNameRangeJson(this.dataSheets[tableId].fields[fieldId].areaAlias)
          if (JSON.stringify(fieldRange) === '{}') {
            extendFunctions.errorMessage(this.$t('report.field') + this.dataSheets[tableId].fields[fieldId].name + '，' + this.$t('report.alias') + this.dataSheets[tableId].fields[fieldId].areaAlias + this.$t('report.notInTemp'))
            checkResult = false
          }
        }
      }
      return checkResult
    },

    // *********************
    // *******单据控制*******
    // *********************
    // 初始化单据
    InitializeReport: async function(row, model, copyCreateTag) {
      if (!copyCreateTag) {
        this.recordId = undefined
      }
      this.printFullUrl = ''
      this.fullUrl = ''
      this.actionParamList = {}
      this.queryFormulaInfos = {}
      this.formulaDictionary = {}
      this.formatFormulaDictionary = {}
      this.conditionDictionary = {}
      this.uploadFileList = []
      this.specCache = {
        DropDown: {},
        ListView: {},
        Cascader: {}
      }
      this.systemValue = {
        ID: 0,
        r1: 0,
        r5: 0,
        r6: 0,
        r7: '1900-1-1',
        r8: null,
        r10: null,
        r11: false,
        r12: null,
        r13: 0,
        r14: 0,
        r15: null
      }
      var onlyView = false
      if (this.editModel === 0) {
        this.recordId = 0
      }
      if (typeof (Worker) === 'undefined') {
        extendFunctions.errorMessage(this.$t('report.notSupportAutomatic'))
      } else {
        console.log('初始化Worker')
        this.InitializeWorker()
      }
      if (this.$route.params.workFlowId && !this.dialogModel) {
        this.workFlowModel = true
        console.log(this.workFlowModel)
        this.workFlowId = +this.$route.params.workFlowId
      }
      // 打开模板文件
      console.time('获取打开模板文件')
      console.time('基础ID和流程信息处理')
      var workFlowActivitys
      if (this.useRouter) {
        this.workFlowModel = this.workFlowId !== undefined && this.workFlowId !== 0
        this.templateId = this.templateId ? this.templateId : +this.$route.params.templateId
        this.recordId = this.recordId > 0 ? this.recordId : +this.$route.params.recordId
        this.editModel = this.editModel.toString() ? this.editModel : +this.$route.params.model
        if (this.lastTab && this.lastTab.openType) {
          if (this.lastTab.openType === 1) {
            this.editModel = 2
            onlyView = true
          } else if (this.lastTab.openType === 2) {
            this.editModel = 1
          }
        }
        if (this.storeTemporaryId) {
          this.temporaryId = this.storeTemporaryId
          this.$store.dispatch('setTemporaryId', null)
        } else {
          this.temporaryId = null
        }
        if (this.workFlowModel) {
          try {
            workFlowActivitys = await getWorkFlowActivitys(0, this.workFlowId)
            if (workFlowActivitys.status >= 200 && workFlowActivitys.status < 300) {
              this.workFlowActivityId = +workFlowActivitys.data.id
              this.workFlowActivityInfo = workFlowActivitys.data
              this.$emit('setUnpause', this.workFlowActivityInfo.unPause)
              this.$emit('setActivity', this.workFlowActivityInfo)
            } else {
              extendFunctions.errorMessage(this.$t('report.processError'), workFlowActivitys)
            }
          } catch (exception) {
            extendFunctions.errorMessage(this.$t('report.processError'), exception)
          }
        }
      } else {
        this.workFlowId !== undefined && this.workFlowId !== 0
        this.templateId = row ? row.templateId || this.$route.params.templateId : this.templateId
        this.recordId = row ? row.recordId || row.rid || this.recordId : this.recordId
        this.editModel = model === undefined ? this.editModel : model
        this.workFlowActivityId = row ? row.activityId : this.workFlowActivityId
        this.temporaryId = row ? row.temporaryId : null
        if (row) {
          if (row.openType === 0) {
            this.editModel = 2
          } else if (row.openType === 1) {
            this.editModel = 2
            onlyView = true
          } else if (row.openType === 2) {
            this.editModel = 1
          }
        }
        if (this.workFlowActivityId) {
          if (this.$route.path.split('/')[1] !== 'preview') {
            try {
              workFlowActivitys = await getWorkFlowActivitys(this.workFlowActivityId)
              if (workFlowActivitys.status >= 200 && workFlowActivitys.status < 300) {
                this.workFlowActivityInfo = workFlowActivitys.data
                this.$emit('setUnpause', this.workFlowActivityInfo.unPause)
                this.$emit('setActivity', this.workFlowActivityInfo)
                this.workFlowModel = true
              } else {
                extendFunctions.errorMessage(this.$t('report.processError'), workFlowActivitys)
              }
            } catch (exception) {
              extendFunctions.errorMessage(this.$t('report.processError'), exception)
            }
          }
        }
      }
      console.timeEnd('基础ID和流程信息处理')
      // 获取模板高级权限
      try {
        var templateData = await this.findTemplateDB(+this.templateId)
        const params = templateData ? { id: templateData.id, hash: templateData.hash, stamp: templateData.stamp } : {}
        params.activityId = this.workFlowActivityId
        var prevResponse = (await prevdependence(this.templateId, params)).data
        this.templateRole = prevResponse.permission
        this.queryFormulaInfos = prevResponse.queryformula
        // 初始化填充字段
        for (var formulaId in this.queryFormulaInfos) {
          var info = this.queryFormulaInfos[formulaId]
          info.filling = []
          info.specialFilling = {}
          // info.match=[]
          for (var fieldId in info.output) {
            switch (info.output[fieldId]) {
              case 1:
                // 按行列匹配
                if (info.match.indexOf(+fieldId) < 0) {
                  info.match.push(+fieldId)
                }
                break
              case 2:
              case 3:
              case 4:
                info.specialFilling[fieldId] = info.output[fieldId]
                info.filling.push(+fieldId)
                break
              case 0:
              default:
                info.filling.push(+fieldId)
                break
            }
          }
        }
        this.templateAttribute = prevResponse.attribute
        var templateFile = prevResponse.template
        this.dataSheets = prevResponse.structure
        this.formatFormulaInfos = {}
        prevResponse.dynamicstyle.forEach(item => {
          if (item.originField) {
            if (item.applyWorkFlow) {
              if (!this.workFlowActivityId || item.activities.indexOf(+this.workFlowActivityId) < 0) {
                return
              }
            }
            this.formatFormulaInfos[item.id] = item
          }
        })
        this.conditionInfos = prevResponse.condition
        this.barCodeBindingInfo = prevResponse.codes
        var systemVariables = prevResponse.systemvar
        var fieldDataSpecInfos = prevResponse.dataspec
        this.templateRole.style = this.templateRole.style.split(',')
        this.formulaMode = this.templateAttribute.formulaMode
        // 编辑权限判断
        var targetStatus
        switch (this.editModel) {
          case 0:
            targetStatus = this.workFlowModel ? 30 : 10
            this.recordId = -2147483648
            if (!this.dialogModel) {
              this.$store.dispatch('setRecordId', this.recordId)
            }
            break
          case 1:
            if (this.workFlowActivityId) {
              targetStatus = 40
            } else {
              if (this.templateRole.modify) {
                targetStatus = 12
              } else {
                targetStatus = 11
                this.editModel = 2
                extendFunctions.errorMessage(this.$t('report.noEditRights'), new Error(this.$t('report.noEditRights')))
              }
            }
            break
          case 2:
            if (onlyView) {
              targetStatus = 20
            } else {
              this.$emit('ChangeRole', 'modify', this.templateRole.modify)
              targetStatus = this.workFlowModel ? 50 : 11
            }
            break
          default:
            targetStatus = 11
            break
        }
        console.timeEnd('权限判断')
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.advancedPermissionError'), exception)
      }
      console.time('控制按钮显示')
      // FIXME:此处重大性能损耗，发生了repaint
      this.RefreshUserRole()
      console.timeEnd('控制按钮显示')
      // 获取模板属性
      try {
        // 上传模式预设值
        this.templateAttribute.uploadModel = 0
        if (this.templateAttribute.pdfOption) {
          this.templateAttribute.pdfOption = JSON.parse(this.templateAttribute.pdfOption)
        } else {
          this.templateAttribute.pdfOption = {
            paperSize: 'A4',
            customPaperSize: {
              width: 210,
              height: 297
            },
            fitWidth: true,
            vCenter: false,
            hCenter: false,
            landscape: false
          }
        }
        console.timeEnd('获取模板属性')
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.templateError'), exception)
      }
      // 显示零值
      this.zeroModel = this.templateAttribute.zero
      this.$emit('changeFromType', this.templateAttribute.type)
      // 主动修改tab和dialog的title
      console.time('修改tab和dialog的title')
      this.$emit('ChangeFormEditStatus', targetStatus, true, true)
      console.timeEnd('修改tab和dialog的title')
      console.time('获取模板文件（包括缓存来源）')
      let jsonFile
      try {
        templateFile.id = +this.templateId
        if (templateFile.hit) {
          jsonFile = templateData.file
        } else {
          jsonFile = templateFile.file
          if (templateData) {
            this.updateTemplateDB(+this.templateId, templateFile)
          } else {
            this.insertTemplateDB(templateFile)
          }
        }
        if (!jsonFile || JSON.stringify(jsonFile) === '{}') {
          // extendFunctions.alertMessage('该模板未设计任何内容！')
          this.$message.warning(this.$t('report.nothingDesigned'))
          this.ChangeLoadingStatus(false)
          return
        }
        // 完成回调
        if (jsonFile === null) {
          extendFunctions.errorMessage(this.$t('report.emptyTemp'), this.$t('report.emptyTemp'))
          return
        }
        console.timeEnd('获取模板文件（包括缓存来源）')
        // 判断sheet数量，决定是否隐藏sheet名称
        console.time('设置sheet页显示')
        if (jsonFile.sheets && jsonFile.sheets.filter(sheet => sheet.visiable).length === 1) {
          this.$refs.reportEditor.$el.lastChild.style.display = 'none'
        }
        console.timeEnd('设置sheet页显示')
        // this.initReportBarCode()
        console.time('加载文件')
        this.spreadSheet.fromJSON(jsonFile, this)
        console.timeEnd('加载文件')
        console.time('升级文件版本')
        this.updateJsonFileVersion(jsonFile)
        console.timeEnd('升级文件版本')
        console.time('获取最大行列')
        this.GetUsedRowColInfo(jsonFile)
        console.timeEnd('获取最大行列')
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.tempFileError'), exception)
      }
      if (this.dialogModel) {
        this.changeDialogSize(jsonFile.showArea)
      }
      this.printProperty = jsonFile.printProperty
      print.showBackground(this)
      // disable wheel
      if (this.templateAttribute.scrollBar) {
        this.spreadSheet._view.scroller.classList.add('hide-scroller')
      }
      try {
        var printObjectList = []
        if (this.printProperty) {
          // 设置过打印属性才可以正常使用打印
          var that = this
          printObjectList = this.printProperty.sheets.filter(sheet => {
            return sheet.enable && (
              that.spreadSheet._workbook._names['printarea_' + sheet.name.toLowerCase()] ||
              that.spreadSheet._workbook._names['\'printarea_' + sheet.name.toLowerCase() + '\''])
          })
          var spreadSheet = this.spreadSheet
          printObjectList.forEach(obj => {
            // 更新名称
            obj.name = spreadSheet.sheetByGuid(obj.guid) ? spreadSheet.sheetByGuid(obj.guid).name() : obj.name
          })
        }
        this.spreadSheet.sheets().forEach(sheetInfo => {
          var printRangeInfo = this.spreadSheet._workbook._names['printarea_' + sheetInfo.name().toLowerCase()] ||
            this.spreadSheet._workbook._names['\'printarea_' + sheetInfo.name().toLowerCase() + '\'']
          if (printRangeInfo && !printObjectList.find(item => item.name.toLowerCase() === sheetInfo.name().toLowerCase())) {
            var printOption = extendFunctions.deepCopy(print.paperOption)
            printOption.name = sheetInfo.name()
            printOption.guid = sheetInfo.guid
            printObjectList.push(printOption)
          }
        })
        this.$emit('updatePrintList', printObjectList)
        print.updatePrintObjectList(printObjectList)
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.printAreaError'))
        console.error(exception)
      }
      largeFile.owner = this
      largeFile.initTemplateImage(jsonFile)
      this.sheetList = this.spreadSheet.sheets()
      console.timeEnd('获取打开模板文件')
      // 处理单元格右键菜单，切换模式时需要重复初始化
      console.time('初始化右键菜单')
      this.RegistSheetContextMenu()
      this.RemoveContextMenu()
      console.timeEnd('初始化右键菜单')
      // 获取数据表
      console.time('获取检查并初始化数据表')
      try {
        console.time('获取数据表')
        for (var dataSheetId in this.dataSheets) {
          var dataSheetsInfo = this.dataSheets[dataSheetId]
          dataSheetsInfo.fields = {}
          dataSheetsInfo.children.forEach(fieldInfo => {
            dataSheetsInfo.fields[fieldInfo.id] = fieldInfo
          })
        }
        console.timeEnd('获取数据表')
        console.time('校验数据表完整性')
        this.dataSheetsIntegralityCheck()
        console.timeEnd('校验数据表完整性')
        console.time('遍历数据表，处理字段显示和数据规范')
        // 循环数据表生成基本信息
        if (targetStatus !== 11 || targetStatus !== 50) {
          await this.DataSheetsLoop(fieldDataSpecInfos)
        }
        console.timeEnd('遍历数据表，处理字段显示和数据规范')
        // 其他数据规范添加处
        // 初始化新数据规范
        this.hideDataSpec()
        console.time('初始化数据规范')
        this.registSwitch()
        this.registSelector()
        this.registProgress()
        this.registRate()
        console.timeEnd('初始化数据规范')
        this.$nextTick(() => {
          this.correntSelection = true
          this.spreadSheet.activeSheet().range(this.spreadSheet.activeSheet().selection()).select()
          this.correntSelection = false
        })
        console.time('初始化打开动作')
        var sheetId, formData
        console.time('初始化条件格式')
        console.log(this.conditionPause)
        await this.InitCondition(systemVariables)
        console.timeEnd('初始化条件格式')
        // 根据填报参数决定是否打开历史单据并作下一步控制
        switch (targetStatus) {
          case 10:
            if (this.temporaryId) {
              var data = await this.getTemporaryData(this.templateId, this.temporaryId)
              if (data && data.data) {
                formData = data.data
                this.OpenHistoryReport(formData)
                await this.ConnectReportSetValue()
                await this.CreateSerial('create')
                this.GetToken(systemVariables, 0)
              } else {
                extendFunctions.errorMessage('暂存的数据不存在！请重新填报。')
              }
            } else {
              await this.handleCopyCreate()
              // 新建单据不打开老单据
              await this.ConnectReportSetValue()
              // this.LockProtectedRanges()
              // this.UnLockWhiteListRanges()
              await this.CreateSerial('create')
              await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
              // // 数据规范
              // await this.BuildDataSpec()
              // // 合并单元格
              // for (sheetId in this.dataSheets) {
              //   this.MergeSameField(sheetId)
              // }
              // // 执行取数公式
              // await this.InitQueryFormula()
              this.GetToken(systemVariables, 0)
            }
            this.onSelect()
            this.initMap = true
            break
          case 11:
            // 查看历史单据
            await this.OpenHistoryReport()
            // 注册附件高级按钮
            this.LockProtectedRanges()
            await this.InitQueryFormula()
            // 合并单元格
            for (sheetId in this.dataSheets) {
              this.MergeSameField(sheetId)
            }
            break
          case 12:
            // 编辑历史单据
            await this.OpenHistoryReport()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            this.LockProtectedRanges()
            await this.GetToken(systemVariables)
            this.onSelect()
            break
          case 20:
            // 查看历史单据
            await this.OpenHistoryReport()
            // 注册附件高级按钮
            this.LockProtectedRanges()
            await this.InitQueryFormula()
            // 合并单元格
            for (sheetId in this.dataSheets) {
              this.MergeSameField(sheetId)
            }
            break
          case 30:
            await this.handleCopyCreate()
            await this.ConnectReportSetValue()
            // this.LockProtectedRanges()
            // this.UnLockWhiteListRanges()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            // // 数据规范
            // await this.BuildDataSpec()
            // // 合并单元格
            // for (sheetId in this.dataSheets) {
            //   this.MergeSameField(sheetId)
            // }
            // // 执行取数公式
            // await this.InitQueryFormula()
            this.GetToken(systemVariables, 0)
            this.onSelect()
            this.initMap = true
            break
          case 40:
            // 办理流程
            await this.OpenHistoryReport()
            await this.ConnectReportSetValue()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            this.LockProtectedRanges()
            await this.GetToken(systemVariables)
            this.onSelect()
            this.initMap = true
            break
          case 50:
            await this.OpenHistoryReport()
            // 注册附件高级按钮
            await this.InitQueryFormula()
            this.LockProtectedRanges()
            // 合并单元格
            for (sheetId in this.dataSheets) {
              this.MergeSameField(sheetId)
            }
            break
        }
        console.time('初始化样式公式')
        await this.InitFormatFormula(systemVariables)
        console.timeEnd('初始化样式公式')
        postdependence(this.templateId).then(response => {
          // TODO: 字段操作约束初始化
          this.connectInfos = response.data.connects
          this.linkInfos = response.data.links
          this.InitReportConnnectLink()
          this.mailInfo = response.data.emails
          this.GetEmailInfo()
          this.actionButtonList = response.data.actions
          this.GetTemplateActionInfo()
          this.controlRoles = response.data.constraints
          this.InitControlRole(systemVariables)
          for (var sheetId in this.dataSheets) {
            this.handleRowObjectHide(this.dataSheets[sheetId])
          }
          this.spreadSheet._workbook._view.render()
        })
        // 重新渲染spreadsheet
        // this.spreadSheet._workbook._view.render()
        this.ChangeLoadingStatus(false)
      } catch (exception) {
        extendFunctions.errorMessage(exception)
      }
      console.timeEnd('获取检查并初始化数据表')
      this.$emit('loadedAction')
    },

    InitializeReportLite: async function(row, model) {
      this.printFullUrl = ''
      this.fullUrl = ''
      this.specCache = {
        DropDown: {},
        ListView: {},
        Cascader: {}
      }
      this.systemValue = {
        ID: 0,
        r1: 0,
        r5: 0,
        r6: 0,
        r7: '1900-1-1',
        r8: null,
        r10: null,
        r11: false,
        r12: null,
        r13: 0,
        r14: 0,
        r15: null
      }
      var jsonFile
      // 打开模板文件
      var templateData = await this.findTemplateDB(+this.templateId)
      const params = templateData ? { id: templateData.id, hash: templateData.hash, stamp: templateData.stamp } : {}
      var response = await GetTemplateJsonFile(this.templateId, params)
      if (response.status < 200 && response.status >= 300) {
        extendFunctions.errorMessage(this.$t('report.tempFileError'), jsonFile)
        this.ChangeLoadingStatus(false)
        return
      }
      response.data.id = +this.templateId
      if (response.data.hit) {
        jsonFile = templateData.file
      } else {
        jsonFile = response.data.file
        if (templateData) {
          this.updateTemplateDB(+this.templateId, response.data)
        } else {
          this.insertTemplateDB(response.data)
        }
      }
      var systemVariables = (await getSystemVariables()).data
      this.RefreshUserRole()
      // 主动修改tab和dialog的title
      try {
        // 完成回调
        if (!jsonFile) {
          extendFunctions.errorMessage(this.$t('report.emptyTemp'), this.$t('report.emptyTemp'))
          return
        }
        console.time('扩展行')
        // 扩展到5W行
        jsonFile.sheets.forEach(sheet => {
          while (sheet.rows.length < 50000) {
            sheet.rows.push({})
          }
        })
        console.timeEnd('扩展行')
        // 判断sheet数量，决定是否隐藏sheet名称
        console.time('设置sheet页显示')
        if (jsonFile.sheets && jsonFile.sheets.length === 1) {
          this.$refs.reportEditor.$el.lastChild.style.display = 'none'
        }
        console.timeEnd('设置sheet页显示')
        // this.initReportBarCode()
        console.time('加载文件')
        this.spreadSheet.fromJSON(jsonFile, this)
        console.timeEnd('加载文件')
        console.time('升级文件版本')
        this.updateJsonFileVersion(jsonFile)
        console.timeEnd('升级文件版本')
        console.time('获取最大行列')
        this.GetUsedRowColInfo(jsonFile)
        console.timeEnd('获取最大行列')
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.tempFileError'), exception)
      }
      if (this.dialogModel) {
        this.changeDialogSize(jsonFile.showArea)
      }
      this.printProperty = jsonFile.printProperty
      print.showBackground(this)
      // disable wheel
      if (this.templateAttribute.scrollBar) {
        this.spreadSheet._view.scroller.style.overflow = 'hidden'
      }
      largeFile.owner = this
      largeFile.initTemplateImage(jsonFile)
      this.sheetList = this.spreadSheet.sheets()
      console.timeEnd('获取打开模板文件')
      // 处理单元格右键菜单，切换模式时需要重复初始化
      console.time('初始化右键菜单')
      this.RegistSheetContextMenu()
      this.RemoveContextMenu()
      console.timeEnd('初始化右键菜单')
      // 获取数据表
      console.time('获取检查并初始化数据表')
      try {
        // 循环数据表生成基本信息
        if (this.targetStatus !== 11 || this.targetStatus !== 50) {
          await this.DataSheetsLoop()
        }
        this.hideDataSpec()
        this.registSwitch()
        this.registSelector()
        this.registProgress()
        this.registRate()
        this.$nextTick(() => {
          this.correntSelection = true
          this.spreadSheet.activeSheet().range(this.spreadSheet.activeSheet().selection()).select()
          this.correntSelection = false
        })
        console.time('初始化打开动作')
        // 查看历史单据
        await this.OpenHistoryReport()
        // 注册附件高级按钮
        this.LockProtectedRanges()
        await this.InitQueryFormula()
        // 合并单元格
        for (var sheetId in this.dataSheets) {
          this.MergeSameField(sheetId)
        }
        console.time('初始化样式公式')
        await this.InitFormatFormula(systemVariables)
        console.timeEnd('初始化样式公式')
        console.time('初始化条件格式')
        await this.InitCondition(systemVariables)
        console.timeEnd('初始化条件格式')
        this.InitConnectInfos()
        this.InitReportLinkInfos()
        this.setConnectLinkInSheet()
        this.GetEmailInfo()
        this.InitControlRole(systemVariables)
        this.GetTemplateActionInfo()
        // 重新渲染spreadsheet
        this.spreadSheet._workbook._view.render()
        this.ChangeLoadingStatus(false)
      } catch (exception) {
        extendFunctions.errorMessage(exception)
      }
      console.timeEnd('获取检查并初始化数据表')
      this.$emit('loadedAction')
    },

    async handleCopyCreate() {
      if (this.copyCreateRID) {
        var formData = await getFormData(this.templateId, this.copyCreateRID)
        if (formData.status < 200 && formData.status >= 300) {
          extendFunctions.errorMessage(this.$t('report.documentConentError') + formData.data)
          console.error(formData)
          return
        }
        console.log(formData)
        for (var tableId in this.dataSheets) {
          for (var fieldInfo of this.dataSheets[tableId].children) {
            if (!fieldInfo.copyable) {
              formData.data[tableId].forEach(row => {
                delete row[fieldInfo.id]
              })
            }
          }
        }
        this.OpenHistoryReport(formData.data)
        this.$store.dispatch('setCopyCreateRID', undefined)
      }
    },

    // 初始化取数公式
    InitQueryFormula: async function() {
      // 后台返回该流程步骤可用的公式
      try {
        this.conditionPause = true
        // 生成可手动执行的取数公式列表
        var manualExcuteList = []
        var formulaId
        for (formulaId in this.queryFormulaInfos) {
          // filling，trigger，match移除ID为0的字段
          this.queryFormulaInfos[formulaId].filling = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].filling.filter(item => item > 0) : []
          this.queryFormulaInfos[formulaId].trigger = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].trigger.filter(item => item > 0) : []
          this.queryFormulaInfos[formulaId].match = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].match.filter(item => item > 0) : []
          if ((this.queryFormulaInfos[formulaId].handle & 256) === 256) {
            manualExcuteList.push({
              name: this.queryFormulaInfos[formulaId].name,
              id: this.queryFormulaInfos[formulaId].id,
              seq: this.queryFormulaInfos[formulaId].seq
            })
          }
        }
        this.$emit('UpdateQueryFormulaList', manualExcuteList)
        // UpdateQueryFormulaList
        // 整理取数公式自动执行触发字典
        console.time('构建字段的自动执行取数公式列表')
        // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
        this.formulaDictionary = {}
        for (formulaId in this.queryFormulaInfos) {
          // 位运算判断是否需要进行自动执行的处理
          if ((this.queryFormulaInfos[formulaId].handle & 128) === 128) {
            for (var fieldId of this.queryFormulaInfos[formulaId].trigger) {
              if (this.formulaDictionary[fieldId] === undefined) {
                this.formulaDictionary[fieldId] = []
              }
              if (this.formulaDictionary[fieldId].indexOf(formulaId) === -1) {
                this.formulaDictionary[fieldId].push(formulaId)
              }
            }
          }
        }
        console.timeEnd('构建字段的自动执行取数公式列表')
        // 执行新建时执行的公式
        if (!this.temporaryId) {
          console.time('执行打开单据时执行的公式')
          switch (this.formEditStatus) {
            case 10:
            case 30:
              this.conditionPause = false
              await this.ExcuteQueryFormulaByHandle('AfterCreated')
              break
            case 40:
            case 12:
              await this.ExcuteQueryFormulaByHandle('BeforeModify')
              break
            default:
              await this.ExcuteQueryFormulaByHandle('AfterView')
              break
          }
          console.timeEnd('执行打开单据时执行的公式')
        }
        this.conditionPause = false
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(this.$t('report.queryFormulaError'), exception)
        this.queryFormulaInfos = undefined
      }
    },
    ReplaceVariables(expression, variables) {
      if (expression.indexOf('@s' >= 0)) {
        expression = expression
          .replace(new RegExp('@s10', 'g'), `'${variables[18]}' `)
          .replace(new RegExp('@s11', 'g'), `'${variables[11]}' `)
          .replace(new RegExp('@s12', 'g'), `'${variables[12]}' `)
          .replace(new RegExp('@s13', 'g'), `'${JSON.stringify(variables[20] || {})}' `)
          .replace(new RegExp('@s1', 'g'), variables[16] + ' ')
          .replace(new RegExp('@s2', 'g'), `'${variables[1]}' `)
          .replace(new RegExp('@s3', 'g'), `'${variables[2]}' `)
          .replace(new RegExp('@s4', 'g'), `'${variables[15]}' `)
          .replace(new RegExp('@s5', 'g'), `'${variables[5]}' `)
          .replace(new RegExp('@s6', 'g'), variables[6] + ' ')
          .replace(new RegExp('@s7', 'g'), `'${variables[17]}' `)
          .replace(new RegExp('@s8', 'g'), `'${variables[3]}' `)
          .replace(new RegExp('@s9', 'g'), `'${variables[4]}' `)
      }
      expression = expression
        .replace(new RegExp('ID', 'g'), this.systemValue.id + ' ')
        .replace(new RegExp('r1', 'g'), this.systemValue.id + ' ')
        .replace(new RegExp('r5', 'g'), this.systemValue.r5 + ' ')
        .replace(new RegExp('r6', 'g'), this.systemValue.r6 + ' ')
        .replace(new RegExp('r7', 'g'), this.systemValue.r7 + ' ')
        .replace(new RegExp('r8', 'g'), this.systemValue.r8 + ' ')
        .replace(new RegExp('r10', 'g'), this.systemValue.r11 + ' ')
        .replace(new RegExp('r11', 'g'), this.systemValue.r12 + ' ')
        .replace(new RegExp('r12', 'g'), this.systemValue.r13 + ' ')
        .replace(new RegExp('r13', 'g'), this.systemValue.r14 + ' ')
        .replace(new RegExp('r14', 'g'), this.systemValue.r15 + ' ')
        .replace(new RegExp('r15', 'g'), this.systemValue.r16 + ' ')
      return expression
    },
    // 初始化动态样式
    InitFormatFormula: async function(systemVariables) {
      // 后台返回该流程步骤可用的公式
      try {
        // 整理取数公式自动执行触发字典
        console.time('构建字段的自动执行动态样式列表')
        // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
        this.formatFormulaDictionary = {}
        var variables = systemVariables || (await getSystemVariables()).data
        for (var formulaId in this.formatFormulaInfos) {
          // 替换系统变量
          // 位运算判断是否需要进行自动执行的处理
          if (this.templateRole.style.indexOf(formulaId) >= 0) {
            this.formatFormulaInfos[formulaId].timing = 128
          }
          if (!this.formatFormulaInfos[formulaId].expression) {
            this.formatFormulaInfos[formulaId].timing = 0
          } else {
            this.formatFormulaInfos[formulaId].expression = this.ReplaceVariables(this.formatFormulaInfos[formulaId].expression, variables)
          }
          if (this.$route.params.workFlowId) {
            if (this.$route.params.workFlowId === this.formatFormulaInfos[formulaId].workFlowId &&
              this.formatFormulaInfos[formulaId].activities.indexOf(this.workFlowActivityId) > -1) {
              this.formatFormulaInfos[formulaId].timing = 128
            }
          }
          if ((this.formatFormulaInfos[formulaId].timing & 128) === 128) {
            this.formatFormulaInfos[formulaId].triggerList = (this.formatFormulaInfos[formulaId].referenceFields || '').split(',').filter(item => { return item !== '0' })
            for (var fieldId of this.formatFormulaInfos[formulaId].triggerList) {
              if (this.formatFormulaDictionary[fieldId] === undefined) {
                this.formatFormulaDictionary[fieldId] = []
              }
              if (this.formatFormulaDictionary[fieldId].indexOf(formulaId) === -1) {
                this.formatFormulaDictionary[fieldId].push(formulaId)
              }
            }
          }
        }
        console.timeEnd('构建字段的自动执行动态样式列表')
        console.log(this.formatFormulaDictionary)
        this.ExcuteFormatFormulaByHandle('AutoExecute')
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage('动态样式初始化失败！', exception)
        this.formatFormulaInfos = undefined
      }
    },

    InitializeWorker: function() {
      if (!this.dialogModel) {
        if (this.statisticsWorker) {
          this.statisticsWorker.terminate()
        }
        this.statisticsWorker = new StatisticsWorker()
        this.statisticsWorker.addEventListener('message', calculateResult => {
          this.statisticsString = calculateResult.data
        })
      }
    },

    // 初始化关联填报参数
    // connectType
    // 0x00000001     模板级
    // 0x00000002     数据表级
    // 0x00000004     字段级
    InitConnectInfos: function() {
      if (this.connectInfos && this.connectInfos.length) {
        // 对参数作处理，返回按钮信息
        var buttonsInfo = []
        this.connectInfos.forEach(info => {
          info.class = 'connect'
          info.beforeSave = (info.timingType & 0x00000001) === 0x00000001
          info.afterSave = (info.timingType & 0x00000002) === 0x00000002
          if (((info.type & 0x00000001) === 0x00000001) && ((this.editModel === 2 && info.afterSave) || (this.editModel !== 2 && info.beforeSave))) {
            // 模板级
            buttonsInfo.push(info)
          }
          info.fieldList = info.fromField ? info.fromField.split(',') : []
        })
        this.$emit('buildConnectButtons', buttonsInfo)
      }
    },

    GetConnectParam: async function(connectId) {
      var connectInfo = await getConnectInfo(connectId)
      if (connectInfo.status >= 200 && connectInfo.status < 300) {
        var params = {}
        var rowData
        if (connectInfo.data.nodes) {
          var activeCell = formatConverter.ConvertAllFormat2Json(this.spreadSheet.activeSheet().selection()._ref, this)
          connectInfo.data.nodes.forEach(node => {
            switch (this.dataSheets[this.id2DataSheets[node.fromField]].type + this.dataSheets[this.id2DataSheets[node.fromField]].extType) {
              case 1:
                params[node.destField] = this.GetDataFromMasterTable(node.fromField)
                break
              case 2:
                rowData = this.GetDataFromExtendTable(this.id2DataSheets[node.fromField], {
                  top: activeCell.topLeft.row - this.GetNameRangeJson(this.id2Info[node.fromField].areaAlias).topLeft.row,
                  length: 1
                }, [node.fromField])
                if (rowData.length > 0) { params[node.destField] = rowData[0][node.fromField] }
                break
              case 3:
                rowData = this.GetDataFromExtendTable(this.id2DataSheets[node.fromField], {
                  top: activeCell.topLeft.col - this.GetNameRangeJson(this.id2Info[node.fromField].areaAlias).topLeft.col,
                  length: 1
                }, [node.fromField])
                if (rowData.length > 0) { params[node.destField] = rowData[0][node.fromField] }
                break
              case 4:
                break
            }
          })
        }
        console.log(params)
        sessionStorage.setItem('connectParams', JSON.stringify(params))
      }
    },

    InitReportConnnectLink() {
      this.InitConnectInfos()
      this.InitReportLinkInfos()
      this.setConnectLinkInSheet()
    },

    // 初始化超链接参数
    InitReportLinkInfos: async function() {
      try {
        this.linkInfos.forEach(info => {
          info.class = 'link'
          info.fieldList = info.fromField.split(',')
        })
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.linkError'), exception)
      }
    },

    // 获取超链接参数
    GetLinkParam: async function(linkId, linkType) {
      var linkInfo = linkType ? await getConnectInfo(linkId) : await getLinkInfo(linkId)
      if (linkInfo.status >= 200 && linkInfo.status < 300) {
        var params = {}
        var rowData
        var nodes = linkType ? linkInfo.data.linkNodes : linkInfo.data.nodes
        if (nodes) {
          var activeCell = formatConverter.ConvertAllFormat2Json(this.spreadSheet.activeSheet().selection()._ref, this)
          nodes.forEach(node => {
            var sheetInfo = this.dataSheets[this.id2DataSheets[node.fromField]]
            if (!sheetInfo) {
              extendFunctions.errorMessage(this.$t('report.paramError'))
              return new Error()
            }
            if (!params[sheetInfo.id]) {
              params[sheetInfo.id] = {}
            }
            switch (sheetInfo.type + sheetInfo.extType) {
              case 1:
                params[sheetInfo.id][node.fromField] = this.GetDataFromMasterTable(node.fromField)
                break
              case 2:
                rowData = this.GetDataFromExtendTable(sheetInfo.id, {
                  top: activeCell.topLeft.row - this.GetNameRangeJson(this.id2Info[node.fromField].areaAlias).topLeft.row,
                  length: 1
                }, [node.fromField])
                if (rowData.length > 0) { params[sheetInfo.id][node.fromField] = rowData[0][node.fromField] }
                break
              case 3:
                rowData = this.GetDataFromExtendTable(sheetInfo.id, {
                  top: activeCell.topLeft.col - this.GetNameRangeJson(this.id2Info[node.fromField].areaAlias).topLeft.col,
                  length: 1
                }, [node.fromField])
                if (rowData.length > 0) { params[sheetInfo.id][node.fromField] = rowData[0][node.fromField] }
                break
              case 4:
                break
            }
          })
        }
        return params
      }
    },

    // 将关联填报和超链接以超链接形式在单据中显示
    setConnectLinkInSheet() {
      var fieldTargets = {}
      var jsonObj
      var that = this
      try {
        // 整理成字段为单位的json
        this.connectInfos.forEach(info => {
          if (info.fieldList) {
            info.fieldList.forEach(fieldId => {
              jsonObj = {
                type: 'connect',
                id: info.id,
                targetTableId: info.fromSheet || that.masterTableId,
                expression: info.execExpression,
                param: info.execParam,
                unhandleMessage: info.unhandleMessage
              }
              if (fieldTargets[fieldId]) {
                fieldTargets[fieldId].push(jsonObj)
              } else {
                fieldTargets[fieldId] = [jsonObj]
              }
            })
          }
        })
        this.linkInfos.forEach(info => {
          if (info.fieldList) {
            jsonObj = {
              type: 'link',
              id: info.id,
              targetTableId: info.fromSheet || that.masterTableId,
              expression: info.execExpression,
              param: info.execParam
            }
            info.fieldList.forEach(fieldId => {
              if (fieldTargets[fieldId]) {
                fieldTargets[fieldId].push(jsonObj)
              } else {
                fieldTargets[fieldId] = [jsonObj]
              }
            })
          }
        })
        // 剔除一个字段有多个绑定的情况
        for (var fieldId in fieldTargets) {
          var handleRangeJson = formatConverter.ConvertAllFormat2Json(this.spreadSheet._workbook._names[this.id2Info[fieldId].areaAlias.toLowerCase()].value)
          if (fieldTargets[fieldId].find(item => item.type === 'connect') && fieldTargets[fieldId].find(item => item.type === 'link')) {
            this.spreadSheet.sheetByName(this.id2Info[fieldId].sheetName).range(formatConverter.ConvertJsonToRange(handleRangeJson))
              .directLink({
                type: 'repetition'
              })
          }
          this.spreadSheet.sheetByName(this.id2Info[fieldId].sheetName).range(formatConverter.ConvertJsonToRange(handleRangeJson))
            .directLink(fieldTargets[fieldId])
        }
      } catch (ex) {
        extendFunctions.errorMessage('关联填报和超链接初始化失败！')
      }
      this.spreadSheet._workbook._view.render()
    },

    async connectLinkClick(command, recordId, type) {
      this.ChangeLoadingStatus(true)
      var createText = this.$t('buttons.create')
      var sourceTemplateId = this.templateId
      this.linkReportList = []
      this.$emit('changeLinkParam', undefined, [])
      var item
      switch (type) {
        case 'connect':
          item = this.connectInfos.find(info => info.id === command)
          await this.GetConnectParam(command)
          // 判断是不是带流程单据
          var workflowInfo = await this.getWorkFlowInfo(item.templateId)
          // 开始执行
          if (item.targetMode === null || (workflowInfo && workflowInfo.length)) {
            var routerTemp
            if (workflowInfo && workflowInfo.length) {
              routerTemp = {
                name: `${workflowInfo[0].name}-${this.$t('buttons.start')}`,
                nodeId: `createWorkFlow-${item.templateId}`,
                templateId: item.templateId,
                routeType: 'createWorkFlow',
                model: 0,
                path: `/workFlow/${item.templateId}/${workflowInfo[0].id}/0`
              }
            } else {
              routerTemp = {
                name: `${item.templateName}-${createText}`,
                nodeId: `create-${item.templateId}`,
                templateId: item.templateId,
                connectTemplateId: sourceTemplateId,
                connectId: item.id,
                connectRecordId: -1,
                routeType: 'create',
                model: 0,
                path: `/report/${item.templateId}/0`
              }
            }
            this.$router.push(routerTemp.path)
            this.$store.dispatch('SetLastTab', routerTemp)
            this.$store.dispatch('addView', routerTemp)
          } else {
            var reportTitle = `${item.templateName}-${createText}`
            var dataRow = {
              templateId: item.templateId,
              recordId: 0
            }
            var model = 0
            var connectData = {
              templateId: sourceTemplateId,
              connectId: item.id,
              recordId: -1
            }
            this.$emit('handleConnect', dataRow, model, connectData, reportTitle)
          }
          break
      }
      this.ChangeLoadingStatus(false)
    },

    // JSON文件版本升级
    updateJsonFileVersion(jsonFile) {
      if (jsonFile.printProperty && jsonFile.printProperty.version !== 2) {
        var property = {
          version: 2,
          defaultPrintObj: jsonFile.sheets[0].name,
          preview: false,
          sheets: []
        }
        var option = jsonFile.printProperty.pdfPreviewOption
        var customPaperSize = {
          height: +jsonFile.printProperty.customPaperSize.height,
          width: +jsonFile.printProperty.customPaperSize.width
        }
        var customMargin = {
          top: +jsonFile.printProperty.customMargin.top,
          bottom: +jsonFile.printProperty.customMargin.bottom,
          left: +jsonFile.printProperty.customMargin.left,
          right: +jsonFile.printProperty.customMargin.right
        }
        // 打印结构升级
        jsonFile.sheets.forEach(sheet => {
          property.sheets.push({
            name: sheet.name,
            guid: sheet.guid,
            printType: 0,
            enable: true,
            printExtTitle: false,
            titleCount: 1,
            linkFilter: '',
            linkTransFilter: '',
            itemMargin: 0,
            linkDataTable: null,
            linkNodes: [],
            handleFormula: [],
            paperOption: {
              author: option.author,
              creator: option.creator,
              emptyCells: option.emptyCells,
              fitWidth: option.fitWidth,
              guideColor: option.guideColor,
              guidelines: option.guidelines,
              hCenter: option.hCenter,
              headerRows: option.headerRows,
              landscape: option.landscape,
              margin: option.margin,
              customMargin: customMargin,
              maxEmpty: option.maxEmpty,
              output: option.output,
              paperSize: option.paperSize,
              customPaperSize: customPaperSize,
              printCount: option.printCount,
              printRange: option.printRange,
              scale: option.scale,
              vCenter: option.vCenter
            }
          })
        })
        jsonFile.printProperty = property
      }
      // if(!jsonFile.version||jsonFile.version<251){
      this.setCellFieldInfo(jsonFile.version)
      // }
      console.log(jsonFile)
    },

    // 获取当前使用的最大行列信息
    GetUsedRowColInfo(jsonFile) {
      jsonFile.sheets.forEach(sheet => {
        this.maxUsedRow[sheet.name] = 0
        this.maxUsedColumn[sheet.name] = 0
        if (!sheet.rows) {
          return
        }
        sheet.rows.forEach(row => {
          if (row.index > this.maxUsedRow[sheet.name]) {
            this.maxUsedRow[sheet.name] = row.index
          }
          if (!row.cells) {
            return
          }
          row.cells.forEach(cell => {
            if (cell.index > this.maxUsedColumn[sheet.name]) {
              this.maxUsedColumn[sheet.name] = cell.index
            }
          })
        })
        this.maxUsedRow[sheet.name] = this.maxUsedRow[sheet.name] + 15 > this.maxControlRow ? this.maxControlRow : this.maxUsedRow[sheet.name] + 20
        this.maxUsedColumn[sheet.name] = this.maxUsedColumn[sheet.name] + 5 > this.maxControlColumn ? this.maxControlColumn : this.maxUsedColumn[sheet.name] + 10
      })
      console.log(this.maxUsedRow, this.maxUsedColumn)
    },

    // 调整dialog模式下窗口大小
    changeDialogSize(sizeArea) {
      if ((!this.dialogModel) || !sizeArea) {
        return
      }
      var widthCount = 20
      var heightCount = 160
      var i
      var handleSheet = this.spreadSheet.sheetByGuid(sizeArea.sheetGuid)
      for (i = 1; i <= sizeArea.range.bottomRight.row; i++) {
        heightCount += handleSheet.rowHeight(i - 1)
      }
      for (i = 1; i <= sizeArea.range.bottomRight.col; i++) {
        widthCount += handleSheet.columnWidth(i - 1)
      }
      console.log(heightCount, widthCount)
      this.$emit('changeSize', heightCount, widthCount)
    },

    // 获取自定义按钮列表，创建按钮
    GetTemplateActionInfo() {
      if (this.actionButtonList) {
        this.actionButtonList.forEach(item => {
          if (item.style && typeof item.style === 'string') {
            try {
              item.style = JSON.parse(item.style)
            } catch (exception) {
              console.log('重复初始化按钮列表')
            }
          } else if (!item.style) {
            item.style = {
              switchable: false,
              showAlias: true,
              alias: item.alias || (item.style && item.style.alias ? item.style.alias : '查询')
            }
          }
        })
        this.changeActionButtons()
      }
    },

    // 初始化字段操作约束
    InitControlRole(systemVariables) {
      this.controlRoleDictionary = {}
      // 除查看状态均可以执行约束
      if (this.editModel === 0 || this.editModel === 1) {
        var tableId
        // 新建修改时初始化
        this.controlRoles.forEach(role => {
          // 初始化信息并执行一次
          var paramFields = role.referenceFields.split(',').filter(fieldId => fieldId !== '0')
          role.param = {}
          paramFields.forEach(fieldId => {
            tableId = this.id2DataSheets[fieldId]
            if (!role.param[tableId]) {
              role.param[tableId] = []
            }
            role.param[tableId].push(+fieldId)
            if (!this.controlRoleDictionary[fieldId]) {
              this.controlRoleDictionary[fieldId] = []
            }
            this.controlRoleDictionary[fieldId].push(role.id)
            if (this.dataSheets[tableId].type === 1) {
              role.handleTable = +tableId
              if (!this.controlRoleDictionary[tableId]) {
                this.controlRoleDictionary[tableId] = []
              }
              if (this.controlRoleDictionary[tableId].indexOf(role.id) === -1) {
                this.controlRoleDictionary[tableId].push(role.id)
              }
            }
          })
          role.lockField = role.operateFields.split(',').filter(fieldId => fieldId !== '0')
          role.lockField.forEach(fieldId => {
            tableId = this.id2DataSheets[fieldId]
            if (fieldId && tableId) {
              if (this.dataSheets[tableId].type === 1) {
                role.handleTable = +tableId
                if (!this.controlRoleDictionary[tableId]) {
                  this.controlRoleDictionary[tableId] = []
                }
                if (this.controlRoleDictionary[tableId].indexOf(role.id) === -1) {
                  this.controlRoleDictionary[tableId].push(role.id)
                }
              }
            }
          })
          role.filter = this.ReplaceVariables(role.filter, systemVariables)
          if (!role.handleTable) {
            if (!this.controlRoleDictionary['extendTableCalc']) {
              this.controlRoleDictionary['extendTableCalc'] = []
            }
            this.controlRoleDictionary['extendTableCalc'].push(role.id)
          }
          this.handleControlRole(role.id)
        })
      }
    },

    controlRoleHelper(roleList, triggerInfo) {
      var forbiddenMessage = ''
      if (roleList && roleList.length) {
        roleList.forEach(roleId => {
          if (!forbiddenMessage) {
            forbiddenMessage = this.handleControlRole(roleId, triggerInfo)
          } else {
            this.handleControlRole(roleId, triggerInfo)
          }
        })
      }
      return forbiddenMessage
    },
    // 执行操作约束
    handleControlRole(roleId, triggerInfo, disableOperation) {
      // debugger
      console.time('执行操作约束')
      var currentRole = this.controlRoles.find(role => role.id === roleId)
      var forbiddenMessage = ''
      var message
      if (currentRole) {
        var params = []
        var tableStr = ''
        for (var tableId in currentRole.param) {
          switch (this.dataSheets[tableId].type) {
            case 0:
              params.push([this.GetParamWithFieldId(currentRole.param[tableId])])
              break
            case 1:
              var tableRangeJson = this.GetNameRangeJson(this.dataSheets[tableId].areaAlias)
              var runEachRow = (currentRole.operation & 2) === 2 && !triggerInfo
              currentRole.lockField.forEach(fieldId => {
                if (this.id2DataSheets[fieldId]) {
                  if (!runEachRow && +this.id2DataSheets[fieldId] === +tableId) {
                    runEachRow = true
                  }
                }
              })
              if (triggerInfo) {
                switch (this.dataSheets[tableId].extType) {
                  case 1:
                    tableRangeJson.topLeft.row += triggerInfo.top
                    tableRangeJson.bottomRight.row = tableRangeJson.topLeft.row
                    break
                  case 2:
                    tableRangeJson.topLeft.col += triggerInfo.top
                    tableRangeJson.bottomRight.col = tableRangeJson.topLeft.col
                    break
                  case 3:
                    // 交叉表
                    break
                }
                params.push([this.GetParamWithFieldId(currentRole.param[tableId], tableRangeJson)])
              } else {
                if (runEachRow) {
                  var i
                  switch (this.dataSheets[tableId].extType) {
                    case 1:
                      for (i = 0; i <= tableRangeJson.bottomRight.row - tableRangeJson.topLeft.row; i++) {
                        message = this.handleControlRole(roleId, {
                          top: i,
                          length: 1
                        })
                        if (message === 'no_message') {
                          if (forbiddenMessage === '') {
                            forbiddenMessage = message
                          }
                        } else {
                          if (forbiddenMessage === 'no_message' || forbiddenMessage === '') {
                            forbiddenMessage = message
                          }
                        }
                      }
                      break
                    case 2:
                      for (i = 0; i <= tableRangeJson.bottomRight.col - tableRangeJson.topLeft.col; i++) {
                        message = this.handleControlRole(roleId, {
                          top: i,
                          length: 1
                        })
                        if (message === 'no_message') {
                          if (forbiddenMessage === '') {
                            forbiddenMessage = message
                          }
                        } else {
                          if (forbiddenMessage === 'no_message' || forbiddenMessage === '') {
                            forbiddenMessage = message
                          }
                        }
                      }
                      break
                    case 3:
                      // 交叉表
                      break
                  }
                  console.timeEnd('执行操作约束')
                  return forbiddenMessage
                } else {
                  var tableData = this.GetDataFromExtendTable(tableId, undefined, currentRole.param[tableId])
                  params.push([tableData && tableData.length ? tableData[0] : {}])
                }
              }
          }
          tableStr += tableStr ? ` INNER JOIN ? [${tableId}]` : `? [${tableId}]`
        }
        var query = 'SELECT 1 '
        if (tableStr.length) {
          query += ' FROM ' + tableStr
        }
        query += ' WHERE ' + currentRole.filter
        var result = tableStr.length ? alasql(query, params) : alasql(query)
        if (result.length) {
          // 锁定
          forbiddenMessage = currentRole.message || 'no_message'
          this.lockControlRoleCells(currentRole.lockField, triggerInfo, forbiddenMessage)
          if ((currentRole.operation & 1) === 1 || disableOperation || (currentRole.operation & 2) === 2) {
            console.timeEnd('执行操作约束')
            return forbiddenMessage
          }
        } else {
          // 解锁
          this.lockControlRoleCells(currentRole.lockField, triggerInfo, forbiddenMessage)
          console.timeEnd('执行操作约束')
          return ''
        }
      }
      console.timeEnd('执行操作约束')
      return ''
    },

    // 锁定操作约束结果
    lockControlRoleCells(fieldList, triggerInfo, forbiddenMessage) {
      // roleLocked
      var fieldInfo, dataSheetInfo, fieldRange
      var handleCollection = {}
      fieldList.forEach(fieldId => {
        if (fieldId) {
          dataSheetInfo = this.dataSheets[this.id2DataSheets[fieldId]]
          fieldInfo = this.id2Info[fieldId]
          fieldRange = this.GetNameRangeJson(fieldInfo.areaAlias)
          if (dataSheetInfo.type === 1 && triggerInfo) {
            switch (dataSheetInfo.extType) {
              case 1:
                // 向下扩展
                fieldRange.topLeft.row += triggerInfo.top
                fieldRange.bottomRight.row = fieldRange.topLeft.row
                break
              case 2:
                // 向右扩展
                fieldRange.topLeft.col += triggerInfo.top
                fieldRange.bottomRight.col = fieldRange.topLeft.col
                break
              case 3:
                // 交叉表
                break
            }
          }
          if (!handleCollection[fieldInfo.sheetName]) {
            handleCollection[fieldInfo.sheetName] = []
          }
          handleCollection[fieldInfo.sheetName].push(formatConverter.ConvertJsonToRange(fieldRange))
        }
      })
      for (var sheetName in handleCollection) {
        var sheet = this.spreadSheet.sheetByName(sheetName)
        sheet.batch(() => {
          handleCollection[sheetName].forEach(range => {
            sheet.range(range).roleLocked(forbiddenMessage)
          })
        })
      }
      // this.spreadSheet.sheetByName(dataSheetInfo.sheetName).range().roleLocked(forbiddenMessage)
    },

    changeActionButtons() {
      var buildButtons = []
      if (this.actionButtonList && this.actionButtonList.length) {
        switch (this.formEditStatus) {
          case 10:
          case 30:
            buildButtons = this.actionButtonList.filter(button => (button.applyTiming & 1) === 1)
            break
          case 11:
          case 12:
          case 20:
          case 40:
          case 50:
          default:
            buildButtons = this.actionButtonList.filter(button => (button.applyTiming & 4) === 4)
            break
        }
      }
      this.$emit('buildActionButtons', buildButtons)
    },

    // 相应按钮点击事件，根据自定义按钮ID，获取整体执行信息Json
    // 对Json执行队列数组进行遍历，执行每个动作
    async ExcuteTemplateAction(actionId) {
      if (actionId === -1) {
        this.$message({
          message: this.$t('report.triggerCustom')
        })
        return
      }
      // console.log(actionId)
      // 调用接口获取执行列表
      var actionList = this.actionParamList[actionId] || []
      if (actionList.length === 0) {
        var actionParamInfo = await getActionParams(actionId)
        if (actionParamInfo.status >= 200 && actionParamInfo.status < 300) {
          // console.log(actionParamInfo)
          actionParamInfo.data.forEach(item => {
            if (item.type === 4 || item.type === 7) {
              try {
                item.setting = JSON.parse(item.setting)
              } catch (ex) { console.log('重复序列化') }
            }
          })
          this.actionParamList[actionId] = actionParamInfo.data
          actionList = this.actionParamList[actionId]
        }
      }
      var queryFormulaList = []
      var queryMessage = {}
      var createTables = {}
      createTables[this.masterTableId] = []
      var masterTableData = {}
      masterTableData[this.masterTableId] = [{}]
      this.dataSheets[this.masterTableId].children.forEach(fieldInfo => {
        createTables[this.masterTableId].push(fieldInfo.id)
        masterTableData[this.masterTableId][0][fieldInfo.id] = this.GetDataFromMasterTable(fieldInfo.id, 1)
      })
      if (actionList.length > 0) {
        for (var i = 0; i < actionList.length; i++) {
          var step = actionList[i]
          // 判断该步骤是否执行
          var queryResult = step.condition ? await this.QuerySQLExpression(createTables, step.condition, masterTableData, undefined, this.masterTableId) : [1]
          if (queryResult.length > 0) {
            switch (step.type) {
              case 1:
                // 取数公式放入队列处理
                step.param = step.actionParam
                queryFormulaList.push(step.actionId)
                queryMessage[step.actionId] = step.tooltip
                break
              default:
                // 优先执行取数公式队列
                if (queryFormulaList.length > 0) {
                  this.showFormulaLoading = true
                  this.resultRowCount = 0
                  await this.QueryFormulaHelper(queryFormulaList, undefined, queryMessage)
                  queryFormulaList = []
                }
                // 执行步骤
                await this.ExcuteActionStep(step)
                break
            }
          } else {
            if (step.nonexectip) {
              extendFunctions.noticeMessage(this.$t('status.warning'), step.nonexectip)
            }
          }
        }
      }
      if (queryFormulaList.length > 0) {
        this.showFormulaLoading = true
        this.resultRowCount = 0
        await this.QueryFormulaHelper(queryFormulaList, undefined, queryMessage)
        queryFormulaList = []
      }
      var buttonInfo = this.actionButtonList.filter(button => { return button.id === actionId })[0]
      if (buttonInfo.style.switchable) {
        this.$set(buttonInfo, 'clickedStatus', !buttonInfo.clickedStatus)
        this.spreadSheet._controller.onScroll()
      }
    },

    async ExcuteActionStep(stepInfo) {
      var excuteResult
      try {
        // 不同类型结构不同
        switch (stepInfo.type) {
          case 2:
            try {
              excuteResult = await getWriteFromulaResult(this.templateId, stepInfo.actionId, this.GetParamWithoutTableInfo(stepInfo.actionParam))
            } catch (exception) {
              extendFunctions.errorMessage(this.$t('report.backFormulaExecuteError') + stepInfo.actionId)
            }
            break
          case 3:
            excuteResult = await getProcedureResult(this.templateId, stepInfo.actionId, this.GetParamWithoutTableInfo(stepInfo.actionParam))
            break
          case 4:
            switch (stepInfo.setting.currentType) {
              case 1:
                // 展开收缩行
                var handleObj = this.dataSheets[stepInfo.setting.actionId]
                var i
                if (!handleObj) {
                  handleObj = this.id2Info[stepInfo.setting.actionId]
                }
                if (!handleObj) {
                  extendFunctions.errorMessage(this.$t('report.actionError') + stepInfo.actionId)
                  return
                }
                // 获取操作行列信息
                var objRange = this.GetNameRangeJson(handleObj.areaAlias)
                var handleRange = []
                if (stepInfo.setting.direction) {
                  // 横向
                  handleRange.push(objRange.topLeft.row - stepInfo.setting.headShift)
                  handleRange.push(objRange.bottomRight.row + stepInfo.setting.footShift)
                  console.log(handleRange)
                  if (stepInfo.setting.initialAction) {
                    // 收缩
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).hideRow(i - 1)
                    }
                  } else {
                    // 展开
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).unhideRow(i - 1)
                    }
                  }
                } else {
                  // 纵向
                  handleRange.push(objRange.topLeft.col - stepInfo.setting.headShift)
                  handleRange.push(objRange.bottomRight.col + stepInfo.setting.footShift)
                  if (stepInfo.setting.initialAction) {
                    // 收缩
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).hideColumn(i - 1)
                    }
                  } else {
                    // 展开
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).unhideColumn(i - 1)
                    }
                  }
                }
                stepInfo.setting.initialAction = stepInfo.setting.initialAction ? 0 : 1
                break
            }
            break
          case 5:
            // 关联填报
            // this.$emit('connectLinkClick', stepInfo.actionId)
            // await this.connectLinkClick(stepInfo.actionId,undefined,'connect')
            this.$emit('connectLinkHandler', this.connectInfos.filter(info => { return info.id === +stepInfo.actionId }))
            break
          case 6:
            // 新增的动态样式
            this.ExcuteFormatFormula(stepInfo.actionId)
            break
          case 7:
            // 打印
            print.handlePrintReport(this, stepInfo.setting, 'print')
            break
          case 8:
            // 发起流程
            getWorkFlowTargets(this.$store.getters.userId).then(res => {
              var workflowInfo = this.GetWorkflowRole(stepInfo.actionId, res.data)
              if (workflowInfo) {
                const routerTemp = {
                  name: `${workflowInfo.name}-${this.$t('buttons.start')}`,
                  nodeId: `createWorkFlow-${workflowInfo.templateId}`,
                  templateId: workflowInfo.templateId,
                  routeType: 'createWorkFlow',
                  model: 0,
                  path: `/workFlow/${workflowInfo.templateId}/${workflowInfo.id}/0`
                }
                this.$router.push(routerTemp.path)
                this.$store.dispatch('SetLastTab', routerTemp)
                this.$store.dispatch('addView', routerTemp)
              }
            })
            break
          case 9:
            // 单据控制
            switch (stepInfo.actionId) {
              case 1:
                // 保存
                // this.$emit('SaveNewForm')
                this.ChangeLoadingStatus(true)
                if (await this.ChangeFormStatus(20)) {
                  this.getFocus()
                  this.ChangeLoadingStatus(false)
                } else {
                  this.getFocus()
                  this.ChangeLoadingStatus(false)
                }
                break
              case 2:
                // 修改
                this.$emit('EditForm')
                break
              case 3:
                // 关闭
                this.$emit('AbortForm', true)
                break
              case 4:
                // 保存新建
                this.$emit('SaveCreateNewForm')
                break
              case 5:
                // 复制新增
                this.$emit('CopyCreateForm')
                break
              case 6:
                // 暂存
                if (this.formEditStatus === 10) {
                  this.$emit('TemporarySaveForm')
                } else {
                  excuteResult = new Error('当前状态不支持暂存。')
                }
                break
              case -1:
                // sheet跳转
                var sheetGuid = stepInfo.setting
                if (this.spreadSheet._workbook.sheetByGuid(sheetGuid)) {
                  this.spreadSheet.activeSheet(this.spreadSheet._workbook.sheetByGuid(sheetGuid))
                }
                break
              default:
                // 跳转单据
                break
            }
            break
          case 10:
            // 标签打印
            var labelResponse = await getCurrentLabel(stepInfo.actionId)
            var labelOrigin = JSON.parse(labelResponse.data.origin)
            // 转换option
            var printJson = {
              w: labelOrigin.width,
              h: labelOrigin.height,
              s: 8,
              e: [],
              d: {}
            }
            var dataList
            var that = this
            labelOrigin.origin.forEach((item, index) => {
              switch (item.type) {
                case 'line':
                  printJson.e.push({
                    i: index,
                    type: 'line',
                    l: item.left,
                    t: item.top,
                    w: item.width,
                    s: item.strokeWidth,
                    a: item.angle
                  })
                  break
                case 'barcode':
                  // 整理打印样式
                  var handleBarcodeInfo = that.barCodeBindingInfo.find(info => { return item.sourceId === info.id })
                  if (handleBarcodeInfo) {
                    printJson.e.push({
                      i: index,
                      type: 'barcode',
                      et: handleBarcodeInfo.type,
                      l: item.realLeft,
                      t: item.realTop,
                      w: item.width,
                      h: item.height,
                      a: item.angle
                    })
                    // 整理打印数据
                    switch (handleBarcodeInfo.function) {
                      case 1:
                      case 2:
                      case 3:
                        printJson.d[index] = [`|${handleBarcodeInfo.function}&${item.sourceId}&${that.templateId}&${handleBarcodeInfo.templateId}&${that.recordId >= 0 ? that.recordId : 0}&&${handleBarcodeInfo.targetMode ? 1 : 0}`]
                        break
                      case 4:
                        if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 1) {
                          dataList = that.GetDataFromExtendTable(that.id2Info[item.sourceFieldId].owner, undefined, [item.sourceFieldId], true)
                          printJson.d[index] = []
                          dataList.forEach(row => {
                            printJson.d[index].push(row[item.sourceFieldId])
                          })
                        } else if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 0) {
                          printJson.d[index] = [that.GetDataFromMasterTable(item.sourceFieldId)]
                        }
                        break
                    }
                    // data[]
                  }
                  break
                case 'text':
                  // 整理打印样式
                  printJson.e.push({
                    i: index,
                    type: 'text',
                    l: item.left - item.width / 2,
                    t: item.top,
                    w: item.width,
                    h: item.height,
                    a: item.angle,
                    b: item.bold ? item.bold : undefined,
                    it: item.italic ? item.italic : undefined,
                    ff: item.fontFamily !== '宋体' ? item.fontFamily : undefined,
                    fs: item.fontSize
                  })
                  // 整理打印数据
                  if (item.dataSource === 2) {
                    if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 1) {
                      dataList = that.GetDataFromExtendTable(that.id2Info[item.sourceFieldId].owner, undefined, [item.sourceFieldId], true)
                      printJson.d[index] = []
                      dataList.forEach(row => {
                        printJson.d[index].push(row[item.sourceFieldId])
                      })
                    } else if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 0) {
                      printJson.d[index] = [that.GetDataFromMasterTable(item.sourceFieldId)]
                    }
                  } else {
                    printJson.d[index] = [item.text]
                  }
                  break
                default:
                  return
              }
            })
            console.log(printJson)
            window.onbeforeunload = () => { }
            this.$refs.labelPrint.href = 'workfineprint:' + JSON.stringify(printJson)
            this.$refs.labelPrint.click()
            window.onbeforeunload = () => { return '是否确定离开页面？' }
            break
          case 11:
            // 获取邮件内容
            excuteResult = await this.ShowMailForm(stepInfo.actionId)
            break
          case 12:
            // 翻页
            var paginationParam = stepInfo.setting.split('_')
            this.currentExtendTable = +paginationParam[0]
            this.$emit('pageChange', +paginationParam[1])
            break
          default:
            extendFunctions.errorMessage(this.$t('report.undefinedAction'))
            return false
        }
        if ((!excuteResult) || (excuteResult.status >= 200 && excuteResult.status < 300)) {
          // 提示信息
          if (stepInfo.tooltip) {
            extendFunctions.noticeMessage(this.$t('status.warning'), stepInfo.tooltip)
          }
          return true
        } else {
          throw new Error(excuteResult)
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.actionError') + stepInfo.id, exception)
        return false
      }
    },

    async ShowMailForm(mailId) {
      var handleMailInfo = this.mailInfo.find(info => info.id === +mailId)
      if (handleMailInfo && ((handleMailInfo.applyTime & 4194304) === 4194304 || (handleMailInfo.applyTime & 256) === 256)) {
        // 整理数据
        try {
          var param = this.GetParamWithTableInfo(handleMailInfo.inputParam)
        } catch (exception) {
          console.error(this.$t('report.mailParamError'))
        }
        try {
          var data = (await getTemplateMailContent(mailId, 0, 0, param)).data
          var content = data.data
          var users = data.user
          if (content.length === 0) {
            return
          }
          var sendContent = {
            id: handleMailInfo.id,
            address: users || handleMailInfo.address,
            copy: handleMailInfo.copy,
            subject: content[0] ? content[0].subject : '',
            body: content[0] ? content[0].body : '',
            attach: []
          }
          this.mailSendList.push(sendContent)
        } catch (exception) {
          console.error('获取邮件参数错误！')
        }
        if (this.mailSendList.length > 0) {
          // 发送邮件
          this.SendMailByStep()
        }
      } else {
        return '邮件发件设置不存在或时机不正确！'
      }
    },

    GetWorkflowRole(workflowId, workflowObj) {
      var result = null
      workflowObj.forEach(item => {
        if (result) {
          return
        }
        if (item.nodeType === 'category' && item.children) {
          result = this.GetWorkflowRole(workflowId, item.children)
        } else if (item.nodeType === 'template') {
          if (item.id === workflowId) {
            result = item
          }
        }
      })
      return result
    },

    GetParamWithoutTableInfo(paramInfo) {
      // 获取param
      var params = {}
      for (var tableId in paramInfo) {
        var sheetInfo = this.dataSheets[tableId]
        if (!sheetInfo) {
          throw new Error(this.$t('report.paramError'))
        }
        var fieldIdList = []
        for (var fieldId of paramInfo[tableId]) {
          fieldIdList.push(fieldId)
        }
        switch (sheetInfo.type + sheetInfo.extType) {
          case 1:
            params[tableId] = [{}]
            fieldIdList.forEach(id => {
              params[tableId][0][id] = this.GetDataFromMasterTable(id)
            })
            break
          case 2:
          case 3:
            params[tableId] = this.GetDataFromExtendTable(tableId, null, fieldIdList)
            break
          case 4:
            break
        }
      }
      params = Object.assign(params, this.systemValue)
      return params
    },

    GetParamWithFieldId(paramArray, activeCell, convertCell, dateFormat, returnType, conditionTag, systemValueTag, conditionDetailTag) {
      if (paramArray && paramArray.length) {
        // 获取param
        var that = this
        var params = {}
        var sheetsData, fieldInfo
        if (convertCell) {
          activeCell = formatConverter.ConvertAllFormat2Json(activeCell, this)
        }
        if (conditionDetailTag) {
          fieldInfo = this.id2Info[paramArray[0]]
          sheetsData = this.GetDataFromExtendTable(fieldInfo.owner, null, paramArray, true, undefined, dateFormat)
          sheetsData.forEach((row, index) => {
            row.tag = index
            row = Object.assign(row, that.systemValue)
          })
          params = sheetsData
          systemValueTag = true
        } else {
          paramArray.forEach(fieldId => {
            fieldInfo = this.id2Info[fieldId]
            var dataSheetInfo = this.dataSheets[fieldInfo.owner]
            fieldInfo.range = this.GetNameRangeJson(fieldInfo.areaAlias)
            switch (dataSheetInfo.type) {
              case 0:
                // 主表取值
                var fieldValue = this.GetDataFromMasterTable(fieldId, dateFormat)
                if (returnType && !conditionTag) {
                  if (fieldValue) {
                    var tempJson = {}
                    tempJson[fieldId] = fieldValue
                    params[fieldId] = [tempJson]
                  }
                } else {
                  params[fieldId] = fieldValue
                }
                break
              case 1:
                // 扩展表取值
                var cellRange
                if (returnType) {
                  cellRange = {
                    top: 0,
                    length: fieldInfo.range.bottomRight.row - fieldInfo.range.topLeft.row + 1
                  }
                } else {
                  cellRange = {
                    top: dataSheetInfo.extType === 1 ? (activeCell.topLeft.row - fieldInfo.range.topLeft.row) : (activeCell.topLeft.col - fieldInfo.range.topLeft.col),
                    length: 1
                  }
                }
                sheetsData = this.GetDataFromExtendTable(fieldInfo.owner, cellRange, [fieldId], false, undefined, dateFormat)
                if (sheetsData.length > 0) {
                  params[fieldId] = returnType ? extendFunctions.deepCopy(sheetsData) : sheetsData[0][fieldId]
                } else {
                  if (!returnType) {
                    params[fieldId] = ''
                  }
                }
                break
              case 2:
                // 交叉表取值
                var triggerInfo
                switch (fieldInfo.extType) {
                  case 1:
                    triggerInfo = {
                      top: activeCell.topLeft.row - fieldInfo.range.topLeft.row,
                      left: -1,
                      length: {
                        row: 1,
                        col: -1
                      }
                    }
                    break
                  case 2:
                    triggerInfo = {
                      top: -1,
                      left: activeCell.topLeft.col - fieldInfo.range.topLeft.col,
                      length: {
                        row: -1,
                        col: 1
                      }
                    }
                    break
                  case 3:
                    triggerInfo = {
                      top: activeCell.topLeft.row - fieldInfo.range.topLeft.row,
                      left: activeCell.topLeft.col - fieldInfo.range.topLeft.col,
                      length: {
                        row: 1,
                        col: 1
                      }
                    }
                    break
                }
                sheetsData = this.GetDataFromExtendTable(this.id2DataSheets[fieldId], triggerInfo)
                if (sheetsData.length > 0) {
                  params[fieldId] = sheetsData[0][fieldId]
                } else {
                  params[fieldId] = ''
                }
            }
          })
        }
        if (!systemValueTag) {
          params = Object.assign(params, this.systemValue)
        }
        return params
      } else {
        if (systemValueTag) {
          return {}
        } else {
          return this.systemValue
        }
      }
    },

    // 含有数据表ID的取值方式
    GetParamWithTableInfo(selectFormulaParams, triggerInfo, targetDataSheetId, dateFormat) {
      // 获取param
      var dataSheetData = {}
      dataSheetData[this.masterTableId] = [{}]
      dataSheetData[this.masterTableId][0] = Object.assign(dataSheetData[this.masterTableId][0], this.systemValue)
      var dataSheetId, fieldId, fieldArrayList, fieldInfo, extendTableTempData
      console.time('整理需要提交的参数')
      // 根据param提供的信息，获取需要取值的别名区域数据存储到dataSheetData中，供下一步使用
      for (dataSheetId in selectFormulaParams) {
        fieldArrayList = []
        for (fieldId of selectFormulaParams[dataSheetId]) {
          fieldArrayList.push(fieldId)
        }
        if (this.dataSheets[dataSheetId].type === 0) {
          for (fieldId of selectFormulaParams[dataSheetId]) {
            fieldInfo = this.dataSheets[dataSheetId].fields[fieldId]
            if (fieldInfo) {
              dataSheetData[dataSheetId][0][fieldInfo.id] = this.GetDataFromMasterTable(fieldInfo.id, dateFormat)
            }
          }
        } else if (this.dataSheets[dataSheetId].type === 1) {
          extendTableTempData = this.GetDataFromExtendTable(dataSheetId, undefined, fieldArrayList, true, true)
          if (triggerInfo && +targetDataSheetId === +dataSheetId) {
            if (extendTableTempData.length >= triggerInfo.top + triggerInfo.length - 1) {
              dataSheetData[dataSheetId] = extendTableTempData.splice(triggerInfo.top, triggerInfo.length)
            }
          } else {
            dataSheetData[dataSheetId] = extendTableTempData
          }
        } else if (this.dataSheets[dataSheetId].type === 2) {
          extendTableTempData = this.GetDataFromExtendTable(dataSheetId, undefined, fieldArrayList, true, true)
          if (triggerInfo && +targetDataSheetId === +dataSheetId && extendTableTempData.length) {
            dataSheetData[dataSheetId] = extendTableTempData.filter(cellData => {
              if (triggerInfo.left < 0) {
                return cellData.row >= triggerInfo.top &&
                  cellData.row <= triggerInfo.top + triggerInfo.length.row - 1
              } else if (triggerInfo.top < 0) {
                return cellData.col >= triggerInfo.left &&
                  cellData.col <= triggerInfo.left + triggerInfo.length.col - 1
              } else {
                return cellData.row >= triggerInfo.top &&
                  cellData.col >= triggerInfo.left &&
                  cellData.row <= triggerInfo.top + triggerInfo.length.row - 1 &&
                  cellData.col <= triggerInfo.left + triggerInfo.length.col - 1
              }
            })
          } else {
            dataSheetData[dataSheetId] = extendTableTempData
          }
          // dataSheetData[dataSheetId]
        }
      }
      // 循环参数Json，去除空数据表参数
      for (dataSheetId in dataSheetData) {
        if ($.isEmptyObject(dataSheetData[dataSheetId])) {
          delete dataSheetData[dataSheetId]
        }
      }
      console.timeEnd('整理需要提交的参数')
      return dataSheetData
    },

    // 保存新单据
    async SaveNewForm(createNew) {
      console.time('保存新单据')
      // 整理数据
      try {
        var newFormJson = await this.PrepareNewFormData()
        if (!newFormJson) {
          this.ChangeLoadingStatus(false)
        } else {
          // 提交数据
          try {
            if (this.temporaryId) {
              var temporaryDatas = await this.findTemporarys(this.templateId, this.temporaryId)
              // debugger
              if (!(temporaryDatas && temporaryDatas.guid)) {
                extendFunctions.errorMessage(this.$t('report.illegalTemporary'))
                return
              }
            }
            var addResult = await addNewForm(this.templateId, this.recordId, newFormJson, this.fillScheme)
            if (addResult.status >= 200 && addResult.status < 300) {
              extendFunctions.noticeMessage(this.$t('status.success'), this.$t('alert.saveSuccess'))
              this.handleSystemValue(addResult.data)
              this.recordId = addResult.data.rid
              await this.PrepareMailByHandle()
              this.ChangeLoadingStatus(false)
              if (this.temporaryId) {
                this.deleteTemporaryData(this.templateId, this.temporaryId)
              }
              if (createNew) {
                this.$route.params.temporaryId = 0
                if (this.useRouter) {
                  this.InitializeReport()
                } else {
                  this.InitializeReport({ recordId: 0, templateId: this.templateId }, 0)
                }
              } else {
                // 锁定所有单元格
                this.LockProtectedRanges()
                this.UnRegistDataSpec()
                this.$emit('ChangeFormEditStatus', 20)
                this.RefreshUserRole(20)
                this.editModel = 2
                if (this.dialogModel) {
                  this.$store.dispatch('setRecordId', this.recordId)
                }
                this.InitConnectInfos(false)
                this.InitReportLinkInfos()
                this.GetTemplateActionInfo()
                // 保存完毕后刷新单据，用来刷新条码
                this.spreadSheet._controller.onScroll()
              }
              return true
            } else {
              this.ChangeLoadingStatus(false)
              extendFunctions.errorMessage(this.$t('report.saveField') + addResult.data)
              console.error(addResult)
              return false
            }
          } catch (exception) {
            this.ChangeLoadingStatus(false)
            return false
          }
        }
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(exception.toString(), exception)
        return false
      }
    },

    // 保存历史单据
    async SaveHistoryReport() {
      var modifyReportJson = await this.PrepareModifyFormData()
      if (modifyReportJson) {
        // 提交数据
        try {
          var response = await modifyForm(this.templateId, this.recordId, modifyReportJson)
          if (response.status >= 200 && response.status < 300) {
            this.handleSystemValue(response.data)
            this.$store.dispatch('setTicket', undefined)
            extendFunctions.noticeMessage(this.$t('status.success'), this.$t('alert.saveSuccess'))
            await this.PrepareMailByHandle()
            // 锁定所有单元格
            this.LockProtectedRanges()
            this.UnRegistDataSpec()
            this.$emit('ChangeFormEditStatus', 20)
            this.RefreshUserRole(20)
            this.ChangeLoadingStatus(false)
            this.editModel = 2
            this.InitConnectInfos(false)
            this.InitReportLinkInfos()
            this.GetTemplateActionInfo()
            return true
          } else {
            this.ChangeLoadingStatus(false)
            extendFunctions.errorMessage(this.$t('report.saveField') + response.data)
            return false
          }
        } catch (exception) {
          this.ChangeLoadingStatus(false)
          extendFunctions.errorMessage(this.$t('report.saveField'), exception)
          return false
        }
      } else {
        return false
      }
    },
    handleSystemValue: function(row) {
      this.systemValue.id = formatConverter.GetValidValue(row.ID || row.rid || 0, 3, 20, 0)
      this.systemValue.r1 = this.systemValue.id
      this.systemValue.r5 = formatConverter.GetValidValue(row.r5 || 0, 3, 20, 0)
      this.systemValue.r6 = formatConverter.GetValidValue(row.r6 || 0, 3, 20, 0)
      if (row.r7 && row.r7 !== '1900-1-1') {
        try {
          this.systemValue.r7 = formatConverter.ConvertDateTime('yyyy-MM-ddThh:mm:ssZ', new Date(row.r7))
        } catch (ex) {
          this.systemValue.r7 = formatConverter.GetValidValue(row.r7 || '1900-1-1', 4)
        }
      } else {
        this.systemValue.r7 = formatConverter.GetValidValue(row.r7 || '1900-1-1', 4)
      }
      this.systemValue.r8 = row.r8 || null
      if (row.r10 && row.r10 !== '1900-1-1') {
        try {
          this.systemValue.r10 = formatConverter.ConvertDateTime('yyyy-MM-ddThh:mm:ssZ', new Date(row.r10))
        } catch (ex) {
          this.systemValue.r10 = formatConverter.GetValidValue(row.r10 || '1900-1-1', 4)
        }
      } else {
        this.systemValue.r10 = null
      }
      this.systemValue.r10 = row.r10 || null
      this.systemValue.r11 = row.r11 || false
      this.systemValue.r12 = row.r12 || null
      this.systemValue.r13 = formatConverter.GetValidValue(row.r13 || 0, 3, 20, 0)
      this.systemValue.r14 = formatConverter.GetValidValue(row.r14 || 0, 3, 20, 0)
      this.systemValue.r15 = row.r15 || null
      delete row.ID
      delete row.r1
      delete row.r5
      delete row.r6
      delete row.r7
      delete row.r8
      delete row.r10
      delete row.r11
      delete row.r12
      delete row.r13
      delete row.r14
      delete row.r15
    },

    // 打开历史单据
    OpenHistoryReport: async function(data) {
      console.time('获取单据数据')
      try {
        var reportData, targetTableId
        if (data) {
          reportData = data
        } else {
          var formData = await getFormData(this.templateId, this.recordId)
          if (formData.status < 200 && formData.status >= 300) {
            extendFunctions.errorMessage(this.$t('report.documentConentError') + formData.data)
            console.error(formData)
            return
          }
          // 完成回调
          if (formData.data === null) {
            extendFunctions.errorMessage(this.$t('report.reportEmpty'))
            return
          }
          reportData = formData.data
        }
        // debugger
        this.handleSystemValue(reportData[this.masterTableId][0])
        // 将获取的数据过滤并填写进表格中
        console.time('写入单据数据')
        if (this.dataSheets === undefined) {
          throw new Error('数据表初始化失败！')
        }
        var execOrder = []
        for (targetTableId in reportData) {
          if (this.dataSheets[targetTableId].type === 0) {
            execOrder.push(targetTableId)
          } else {
            execOrder.unshift(targetTableId)
          }
        }
        for (targetTableId of execOrder) {
          if (this.dataSheets[targetTableId].type === 0) {
            this.InsertMasterFieldValue(targetTableId, reportData[targetTableId], true)
          } else {
            // 清空数据
            this.CleanDataSheetAreaData(targetTableId)
            // 扩展行
            this.CheckAndExtendRows(targetTableId,
              this.dataSheets[targetTableId].extType !== 3 ? reportData[targetTableId].length
                : {
                  row: alasql(`SELECT MAX([row])+1 AS [row] from ?`, [reportData[targetTableId]])[0].row,
                  col: alasql(`SELECT MAX([col])+1 AS [col] from ?`, [reportData[targetTableId]])[0].col
                }, undefined, undefined, undefined, undefined, true)
            this.modifyIndexObj[targetTableId + '_del'] = []
            for (var singleRow of reportData[targetTableId]) {
              this.modifyIndexObj[targetTableId + '_del'].push({ index: singleRow.index })
            }
            // 开始执行插入
            this.InsertData2ExtendTable(targetTableId, this.dataSheets[targetTableId].extType !== 3 ? 0 : { row: 0, col: 0 }, reportData[targetTableId], true)
          }
          // modifyIndexObj
          console.timeEnd('写入单据数据')
        }
        // 合并单元格
        for (var sheetId in this.dataSheets) {
          this.MergeSameField(sheetId)
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.documentConentError'), exception)
      }
      console.timeEnd('获取单据数据')
    },

    // 关联填报填值
    ConnectReportSetValue: async function() {
      var connectInfo
      this.connectReport = this.dialogModel ? this.connectProps : this.connectInfo
      console.log(this.connectReport)
      if (this.connectReport.connectSource === 'barCode') {
        if (this.connectReport.connectRecordId === 0) {
          return
        }
        connectInfo = await getBarCodeFormData(this.connectReport.connectBarCodeId, this.connectReport.connectTemplateId, this.connectReport.connectRecordId)
        if (connectInfo.status >= 200 || connectInfo.status < 300) {
          this.InsertMasterFieldValue(this.masterTableId, connectInfo.data)
        }
      } else if (this.connectReport.connectId) {
        console.log('开始关联填报填值')
        if (this.connectReport.recordId > 0) {
          connectInfo = await GetTemplateConnectInfo(this.connectReport)
          if (connectInfo.status >= 200 || connectInfo.status < 300) {
            const insertValues = connectInfo.data
            for (var tableId in insertValues) {
              if (this.dataSheets[tableId].type === 0) {
                if (insertValues[tableId].length > 0) {
                  this.InsertMasterFieldValue(tableId, insertValues[tableId])
                }
              }
            }
          }
        } else {
          this.InsertMasterFieldValue(undefined, [JSON.parse(sessionStorage.getItem('connectParams'))])
          sessionStorage.removeItem('connectParams')
        }
      } else {
        this.$nextTick(() => {
          var value = sessionStorage.getItem('connectParams')
          if (value) {
            value = JSON.parse(value)
            console.log(value)
            if (value.type === 'workflow') {
              delete value.type
              for (var targetTableId in value) {
                if (this.dataSheets[targetTableId].type === 0) {
                  this.InsertMasterFieldValue(targetTableId, value[targetTableId], true)
                } else {
                  // 清空数据
                  this.CleanDataSheetAreaData(targetTableId)
                  // 扩展行
                  this.CheckAndExtendRows(targetTableId,
                    this.dataSheets[targetTableId].extType !== 3 ? value[targetTableId].length
                      : {
                        row: alasql(`SELECT MAX([row])+1 AS [row] from ?`, [value[targetTableId]])[0].row,
                        col: alasql(`SELECT MAX([col])+1 AS [col] from ?`, [value[targetTableId]])[0].col
                      }, undefined, undefined, undefined, undefined, true)
                  this.modifyIndexObj[targetTableId + '_del'] = []
                  for (var singleRow of value[targetTableId]) {
                    this.modifyIndexObj[targetTableId + '_del'].push({ index: singleRow.index })
                  }
                  // 开始执行插入
                  this.InsertData2ExtendTable(targetTableId, this.dataSheets[targetTableId].extType !== 3 ? 0 : { row: 0, col: 0 }, value[targetTableId], true)
                }
                // modifyIndexObj
                console.timeEnd('写入单据数据')
              }
            } else {
              this.InsertMasterFieldValue(undefined, [value])
            }
            sessionStorage.removeItem('connectParams')
          }
        })
      }
      this.connectReport = null
    },

    handleAutoFill: function(data) {
      var insertTable = {}
      var matchResult
      for (var tableId in this.dataSheets) {
        for (var dataName in data[0]) {
          matchResult = this.dataSheets[tableId].children.filter(info => {
            return info.name === dataName
          })
          if (matchResult.length > 0) {
            insertTable[tableId] = insertTable[tableId] || [{}]
            insertTable[tableId][0][matchResult[0].id] = data[0][dataName]
          }
        }
      }
      for (tableId in insertTable) {
        if (this.dataSheets[tableId].type === 0) {
          this.InsertMasterFieldValue(tableId, insertTable[tableId])
        } else if (this.dataSheets[tableId].type === 1) {
          var usedRowColumnCount = this.CheckAndExtendRows(tableId, 1, undefined, undefined, undefined, undefined, true)
          this.InsertData2ExtendTable(tableId, usedRowColumnCount, insertTable[tableId], true)
        } else {
          this.errorMessage(this.$t('report.crossTableFillError'))
        }
      }
    },

    // 切换当前单据状态
    async ChangeFormStatus(targetStatus) {
      switch (targetStatus) {
        case 20:
          if (this.formEditStatus === 10) {
            // 点击保存后转换为新建完成状态
            return await this.SaveNewForm()
          } else if (this.formEditStatus === 12) {
            return await this.SaveHistoryReport()
          } else {
            extendFunctions.errorMessage(this.$t('report.stateError'))
            return false
          }
        case 12:
        case 40:
          if (this.formEditStatus === 11 || this.formEditStatus === 50) {
            // 查看状态下点修改转换为编辑状态
            this.editModel = 1
            // 重新获取模板信息
            this.$emit('ChangeFormEditStatus', targetStatus)
            this.$nextTick(() => {
              this.InitializeReport(undefined, undefined, 1)
            })
            return true
          } else {
            return false
          }
        default:
          throw new Error(this.$t('report.stateError'))
      }
    },

    // 整理需要提交的数据
    async PrepareNewFormData(skipValidation, skipRequire) {
      if (this.uploadingFile) {
        extendFunctions.errorMessage(this.$t('report.uploadTryLater'))
        return
      }
      // 验证Ticket合法
      if (this.editTicket === undefined) {
        extendFunctions.errorMessage(this.$t('report.editLockError'))
        this.ChangeLoadingStatus(false)
        return
      }
      var dataSheetId
      // 执行保存前执行的表间公式
      await this.ExcuteQueryFormulaByHandle('AfterSaving', skipValidation)
      var newFormJson = await this.GetWholeData()
      // 生成自动编号
      await this.CreateSerial('save', 'new', newFormJson)
      await this.CreateSystemVariables('save', 'new', newFormJson)
      if (skipValidation || this.CheckSubmitData(newFormJson, skipRequire)) {
        // 删除空表
        for (dataSheetId in newFormJson) {
          if (newFormJson[dataSheetId].length === 0 && this.dataSheets[dataSheetId].type !== 0) {
            delete newFormJson[dataSheetId]
          }
        }
        await this.UploadFiles()
        newFormJson.ticket = this.editTicket
        return newFormJson
      } else {
        this.ChangeLoadingStatus(false)
        return
      }
    },

    // 整理修改时需要提交的数据
    async PrepareModifyFormData(skipValidation, skipRequire, emptyType, emptyArea) {
      var dataSheetId
      var that = this
      var modifyReportJson = {}
      // 验证Ticket合法
      if (this.editTicket === undefined) {
        extendFunctions.errorMessage(this.$t('report.editLockError'))
        this.ChangeLoadingStatus(false)
        return false
      }
      modifyReportJson.ticket = this.editTicket
      // 执行保存前执行的表间公式
      await this.ExcuteQueryFormulaByHandle('AfterSaving', skipValidation)
      // 整理数据
      for (dataSheetId in this.dataSheets) {
        if (this.dataSheets[dataSheetId].type === 0) {
          modifyReportJson[dataSheetId] = this.GetDataFromMasterTable()
          modifyReportJson[dataSheetId][0] = Object.assign(modifyReportJson[dataSheetId][0], this.systemValue)
          modifyReportJson[dataSheetId][0].id = +this.recordId
        } else {
          // 扩展表取值
          modifyReportJson[dataSheetId + '_add'] = extendFunctions.deepCopy(this.GetDataFromExtendTable(dataSheetId, undefined, undefined, false))
          modifyReportJson[dataSheetId + '_del'] = extendFunctions.deepCopy(this.modifyIndexObj[dataSheetId + '_del'])
          if (modifyReportJson[dataSheetId + '_add'].length === 0) {
            delete modifyReportJson[dataSheetId + '_add']
          }
          if (modifyReportJson[dataSheetId + '_del'].length === 0) {
            delete modifyReportJson[dataSheetId + '_del']
          }
        }
      }
      // 生成自动编号
      await this.CreateSerial('save', 'modify', modifyReportJson)
      await this.CreateSystemVariables('save', 'modify', modifyReportJson)
      // 回退时清空数据
      var sheetId, fieldId
      if (emptyType === 23) {
        for (sheetId in modifyReportJson) {
          if (typeof modifyReportJson[sheetId] === 'object') {
            modifyReportJson[sheetId].forEach(row => {
              for (fieldId in row) {
                if (that.id2Info[fieldId]) {
                  row[fieldId] = formatConverter.GetValidNullValue(that.id2Info[fieldId].baseType)
                }
              }
            })
          }
        }
      } else if (emptyType === 24 && emptyArea && emptyArea.length) {
        for (sheetId in modifyReportJson) {
          if (typeof modifyReportJson[sheetId] === 'object') {
            modifyReportJson[sheetId].forEach(row => {
              for (fieldId in row) {
                if (emptyArea.find(item => item.id === +fieldId)) {
                  row[fieldId] = formatConverter.GetValidNullValue(that.id2Info[fieldId].baseType)
                }
              }
            })
          }
        }
      }
      // 数据项验证
      // console.log(modifyReportJson)
      if (skipValidation || this.CheckSubmitData(modifyReportJson, 'modify', skipRequire)) {
        // 剔除空行
        var recordWithData = false
        var len, i, fieldValue
        for (dataSheetId in modifyReportJson) {
          if (this.dataSheets[dataSheetId.replace('_add', '')] !== undefined) {
            if (this.dataSheets[dataSheetId.replace('_add', '')].type > 0) {
              len = modifyReportJson[dataSheetId].length
              for (i = len - 1; i >= 0; i--) {
                for (fieldValue in modifyReportJson[dataSheetId][i]) {
                  if (modifyReportJson[dataSheetId][i][fieldValue]) {
                    recordWithData = true
                    break
                  }
                }
                // console.log(recordWithData)
                if (!recordWithData) {
                  modifyReportJson[dataSheetId].splice(i, 1)
                }
                recordWithData = false
              }
            }
          }
        }
        // 删除空表
        for (dataSheetId in modifyReportJson) {
          if (dataSheetId === 'ticket') {
            continue
          }
          if (modifyReportJson[dataSheetId].length === 0 && this.dataSheets[dataSheetId.replace('_add', '')].type !== 0) {
            delete modifyReportJson[dataSheetId]
          }
        }
        await this.UploadFiles()
        return modifyReportJson
      } else {
        this.ChangeLoadingStatus(false)
        return false
      }
    },

    GetWholeData: async function(detailTableWithBlankRow) {
      console.time('取整表数据')
      var dataJson = {}
      var that = this
      var dataSheetId
      for (dataSheetId in this.dataSheets) {
        console.time(dataSheetId + '取值')
        if (this.dataSheets[dataSheetId].type === 0) {
          dataJson[dataSheetId] = this.GetDataFromMasterTable()
        } else {
          // 扩展表取值
          dataJson[dataSheetId] = extendFunctions.deepCopy(this.GetDataFromExtendTable(dataSheetId, undefined, undefined, detailTableWithBlankRow))
          for (var fieldId in this.dataSheets[dataSheetId].fields) {
            dataJson[dataSheetId].forEach(dataRow => {
              if (!dataRow[fieldId]) {
                dataRow[fieldId] = formatConverter.GetValidNullValue(that.id2Info[fieldId].baseType)
              }
            })
          }
        }
        console.timeEnd(dataSheetId + '取值')
      }
      console.timeEnd('取整表数据')
      return dataJson
    },

    dataURLtoFile(dataurl, filename) {
      // eslint-disable-next-line no-undef
      const mime = arr[0].match(/:(.*?);/)[1]
      // eslint-disable-next-line no-undef
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },

    async compress(file, width, height, ratio) {
      return new Promise((resolve, reject) => {
        if (ratio === 1) {
          resolve(file.obj)
        } else if (file.obj.type === 'image/gif' || file.obj.type.split('/')[0] !== 'image') {
          resolve(file.obj)
        } else {
          const that = this
          const fileObj = file.obj
          const reader = new FileReader()
          reader.readAsDataURL(fileObj)
          reader.onload = function(e) {
            const image = new Image()
            image.src = e.target.result
            image.onload = function() {
              const canvas = document.createElement('canvas')
              const context = canvas.getContext('2d')
              let data = ''
              context.drawImage(image, 0, 0, width, height)
              data = canvas.toDataURL('image/jpeg', ratio)
              resolve(that.dataURLtoFile(data, fileObj.name))
            }
          }
        }
      })
    },

    UploadFiles: async function() {
      // 检查未上传的文件
      // if (+localStorage.uploadWarning !== 0) {
      //   await this.$uploadConfirm()
      // }
      if (!this.uploadFileList || !this.uploadFileList.length) {
        return
      }
      console.time('上传文件')
      // 上传文件
      const loading = this.$loading({
        lock: true,
        text: `${this.$t('report.uploading')}(0/${this.uploadFileList.length})`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      for (var i = 0; i < this.uploadFileList.length; i++) {
        console.log(this.uploadFileList[i])
        loading.text = `${this.$t('report.uploading')}(${i}/${this.uploadFileList.length})`
        const param = new FormData()
        // const f = await this.compress(this.uploadFileList[i], 1000, 1000, +localStorage.quality)
        // console.log(f)
        param.append('file', this.uploadFileList[i].obj, this.uploadFileList[i].name)
        await updateEmptyFile(this.uploadFileList[i].id, param)
      }
      loading.close()
      this.uploadFileList = []
      console.timeEnd('上传文件')
    },

    getImageRatio(url) {
      return new Promise(resolve => {
        const img = new Image()
        img.onload = () => {
          resolve(img.naturalWidth / img.naturalHeight)
        }
        img.src = url
      })
    },

    getCurrentImageRatio(imageId) {
      return largeFile.localImageRatio[imageId]
    },

    async liveUploadFiles(length, notification) {
      try {
        this.uploadingFile = true
        length = length || 1
        var handleFile = this.uploadFileList.shift()
        var fileUploadContent = `${this.$t('report.completed')}(${length}/${this.uploadFileList.length + length})...`
        if (length === 1) {
          notification = this.$notify.info({
            title: this.$t('report.uploadSelect'),
            message: fileUploadContent,
            duration: 0,
            showClose: false
          })
        } else {
          notification.message = fileUploadContent
        }
        const param = new FormData()
        param.append('file', handleFile.obj, handleFile.name)
        var config = {
          onUploadProgress: progressEvent => {
            var progressPersent = (progressEvent.loaded / progressEvent.total * 100 | 0)
            notification.message = `${this.$t('report.completed')} ${progressPersent}% (${length}/${this.uploadFileList.length + length})...`
          }
        }
        var uploadResult = await updateEmptyFile(handleFile.id, param, config)
        if (uploadResult.status >= 200 && uploadResult.status < 300) {
          if (uploadResult.data.fileType.indexOf('Image') >= 0) {
            largeFile.localImageRatio[handleFile.id] = await this.getImageRatio(extendFunctions.getFileURL(handleFile.obj))
          }
          // console.log(largeFile.localImageRatio[handleFile.id])
          if (this.uploadFileList.length > 0) {
            await this.liveUploadFiles(++length, notification)
          } else {
            notification.close()
            this.$notify({
              title: this.$t('status.success'),
              message: this.$t('report.uploaded'),
              type: 'success'
            })
            this.uploadingFile = false
          }
        } else {
          extendFunctions.errorMessage(this.$t('report.uploadFail') + uploadResult.data)
          this.uploadingFile = false
        }
      } catch (ex) {
        extendFunctions.errorMessage(this.$t('report.uploadFail'))
        this.uploadingFile = false
        console.error(ex.toString())
      }
    },

    supplyAttachFile: function(data) {
      this.showFileSelector({ type: 'supply', data: data })
    },

    // 判断提交的数据是否合法
    CheckSubmitData: function(formJSON, submitModel, skipRequire) {
      var returnMessage = []
      var dataSheetId, fieldId, record, isBlankRow, currentDataSheetId, fieldValue, reg // , serialInfo, skipSubmit
      // 检查操作约束
      var controlRoleList = this.controlRoles.filter(role => (role.operation & 2) === 2)
      if (controlRoleList && controlRoleList.length) {
        var roleList = []
        controlRoleList.forEach(item => {
          roleList.push(item.id)
        })
        var result = this.controlRoleHelper(roleList)
        if (result) {
          extendFunctions.errorMessage(result === 'no_message' ? '不满足操作约束，保存失败！' : result)
          return false
        }
      }
      // 判断扩展表必填情况
      try {
        this.requiredTableList.forEach(id => {
          id = submitModel === 'modify' ? (id + '_add') : id
          if (!formJSON[id] || formJSON[id].length === 0) {
            throw new Error()
          }
        })
      } catch (ex) {
        extendFunctions.errorMessage('明细数据需要填写至少一条记录！')
        return false
      }
      for (dataSheetId in formJSON) {
        currentDataSheetId = dataSheetId
        if (submitModel === 'modify') {
          if (dataSheetId.indexOf('_del') >= 0 || dataSheetId === 'ticket') {
            continue
          }
          if (dataSheetId.indexOf('_add') >= 0) {
            currentDataSheetId = dataSheetId.replace('_add', '')
          }
        }
        // 按字段进行判断
        if (this.dataSheets[currentDataSheetId].type >= 1) {
          // 本表组合唯一
          var command = 'SELECT DISTINCT '
          var primaryFields = ''
          var localPrimaryList = this.dataSheets[currentDataSheetId].children.filter(fieldInfo => {
            if (fieldInfo.localPrimary) {
              command += `[${fieldInfo.id}],`
              primaryFields += fieldInfo.name + ','
            }
            return fieldInfo.localPrimary
          })
          if (localPrimaryList.length > 0) {
            command = command.substring(0, command.length - 1)
            command += ` FROM ?`
            var selectResult = alasql(command, [formJSON[dataSheetId]])
            if (selectResult.length < formJSON[dataSheetId].length) {
              returnMessage.push(primaryFields.substring(0, primaryFields.length - 1) + this.$t('report.duplicate'))
              extendFunctions.errorMessage(returnMessage.join(','))
              return false
            }
          }
          // 本表单独唯一
          var localUniqueList = this.dataSheets[currentDataSheetId].children.filter(fieldInfo => fieldInfo.localUnique)
          if (localUniqueList.length) {
            localUniqueList.forEach(fieldInfo => {
              if (returnMessage.length) {
                return false
              }
              var valueTempArray = []
              // 插入数据并做重复判断
              formJSON[dataSheetId].forEach(row => {
                if (returnMessage.length) {
                  return false
                }
                if (valueTempArray.find(x => x === row[fieldInfo.id])) {
                  returnMessage.push(`${fieldInfo.name}${this.$t('report.duplicateValue')}'${row[fieldInfo.id] ? row[fieldInfo.id].toString() : '空值'}'`)
                  extendFunctions.errorMessage(returnMessage.join(','))
                } else {
                  valueTempArray.push(row[fieldInfo.id])
                }
              })
            })
            if (returnMessage.length) {
              return false
            }
          }
        }
        if (this.dataSheets[currentDataSheetId].type === 2) {
          // 判断交叉表是否左侧上方均有值
          var leftSideFieldId = []
          var topSideFieldId = []
          var centerFieldId
          for (var fieldInfo of this.dataSheets[currentDataSheetId].children) {
            switch (fieldInfo.extType) {
              case 1:
                leftSideFieldId.push(+fieldInfo.id)
                break
              case 2:
                topSideFieldId.push(+fieldInfo.id)
                break
              case 3:
                centerFieldId = +fieldInfo.id
                break
            }
          }
          var errorTag
          for (record of formJSON[dataSheetId]) {
            if (record[centerFieldId]) {
              errorTag = true
              for (var leftFieldId of leftSideFieldId) {
                if (record[leftFieldId]) {
                  errorTag = false
                }
              }
              if (errorTag) {
                extendFunctions.errorMessage(`${this.$t('report.crosstab')}${this.dataSheets[currentDataSheetId].name}${this.$t('report.dataFormatError')}`)
                return false
              }
              errorTag = true
              for (var topFieldId of topSideFieldId) {
                if (record[topFieldId]) {
                  errorTag = false
                }
              }
              if (errorTag) {
                extendFunctions.errorMessage(`${this.$t('report.crosstab')}${this.dataSheets[currentDataSheetId].name}${this.$t('report.dataFormatError')}`)
                return false
              }
            } else {
              if (!(record.row >= 0 && record.col >= 0)) {
                extendFunctions.errorMessage(`${this.$t('report.crosstab')}${this.dataSheets[currentDataSheetId].name}${this.$t('report.dataFormatError')}`)
                return false
              }
            }
          }
        }
        // 按行进行判断
        for (record in formJSON[dataSheetId]) {
          isBlankRow = true
          for (fieldValue in formJSON[dataSheetId][record]) {
            if (formJSON[dataSheetId][record][fieldValue]) {
              isBlankRow = false
              break
            }
          }
          if (isBlankRow && this.dataSheets[currentDataSheetId].type !== 0) {
            continue
          }
          for (fieldId in this.dataSheets[currentDataSheetId].fields) {
            var value = formJSON[dataSheetId][record][fieldId]
            if (this.dataSheets[currentDataSheetId].fields[fieldId].required && !skipRequire) {
              if (value === undefined || value === '' ||
                value === null || (value === 0 &&
                  this.dataSheets[currentDataSheetId].fields[fieldId].baseType === 3)) {
                if (this.templateRole.disableField && this.templateRole.disableField.indexOf(+fieldId) > -1) {
                  continue
                }
                if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.operAreaArray) {
                  if (this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId) > -1) {
                    if (this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo) {
                      returnMessage.push(this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo)
                    } else {
                      returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.isRequired'))
                    }
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                } else {
                  if (this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo) {
                    returnMessage.push(this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo)
                  } else {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.isRequired'))
                  }
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
              }
            }
            // 根据数据类型判断是否合法
            switch (this.dataSheets[currentDataSheetId].fields[fieldId].baseType) {
              case 1:
                if (value === '$max_length$') {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.exceedLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 3:
                if (value === -2147483647) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.digitsLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                } else if (value === -2147483648) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mustNumber'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 4:
                if (!(new Date(value) instanceof Date)) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mustDate'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                } else if (value === 'error') {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalDate'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 5:
              case 6:
                if (value && value.toString().length >
                  (this.dataSheets[currentDataSheetId].fields[fieldId].fieldLength || 500)) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.contentLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
            }
            // 根据字段样式判断是否合法
            if (value) {
              switch (this.dataSheets[currentDataSheetId].fields[fieldId].dataType) {
                case 103:
                  // 身份证
                  reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalID'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 104:
                  // 邮箱
                  reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalEmail'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 105:
                  // 手机号码
                  reg = /^1\d{10}$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mobileVaild'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 106:
                  // 电话号码
                  reg = /^0\d{2,3}-?\d{7,8}$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.phoneVaild'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
              }
            }
          }
        }
      }
      if (returnMessage.length > 0) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(returnMessage.join(','))
        return false
      } else {
        return true
      }
    },

    // 获取编辑锁
    GetToken: async function(systemVariables, recordId) {
      try {
        var ticket = await getReportTicket(recordId === 0 ? 0 : this.recordId)
        if (ticket.status >= 200 && ticket.status < 300) {
          this.editTicket = ticket.data
          if (this.useRouter) {
            this.$store.dispatch('setTicket', this.editTicket)
          }
          this.UnLockWhiteListRanges()
          // 数据规范
          await this.BuildDataSpec()
          // 合并单元格
          for (var sheetId in this.dataSheets) {
            this.MergeSameField(sheetId)
          }
          // 执行取数公式
          await this.InitQueryFormula()
        } else {
          extendFunctions.errorMessage(this.$t('report.openReportFailed') + this.$t('report.editState'))
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.openReportFailed'), exception)
        this.UnRegistDataSpec()
        this.$emit('ChangeFormEditStatus', 11)
        this.ChangeLoadingStatus(false)
        this.RefreshUserRole(11)
        this.editModel = 2
        this.InitConnectInfos(false)
        this.InitReportLinkInfos()
        this.GetTemplateActionInfo()
        // 保存完毕后刷新单据，用来刷新条码
        // this.spreadSheet._controller.onScroll()
      }
    },
    // 解除编辑锁
    DropToken: function() {
      if (this.formEditStatus === 10 && !this.useRouter) {
        reportOperation(this.templateId, this.recordId, 'close')
      }
      if (this.editTicket !== undefined && this.editTicket !== null) {
        dropReportTicket(this.editTicket).then(response => {
          if (response.status >= 200 && response.status < 300) {
            this.editTicket = undefined
          } else {
            extendFunctions.errorMessage(this.$t('report.editLockError') + this.$t('report.editLockError1'))
          }
        }).catch(exception => {
          extendFunctions.errorMessage(this.$t('report.editLockError') + this.$t('report.unknown'))
        })
      } else {
        return true
      }
    },
    // 整理用户打印导出权限
    RefreshUserRole(targetRoleId) {
      if (this.templateRole) {
        switch (targetRoleId || this.formEditStatus) {
          case 11:
          case 20:
          case 50:
            this.$emit('ChangeRole', 'print', this.templateRole.print)
            this.$emit('ChangeRole', 'output', this.templateRole.export)
            break
          case 10:
          case 12:
          case 30:
          case 40:
            this.$emit('ChangeRole', 'print', this.templateRole.print)
            this.$emit('ChangeRole', 'output', this.templateRole.export)
            break
          default:
            this.$emit('ChangeRole', 'print', false)
            this.$emit('ChangeRole', 'output', false)
            break
        }
        this.$emit('ChangeRole', 'modify', this.templateRole.modify)
      } else {
        this.$emit('ChangeRole', 'print', false)
        this.$emit('ChangeRole', 'output', false)
      }
    },

    // *********************
    // *******数据规范*******
    // *********************
    // 创建数据规范按钮
    async BuildDataSpec() {
      console.time('处理数据规范')
      this.specificationList.ListView.forEach(listViewInfo => {
        var handleRange = this.spreadSheet.sheetByName(listViewInfo.sheetName).range(formatConverter.ConvertJsonToRange(this.GetNameRangeJson(listViewInfo.areaAlias)))
        if (handleRange.listView()) {
          var lists = handleRange.listView()
          lists.push(extendFunctions.deepCopy(listViewInfo))
          handleRange.listView(lists)
        } else {
          handleRange.listView([extendFunctions.deepCopy(listViewInfo)])
        }
      })
      this.specificationList.DropDown.forEach(dropDownInfo => {
        this.spreadSheet.sheetByName(dropDownInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dropDownInfo.areaAlias)))
          .dropDown(extendFunctions.deepCopy(dropDownInfo))
      })
      this.specificationList.DateTime.forEach(dateTimeInfo => {
        this.spreadSheet.sheetByName(dateTimeInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dateTimeInfo.areaAlias)))
          .dateTime(extendFunctions.deepCopy(dateTimeInfo))
      })
      this.specificationList.Location.forEach(locationInfo => {
        this.spreadSheet.sheetByName(locationInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(locationInfo.areaAlias)))
          .location(extendFunctions.deepCopy(locationInfo))
      })
      this.specificationList.Cascader.forEach(CascaderInfo => {
        this.spreadSheet.sheetByName(CascaderInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(CascaderInfo.areaAlias)))
          .cascader({
            cascaderId: CascaderInfo.cascaderId,
            allowMiddle: CascaderInfo.allowMiddle,
            fieldId: CascaderInfo.fieldId
          })
      })
      console.timeEnd('处理数据规范')
    },

    // 注销数据规范
    UnRegistDataSpec() {
      var that = this
      this.specificationList.ListView.forEach(listViewInfo => {
        that.spreadSheet.sheetByName(listViewInfo.sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(listViewInfo.areaAlias))).listView(null)
      })
      this.specificationList.DropDown.forEach(dropDownInfo => {
        that.spreadSheet.sheetByName(dropDownInfo.sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(dropDownInfo.areaAlias))).dropDown(null)
      })
      this.specificationList.DateTime.forEach(dateTimeInfo => {
        that.spreadSheet.sheetByName(dateTimeInfo.sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(dateTimeInfo.areaAlias))).dateTime(null)
      })
      this.specificationList.Cascader.forEach(cascaderInfo => {
        that.spreadSheet.sheetByName(cascaderInfo.sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(cascaderInfo.areaAlias))).cascader(null)
      })
      this.specificationList.Location.forEach(locationInfo => {
        that.spreadSheet.sheetByName(locationInfo.sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(locationInfo.areaAlias))).location(null)
      })
    },

    hideDataSpec() {
      for (var sheetId in this.dataSheets) {
        if (this.dataSheets[sheetId].type >= 1) {
          var tableRange = formatConverter.ConvertJsonToRange(this.GetNameRangeJson(this.dataSheets[sheetId].areaAlias))
          this.spreadSheet.sheetByName(this.dataSheets[sheetId].sheetName).range(tableRange).showController(false)
        }
      }
    },

    registSwitch() {
      // TODO:batch处理
      var sheets = {}
      this.specificationList.Switch.forEach(switchInfo => {
        if (!sheets[switchInfo.sheetName]) {
          sheets[switchInfo.sheetName] = []
        }
        sheets[switchInfo.sheetName].push(extendFunctions.deepCopy(switchInfo))
      })
      for (var sheetName in sheets) {
        this.spreadSheet.sheetByName(sheetName).batch(() => {
          sheets[sheetName].forEach(setting => {
            this.spreadSheet.sheetByName(sheetName).range(
              formatConverter.ConvertJsonToRange(this.GetNameRangeJson(setting.areaAlias)))
              .switch(extendFunctions.deepCopy(setting))
          })
        })
      }
    },

    registSelector() {
      this.specificationList.Selector.forEach(async SelectorInfo => {
        if (SelectorInfo.source === 1) {
          var output = await getSelectorSpecsOutput(SelectorInfo.specId, SelectorInfo.fieldId)
          SelectorInfo.values = output.data
        }
        this.spreadSheet.sheetByName(SelectorInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(SelectorInfo.areaAlias)))
          .selector(extendFunctions.deepCopy(SelectorInfo))
      })
    },

    registProgress() {
      this.specificationList.Progress.forEach(ProgressInfo => {
        this.spreadSheet.sheetByName(ProgressInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(ProgressInfo.areaAlias)))
          .progress(extendFunctions.deepCopy(ProgressInfo))
      })
    },

    registRate() {
      var shape = {
        101: 'star',
        102: 'face',
        103: 'heart',
        104: 'medal',
        105: 'like'
      }
      var color = ['red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'purple']
      this.specificationList.Rate.forEach(rateInfo => {
        this.spreadSheet.sheetByName(rateInfo.sheetName).range(
          formatConverter.ConvertJsonToRange(this.GetNameRangeJson(rateInfo.areaAlias)))
          .rate({
            color: color[rateInfo.display.themeColor],
            shape: shape[rateInfo.shape],
            showScore: rateInfo.display.showNumber,
            enable: rateInfo.enable
          })
      })
    },

    // async initReportBarCode() {
    //   // 条码辅助
    //   console.time('初始化条码')
    //   var bindingInfo = await getBindingBarCodeInfo(this.$store.getters.userId, this.templateId)
    //   this.barCodeBindingInfo = bindingInfo.data
    //   console.timeEnd('初始化条码')
    // },
    CreateBarCode(barCodeInfo) {
      var barCodeBase = this.barCodeBindingInfo.find(info => { return barCodeInfo.id === info.id })
      if (barCodeBase) {
        switch (barCodeBase.function) {
          case 1:
          case 2:
          case 3:
            barCodeInfo.value = `|${barCodeBase.function}&${barCodeInfo.id}&${this.templateId}&${barCodeBase.templateId}&${this.recordId >= 0 ? this.recordId : 0}&&${barCodeBase.targetMode ? 1 : 0}`
            break
          case 4:
            if (!barCodeInfo.value && barCodeInfo.value !== 0) {
              return { url: null }
            }
            break
        }
        return barCode.createBarCode(barCodeBase, barCodeInfo.value || '', barCodeInfo.setting)
      } else {
        return { url: null }
      }
    },

    async initCascaderData(fieldId) {
      // 取参传参获取结果数据
      var handleCascader = this.specificationList.Cascader.filter(cascaderInfo => {
        return cascaderInfo.fieldId === fieldId
      })[0]
      this.cascaderData = null
      var activeCell = formatConverter.ConvertAllFormat2Json(this.spreadSheet.activeSheet().selection()._ref, this)
      var params = {}
      params.param = this.GetParamWithFieldId(handleCascader.params, activeCell)
      params.id = handleCascader.cascaderId
      params.fieldId = fieldId
      var cacheable = handleCascader.cache
      var cache = this.specCache.Cascader
      if (cacheable) {
        if (cache[handleCascader.cascaderId]) {
          console.time('查找缓存')
          var cacheValue = cache[handleCascader.cascaderId].find(item => item.params === JSON.stringify(params))
          if (cacheValue) {
            this.cascaderData = cacheValue.value
          }
          console.timeEnd('查找缓存')
        } else {
          cache[handleCascader.cascaderId] = []
        }
      }
      if (!this.cascaderData) {
        try {
          var cascaderOutput = await getCascaderSpecsOutput(params)
          if (cascaderOutput.status === 200) {
            this.cascaderData = cascaderOutput.data
            if (cacheable) {
              cache[handleCascader.cascaderId].push({
                params: JSON.stringify(params),
                value: cascaderOutput.data
              })
            }
          }
        } catch (exception) {
          extendFunctions.errorMessage(this.$t('report.cascadError'))
        }
      }
      console.time('构建')
      var result = this.handleCascaderData(fieldId, [])
      console.timeEnd('构建')
      console.log(result)
      return result
    },

    handleCascaderData(fieldId, selections) {
      // 判断数据来源类型
      var handleCascader = this.specificationList.Cascader.filter(cascaderInfo => {
        return cascaderInfo.fieldId === fieldId
      })[0]
      var replaceAll = (str) => {
        if (typeof str === 'string') {
          return `'${str.replace(/'/g, "''")}'`
        } else {
          return str
        }
      }
      var nextLevelItems = []
      var data, i
      switch (handleCascader.sourceType) {
        case 0:
          // 列表
          // 当前选择数据所在的层级
          var currentLevel = selections.length
          // 当前选择数据所在层级的ID
          var currentLevelId = handleCascader.level2ColumnId[currentLevel]
          var cascaderQuery = `[${currentLevelId}] IS NOT NULL AND [${currentLevelId}] <> ''`
          selections.forEach((selectInfo, index) => {
            const handleLevelId = handleCascader.level2ColumnId[index]
            if (this.cascaderData.length && typeof this.cascaderData[0][handleLevelId] !== 'string') {
              try {
                selectInfo.value = parseFloat(selectInfo.value)
              } catch (ex) {
                console.error(ex)
              }
            }
            cascaderQuery += ` AND [${handleLevelId}]=${replaceAll(selectInfo.value)}`
          })
          // 获取层级数据
          var currentLevelData = alasql(`SELECT DISTINCT [${currentLevelId}] FROM ? WHERE ${cascaderQuery}`, [this.cascaderData])
          var currentLevelDataArr = []
          var maxLevel = handleCascader.columns.filter(columnInfo => { return (columnInfo.level >= 0 && columnInfo.level !== null) }).length - 1
          var canSelect, rowData
          currentLevelData.forEach(data => {
            var lastLevel = false
            var childDataCollection = alasql(`SELECT DISTINCT * FROM ? WHERE ${cascaderQuery} AND [${currentLevelId}]=${replaceAll(data[currentLevelId])}`, [this.cascaderData])
            canSelect = false
            // 判断自身是否可选
            for (var i = 0; i < childDataCollection.length; i++) {
              var compareData = ''
              for (var j = currentLevel + 1; j <= maxLevel; j++) {
                compareData += childDataCollection[i][handleCascader.level2ColumnId[j]]
              }
              if (!compareData) {
                canSelect = true
                rowData = childDataCollection[i]
                break
              }
            }
            if (childDataCollection.length === 1 && canSelect) {
              lastLevel = true
            }
            // 判断该节点是否可被选择
            currentLevelDataArr.push({
              label: data[currentLevelId],
              value: data[currentLevelId],
              lastLevel: lastLevel,
              canSelect: canSelect,
              rowData: rowData
            })
          })
          return currentLevelDataArr
        case 1:
          // 树形
          var parentColumnId = handleCascader.columns.filter(column => { return column.parent })[0].id
          var currentColumnId = handleCascader.columns.filter(column => { return column.child })[0].id
          var displayColumnId = handleCascader.columns.filter(column => { return column.show })[0].id
          data = this.cascaderData
          if (selections.length === 0) {
            var firstLevelItems = []
            data.filter(item1 => { return data.filter(item2 => { return item1[parentColumnId] === item2[currentColumnId] }).length === 0 }).forEach(row => {
              firstLevelItems.push({
                label: row[displayColumnId],
                value: row[currentColumnId],
                lastLevel: data.filter(item => { return item[parentColumnId] === row[currentColumnId] }).length === 0,
                canSelect: handleCascader.allowMiddle,
                rowData: row
              })
            })
            return firstLevelItems
          } else {
            var currentValue = selections.pop().value
            // 为了解决类型对应问题，使用双等号，勿改动
            /*eslint eqeqeq: off*/
            data.filter(item => { return item[parentColumnId] == currentValue && item[parentColumnId] !== item[currentColumnId] }).forEach(row => {
              nextLevelItems.push({
                label: row[displayColumnId],
                value: row[currentColumnId],
                lastLevel: data.filter(item => { return item[parentColumnId] === row[currentColumnId] && row[parentColumnId] !== item[currentColumnId] }).length === 0,
                canSelect: handleCascader.allowMiddle,
                rowData: row
              })
            })
            return nextLevelItems
          }
        case 2:
          var splitField = handleCascader.columns.find(col => col.option)
          var labelField = handleCascader.columns.find(col => col.show)
          if (!splitField || !labelField) {
            extendFunctions.errorMessage('分级字段信息缺失！')
            return nextLevelItems
          }
          var splitInfo = JSON.parse(splitField.option).split.split(',')
          var sum = 0
          for (i = 0; i < splitInfo.length; i++) {
            splitInfo[i] = parseInt(splitInfo[i])
            sum += parseInt(splitInfo[i])
            splitInfo[i] = sum
          }
          i = selections.length
          data = i === 0 ? this.cascaderData.filter(row => row[splitField.id].length === splitInfo[0]) : this.cascaderData.filter(row => row[splitField.id].length === splitInfo[i] && row[splitField.id].substr(0, splitInfo[i - 1]) === selections[i - 1].value)
          data.forEach(row => {
            nextLevelItems.push({
              label: row[labelField.id],
              value: row[splitField.id],
              lastLevel: this.cascaderData.filter(row2 => row2[splitField.id].length === splitInfo[i + 1] && row2[splitField.id].substr(0, splitInfo[i]) === row[splitField.id]).length === 0,
              canSelect: true,
              rowData: row
            })
          })
          return nextLevelItems
      }
    },

    handleCascaderSelect(fieldId, handleRange, selectionData) {
      var handleCascader = this.specificationList.Cascader.filter(cascaderInfo => {
        return cascaderInfo.fieldId === fieldId
      })[0]
      var sourceTableInfo = this.dataSheets[this.id2DataSheets[fieldId]]
      this.connectInsert(sourceTableInfo, handleCascader.mapping, [selectionData], formatConverter.ConvertAllFormat2Json(handleRange, this))
    },

    cleanCascaderMappingData(fieldId, effectRangeJson) {
      var mappingInfo = this.specificationList.Cascader.find(cascaderInfo => {
        return cascaderInfo.fieldId === fieldId
      }).mapping
      this.CleanMappingRange(mappingInfo, this.dataSheets[this.id2DataSheets[fieldId]], effectRangeJson)
    },

    // 生成自动编号
    // model=create为打开时执行，model=save为保存时执行
    async CreateSerial(model, targetType, target) {
      console.log('开始获取自动编号')
      var serialGetInfos = []
      let i, serialInfo
      var serialGetNum = 1
      for (serialInfo of this.specificationList.Serial) {
        serialGetInfos.push(serialInfo)
      }
      if (serialGetInfos.length === 0) {
        return
      }
      for (serialInfo of serialGetInfos) {
        var dataSheetType = this.dataSheets[serialInfo.dataSheetId].extType
        var fieldExtType = this.id2Info[serialInfo.fieldId].extType
        if (this.dataSheets[serialInfo.dataSheetId].type === 0) {
          // 主表
          if (model === 'create' && !serialInfo.single) {
            continue
          }
          const masterFiledValue = this.GetDataFromMasterTable(serialInfo.fieldId)
          if (masterFiledValue && !this.temporaryId) {
            continue
          }
        } else {
          // 扩展表
          // 获取需要生成的自动编号个数
          var sideFieldList = []
          switch (fieldExtType) {
            case 1:
            case 2:
              this.dataSheets[serialInfo.dataSheetId].children.filter(fieldInfo => {
                return fieldInfo.extType === fieldExtType
              }).forEach(fieldInfo => {
                sideFieldList.push(fieldInfo.id)
              })
              break
            case 3:
              continue
          }
          // var extendTableData = target[serialInfo.dataSheetId] || target[serialInfo.dataSheetId + '_add']
          var extendTableData
          if (this.dataSheets[serialInfo.dataSheetId].extType !== 3) {
            extendTableData = this.GetDataFromExtendTable(serialInfo.dataSheetId)
          } else {
            var fieldIdList = []
            this.dataSheets[serialInfo.dataSheetId].children.filter(field => field.extType === fieldExtType).forEach(field => {
              fieldIdList.push(+field.id)
            })
            extendTableData = this.GetDataFromExtendTable(serialInfo.dataSheetId, undefined, fieldIdList)
          }
          if (!extendTableData) {
            return
          }
          var recordWithData = false
          var len = extendTableData.length
          var createRowRecord = []
          for (i = 0; i < len; i++) {
            if ((this.temporaryId && model === 'create') || !extendTableData[i][serialInfo.fieldId]) {
              recordWithData = false
              for (var fieldId in extendTableData[i]) {
                if ((!this.id2Info[fieldId]) || this.id2Info[fieldId].specType === 5) {
                  continue
                }
                if (extendTableData[i][fieldId]) {
                  recordWithData = true
                  break
                }
              }
              if (recordWithData) {
                if (dataSheetType <= 2) {
                  createRowRecord.push(extendTableData[i].index)
                } else {
                  switch (fieldExtType) {
                    case 1:
                      createRowRecord.push(extendTableData[i].row)
                      break
                    case 2:
                      createRowRecord.push(extendTableData[i].col)
                      break
                    default:
                      return false
                  }
                }
              }
            }
          }
          serialGetNum = createRowRecord.length
        }
        if (serialGetNum === 0) {
          continue
        }
        var serialResult = await getSerialOutput(serialInfo.specId, {
          num: serialGetNum,
          recordId: this.recordId,
          templateId: this.templateId,
          fieldId: serialInfo.fieldId
        })
        if (serialResult.status >= 200 && serialResult.status < 300) {
          if (this.recordId < 0 && this.recordId !== serialResult.data.relationId) {
            this.recordId = serialResult.data.relationId
            if (!this.dialogModel) {
              this.$store.dispatch('setRecordId', this.recordId)
            }
          }
          if (serialResult.data.data.length > 0) {
            var targetFieldInfo = this.dataSheets[serialInfo.dataSheetId].fields[serialInfo.fieldId]
            if (this.dataSheets[serialInfo.dataSheetId].type === 0) {
              const insertFields = {}
              var insertValue = formatConverter.GetValidValue(serialResult.data.data[0], targetFieldInfo.baseType, targetFieldInfo.fieldLength, targetFieldInfo.scale)
              insertFields[serialInfo.fieldId] = insertValue
              console.log(serialInfo, [insertFields])
              this.InsertMasterFieldValue(serialInfo.dataSheetId, [insertFields])
              if (targetType) {
                target[serialInfo.dataSheetId][0][serialInfo.fieldId] = insertValue
              }
            } else {
              // 向扩展表填值
              var fieldRangeJson, count
              switch (dataSheetType) {
                case 1:
                  // 向下扩展
                  fieldRangeJson = this.GetNameRangeJson(serialInfo.areaAlias)
                  this.spreadSheet.sheetByName(serialInfo.sheetName).batch(function() {
                    count = 0
                    createRowRecord.forEach(i => {
                      this._workbook.sheetByName(serialInfo.sheetName).range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: fieldRangeJson.topLeft.row + i,
                          col: fieldRangeJson.topLeft.col
                        },
                        bottomRight: {
                          row: fieldRangeJson.topLeft.row + i,
                          col: fieldRangeJson.bottomRight.col
                        }
                      })).value(serialResult.data.data[count])
                      count++
                    })
                  })
                  break
                case 2:
                  // 向右扩展
                  fieldRangeJson = this.GetNameRangeJson(serialInfo.areaAlias)
                  this.spreadSheet.sheetByName(serialInfo.sheetName).batch(function() {
                    count = 0
                    createRowRecord.forEach(i => {
                      this._workbook.sheetByName(serialInfo.sheetName).range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: fieldRangeJson.topLeft.row,
                          col: fieldRangeJson.topLeft.col + i
                        },
                        bottomRight: {
                          row: fieldRangeJson.topLeft.row,
                          col: fieldRangeJson.bottomRight.col + i
                        }
                      })).value(serialResult.data.data[count])
                      count++
                    })
                  })
                  break
                case 3:
                  // 交叉表
                  fieldRangeJson = this.GetNameRangeJson(serialInfo.areaAlias)
                  var modifyFieldRangeJson
                  this.spreadSheet.sheetByName(serialInfo.sheetName).batch(function() {
                    count = 0
                    for (i = 0; i < len; i++) {
                      if (createRowRecord.indexOf(i) >= 0) {
                        var handleRow = extendTableData.find(row => {
                          switch (fieldExtType) {
                            case 1:
                              return row.row === i
                            case 2:
                              return row.col === i
                            default:
                              return false
                          }
                        })
                        if (!handleRow) {
                          break
                        }
                        switch (fieldExtType) {
                          case 1:
                            modifyFieldRangeJson = {
                              topLeft: {
                                row: fieldRangeJson.topLeft.row + handleRow.row,
                                col: fieldRangeJson.topLeft.col
                              },
                              bottomRight: {
                                row: fieldRangeJson.topLeft.row + handleRow.row,
                                col: fieldRangeJson.bottomRight.col
                              }
                            }
                            break
                          case 2:
                            modifyFieldRangeJson = {
                              topLeft: {
                                row: fieldRangeJson.topLeft.row,
                                col: fieldRangeJson.topLeft.col + handleRow.col
                              },
                              bottomRight: {
                                row: fieldRangeJson.bottomRight.row,
                                col: fieldRangeJson.topLeft.col + handleRow.col
                              }
                            }
                            break
                          case 3:
                            // 右下区域不支持
                            continue
                        }
                        this._workbook.sheetByName(serialInfo.sheetName).range(
                          formatConverter.ConvertJsonToRange(modifyFieldRangeJson)).value(serialResult.data.data[count])
                        count++
                      }
                    }
                  })
                  break
              }
              if (targetType) {
                var handleDataSheet
                if (targetType === 'new') {
                  handleDataSheet = serialInfo.dataSheetId
                } else if (targetType === 'modify') {
                  handleDataSheet = serialInfo.dataSheetId + '_add'
                }
                count = 0
                createRowRecord.forEach(index => {
                  var handleRow = target[handleDataSheet].filter(row => {
                    if (dataSheetType <= 2) {
                      return row.index === index
                    } else {
                      switch (fieldExtType) {
                        case 1:
                          return row.row === index
                        case 2:
                          return row.col === index
                        default:
                          return false
                      }
                    }
                  })
                  handleRow.forEach(row => {
                    row[serialInfo.fieldId] = formatConverter.GetValidValue(serialResult.data.data[count], targetFieldInfo.baseType, targetFieldInfo.fieldLength, targetFieldInfo.scale)
                  })
                  count++
                })
              }
              // for (i = 0; i < target[handleDataSheet].length; i++) {
              //   if (createRowRecord.indexOf(i) > -1) {
              //     target[handleDataSheet][i][serialInfo.fieldId] = serialResult.data.data[count]
              //     count++
              //   }
              // }
            }
          } else {
            extendFunctions.errorMessage('id：' + serialInfo.id + this.$t('report.automaticNmberError') + serialResult.data)
            console.error(serialResult)
          }
        }
      }
    },

    // 生成系统变量
    async CreateSystemVariables(model, targetType, target, systemVariables) {
      var variableGetInfos = []
      let i, variableInfo
      for (variableInfo of this.specificationList.System) {
        switch (model) {
          case 'create':
            if (this.dataSheets[variableInfo.dataSheetId].type === 0) {
              variableGetInfos.push(variableInfo)
            }
            break
          case 'save':
            variableGetInfos.push(variableInfo)
            break
        }
      }
      if (variableGetInfos.length === 0) {
        return
      }
      var variables = systemVariables || (await getSystemVariables()).data
      for (variableInfo of variableGetInfos) {
        if (this.dataSheets[variableInfo.dataSheetId].type === 0) {
          // 主表
          const masterFiledValue = this.GetDataFromMasterTable(variableInfo.fieldId)
          if (masterFiledValue) {
            continue
          } else {
            var insertObj = {}
            insertObj[variableInfo.fieldId] = variables[variableInfo.specId]
            this.InsertMasterFieldValue(variableInfo.dataSheetId, [insertObj])
            if (targetType) {
              target[variableInfo.dataSheetId][0][variableInfo.fieldId] = (variableInfo.specId === 3 || variableInfo.specId === 4) ? formatConverter.GetValidValue(variables[variableInfo.specId], 4) : variables[variableInfo.specId]
            }
          }
        } else {
          // 扩展表
          // 获取需要生成的自动编号个数
          var dataSheetType = this.dataSheets[variableInfo.dataSheetId].extType
          var fieldExtType = this.id2Info[variableInfo.fieldId].extType
          var fieldRangeJson
          var extendTableData = target[variableInfo.dataSheetId] || target[variableInfo.dataSheetId + '_add']
          if (!extendTableData) {
            return
          }
          var recordWithData = false
          var len = extendTableData.length
          for (i = 0; i < len; i++) {
            if (!extendTableData[i][variableInfo.fieldId]) {
              recordWithData = false
              for (var fieldId in extendTableData[i]) {
                if ((!this.id2Info[fieldId]) || this.id2Info[fieldId].specType === 5) {
                  continue
                }
                if (extendTableData[i][fieldId] !== '' && extendTableData[i][fieldId] !== null && extendTableData[i][fieldId] !== 0) {
                  recordWithData = true
                  break
                }
              }
              if (recordWithData) {
                extendTableData[i][variableInfo.fieldId] = (variableInfo.specId === 3 || variableInfo.specId === 4) ? formatConverter.GetValidValue(variables[variableInfo.specId], 4) : variables[variableInfo.specId]
                switch (dataSheetType) {
                  case 1:
                    // 向下扩展
                    fieldRangeJson = this.GetNameRangeJson(variableInfo.areaAlias)
                    this.spreadSheet.sheetByName(variableInfo.sheetName).batch(function() {
                      this._workbook.sheetByName(variableInfo.sheetName).range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: fieldRangeJson.topLeft.row + extendTableData[i].index,
                          col: fieldRangeJson.topLeft.col
                        },
                        bottomRight: {
                          row: fieldRangeJson.topLeft.row + extendTableData[i].index,
                          col: fieldRangeJson.bottomRight.col
                        }
                      })).value(variables[variableInfo.specId])
                    })
                    break
                  case 2:
                    // 向右扩展
                    fieldRangeJson = this.GetNameRangeJson(variableInfo.areaAlias)
                    this.spreadSheet.sheetByName(variableInfo.sheetName).batch(function() {
                      this._workbook.sheetByName(variableInfo.sheetName).range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: fieldRangeJson.topLeft.row,
                          col: fieldRangeJson.topLeft.col + extendTableData[i].index
                        },
                        bottomRight: {
                          row: fieldRangeJson.bottomRight.row,
                          col: fieldRangeJson.topLeft.col + extendTableData[i].index
                        }
                      })).value(variables[variableInfo.specId])
                    })
                    break
                  case 3:
                    // 交叉表
                    fieldRangeJson = this.GetNameRangeJson(variableInfo.areaAlias)
                    var modifyFieldRangeJson
                    if (fieldExtType === 3) {
                      // 右下区域不支持
                      continue
                    }
                    this.spreadSheet.sheetByName(variableInfo.sheetName).batch(function() {
                      switch (fieldExtType) {
                        case 1:
                          modifyFieldRangeJson = {
                            topLeft: {
                              row: fieldRangeJson.topLeft.row + extendTableData[i].row,
                              col: fieldRangeJson.topLeft.col
                            },
                            bottomRight: {
                              row: fieldRangeJson.topLeft.row + extendTableData[i].row,
                              col: fieldRangeJson.bottomRight.col
                            }
                          }
                          break
                        case 2:
                          modifyFieldRangeJson = {
                            topLeft: {
                              row: fieldRangeJson.topLeft.row,
                              col: fieldRangeJson.topLeft.col + extendTableData[i].col
                            },
                            bottomRight: {
                              row: fieldRangeJson.bottomRight.row,
                              col: fieldRangeJson.topLeft.col + extendTableData[i].col
                            }
                          }
                          break
                      }
                      this._workbook.sheetByName(variableInfo.sheetName).range(
                        formatConverter.ConvertJsonToRange(modifyFieldRangeJson)).value(variables[variableInfo.specId])
                    })
                    break
                }
              }
            }
          }
        }
      }
    },

    SetDateTime: function(dateTime, dateType) {
      console.log(dateType)
      var needMonth = dateType !== 'year'
      var needDay = dateType !== 'year' && dateType !== 'month'
      var needTime = dateType.toLowerCase().indexOf('time') > -1
      var convertDateTime = (dateJson) => {
        if (JSON.stringify(dateJson) === '{}') { return null }
        var dateNow = new Date()
        var dateStr = ''
        dateStr += dateJson.year === undefined ? dateNow.getFullYear() : dateJson.year
        dateStr += '-'
        dateStr += needMonth ? (dateJson.month === undefined ? (dateNow.getMonth() + 1) : dateJson.month) : '01'
        dateStr += '-'
        dateStr += needDay ? (dateJson.date === undefined ? dateNow.getDate() : dateJson.date) : '01'
        dateStr += ' '
        dateStr += needTime ? (dateJson.hours === undefined ? dateNow.getHours() : dateJson.hours) : '00'
        dateStr += ':'
        dateStr += needTime ? (dateJson.minutes === undefined ? dateNow.getMinutes() : dateJson.minutes) : '00'
        dateStr += ':'
        dateStr += needTime ? (dateJson.seconds === undefined ? dateNow.getSeconds() : dateJson.seconds) : '00'
        return dateStr
      }
      var cellInNameRanges = this.getSelectionNameRange(this.spreadSheet.activeSheet().selection())
      var rangeItem, dateTimeInfo
      if (cellInNameRanges.length >= 1) {
        rangeItem = cellInNameRanges[0]
      } else {
        return
      }
      var fieldInfo = this.name2IdInfo[rangeItem.name]
      var dateTimeInfos = this.specificationList.DateTime.filter(dateInfo => {
        return dateInfo.fieldId === fieldInfo.id
      })
      if (dateTimeInfos.length) {
        dateTimeInfo = dateTimeInfos[0]
      }
      var startDate = convertDateTime(dateTime[0])
      if (JSON.stringify(dateTime[1]) === '{}' && dateTimeInfo.single) {
        if (JSON.stringify(dateTime[0]) !== '{}') {
          this.spreadSheet.activeSheet().selection().input(startDate)
        } else {
          this.spreadSheet.activeSheet().selection().value(null)
        }
      } else {
        var endDate = convertDateTime(dateTime[1])
        var fieldValueArray = [{}]
        var dataTableInfo = this.dataSheets[fieldInfo.owner]
        var startDateFieldId, endDateFieldId
        for (var fieldId in dateTimeInfo.mapping) {
          if (+dateTimeInfo.mapping[fieldId] === 1) {
            startDateFieldId = fieldId
          }
          if (+dateTimeInfo.mapping[fieldId] === 2) {
            endDateFieldId = fieldId
          }
        }
        fieldValueArray[0][startDateFieldId] = startDate
        fieldValueArray[0][endDateFieldId] = endDate
        switch (dataTableInfo.type) {
          case 0:
            this.InsertMasterFieldValue(dataTableInfo.id, fieldValueArray)
            break
          case 1:
            // 扩展表
            var usedRowColumnCount = 0
            var sheetRange = this.GetNameRangeJson(dataTableInfo.areaAlias)
            var selectionJson = formatConverter.ConvertAllFormat2Json(this.spreadSheet.activeSheet().selection()._ref, this)
            if (dataTableInfo.extType === 1) {
              // 向下扩展
              usedRowColumnCount = selectionJson.topLeft.row - sheetRange.topLeft.row
            } else {
              // 向右扩展
              usedRowColumnCount = selectionJson.topLeft.col - sheetRange.topLeft.col
            }
            this.InsertData2ExtendTable(dataTableInfo.id, usedRowColumnCount, fieldValueArray)
            break
        }
      }
    },

    // 注册数值的数据验证
    RegistNumberValidation: function() {
      console.time('数值提供验证服务')
      const that = this
      for (var dataSheetId in this.dataSheets) {
        switch (this.dataSheets[dataSheetId].type) {
          case 0:
            // 主表
            for (var fieldId in this.dataSheets[dataSheetId].fields) {
              if (this.dataSheets[dataSheetId].fields[fieldId].baseType === 3) {
                this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].fields[fieldId].sheetName).batch(function() {
                  that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].fields[fieldId].sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias))).validation({
                    dataType: 'number',
                    showButton: true,
                    type: 'reject',
                    comparerType: 'greaterThan',
                    from: '-100000000000000',
                    allowNulls: true
                  })
                })
              }
            }
            break
          case 1:
            // 扩展表
            this.spreadSheet.sheetByName(this.dataSheets[dataSheetId].sheetName).batch(function() {
              for (var fieldId in that.dataSheets[dataSheetId].fields) {
                if (that.dataSheets[dataSheetId].fields[fieldId].baseType === 3) {
                  that.spreadSheet.sheetByName(that.dataSheets[dataSheetId].sheetName).range(formatConverter.ConvertJsonToRange(that.GetNameRangeJson(that.dataSheets[dataSheetId].fields[fieldId].areaAlias))).validation({
                    dataType: 'number',
                    showButton: true,
                    type: 'reject',
                    comparerType: 'greaterThan',
                    from: '-100000000000000',
                    allowNulls: true
                  })
                }
              }
            })
            break
        }
      }
      console.timeEnd('数值提供验证服务')
    },

    GetComboOutput: async function(dropDownInfo, activeCell) {
      var cache = this.specCache.DropDown
      var cacheable = dropDownInfo.cache
      var params = this.GetParamWithFieldId(dropDownInfo.params, formatConverter.ConvertAllFormat2Json(activeCell, this))
      if (cacheable) {
        if (cache[dropDownInfo.specId]) {
          console.time('查找缓存')
          var cacheValue = cache[dropDownInfo.specId].find(item => item.params === JSON.stringify(params))
          if (cacheValue) {
            console.timeEnd('查找缓存')
            return cacheValue.value
          }
        } else {
          cache[dropDownInfo.specId] = []
        }
      }
      var output = await getComboOutput(dropDownInfo.specId, params, dropDownInfo.fieldId)
      if (output.status >= 200 && output.status < 300) {
        if (this.id2Info[dropDownInfo.fieldId].baseType === 4) {
          var data = []
          output.data.forEach(singleDate => {
            switch (this.id2Info[dropDownInfo.fieldId].dataType) {
              case 401:
                // 2019
                data.push(formatConverter.ConvertDateTime('yyyy', new Date(singleDate)))
                break
              case 402:
                // 2019年
                data.push(formatConverter.ConvertDateTime('yyyy年', new Date(singleDate)))
                break
              case 403:
                // 2019-1
                data.push(formatConverter.ConvertDateTime('yyyy-M', new Date(singleDate)))
                break
              case 404:
                // 2019/1
                data.push(formatConverter.ConvertDateTime('yyyy/M', new Date(singleDate)))
                break
              case 405:
                // 2019年1月
                data.push(formatConverter.ConvertDateTime('yyyy年M月', new Date(singleDate)))
                break
              case 412:
                // 1月
                data.push(formatConverter.ConvertDateTime('M月', new Date(singleDate)))
                break
              case 406:
                // 2019-1-1
                data.push(formatConverter.ConvertDateTime('yyyy-M-d', new Date(singleDate)))
                break
              case 407:
                // 2019/1/1
                data.push(formatConverter.ConvertDateTime('yyyy/M/d', new Date(singleDate)))
                break
              case 408:
                // 2019年1月1日
                data.push(formatConverter.ConvertDateTime('yyyy年M月d日', new Date(singleDate)))
                break
              case 413:
                // 1-1
                data.push(formatConverter.ConvertDateTime('M-d', new Date(singleDate)))
                break
              case 414:
                // 1/1
                data.push(formatConverter.ConvertDateTime('M/d', new Date(singleDate)))
                break
              case 415:
                // 1月1日
                data.push(formatConverter.ConvertDateTime('M月d日', new Date(singleDate)))
                break
              case 409:
                // 2019-1-1 1:01:01
                data.push(formatConverter.ConvertDateTime('yyyy-M-d h:mm:ss', new Date(singleDate)))
                break
              case 410:
                // 2019/1/1 1:01:01
                data.push(formatConverter.ConvertDateTime('yyyy/M/d h:mm:ss', new Date(singleDate)))
                break
              case 411:
                // 2019年1月1日 1时01分01秒
                data.push(formatConverter.ConvertDateTime('yyyy年M月d日 h时mm分ss秒', new Date(singleDate)))
                break
              case 416:
                // 1:01
                data.push(formatConverter.ConvertDateTime('h:mm', new Date(singleDate)))
                break
              case 417:
                // 1时01分
                data.push(formatConverter.ConvertDateTime('h时mm分', new Date(singleDate)))
                break
              case 418:
                // 1:01:01
                data.push(formatConverter.ConvertDateTime('h:mm:ss', new Date(singleDate)))
                break
              case 419:
                // 1时01分01秒
                data.push(formatConverter.ConvertDateTime('h时mm分ss秒', new Date(singleDate)))
                break
              case 433:
                data.push(formatConverter.ConvertDateTime('yyyy-m-d h:mm', new Date(singleDate)))
                break
              case 434:
                data.push(formatConverter.ConvertDateTime('yyyy-mm-dd h:mm', new Date(singleDate)))
                break
              case 435:
                data.push(formatConverter.ConvertDateTime('yyyy/m/d h:mm', new Date(singleDate)))
                break
              case 436:
                data.push(formatConverter.ConvertDateTime('yyyy/mm/dd h:mm', new Date(singleDate)))
                break
              case 437:
                data.push(formatConverter.ConvertDateTime('yyyy"年"m"月"d"日" h时mm分', new Date(singleDate)))
                break
              case 438:
                data.push(formatConverter.ConvertDateTime('yyyy"年"mm"月"dd"日" h时mm分', new Date(singleDate)))
                break
              default:
                data.push(formatConverter.ConvertDateTime('yyyy-M-d h:mm:ss', new Date(singleDate)))
                break
            }
          })
          if (cacheable) {
            cache[dropDownInfo.specId] = {
              params: JSON.stringify(params),
              value: data
            }
          }
          return data
        } else {
          if (cacheable) {
            cache[dropDownInfo.specId].push({
              params: JSON.stringify(params),
              value: output.data
            })
          }
          return output.data
        }
      } else {
        extendFunctions.errorMessage('id：' + dropDownInfo.specId + this.$t('report.dropDownError') + output.data)
      }
      return []
    },

    SetDropDownValue: function(value) {
      console.log(value)
      value = value === 'clean_selected_item' ? null : value
      var cellValue = this.spreadSheet.activeSheet().selection().value()
      if (value !== null) {
        if (cellValue === null || cellValue.toString() !== value) {
          this.spreadSheet.activeSheet().selection().input(value)
        }
      } else {
        if (cellValue === value) {
          return
        }
        this.spreadSheet.activeSheet().selection().value(value)
      }
    },

    mapReadyHandler: function({ BMap, map }) {
      this.BMap = BMap
      const that = this
      var geolocation = new BMap.Geolocation()
      // geolocation.getCurrentPosition(function(r) {
      //   var point = r.point
      //   that.getLocationName(r.point).then(address => {
      //     console.log(address)
      //     that.specificationList.Location.forEach(item => {
      //       if (item.property.autoLoc && item.type === 101 && that.dataSheets[that.id2DataSheets[item.fieldId]].type === 0) {
      //         that.currentLocation = item
      //         item.property.startPoint = point
      //         that.handleSaveLocation({
      //           startPoint: r.point,
      //           startContent: address
      //         })
      //       }
      //     })
      //   })
      // }, { enableHighAccuracy: true })
      var point, address
      that.specificationList.Location.forEach(item => {
        if (item.property.autoLoc &&
          item.type === 101 &&
          that.dataSheets[that.id2DataSheets[item.fieldId]].type === 0 &&
          !that.GetDataFromMasterTable(item.fieldId)) {
          if (point && address) {
            that.currentLocation = item
            item.property.startPoint = point
            that.handleSaveLocation({
              startPoint: point,
              startContent: address
            })
          } else {
            geolocation.getCurrentPosition(function(r) {
              point = r.point
              that.getLocationName(point, item.property.nameMode).then(address => {
                console.log(address)
                that.currentLocation = item
                item.property.startPoint = point
                that.handleSaveLocation({
                  startPoint: point,
                  startContent: address
                })
              })
            }, { enableHighAccuracy: true })
          }
        }
      })
    },

    // 获取地名
    getLocationName(point, nameMode) {
      return new Promise((resolve, reject) => {
        const a = new this.BMap.Point(point.lng, point.lat)
        const gc = new this.BMap.Geocoder({
        })
        gc.getLocation(a, function(rs) {
          console.log(rs)
          const addComp = rs.addressComponents
          const mapDistrict = addComp.province !== addComp.city ? addComp.province + addComp.city + addComp.district : addComp.city + addComp.district
          if (nameMode) {
            // 街区
            resolve(mapDistrict + addComp.street + addComp.streetNumber)
          } else {
            // 商圈
            let addPlace = rs.business
            if (addPlace.indexOf(',') >= 0) {
              addPlace = addPlace.split(',')[0]
            }
            const surroundingPoint = (rs.surroundingPois && rs.surroundingPois.length) ? rs.surroundingPois[0] : null
            if (surroundingPoint) {
              addPlace = surroundingPoint.title
            }
            resolve(mapDistrict + addPlace)
          }
        })
      })
    },

    showLocationDialog(locationInfo, rangeRef) {
      console.log(locationInfo)
      var that = this
      rangeRef.sheet = this.spreadSheet.activeSheet().name()
      rangeRef = formatConverter.ConvertAllFormat2Json(rangeRef)
      this.currentLocation = locationInfo
      var getFieldValue = (fieldId) => {
        if (that.id2DataSheets[fieldId]) {
          switch (that.dataSheets[that.id2DataSheets[fieldId]].type) {
            case 0:
              return that.GetDataFromMasterTable(fieldId)
            case 1:
              var dataSheetRange = that.GetNameRangeJson(that.dataSheets[that.id2DataSheets[fieldId]].areaAlias)
              locationInfo.triggerInfo = { top: rangeRef.topLeft.row - dataSheetRange.topLeft.row + 1, left: rangeRef.topLeft.col - dataSheetRange.topLeft.col + 1, length: 1 }
              var value = that.GetDataFromExtendTable(that.id2DataSheets[fieldId], locationInfo.triggerInfo, [fieldId])
              return (value && value.length === 1) ? value[fieldId] : undefined
            case 2:
              break
          }
        }
      }
      // lng=经度 lat=纬度
      var property = locationInfo.property
      property.startPoint = {
        lng: 116.404,
        lat: 39.915
      }// 默认值
      property.endPoint = {}
      property.specId = locationInfo.type
      var startPoint = {}
      var endPoint = {}
      var bd09Point
      switch (+locationInfo.type) {
        case 101:
          // 单点
          property.mapDisplay.forEach(item => {
            switch (item.specId) {
              case 1:
                startPoint.lng = +getFieldValue(item.fieldId) || 0// 116.404
                break
              case 2:
                startPoint.lat = +getFieldValue(item.fieldId) || 0// 39.915
                break
            }
          })
          if (startPoint.lng && startPoint.lng) {
            bd09Point = formatConverter.wgs84tobd09(startPoint.lng, startPoint.lat)
            property.startPoint = {
              lng: bd09Point[0],
              lat: bd09Point[1]
            }
          }
          property.startContent = getFieldValue(locationInfo.fieldId) || '定位点'
          break
        case 102:
          // 两点
          property.mapDisplay.forEach(item => {
            switch (item.specId) {
              case 1:
                startPoint.lng = +getFieldValue(item.fieldId) || 0
                break
              case 2:
                startPoint.lat = +getFieldValue(item.fieldId) || 0
                break
              case 3:
                property.startContent = getFieldValue(item.fieldId)
                break
              case 4:
                endPoint.lng = +getFieldValue(item.fieldId) || 0
                break
              case 5:
                endPoint.lat = +getFieldValue(item.fieldId) || 0
                break
              case 6:
                property.endContent = getFieldValue(item.fieldId)
                break
            }
          })
          property.routeName = getFieldValue(locationInfo.fieldId) || '路线'
          if (startPoint.lng && startPoint.lng) {
            bd09Point = formatConverter.wgs84tobd09(startPoint.lng, startPoint.lat)
            property.startPoint = {
              lng: bd09Point[0],
              lat: bd09Point[1]
            }
          }
          if (endPoint.lng && endPoint.lng) {
            bd09Point = formatConverter.wgs84tobd09(endPoint.lng, endPoint.lat)
            property.endPoint = {
              lng: bd09Point[0],
              lat: bd09Point[1]
            }
          }
          break
      }
      console.log(property)
      this.$refs.location.handleOpenLocation(property)
    },

    handleSaveLocation(property) {
      console.log(property)
      var mappings = this.currentLocation.property.mapDisplay
      var insertData = {}
      var startPoint, endPoint
      switch (this.currentLocation.type) {
        case 101:
          if (property.startPoint) {
            startPoint = formatConverter.bd09towgs84(property.startPoint.lng, property.startPoint.lat)
            if (mappings.find(item => item.specId === 1)) {
              insertData[mappings.find(item => item.specId === 1).fieldId] = startPoint[0] || 0
            }
            if (mappings.find(item => item.specId === 2)) {
              insertData[mappings.find(item => item.specId === 2).fieldId] = startPoint[1] || 0
            }
          }
          insertData[this.currentLocation.fieldId] = property.startContent || '定位点'
          break
        case 102:
          if (property.startPoint) {
            startPoint = formatConverter.bd09towgs84(property.startPoint.lng, property.startPoint.lat)
            if (mappings.find(item => item.specId === 1)) {
              insertData[mappings.find(item => item.specId === 1).fieldId] = startPoint[0] || 0
            }
            if (mappings.find(item => item.specId === 2)) {
              insertData[mappings.find(item => item.specId === 2).fieldId] = startPoint[1] || 0
            }
            if (mappings.find(item => item.specId === 3)) {
              insertData[mappings.find(item => item.specId === 3).fieldId] = property.startContent || '起点'
            }
          }
          if (property.endPoint) {
            endPoint = formatConverter.bd09towgs84(property.endPoint.lng, property.endPoint.lat)
            if (mappings.find(item => item.specId === 4)) {
              insertData[mappings.find(item => item.specId === 4).fieldId] = endPoint[0] || 0
            }
            if (mappings.find(item => item.specId === 5)) {
              insertData[mappings.find(item => item.specId === 5).fieldId] = endPoint[1] || 0
            }
            if (mappings.find(item => item.specId === 6)) {
              insertData[mappings.find(item => item.specId === 6).fieldId] = property.endContent || '终点'
            }
          }
          if (mappings.find(item => item.specId === 7)) {
            insertData[mappings.find(item => item.specId === 7).fieldId] = (property.distance / 1000) || 0
          }
          if (mappings.find(item => item.specId === 8)) {
            insertData[mappings.find(item => item.specId === 8).fieldId] = Math.ceil(property.duration / 60) || 0
          }
          insertData[this.currentLocation.fieldId] = property.routeName || '路线'
      }
      var dataSheet = this.dataSheets[this.id2DataSheets[this.currentLocation.fieldId]]
      switch (dataSheet.type) {
        case 0:
          this.InsertMasterFieldValue(null, [insertData])
          break
        case 1:
          this.InsertData2ExtendTable(dataSheet.id, dataSheet.extType === 1 ? this.currentLocation.triggerInfo.top - 1 : this.currentLocation.triggerInfo.left - 1,
            [insertData])
          break
        case 2:
          break
      }
    },

    listViewShow(listViewInfos, activeCell, sheetName) {
      const fieldId = (activeCell.fieldInfo() || undefined)
      activeCell = formatConverter.ConvertAllFormat2Json(activeCell._ref, this)
      // const fieldId = this.name2IdInfo[this.GetCellInNameRange(activeCell, sheetName).name].id
      if (fieldId === undefined) {
        extendFunctions.errorMessage(this.$t('report.listError'))
        return
      }
      this.listViewInfo = this.SelectCurrentListView(listViewInfos, activeCell)
      if (this.listViewInfo instanceof Error) {
        return
      }
      if (!this.listViewInfo) {
        var message = ''
        listViewInfos.forEach(info => {
          if (!message) {
            message = info.failtext
          }
        })
        extendFunctions.errorMessage(message || this.$t('report.noListAvailable'))
        return
      }
      // 获取本单据的参数内容
      this.listViewInfo.params = this.GetParamWithFieldId(this.listViewInfo.params, activeCell)
      // 获取本单据的唯一列信息
      var unique = this.GetParamWithFieldId(this.listViewInfo.unique, undefined, undefined, undefined, 1, undefined, true)
      var uniqueArray = []
      for (var tempFieldId in unique) {
        if (typeof unique[tempFieldId] === 'object') {
          unique[tempFieldId].forEach((fieldValue, index) => {
            if (!uniqueArray[index]) {
              uniqueArray.push({})
            }
            uniqueArray[index][tempFieldId] = fieldValue[tempFieldId]
          })
        }
      }
      this.listViewInfo.unique = uniqueArray
      this.listViewInfo.fieldId = fieldId
      this.listViewInfo.activeRange = activeCell
      this.listViewVisiable = true
      this.$nextTick(function() {
        this.$refs.listViewDataTable.queryStr = ''
        this.$refs.listViewDataTable.selectionTableData = []
        this.$refs.listViewDataTable.GetListViewData()
      })
    },

    // 列表规范回写数据
    WriteListSpecSelectedData: function(fieldId, selectedData, listViewInfo) {
      this.listViewVisiable = false
      var tempValue, columnId
      if (selectedData.length > 0) {
        if (listViewInfo.resultOneRow) {
          var mergedData = [{}]
          for (columnId in selectedData[0]) {
            if (columnId === 'select') {
              continue
            }
            tempValue = ''
            selectedData.forEach(dataRow => {
              if (!dataRow[columnId]) {
                return
              }
              if (dataRow[columnId].toString().indexOf('{"data":') === 0) {
                if (tempValue) {
                  try {
                    var obj = JSON.parse(tempValue)
                    JSON.parse(dataRow[columnId]).data.forEach(item => {
                      obj.data.push(item)
                    })
                    tempValue = JSON.stringify(obj) + ' '
                  } catch (exception) {
                    tempValue = '{data:[]} '
                  }
                } else {
                  tempValue = dataRow[columnId] + ' '
                }
              } else {
                if (tempValue.indexOf(dataRow[columnId] + ',') < 0 || !listViewInfo.distinct) {
                  tempValue += dataRow[columnId] + ','
                }
              }
            })
            mergedData[0][columnId] = tempValue.substring(0, tempValue.length - 1)
          }
          selectedData = mergedData
        }
        console.time('列表规范写入数据')
        const mappingInfo = listViewInfo.mapping
        const dataTableInfo = this.dataSheets[this.id2DataSheets[fieldId]]
        this.connectInsert(dataTableInfo, mappingInfo, selectedData, listViewInfo.activeRange, true)
        console.timeEnd('列表规范写入数据')
      }
    },

    connectInsert(dataTableInfo, mappingInfo, selectedData, targetRange, addNewLine) {
      var usedRowColumnCount, i, insertRows, insertCols, usedRowInfo, usedColInfo, fieldId
      var insertData = []
      switch (dataTableInfo.type) {
        case 0:
          // 主表形式
          insertData.push({})
          for (fieldId in mappingInfo) {
            // 整理需要写入的主表字段
            insertData[0][fieldId] = selectedData[0][mappingInfo[fieldId]]
          }
          this.InsertMasterFieldValue(dataTableInfo.id, insertData)
          break
        case 1:
          // 扩展表
          if (dataTableInfo.extType === 1) {
            // 向下扩展
            // 检查空白行是否够用
            // 整理需要插入的内容
            for (fieldId in mappingInfo) {
              for (i = 0; i < selectedData.length; i++) {
                if (!insertData[i]) {
                  insertData.push({})
                }
                insertData[i][fieldId] = selectedData[i][mappingInfo[fieldId]]
              }
            }
            insertRows = 0
            const dataRowCount = insertData.length
            usedRowInfo = this.GetDataSheetUsedRowInfo(dataTableInfo.id)
            const remainRowCount = usedRowInfo.usedRangeJson.bottomRight.row - targetRange.topLeft.row + 1
            insertRows = dataRowCount - remainRowCount
            if (insertRows === 0 && addNewLine) {
              insertRows++
            }
            if (insertRows > 0) {
              this.InsertRowColumn({
                topLeft: {
                  row: usedRowInfo.usedRangeJson.bottomRight.row,
                  col: usedRowInfo.usedRangeJson.topLeft.col
                },
                bottomRight: {
                  row: usedRowInfo.usedRangeJson.bottomRight.row,
                  col: usedRowInfo.usedRangeJson.bottomRight.col
                },
                workSheet: this.dataSheets[dataTableInfo.id].sheetName
              }, 'row', insertRows, undefined, undefined, true)
            }
            const usedRowColumnCount = targetRange.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
            // 开始执行插入
            console.time('插入查询结果')
            this.InsertData2ExtendTable(dataTableInfo.id, usedRowColumnCount, insertData)
            console.timeEnd('插入查询结果')
          } else {
            // 向右扩展
            // 检查空白行是否够用
            // 整理需要插入的内容
            for (fieldId in mappingInfo) {
              for (i = 0; i < selectedData.length; i++) {
                if (!insertData[i]) {
                  insertData.push({})
                }
                insertData[i][fieldId] = selectedData[i][mappingInfo[fieldId]]
                // if (selectedData[i][`${mappingInfo[fieldId]}_I`]) {
                //   insertData[i][fieldId] = selectedData[i][`${mappingInfo[fieldId]}_I`]
                // }
                // if (selectedData[i][`${mappingInfo[fieldId]}_A`]) {
                //   insertData[i][fieldId] = selectedData[i][`${mappingInfo[fieldId]}_A`]
                // }
              }
            }
            insertCols = 0
            const dataColCount = insertData.length
            usedColInfo = this.GetDataSheetUsedColumnInfo(dataTableInfo.id)
            const remainColCount = usedColInfo.usedRangeJson.bottomRight.col - targetRange.topLeft.col + 1
            if (remainColCount < dataColCount) {
              insertCols = dataColCount - remainColCount
            }
            if (insertCols === 0 && addNewLine) {
              insertCols++
            }
            if (insertCols > 0) {
              this.InsertRowColumn({
                topLeft: {
                  row: usedColInfo.usedRangeJson.topLeft.row,
                  col: usedColInfo.usedRangeJson.bottomRight.col
                },
                bottomRight: {
                  row: usedColInfo.usedRangeJson.bottomRight.row,
                  col: usedColInfo.usedRangeJson.bottomRight.col
                },
                workSheet: this.dataSheets[dataTableInfo.id].sheetName
              }, 'column', insertCols, undefined, undefined, true)
            }
            usedRowColumnCount = targetRange.topLeft.col - usedColInfo.usedRangeJson.topLeft.col
            // 开始执行插入
            console.time('插入查询结果')
            this.InsertData2ExtendTable(dataTableInfo.id, usedRowColumnCount, insertData)
            console.timeEnd('插入查询结果')
          }
          break
        case 2:
          // 交叉表
          // 验证填充内容是否合法
          var fieldList = []
          var fieldPosition = []
          for (fieldId in mappingInfo) {
            fieldList.push(this.id2Info[fieldId])
            fieldPosition.push(this.id2Info[fieldId].extType)
            for (i = 0; i < selectedData.length; i++) {
              if (!insertData[i]) {
                insertData.push({})
              }
              insertData[i][fieldId] = selectedData[i][mappingInfo[fieldId]]
            }
          }
          fieldPosition = extendFunctions.ArrayDistinct(fieldPosition)
          var dataField = fieldList.filter(fieldInfo => { return fieldInfo.extType === 3 })
          if (!dataField.length) {
            // 单维度插入
            if (fieldPosition.length > 1) {
              extendFunctions.errorMessage(this.$t('report.corsstabDimension'))
              return
            } else {
              switch (fieldList[0].extType) {
                case 1:
                  // 左侧
                  insertRows = 0
                  var dataRowCount = insertData.length
                  usedRowInfo = this.GetMatrixUsedInfo(dataTableInfo.id)
                  var remainRowCount = usedRowInfo.usedRangeJson.bottomRight.row - targetRange.topLeft.row + 1
                  if (remainRowCount < dataRowCount) {
                    insertRows = dataRowCount - remainRowCount
                  }
                  if (insertRows > 0) {
                    this.InsertRowColumn({
                      topLeft: {
                        row: usedRowInfo.usedRangeJson.bottomRight.row,
                        col: usedRowInfo.usedRangeJson.topLeft.col
                      },
                      bottomRight: {
                        row: usedRowInfo.usedRangeJson.bottomRight.row,
                        col: usedRowInfo.usedRangeJson.bottomRight.col
                      },
                      workSheet: this.dataSheets[dataTableInfo.id].sheetName
                    }, 'row', insertRows, undefined, undefined, true)
                  }
                  usedRowColumnCount = targetRange.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
                  // 开始执行插入
                  console.time('插入查询结果')
                  this.InsertData2ExtendTable(dataTableInfo.id, { row: usedRowColumnCount }, insertData)
                  console.timeEnd('插入查询结果')
                  break
                case 2:
                  // 上方
                  insertCols = 0
                  var dataColCount = insertData.length
                  usedColInfo = this.GetMatrixUsedInfo(dataTableInfo.id)
                  var remainColCount = usedColInfo.usedRangeJson.bottomRight.col - targetRange.topLeft.col + 1
                  if (remainColCount < dataColCount) {
                    insertCols = dataColCount - remainColCount
                  }
                  if (insertCols > 0) {
                    this.InsertRowColumn({
                      topLeft: {
                        row: usedColInfo.usedRangeJson.topLeft.row,
                        col: usedColInfo.usedRangeJson.bottomRight.col
                      },
                      bottomRight: {
                        row: usedColInfo.usedRangeJson.bottomRight.row,
                        col: usedColInfo.usedRangeJson.bottomRight.col
                      },
                      workSheet: this.dataSheets[dataTableInfo.id].sheetName
                    }, 'column', insertCols, undefined, undefined, true)
                  }
                  usedRowColumnCount = targetRange.topLeft.col - usedColInfo.usedRangeJson.topLeft.col
                  // 开始执行插入
                  console.time('插入查询结果')
                  this.InsertData2ExtendTable(dataTableInfo.id, { col: usedRowColumnCount }, insertData, false)
                  console.timeEnd('插入查询结果')
                  break
              }
            }
          } else {
            // 混合维度插入，必须包含数据列
            // 只支持插入单行数据
            insertData = insertData[0]
            var dataFieldRange = this.GetNameRangeJson(dataField[0].areaAlias)
            insertData.row = targetRange.topLeft.row - dataFieldRange.topLeft.row
            insertData.col = targetRange.topLeft.col - dataFieldRange.topLeft.col
            this.CheckAndExtendRows(dataTableInfo.id, {
              row: 1,
              col: 1
            }, {
              row: targetRange.topLeft.row - dataFieldRange.topLeft.row,
              col: targetRange.topLeft.col - dataFieldRange.topLeft.col,
              length: {
                row: 1,
                col: 1
              }
            }, undefined, undefined, undefined, true)
            // 开始执行插入
            console.time('插入查询结果')
            this.InsertData2ExtendTable(dataTableInfo.id, {
              row: targetRange.topLeft.row - dataFieldRange.topLeft.row,
              col: targetRange.topLeft.col - dataFieldRange.topLeft.col
            }, [insertData])
            console.timeEnd('插入查询结果')
          }
          break
        default:
          extendFunctions.errorMessage(this.$t('report.dataSheetType') + dataTableInfo.type + this.$t('report.notExist'))
          break
      }
    },

    // 列表规范清空数据
    WriteListCleanFillRange: function(listViewInfo, effectRangeJson) {
      this.listViewVisiable = false
      console.time('列表规范清空数据')
      const mappingInfo = extendFunctions.deepCopy(listViewInfo.mapping)
      const dataTableInfo = this.dataSheets[this.id2DataSheets[listViewInfo.fieldId]]
      this.CleanMappingRange(mappingInfo, dataTableInfo, effectRangeJson)
      console.timeEnd('列表规范清空数据')
    },

    CleanMappingRange: function(mappingInfo, dataTableInfo, effectRangeJson) {
      var usedRowColumnCount, i, usedRowInfo, usedColInfo, targetFieldId
      var insertData = [{}]
      switch (dataTableInfo.type) {
        case 0:
          // 主表形式
          var insertJson = {}
          for (targetFieldId in mappingInfo) {
            // 整理需要写入的主表字段
            insertJson[targetFieldId] = null
          }
          this.InsertMasterFieldValue(dataTableInfo.id, [insertJson])
          break
        case 1:
          // 扩展表
          // 检查空白行是否够用
          // 整理需要插入的内容
          for (targetFieldId in mappingInfo) {
            insertData[0][targetFieldId] = null
          }
          if (dataTableInfo.extType === 1) {
            // 向下扩展
            usedRowInfo = this.GetDataSheetUsedRowInfo(dataTableInfo.id)
            if (effectRangeJson) {
              usedRowColumnCount = effectRangeJson.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
              for (i = 0; i < effectRangeJson.bottomRight.row - effectRangeJson.topLeft.row; i++) {
                insertData.push(insertData[0])
              }
            } else {
              usedRowColumnCount = this.listViewInfo.activeRange.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
            }
            // 开始执行插入
            console.time('插入查询结果')
            this.InsertData2ExtendTable(dataTableInfo.id, usedRowColumnCount, insertData)
            console.timeEnd('插入查询结果')
          } else {
            // 向右扩展
            usedColInfo = this.GetDataSheetUsedColumnInfo(dataTableInfo.id)
            if (effectRangeJson) {
              usedRowColumnCount = effectRangeJson.topLeft.col - usedRowInfo.usedRangeJson.topLeft.col
              for (i = 0; i < effectRangeJson.bottomRight.col - effectRangeJson.topLeft.col; i++) {
                insertData.push(insertData[0])
              }
            } else {
              usedRowColumnCount = this.listViewInfo.activeRange.topLeft.col - usedRowInfo.usedRangeJson.topLeft.col
            }
            // 开始执行插入
            console.time('插入查询结果')
            this.InsertData2ExtendTable(dataTableInfo.id, usedRowColumnCount, insertData)
            console.timeEnd('插入查询结果')
          }
          break
        case 2:
          // 交叉表
          var fieldPosition
          for (targetFieldId in mappingInfo) {
            if (fieldPosition) {
              if (fieldPosition !== this.id2Info[targetFieldId].extType) {
                extendFunctions.errorMessage(this.$t('report.corsstabDimension'))
                return
              }
            } else {
              fieldPosition = this.id2Info[targetFieldId].extType
            }
            insertData[0][targetFieldId] = null
          }
          switch (fieldPosition) {
            case 1:
              // 左侧
              usedRowInfo = this.GetMatrixUsedInfo(dataTableInfo.id)
              if (effectRangeJson) {
                usedRowColumnCount = effectRangeJson.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
                for (i = 0; i < effectRangeJson.bottomRight.row - effectRangeJson.topLeft.row; i++) {
                  insertData.push(insertData[0])
                }
              } else {
                usedRowColumnCount = this.listViewInfo.activeRange.topLeft.row - usedRowInfo.usedRangeJson.topLeft.row
              }
              // 开始执行插入
              console.time('插入查询结果')
              this.InsertData2ExtendTable(dataTableInfo.id, { row: usedRowColumnCount }, insertData)
              console.timeEnd('插入查询结果')
              break
            case 2:
              // 上方
              usedColInfo = this.GetMatrixUsedInfo(dataTableInfo.id)
              if (effectRangeJson) {
                usedRowColumnCount = effectRangeJson.topLeft.col - usedColInfo.usedRangeJson.topLeft.col
                for (i = 0; i < effectRangeJson.bottomRight.col - effectRangeJson.topLeft.col; i++) {
                  insertData.push(insertData[0])
                }
              } else {
                usedRowColumnCount = this.listViewInfo.activeRange.topLeft.col - usedColInfo.usedRangeJson.topLeft.col
              }
              // 开始执行插入
              console.time('插入查询结果')
              this.InsertData2ExtendTable(dataTableInfo.id, { col: usedRowColumnCount }, insertData)
              console.timeEnd('插入查询结果')
              break
            case 3:
              // 交叉区域
              break
          }
          break
        default:
          extendFunctions.errorMessage(this.$t('report.dataSheetType') + dataTableInfo.type + this.$t('report.notExist'))
          break
      }
    },

    // 判断使用哪个列表规范
    SelectCurrentListView: function(listViewInfos, activeCell) {
      var paramArray, params, query
      for (var i = 0; i < listViewInfos.length; i++) {
        query = ''
        params = []
        for (var tableId in listViewInfos[i].conditionParam) {
          if (!query) {
            query = 'SELECT 1 FROM '
          }
          if (+tableId === listViewInfos[i].dataSheetId || this.dataSheets[tableId].type === 0) {
            paramArray = []
            listViewInfos[i].conditionParam[tableId].forEach(fieldId => {
              paramArray.push(fieldId)
            })
            params.push([this.GetParamWithFieldId(paramArray, activeCell)])
            query += `? [${tableId}], `
          } else {
            extendFunctions.errorMessage(this.$t('report.otherTable'))
            return Error('暂不支持取其他扩展表值！')
          }
        }
        if (params.length) {
          query = query.substring(0, query.length - 2)
        } else {
          query = 'SELECT 1 '
        }
        if (listViewInfos[i].condition) {
          query += ' WHERE ' + listViewInfos[i].condition
        }
        // 根据计算结果进行扩展收缩处理
        var result = params.length ? alasql(query, params) : alasql(query)
        if (result.length) {
          return extendFunctions.deepCopy(listViewInfos[i])
        }
      }
      return null
    },

    // *********************
    // *****附件图片处理*****
    // *********************
    attachContextnClicked: function(e) {
      largeFile.owner = this
      largeFile.attachContextnClicked(e)
    },

    showFileSelector(handleRange) {
      largeFile.owner = this
      largeFile.showFileSelector(handleRange)
    },

    onSelectedFile: function() {
      largeFile.owner = this
      largeFile.onSelectedFile()
    },

    setFieldImage: function(sheet, fieldRange, imageId) {
      largeFile.owner = this
      largeFile.setFieldImage(sheet, fieldRange, imageId)
    },

    setFieldImageGroup: function(sheet, fieldRange, imageInfo, sign) {
      if (imageInfo) {
        if (!(imageInfo instanceof Object)) {
          try {
            imageInfo = JSON.parse(imageInfo)
          } catch (ex) {
            // imageInfo = null
          }
        }
      }
      largeFile.owner = this
      largeFile.setFieldImageGroup(sheet, fieldRange, imageInfo, sign)
    },

    setFieldAttachGroup: function(sheet, fieldRange, attachInfo) {
      if (attachInfo) {
        if (!(attachInfo instanceof Object)) {
          try {
            attachInfo = JSON.parse(attachInfo)
          } catch (ex) {
            // attachInfo = null
          }
        }
      }
      largeFile.owner = this
      largeFile.setFieldAttachGroup(sheet, fieldRange, attachInfo)
    },

    downloadAttach: function(attachId) {
      largeFile.owner = this
      largeFile.downloadAttach(attachId)
    },

    getStorageImage: function(imageId) {
      return largeFile.localImageStorage[imageId] ? extendFunctions.getFileURL(largeFile.localImageStorage[imageId]) : null
    },

    getStorageList: function() {
      console.log(largeFile.localImageStorage)
    },

    refreshView: function(fieldRange, type) {
      if (fieldRange) {
        switch (type) {
          case 1:
            largeFile.setImageGroupValue(fieldRange)
            break
          case 2:
            largeFile.setAttachGroupValue(fieldRange)
            break
        }
      }
      this.spreadSheet._controller.onScroll()
    },

    async showSignature(handleCell) {
      this.signatureCell = handleCell
      var signData = handleCell.imageGroup().data
      var img
      if (signData && signData.length) {
        var imageId = signData[0].id
        try {
          if (this.uploadFileList.find(item => item.id === imageId)) {
            img = this.uploadFileList.find(item => item.id === imageId).base
          } else {
            img = (await downloadFile(imageId)).data
          }
        } catch (ex) {
          extendFunctions.errorMessage(this.$t('report.noSignature'), ex)
        }
      }
      this.$refs.signature.handleOpenSignature(img)
    },

    async handleSaveSignature(base64) {
      // 上传模式
      var imageBlob = extendFunctions.b64toBlob(base64.split(',')[1], 'image/jpg')
      var imageGroupInfo = this.signatureCell.imageGroup()
      var response = await identifyFiles(1)
      var id = response.data[0]
      if (imageGroupInfo && imageGroupInfo.data && imageGroupInfo.data.length > 0) {
        // 有图片
        imageGroupInfo.data[0].src = base64
        imageGroupInfo.data[0].id = id
      } else {
        // 没有图片
        imageGroupInfo = {
          data: [{
            id: id,
            src: base64
          }]
        }
      }
      if (this.uploadFileList.find(item => item.id === id)) {
        this.uploadFileList.find(item => item.id === id).obj = imageBlob
      } else {
        this.uploadFileList.push({ id: id, obj: imageBlob, base: base64, name: 'signature.jpg', status: 'ready' })
      }
      if (this.templateAttribute.uploadMode) {
        if (!this.uploadingFile) {
          this.liveUploadFiles()
        }
      }
      this.signatureCell.imageGroup(imageGroupInfo)
      this.signatureCell.value('已签名')
    },

    async handleDefaultSignature() {
      var variables = (await getSystemVariables()).data
      if (variables[20] && variables[20].data && variables[20].data.length) {
        largeFile.setFieldImageGroup(this.spreadSheet.activeSheet(), this.signatureCell._ref.toString(), variables[20])
      } else {
        extendFunctions.errorMessage(this.$t('report.defaultSignature'))
      }
      console.log(variables)
    },

    // *********************
    // *******取数公式*******
    // *********************
    // 取数公式队列方法
    async QueryFormulaHelper(queryFormulaList, triggerInfo, messageObj, sourceTableId, fromOnChange) {
      try {
        if (!(queryFormulaList instanceof Array) || !queryFormulaList.length > 0) {
          return
        }
        queryFormulaList = extendFunctions.ArrayDistinct(queryFormulaList)
        if (!messageObj) {
          messageObj = {}
        }
        var i
        var effectTableId = []
        // 用来找到关联的取数公式
        for (i = 0; i < queryFormulaList.length; i++) {
          if (queryFormulaList.length >= 100) {
            // extendFunctions.errorMessage('取数公式超出引用上限（100）！请检查是否发生了循环引用！', '取数公式循环引用错误')
            // console.error(queryFormulaList)
            // return false
            break
          }
          this.queryFormulaInfos[queryFormulaList[i]].filling.forEach(fillFieldId => {
            if (this.formulaDictionary[fillFieldId]) {
              for (var connectFormulaId of this.formulaDictionary[fillFieldId]) {
                // i += 1
                queryFormulaList.splice(i + 1, 0, connectFormulaId)
              }
            }
            effectTableId.push(this.id2DataSheets[fillFieldId])
          })
        }
        // 根据seq排序
        if (queryFormulaList.length > 0) {
          var queryFormulaSeq = []
          queryFormulaList.forEach(formulaId => {
            if (this.queryFormulaInfos[formulaId]) {
              queryFormulaSeq.push({
                id: formulaId,
                seq: this.queryFormulaInfos[formulaId].seq
              })
            }
          })
          queryFormulaSeq.sort(extendFunctions.sortBy('seq'))
          queryFormulaList = []
          queryFormulaSeq.forEach(formulaInfo => {
            queryFormulaList.push(formulaInfo.id)
          })
        }
        // 批量解除合并
        // 获取受影响的数据表
        effectTableId = extendFunctions.ArrayDistinct(effectTableId)
        effectTableId.forEach(tableId => {
          if (this.masterTableId !== tableId) { this.MergeSameField(tableId, true) }
        })
        // 排除重复
        queryFormulaList = extendFunctions.ArrayDistinct(queryFormulaList)
        // 提交处理
        var loadingInstance
        if (this.showFormulaLoading) {
          loadingInstance = Loading.service({
            background: 'transparent',
            text: this.$t('report.waiting')
          })
        }
        var effectFieldList = []
        var controlRoleList = []
        var formatFormulaList = []
        for (var formulaId of queryFormulaList) {
          await this.ExcuteQueryFormula(formulaId, (this.queryFormulaInfos[formulaId].tableId === sourceTableId || !sourceTableId) ? triggerInfo : undefined)
          if (messageObj[formulaId]) {
            extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[formulaId])
          }
          effectFieldList = effectFieldList.concat(this.queryFormulaInfos[formulaId].filling)
          // 算出所有被填充的字段，重新执行条件格式
        }
        if (this.resultRowCount === 0) {
          extendFunctions.warningMessage(this.$t('report.noDataObtained'))
        }
        if (this.resultRowCount >= 0) {
          this.resultRowCount = -1
        }
        var conditionFieldList = extendFunctions.deepCopy(effectFieldList)
        // 执行动态样式
        effectFieldList.forEach(fieldId => {
          conditionFieldList = conditionFieldList.concat(extendFunctions.deepCopy(this.conditionDictionary[fieldId]) || [])
        })
        for (i = 0; i < conditionFieldList.length; i++) {
          conditionFieldList[i] = +conditionFieldList[i]
        }
        conditionFieldList = extendFunctions.ArrayDistinct(conditionFieldList)
        await this.ConditionHelper(conditionFieldList, triggerInfo)
        if (this.conditionTriggerInfo && !fromOnChange) {
          switch (this.conditionTriggerInfo.alertType) {
            case 1:
              extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
              break
            case 2:
              extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
              break
          }
          this.conditionTriggerInfo = null
        }
        // 执行动态样式
        effectFieldList.forEach(fieldId => {
          formatFormulaList = formatFormulaList.concat(extendFunctions.deepCopy(this.formatFormulaDictionary[fieldId]) || [])
        })
        for (i = 0; i < formatFormulaList.length; i++) {
          formatFormulaList[i] = +formatFormulaList[i]
        }
        formatFormulaList = extendFunctions.ArrayDistinct(formatFormulaList)
        if (formatFormulaList && formatFormulaList.length) {
          this.FormatFormulaHelper(formatFormulaList)
        }
        // 执行操作约束
        effectFieldList.forEach(fieldId => {
          controlRoleList = controlRoleList.concat(extendFunctions.deepCopy(this.controlRoleDictionary[fieldId]) || [])
        })
        for (i = 0; i < formatFormulaList.length; i++) {
          formatFormulaList[i] = +formatFormulaList[i]
        }
        controlRoleList = extendFunctions.ArrayDistinct(controlRoleList)
        if (controlRoleList && controlRoleList.length) {
          this.controlRoleHelper(controlRoleList)
        }
        if (this.showFormulaLoading) {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        // 批量合并
        effectTableId.forEach(tableId => {
          if (this.masterTableId !== tableId) { this.MergeSameField(tableId) }
        })
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.queryFail'), exception)
        return false
      }
    },

    // 取数公式执行主方法
    // triggerInfo={top:开始行,left:开始列,length:影响行数}
    async ExcuteQueryFormula(formulaId, triggerInfo) {
      var fieldInfo, fieldJson, leftRow, leftCol, fieldId, i
      const execFormulaInfo = this.queryFormulaInfos[formulaId]
      if (!execFormulaInfo) {
        console.log('取数公式' + formulaId + '不存在！')
        return
      }
      console.time('====================执行取数公式：' + formulaId + '===================')
      const targetTableId = execFormulaInfo.tableId
      const paginationInfo = this.paginationItems.find(item => item.id === +targetTableId)
      if (execFormulaInfo.condExpression) {
        console.time('执行前判断')
        if ((await this.excuteDecide(targetTableId, triggerInfo, execFormulaInfo.condParam, execFormulaInfo.condExpression)).length === 0) {
          console.timeEnd('执行前判断')
          console.timeEnd('====================执行取数公式：' + formulaId + '===================')
          return
        }
        console.timeEnd('执行前判断')
      }
      if (execFormulaInfo.match.length === 0) {
        triggerInfo = undefined
      }
      if (this.tableClassifyInfo[targetTableId]) {
        this.cancelClassify(targetTableId)
      }
      var that = this
      var cleanData = () => {
        // 执行前清空所在区域所有数据
        if (execFormulaInfo.cleanAll === 1 && triggerInfo === undefined) {
          console.time('清空全部数据')
          // 循环数据表每一列
          this.CleanDataSheetAreaData(targetTableId)
          console.timeEnd('清空全部数据')
        }
        // 执行前清空填充部分数据
        if (execFormulaInfo.cleanAll !== 1 && execFormulaInfo.cleanPart === 1) {
          console.time('执行前清空填充部分数据')
          var fieldRange, fieldObj
          if (this.dataSheets[targetTableId].type === 0) {
            // 主表处理方式
            for (fieldId of execFormulaInfo.filling) {
              // 取列/行别名所在区域
              fieldInfo = that.dataSheets[targetTableId].fields[fieldId]
              // 给整个别名区域赋值null
              fieldRange = formatConverter.ConvertJsonToRange(that.GetNameRangeJson(fieldInfo.areaAlias))
              fieldObj = that.spreadSheet.sheetByName(fieldInfo.sheetName).range(fieldRange)
              fieldObj.values([], true)
              if (fieldObj.imageGroup()) {
                that.setFieldImageGroup(that.spreadSheet.sheetByName(fieldInfo.sheetName), fieldObj._ref.toString())
              }
              if (fieldObj.attachGroup()) {
                that.setFieldAttachGroup(that.spreadSheet.sheetByName(fieldInfo.sheetName), fieldObj._ref.toString())
              }
              fieldObj.customButtons(null)
              fieldObj._manualAdjustRowHeight()
            }
          } else {
            if (paginationInfo) {
              if (this.extendDataCollection[targetTableId]) {
                if (triggerInfo !== undefined && triggerInfo.length) {
                  // 忽略表单上trigger导致的变化
                  for (i = triggerInfo.top; i < triggerInfo.top + triggerInfo.length - 1; i++) {
                    for (fieldId of execFormulaInfo.filling) {
                      delete this.extendDataCollection[targetTableId][i].fieldId
                    }
                  }
                } else {
                  this.extendDataCollection[targetTableId].forEach(row => {
                    for (fieldId of execFormulaInfo.filling) {
                      delete row.fieldId
                    }
                  })
                }
              }
            } else {
              // 循环填充字段每一别名区域
              this.spreadSheet.sheetByName(this.dataSheets[targetTableId].sheetName).batch(function() {
                for (fieldId of execFormulaInfo.filling) {
                  // 取列/行别名所在区域
                  fieldInfo = that.dataSheets[targetTableId].fields[fieldId]
                  fieldJson = that.GetNameRangeJson(fieldInfo.areaAlias)
                  if (triggerInfo !== undefined && triggerInfo.length) {
                    switch (that.dataSheets[targetTableId].extType) {
                      case 1:
                        // 向下扩展
                        fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length - 1
                        fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                        break
                      case 2:
                        // 向右扩展
                        fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.top + triggerInfo.length - 1
                        fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.top
                        break
                      case 3:
                        // 交叉扩展
                        switch (fieldInfo.extType) {
                          case 1:
                            fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                            fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                            break
                          case 2:
                            fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                            fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                            break
                          case 3:
                            if (triggerInfo.top >= 0) {
                              fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                              fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                            }
                            if (triggerInfo.col >= 0) {
                              fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                              fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                            }
                            break
                        }
                        break
                    }
                  }
                  // 给整个别名区域赋值null
                  fieldRange = formatConverter.ConvertJsonToRange(fieldJson)
                  fieldObj = that.spreadSheet.sheetByName(fieldInfo.sheetName).range(fieldRange)
                  fieldObj.values([])
                  if (fieldObj.imageGroup()) {
                    that.setFieldImageGroup(that.spreadSheet.sheetByName(fieldInfo.sheetName), fieldObj._ref.toString())
                  }
                  if (fieldObj.attachGroup()) {
                    that.setFieldAttachGroup(that.spreadSheet.sheetByName(fieldInfo.sheetName), fieldObj._ref.toString())
                  }
                  fieldObj.customButtons(null)
                  fieldObj._manualAdjustRowHeight()
                }
              })
            }
          }
          console.timeEnd('执行前清空填充部分数据')
        }
      }
      // 执行前清空
      if (execFormulaInfo.cleanTiming === 0) {
        cleanData()
      }
      // 拼接返回后台的参数Json
      const selectFormulaParams = extendFunctions.deepCopy(execFormulaInfo.param)
      // debugger
      var dataSheetData, deleteRangeJson
      if (selectFormulaParams) {
        dataSheetData = this.GetParamWithTableInfo(selectFormulaParams, triggerInfo, targetTableId)
      } else {
        dataSheetData = {}
      }
      if (!dataSheetData[this.masterTableId]) {
        dataSheetData[this.masterTableId] = [{}]
      }
      dataSheetData[this.masterTableId][0].id = this.recordId < 0 ? 0 : this.recordId
      // 执行时清空
      if (execFormulaInfo.cleanTiming === 1) {
        cleanData()
      }
      // 调取接口，接收返回值
      try {
        var queryFormulaResult = await getQueryFormulaOutput(this.templateId, formulaId, dataSheetData)
        if (queryFormulaResult.status >= 200 && queryFormulaResult.status < 300) {
          var queryData = queryFormulaResult.data
          // 合并填充
          console.time('合并填充数据处理')
          var mergeFields = []
          var insertFields = []
          var leftExpression = 'select distinct '
          var rightExpression = 'select '
          for (fieldId in execFormulaInfo.output) {
            if (execFormulaInfo.specialFilling[fieldId] === 2) {
              // excel公式预处理
              queryData.forEach(row => {
                if (row.fieldId) {
                  row.fieldId = row.fieldId.toString().trim()
                  if (row.fieldId.indexOf('=') !== 0) {
                    row.fieldId = '=' + row.fieldId
                  }
                }
              })
            }
            if (execFormulaInfo.specialFilling[fieldId] === 4) {
              mergeFields.push(+fieldId)
              rightExpression += `[${fieldId}], `
            } else {
              insertFields.push(+fieldId)
              leftExpression += `[${fieldId}], `
            }
          }
          if (mergeFields.length && queryData.length) {
            var delimiter = (execFormulaInfo.delimiter & 1) === 1 ? execFormulaInfo.delimiter - 1 : execFormulaInfo.delimiter
            var joinStr = ''
            var mergeInfo = {
              enable: (execFormulaInfo.delimiter & 1) === 1,
              joinStr: this.joinStrList.find(item => item.value === delimiter)
            }
            if (mergeInfo.enable) {
              joinStr = mergeInfo.joinStr ? mergeInfo.joinStr.label : ','
            }
            // 含有合并填充项
            if (insertFields.length) {
              leftExpression = leftExpression.substr(0, leftExpression.length - 2)
              var leftSide = alasql(leftExpression + ' from ?', [queryData])
              rightExpression = rightExpression.substr(0, rightExpression.length - 2)
              leftSide.forEach(row => {
                var expression = rightExpression + ' from ? where'
                for (var colId in row) {
                  expression += ` [${colId}]=${typeof row[colId] === 'number' ? row[colId] : `'${row[colId]}'`} and`
                }
                expression = expression.substr(0, expression.length - 4)
                var dataRows = alasql(expression, [queryData])
                var typeCache = {}
                dataRows.forEach(resultRow => {
                  for (var resultColId in resultRow) {
                    if (!row[resultColId]) {
                      if (this.id2Info[resultColId].baseType === 3) {
                        typeCache[resultColId] = 0
                        row[resultColId] = 0
                      } else {
                        typeCache[resultColId] = 1
                        row[resultColId] = ''
                      }
                    }
                    if (resultRow[resultColId]) {
                      if (typeCache[resultColId]) {
                        row[resultColId] += resultRow[resultColId] + joinStr
                      } else {
                        row[resultColId] += resultRow[resultColId]
                      }
                    }
                  }
                })
                mergeFields.forEach(fieldId => {
                  if (row[fieldId]) {
                    if (typeCache[fieldId]) {
                      row[fieldId] = row[fieldId].substr(0, row[fieldId].length - 1)
                    }
                  }
                })
              })
              queryData = leftSide
            } else {
              var result = {}
              var typeCache = {}
              queryData.forEach(row => {
                for (var colId in row) {
                  if (!result[colId]) {
                    if (this.id2Info[colId].baseType === 3) {
                      typeCache[colId] = 0
                      result[colId] = 0
                    } else {
                      typeCache[colId] = 1
                      result[colId] = ''
                    }
                  }
                  if (row[colId]) {
                    if (typeCache[colId]) {
                      result[colId] += row[colId] + joinStr
                    } else {
                      result[colId] += row[colId]
                    }
                  }
                }
              })
              mergeFields.forEach(fieldId => {
                if (result[fieldId]) {
                  if (typeCache[fieldId]) {
                    result[fieldId] = result[fieldId].substr(0, result[fieldId].length - 1)
                  }
                }
              })
              queryData = [result]
            }
          }
          console.timeEnd('合并填充数据处理')
          if (this.resultRowCount >= 0) {
            this.resultRowCount += queryData.length
          }
          if (this.dataSheets[targetTableId].type === 0) {
            console.time('主表填值')
            this.InsertMasterFieldValue(targetTableId, queryData, true, execFormulaInfo.specialFilling, true)
            if (execFormulaInfo.filling && execFormulaInfo.filling.length) {
              var recalcSheetList = []
              execFormulaInfo.filling.forEach(fieldId => {
                var sheetName = that.id2Info[fieldId].sheetName
                if (sheetName !== that.spreadSheet.activeSheet().name() && recalcSheetList.indexOf(sheetName) === -1) {
                  recalcSheetList.push(sheetName)
                  that.spreadSheet.sheetByName(sheetName).recalc(that.spreadSheet._workbook._context)
                }
              })
            }
            console.timeEnd('主表填值')
          } else {
            // 按行列匹配处理
            // if(hasAddInsert){
            //   for(var fieldId in execFormulaInfo.specialFilling){
            //     if(execFormulaInfo.specialFilling[fieldId]===0){
            //       if(execFormulaInfo.match.indexOf(+fieldId)<0){
            //         execFormulaInfo.match.push(+fieldId)
            //       }
            //     }
            //   }
            // }
            if (execFormulaInfo.match.length > 0 && queryData.length > 0) {
              console.time('按行列匹配处理')
              // 创建表结构
              if (this.CreateDataTable(targetTableId)) {
                // 插入数据
                this.InsertDataIntoDataTable(targetTableId, triggerInfo)
                const tempDataTableName = this.InsertDataIntoTempDataTable(queryData, targetTableId)
                var localColumns = ''
                for (fieldId in this.dataSheets[targetTableId].fields) {
                  localColumns += 'a.[' + fieldId + '],'
                }
                // 将输出列从数据表中drop，匹配字段列不drop，并移除筛选
                for (fieldId in queryData[0]) {
                  if (execFormulaInfo.match.indexOf(parseInt(fieldId)) < 0) {
                    localColumns = localColumns.replace('a.[' + fieldId + '],', '')
                    if (execFormulaInfo.output[fieldId] === 3) {
                      localColumns += 'CASE WHEN b.[' + fieldId + '] IS NULL THEN a.[' + fieldId + '] ELSE a.[' + fieldId + ']+b.[' + fieldId + '] END as [' + fieldId + '],'
                    } else {
                      localColumns += 'CASE WHEN b.[' + fieldId + '] IS NULL THEN a.[' + fieldId + '] ELSE b.[' + fieldId + '] END as [' + fieldId + '],'
                    }
                  }
                }
                if (this.dataSheets[targetTableId].type < 2) {
                  localColumns = localColumns.substr(0, localColumns.length - 1)
                } else {
                  localColumns += 'a.[index],a.[row],a.[col]'
                }
                var groupBySQL = `SELECT ${localColumns} FROM [${targetTableId}] a LEFT JOIN [${tempDataTableName}] b ON `
                // 构建左关联语句
                // var indexField = ''
                for (fieldId of execFormulaInfo.match) {
                  groupBySQL += `a.[${fieldId}]=b.[${fieldId}] and `
                  // indexField += `[${fieldId}],`
                }
                groupBySQL = groupBySQL.substring(0, groupBySQL.length - 4)
                // 创建索引，由于匹配列内容不适合作字典，速度几乎没有区别
                // alasql(`DROP INDEX [MatrixIndex]`)
                // alasql(`CREATE INDEX [MatrixIndex] ON [${targetTableId}](${indexField.substr(0, indexField.length - 1) })`)
                // alasql(`DROP INDEX [TempMatrixIndex]`)
                // alasql(`CREATE INDEX [TempMatrixIndex] ON [${tempDataTableName}](${indexField.substr(0, indexField.length - 1) })`)
                // 执行，并将结果返回到queryData中
                // console.log(alasql(`select * from ${targetTableId}`))
                // console.log(alasql(`select * from ${tempDataTableName}`))
                // debugger
                queryData = alasql(groupBySQL)
                // 按行列匹配因为引入了整表内容，所以需要整表覆盖回写
                // 如果触发来源为部分行，由于回写时会覆盖，所以无需进行清空
                if (triggerInfo === undefined) {
                  this.CleanDataSheetAreaData(targetTableId)
                }
              }
              // 清空数据
              console.timeEnd('按行列匹配处理')
            }
            // 检查空白行是否够用并扩展
            var usedRowColumnCount
            // 判断目标表是不是交叉表
            if (this.dataSheets[targetTableId].type < 2) {
              usedRowColumnCount = this.CheckAndExtendRows(targetTableId, queryData.length, triggerInfo, undefined, undefined, undefined, true)
              // 开始执行插入
              console.time('插入查询结果')
              this.InsertData2ExtendTable(targetTableId, usedRowColumnCount, queryData, true, execFormulaInfo.specialFilling, null, null, true)
              // 更新受影响行的长度
              if (triggerInfo) { triggerInfo.length = queryData.length || triggerInfo.length }
              console.timeEnd('插入查询结果')
            } else {
              var insertField = {
                top: '',
                left: '',
                data: ''
              }
              for (fieldId in queryData[0]) {
                if (this.id2Info[fieldId]) {
                  switch (this.id2Info[fieldId].extType) {
                    case 1:
                      insertField.left += `[${fieldId}],`
                      break
                    case 2:
                      insertField.top += `[${fieldId}],`
                      break
                    case 3:
                      insertField.data += `[${fieldId}],`
                      break
                  }
                }
              }
              var insertData, dataRowColInfo
              var usedRangeInfo = this.GetMatrixUsedInfo(targetTableId)
              for (var position in insertField) {
                if (insertField[position]) {
                  var hasValue = false
                  insertField[position] = insertField[position].substring(0, insertField[position].length - 1)
                  switch (position) {
                    case 'left':
                      insertData = alasql(`SELECT ${insertField[position]}${insertField.data ? ',[row]' : ''} FROM ? GROUP BY ${insertField[position]}${insertField.data ? ',[row]' : ''}`, [queryData])
                      insertData.forEach((row, index) => {
                        row.row = index
                        if (!hasValue) {
                          for (fieldId in row) {
                            if (row[fieldId] !== undefined && fieldId !== 'row') {
                              hasValue = true
                              break
                            }
                          }
                        }
                      })
                      dataRowColInfo = {
                        row: insertData.length
                      }
                      break
                    case 'top':
                      insertData = alasql(`SELECT ${insertField[position]}${insertField.data ? ',[col]' : ''} FROM ? GROUP BY ${insertField[position]}${insertField.data ? ',[col]' : ''}`, [queryData])
                      insertData.forEach((col, index) => {
                        col.col = index
                        if (!hasValue) {
                          for (fieldId in col) {
                            if (col[fieldId] !== undefined && fieldId !== 'col') {
                              hasValue = true
                              break
                            }
                          }
                        }
                      })
                      dataRowColInfo = {
                        col: insertData.length
                      }
                      break
                    case 'data':
                      insertData = alasql(`SELECT ${insertField[position]},[row],[col] FROM ?`, [queryData])
                      insertData.forEach((row, index) => {
                        if (!hasValue) {
                          for (fieldId in row) {
                            if (row[fieldId] !== undefined && fieldId !== 'row' && fieldId !== 'col') {
                              hasValue = true
                              break
                            }
                          }
                        }
                      })
                      dataRowColInfo = {
                        row: alasql(`SELECT DISTINCT count([col]) AS [col] FROM ? GROUP BY [col]`, [insertData])[0].col,
                        col: alasql(`SELECT DISTINCT count([row]) AS [row] FROM ? GROUP BY [row]`, [insertData])[0].row
                      }
                      break
                  }
                  if (!hasValue) {
                    continue
                  }
                  usedRowColumnCount = this.CheckAndExtendRows(targetTableId, dataRowColInfo, triggerInfo, position, usedRangeInfo, undefined, true)
                  console.time('插入查询结果')
                  if (execFormulaInfo.match.length > 0) {
                    if (triggerInfo) {
                      this.InsertData2ExtendTable(targetTableId, { row: triggerInfo.top, col: triggerInfo.left }, insertData, true)
                    } else {
                      this.InsertData2ExtendTable(targetTableId, { row: 0, col: 0 }, insertData, true)
                    }
                  } else {
                    this.InsertData2ExtendTable(targetTableId, {
                      row: usedRowColumnCount.usedRowColumnCount.row > usedRowColumnCount.centerUsedCount.row
                        ? usedRowColumnCount.usedRowColumnCount.row : usedRowColumnCount.centerUsedCount.row,
                      col: usedRowColumnCount.usedRowColumnCount.col > usedRowColumnCount.centerUsedCount.col
                        ? usedRowColumnCount.usedRowColumnCount.col : usedRowColumnCount.centerUsedCount.col
                    }, insertData, true)
                  }
                  // 更新受影响行的长度
                  if (triggerInfo) {
                    if (triggerInfo.length.row < dataRowColInfo.row) {
                      triggerInfo.length.row = dataRowColInfo.row || triggerInfo.length.row
                    }
                    if (triggerInfo.length.col < dataRowColInfo.col) {
                      triggerInfo.length.col = dataRowColInfo.col || triggerInfo.length.col
                    }
                  }
                  console.timeEnd('插入查询结果')
                }
              }
            }
            console.time('执行后清除空行')
            // 填充表为扩展表时才会执行
            if (execFormulaInfo.cleanBlank === 1) {
              const dataSheetInfo = this.dataSheets[execFormulaInfo.tableId]
              const usedRowColumnInfo = dataSheetInfo.extType === 2 ? this.GetDataSheetUsedColumnInfo(execFormulaInfo.tableId) : this.GetDataSheetUsedRowInfo(execFormulaInfo.tableId)
              // 取数据表默认行数
              deleteRangeJson = this.GetNameRangeJson(dataSheetInfo.areaAlias)
              deleteRangeJson.workSheet = that.dataSheets[targetTableId].sheetName
              // 执行删除行
              if (usedRowColumnInfo.usedRowColumnCount < this.dataSheetDefaultLines[execFormulaInfo.tableId] && execFormulaInfo.keepRowCol === 1) {
                // 判断是否需要保留设计行数
                usedRowColumnInfo.usedRowColumnCount = this.dataSheetDefaultLines[execFormulaInfo.tableId]
              }
              usedRowColumnInfo.usedRowColumnCount = usedRowColumnInfo.usedRowColumnCount > 2 ? usedRowColumnInfo.usedRowColumnCount : 2
              switch (dataSheetInfo.extType) {
                case 1:
                  // 向下扩展
                  leftRow = usedRowColumnInfo.usedRangeJson.bottomRight.row - usedRowColumnInfo.usedRangeJson.topLeft.row + 1
                  if (leftRow > 2 && leftRow > usedRowColumnInfo.usedRowColumnCount) {
                    deleteRangeJson.topLeft.row = usedRowColumnInfo.usedRowColumnCount <= 2 ? deleteRangeJson.topLeft.row + 2 : usedRowColumnInfo.usedRangeJson.topLeft.row + usedRowColumnInfo.usedRowColumnCount
                    this.DeleteRowColumn(deleteRangeJson, 'row', true, true, true)
                  }
                  break
                case 2:
                  // 向右扩展
                  leftCol = usedRowColumnInfo.usedRangeJson.bottomRight.col - usedRowColumnInfo.usedRangeJson.topLeft.col + 1
                  if (leftCol > 2 && leftCol > usedRowColumnInfo.usedRowColumnCount) {
                    deleteRangeJson.topLeft.col = usedRowColumnInfo.usedRowColumnCount <= 2 ? deleteRangeJson.topLeft.col + 2 : usedRowColumnInfo.usedRangeJson.topLeft.col + usedRowColumnInfo.usedRowColumnCount
                    this.DeleteRowColumn(deleteRangeJson, 'column', true, true, true)
                  }
                  break
                case 3:
                  // 交叉扩展
                  if (execFormulaInfo.keepRowCol === 1) {
                    usedRowColumnInfo.matrix.usedRow = usedRowColumnInfo.matrix.usedRow > this.dataSheetDefaultLines[execFormulaInfo.tableId].row ? usedRowColumnInfo.matrix.usedRow : this.dataSheetDefaultLines[execFormulaInfo.tableId].row
                    usedRowColumnInfo.matrix.usedCol = usedRowColumnInfo.matrix.usedCol > this.dataSheetDefaultLines[execFormulaInfo.tableId].col ? usedRowColumnInfo.matrix.usedCol : this.dataSheetDefaultLines[execFormulaInfo.tableId].col
                  } else {
                    usedRowColumnInfo.matrix.usedRow = usedRowColumnInfo.matrix.usedRow > 2 + dataSheetInfo.topMargin ? usedRowColumnInfo.matrix.usedRow : 2 + dataSheetInfo.topMargin
                    usedRowColumnInfo.matrix.usedCol = usedRowColumnInfo.matrix.usedCol > 2 + dataSheetInfo.leftMargin ? usedRowColumnInfo.matrix.usedCol : 2 + dataSheetInfo.leftMargin
                  }
                  if (usedRowColumnInfo.matrix.usedRow > 2 + dataSheetInfo.topMargin && usedRowColumnInfo.usedRangeJson.bottomRight.row - usedRowColumnInfo.usedRangeJson.topLeft.row > usedRowColumnInfo.matrix.usedRow - 1) {
                    const deleteRangeJsonRow = extendFunctions.deepCopy(deleteRangeJson)
                    deleteRangeJsonRow.topLeft.row = usedRowColumnInfo.usedRangeJson.topLeft.row + usedRowColumnInfo.matrix.usedRow
                    this.DeleteRowColumn(deleteRangeJsonRow, 'row', true)
                  }
                  if (usedRowColumnInfo.matrix.usedCol > 2 + dataSheetInfo.leftMargin && usedRowColumnInfo.usedRangeJson.bottomRight.col - usedRowColumnInfo.usedRangeJson.topLeft.col > usedRowColumnInfo.matrix.usedCol - 1) {
                    deleteRangeJson.topLeft.col = usedRowColumnInfo.usedRangeJson.topLeft.col + usedRowColumnInfo.matrix.usedCol
                    this.DeleteRowColumn(deleteRangeJson, 'column', true)
                  }
                  break
              }
            }
            console.timeEnd('执行后清除空行')
            if (this.dataSheets[targetTableId].sheetName !== this.spreadSheet.activeSheet().name()) {
              this.spreadSheet.sheetByName(this.dataSheets[targetTableId].sheetName).recalc(this.spreadSheet._workbook._context)
              console.log('计算非活动sheet公式')
            }
            // 执行完后整表排序
            console.time('执行完后排序')
            if (execFormulaInfo.sort.length > 0) {
              // 检查创建表结构
              if (this.CreateDataTable(targetTableId)) {
                // 插入数据
                this.InsertDataIntoDataTable(targetTableId)
                // 创建orderby查询语句
                var orderBySQL = `SELECT * FROM [${targetTableId}] ORDER BY `
                for (var sortInfo of execFormulaInfo.sort) {
                  orderBySQL += `[${sortInfo.key}] `
                  orderBySQL += sortInfo.order === 0 ? 'DESC ,' : 'ASC ,'
                }
                queryData = alasql(orderBySQL.substring(0, orderBySQL.length - 2))
                console.time('插入排序结果')
                this.CleanDataSheetAreaData(targetTableId)
                this.InsertData2ExtendTable(targetTableId, 0, queryData, true)
                console.timeEnd('插入排序结果')
              }
            }
            console.timeEnd('执行完后排序')
            // 测试数据
            console.time('执行完后分类汇总')
            if (execFormulaInfo.classify > 0 && !paginationInfo) {
              // 取整表数据
              var tableData = this.GetDataFromExtendTable(targetTableId)
              if (tableData && tableData.length > 0) {
                // 数据层级拆分
                var splitTableData = []
                // 统计结果
                var summaryDataInfo = []
                var classifyInfo = extendFunctions.deepCopy(execFormulaInfo.classifySet)
                var fieldIdList = []
                classifyInfo.unshift(extendFunctions.deepCopy(classifyInfo[0]))
                classifyInfo.forEach((item, index) => {
                  if (index === 0) {
                    item.fieldId = -1
                    item.showFieldName = false
                  }
                  fieldIdList.push(item.fieldId)
                  item.level = index
                })
                var splitData = (tableData, fieldIdList) => {
                  var fieldId = fieldIdList.shift()
                  if (tableData.length > 0) {
                    var splitTableData = []
                    var tempTableData = [tableData[0]]
                    tableData.forEach((row, index) => {
                      if (!tableData[index + 1]) {
                        if (fieldIdList.length > 0) {
                          splitTableData.push(splitData(tempTableData, extendFunctions.deepCopy(fieldIdList)))
                        } else {
                          splitTableData.push(tempTableData)
                        }
                        return
                      }
                      if (fieldId === -1 || tableData[index][fieldId] === tableData[index + 1][fieldId]) {
                        tempTableData.push(tableData[index + 1])
                      } else {
                        if (fieldIdList.length > 0) {
                          splitTableData.push(splitData(extendFunctions.deepCopy(tempTableData), extendFunctions.deepCopy(fieldIdList)))
                        } else {
                          splitTableData.push(extendFunctions.deepCopy(tempTableData))
                        }
                        tempTableData = [tableData[index + 1]]
                      }
                    })
                    return splitTableData
                  }
                }
                splitTableData = splitData(tableData, extendFunctions.deepCopy(fieldIdList))
                console.log(splitTableData)
                // 统计计算
                var summaryData = (dataGroup, singleInfo, classifyInfoCopy) => {
                  var fieldId = singleInfo ? singleInfo.fieldId : null
                  var currentDataGroup = []
                  if (classifyInfoCopy.length > 0) {
                    var tempFieldInfo = classifyInfoCopy.shift()
                    dataGroup.forEach((group, index) => {
                      currentDataGroup = currentDataGroup.concat(summaryData(group, tempFieldInfo, extendFunctions.deepCopy(classifyInfoCopy)))
                    })
                  } else {
                    currentDataGroup = dataGroup
                  }
                  if (fieldId) {
                    // 对每个dataGroup做统计
                    var summaryResult = summaryDataInfo.find(info => { info.fieldId === fieldId })
                    var insertTag = false
                    if (!summaryResult) {
                      summaryResult = {
                        fieldId: fieldId,
                        fieldValue: null,
                        labelPosition: singleInfo.labelPosition,
                        background: singleInfo.background,
                        showFieldName: singleInfo.showFieldName,
                        summaryLabel: singleInfo.summaryLabel,
                        level: singleInfo.level,
                        startIndex: -1,
                        endIndex: -1,
                        insertIndex: 0,
                        summary: {}
                      }
                      insertTag = true
                    }
                    currentDataGroup.forEach(dataRow => {
                      if (summaryResult.startIndex < 0) {
                        summaryResult.startIndex = dataRow.index
                      }
                      summaryResult.endIndex = dataRow.index
                      if (!summaryResult.fieldValue) {
                        summaryResult.fieldValue = dataRow[fieldId]
                      }
                      singleInfo.summary.forEach(summaryFieldInfo => {
                        if (!summaryResult.summary[summaryFieldInfo.fieldId]) {
                          summaryResult.summary[summaryFieldInfo.fieldId] = {
                            value: null,
                            temp: null,
                            type: summaryFieldInfo.type
                          }
                        }
                        switch (summaryFieldInfo.type) {
                          case 'sum':
                            if (summaryResult.summary[summaryFieldInfo.fieldId].value === null) {
                              summaryResult.summary[summaryFieldInfo.fieldId].value = dataRow[summaryFieldInfo.fieldId]
                            } else {
                              summaryResult.summary[summaryFieldInfo.fieldId].value += dataRow[summaryFieldInfo.fieldId]
                            }
                            break
                          case 'count':
                            if (summaryResult.summary[summaryFieldInfo.fieldId].value === null) {
                              summaryResult.summary[summaryFieldInfo.fieldId].value = 1
                            } else {
                              summaryResult.summary[summaryFieldInfo.fieldId].value += 1
                            }
                            break
                          case 'max':
                            if (summaryResult.summary[summaryFieldInfo.fieldId].value === null) {
                              summaryResult.summary[summaryFieldInfo.fieldId].value = dataRow[summaryFieldInfo.fieldId]
                            } else {
                              if (summaryResult.summary[summaryFieldInfo.fieldId].value < dataRow[summaryFieldInfo.fieldId]) {
                                summaryResult.summary[summaryFieldInfo.fieldId].value = dataRow[summaryFieldInfo.fieldId]
                              }
                            }
                            break
                          case 'min':
                            if (summaryResult.summary[summaryFieldInfo.fieldId].value === null) {
                              summaryResult.summary[summaryFieldInfo.fieldId].value = dataRow[summaryFieldInfo.fieldId]
                            } else {
                              if (summaryResult.summary[summaryFieldInfo.fieldId].value > dataRow[summaryFieldInfo.fieldId]) {
                                summaryResult.summary[summaryFieldInfo.fieldId].value = dataRow[summaryFieldInfo.fieldId]
                              }
                            }
                            break
                          case 'average':
                            if (!summaryResult.summary[summaryFieldInfo.fieldId].temp) {
                              summaryResult.summary[summaryFieldInfo.fieldId].temp = {
                                sum: 0,
                                count: 0
                              }
                            }
                            summaryResult.summary[summaryFieldInfo.fieldId].temp.sum += dataRow[summaryFieldInfo.fieldId]
                            summaryResult.summary[summaryFieldInfo.fieldId].temp.count += 1
                            summaryResult.summary[summaryFieldInfo.fieldId].value = summaryResult.summary[summaryFieldInfo.fieldId].temp.sum / summaryResult.summary[summaryFieldInfo.fieldId].temp.count
                            break
                        }
                      })
                    })
                    if (insertTag) {
                      summaryDataInfo.push(summaryResult)
                    }
                    return currentDataGroup
                  }
                }
                // 由于是从内向外计算，所以summaryDataInfo的顺序就是插入统计行的顺序
                summaryData(splitTableData, null, extendFunctions.deepCopy(classifyInfo))
                console.log(summaryDataInfo)
                // 插入行位置处理
                var tempSummaryInfo = []
                var handlePosition = () => {
                  if (summaryDataInfo.length === 0) {
                    return
                  }
                  var temp = summaryDataInfo.shift()
                  temp.insertIndex = temp.endIndex + 1
                  tempSummaryInfo.push(temp)
                  summaryDataInfo.filter(info => info.startIndex > temp.startIndex).forEach(info => {
                    info.startIndex += 1
                  })
                  summaryDataInfo.forEach(info => {
                    info.insertIndex += 1
                    info.endIndex += 1
                  })
                  handlePosition()
                }
                handlePosition()
                console.log(tempSummaryInfo)
                // 插入分类汇总信息
                // 获取扩展表所在区域JSON
                var tableRangeJson = this.GetNameRangeJson(this.dataSheets[targetTableId].areaAlias)
                var handleSheet = this.spreadSheet.sheetByName(that.dataSheets[targetTableId].sheetName)
                console.time('单列赋值')
                tempSummaryInfo.forEach(summaryInfo => {
                  var handleRangeJson = {
                    topLeft: {
                      row: tableRangeJson.topLeft.row + summaryInfo.insertIndex - 1,
                      col: tableRangeJson.topLeft.col
                    },
                    bottomRight: {
                      row: tableRangeJson.topLeft.row + summaryInfo.insertIndex - 1,
                      col: tableRangeJson.bottomRight.col
                    },
                    workSheet: this.dataSheets[targetTableId].sheetName
                  }
                  // 插入行
                  this.InsertRowColumn(handleRangeJson, 'row', 1, true, undefined, false)
                  // 填入值
                  var insertData = {}
                  insertData[summaryInfo.labelPosition] = (summaryInfo.showFieldName ? summaryInfo.fieldValue : '') + (summaryInfo.summaryLabel || '总合计')
                  summaryInfo.labelCol = this.GetNameRangeJson(this.id2Info[summaryInfo.labelPosition].areaAlias).topLeft.col - 1
                  for (var fieldId in summaryInfo.summary) {
                    insertData[fieldId] = summaryInfo.summary[fieldId].value
                  }
                  delete summaryInfo.summary
                  var that = this
                  // 按列/行进行插入
                  handleSheet.batch(function() {
                    // 填充颜色
                    handleRangeJson.topLeft.row += 1
                    handleRangeJson.bottomRight.row += 1
                    var handleExtentTable = that.dataSheets[targetTableId].areaAlias
                    var fieldInfo, insertRangeJson, fieldRange, insertColumnValues
                    for (var fieldId in insertData) {
                      fieldInfo = that.dataSheets[targetTableId].fields[fieldId]
                      insertColumnValues = []
                      // 向下扩展
                      insertColumnValues.push([formatConverter.SetValidValue(fieldInfo.baseType, insertData[fieldId], that)])
                      insertRangeJson = that.GetNameRangeJson(fieldInfo.areaAlias)
                      insertRangeJson.topLeft.row = insertRangeJson.topLeft.row + summaryInfo.insertIndex
                      insertRangeJson.bottomRight.row = insertRangeJson.topLeft.row
                      fieldRange = formatConverter.ConvertJsonToRange(insertRangeJson)
                      // 一次6个有值单元格耗时1.5ms
                      this.range(fieldRange).values(insertColumnValues)
                      this.range(fieldRange).classify(summaryInfo)
                    }
                    this.range(formatConverter.ConvertJsonToRange(handleRangeJson)).background(summaryInfo.background)
                    handleExtentTable = formatConverter.ConvertJsonToRange(that.GetNameRangeJson(handleExtentTable))
                    this.range(handleExtentTable)._manualAdjustRowHeight()
                  })
                })
                console.timeEnd('单列赋值')
                this.tableClassifyInfo[targetTableId] = tempSummaryInfo
                // 锁定扩展表
                handleSheet.range(formatConverter.ConvertAllFormat2Json(tableRangeJson, this)).enable(false)
                handleSheet.range(formatConverter.ConvertAllFormat2Json(tableRangeJson, this)).attachEnable(false)
              }
            }
            this.RefreshExtendTable(targetTableId, true)
            console.timeEnd('执行完后分类汇总')
          }
          console.timeEnd('====================执行取数公式：' + formulaId + '===================')
          if (queryData.length === 0) {
            console.warn('取数公式：' + formulaId + '执行结果为空！')
          }
        } else {
          throw new Error('取数公式执行失败！数据库执行错误。')
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.queryFail'), exception)
      }
    },

    async excuteDecide(targetTableId, triggerInfo, param, expression) {
      var query = 'SELECT 1 ' + (JSON.stringify(param) === '{}' ? '' : 'FROM ')
      var tableId
      var paramObj = this.GetParamWithTableInfo(param, triggerInfo, targetTableId)
      var paramData = []
      for (tableId in paramObj) {
        paramData.push(paramObj[tableId])
        // var tableJson = {}
        // tableJson[tableId] = param[tableId]
        query += `? [${tableId}],`
      }
      // 组合查询语句
      if (JSON.stringify(param) !== '{}') {
        query = query.substring(0, query.length - 1)
      }
      query += (' WHERE ' + expression)
      if (query.indexOf('@s') >= 0) {
        var variables = (await getSystemVariables()).data
        query = this.ReplaceVariables(query, variables)
      }
      var result = alasql(query, paramData)
      console.log(query, paramData, result)
      return result
    },

    handleClassifyHidden(handleRange) {
      var classify = handleRange.classify()
      var hidden = handleRange.classifyHidden()
      var handleTableInfo = this.dataSheets[this.id2Info[classify.labelPosition].owner]
      var tableRangeJson = this.GetNameRangeJson(handleTableInfo.areaAlias)
      var handleSheet = this.spreadSheet.sheetByName(handleTableInfo.sheetName)
      handleSheet.batch(() => {
        for (var i = tableRangeJson.topLeft.row + classify.startIndex; i <= tableRangeJson.topLeft.row + classify.endIndex; i++) {
          if (hidden) {
            // 转展现
            if (handleSheet.isHiddenRow(i - 1)) {
              handleSheet.unhideRow(i - 1)
            }
          } else {
            // 转隐藏
            if (!handleSheet.isHiddenRow(i - 1)) {
              handleSheet.hideRow(i - 1)
            }
          }
        }
      })
      handleRange.classifyHidden(!hidden)
      handleSheet.range(formatConverter.ConvertJsonToRange({
        topLeft: {
          row: tableRangeJson.topLeft.row + classify.startIndex,
          col: tableRangeJson.topLeft.col
        },
        bottomRight: {
          row: tableRangeJson.topLeft.row + classify.endIndex,
          col: tableRangeJson.bottomRight.col
        }
      })).classifyHidden(!hidden)
    },
    cancelClassify(tableId) {
      var handleTableInfo = this.dataSheets[tableId]
      var tableRangeJson = this.GetNameRangeJson(handleTableInfo.areaAlias)
      var handleSheet = this.spreadSheet.sheetByName(handleTableInfo.sheetName)
      var targetProp = this.tableClassifyInfo[tableId]
      handleSheet.batch(() => {
        for (var i = targetProp.length - 1; i >= 0; i--) {
          handleSheet.deleteRow(tableRangeJson.topLeft.row + targetProp[i].insertIndex - 1)
        }
      })
      delete this.tableClassifyInfo[tableId]
      this.UnLockWhiteListRanges(handleTableInfo.sheetName)
    },
    // 执行所有手动执行公式
    execManualFormula: function() {
      var formulaList = []
      for (var formulaId in this.queryFormulaInfos) {
        if ((this.queryFormulaInfos[formulaId].handle & 0x00000020) === 0x00000020) {
          formulaList.push(parseInt(formulaId))
        }
      }
      this.showFormulaLoading = true
      this.QueryFormulaHelper(formulaList)
    },

    // 按执行时机执行取数公式
    // 新建后
    // AfterCreated = 0x00000001,
    // 修改时
    // Modifying    = 0x00000002,
    // 保存前
    // AfterSaving  = 0x00000004,
    // 自动
    // Auto         = 0x00000128,
    // 手动
    // Manual       = 0x00000256
    async ExcuteQueryFormulaByHandle(handle, skipWorkflow) {
      // console.log(handle)
      this.showFormulaLoading = false
      switch (handle) {
        case 'AfterCreated':
          handle = 1
          break
        case 'BeforeModify':
          handle = 2
          break
        case 'AfterSaving':
          handle = 4
          break
        case 'AfterView':
          handle = 512
          break
        case 'AutoExecute':
          this.showFormulaLoading = true
          handle = 128
          break
        case 'ManualExecute':
          this.showFormulaLoading = true
          handle = 256
          break
        default:
          extendFunctions.errorMessage(this.$t('report.queryTimingError'), this.$t('report.queryTimingError'))
          return
      }
      var formulaList = []
      for (var formulaId in this.queryFormulaInfos) {
        // 位运算判断需要进行新增时执行的公式，放入数组等待处理
        if ((this.queryFormulaInfos[formulaId].handle & handle) === handle) {
          if (skipWorkflow) {
            if (!this.queryFormulaInfos[formulaId].workFlowId) {
              formulaList.push(formulaId)
            }
          } else {
            formulaList.push(formulaId)
          }
        }
      }
      await this.QueryFormulaHelper(formulaList)
    },
    // *********************
    // *******动态样式*******
    // *********************
    async ExcuteFormatFormulaByHandle(handle) {
      // console.log(handle)
      this.showFormulaLoading = false
      switch (handle) {
        case 'AfterCreated':
          handle = 1
          break
        case 'BeforeModify':
          handle = 2
          break
        case 'AfterSaving':
          handle = 4
          break
        case 'AfterView':
          handle = 512
          break
        case 'AutoExecute':
          this.showFormulaLoading = true
          handle = 128
          break
        case 'ManualExecute':
          this.showFormulaLoading = true
          handle = 256
          break
        default:
          extendFunctions.errorMessage(this.$t('report.styleTimingError'), this.$t('report.styleTimingError'))
          return
      }
      var formulaList = []
      for (var formulaId in this.formatFormulaInfos) {
        // 位运算判断需要进行新增时执行的公式，放入数组等待处理
        if ((this.formatFormulaInfos[formulaId].timing & handle) === handle) {
          formulaList.push(formulaId)
        }
      }
      await this.FormatFormulaHelper(formulaList)
    },

    // 动态样式队列方法
    async FormatFormulaHelper(formatFormulaList, triggerInfo, messageObj, sourceTableId) {
      try {
        if (!(formatFormulaList instanceof Array) || !formatFormulaList.length > 0) {
          return
        }
        formatFormulaList = extendFunctions.ArrayDistinct(formatFormulaList)
        if (!messageObj) {
          messageObj = {}
        }
        // 根据seq排序
        if (formatFormulaList.length > 0) {
          var formatFormulaSeq = []
          formatFormulaList.forEach(formulaId => {
            if (this.formatFormulaInfos[formulaId]) {
              formatFormulaSeq.push({
                id: formulaId,
                seq: this.formatFormulaInfos[formulaId].seq
              })
            }
          })
          formatFormulaSeq.sort(extendFunctions.sortBy('seq'))
          formatFormulaList = []
          formatFormulaSeq.forEach(formulaInfo => {
            formatFormulaList.push(formulaInfo.id)
          })
        }
        // 提交处理
        var loadingInstance
        if (this.showFormulaLoading) {
          loadingInstance = Loading.service({
            background: 'transparent',
            text: this.$t('report.waiting')
          })
        }
        for (var formulaId of formatFormulaList) {
          await this.ExcuteFormatFormula(formulaId, this.formatFormulaInfos[formulaId].tableId === sourceTableId ? triggerInfo : undefined)
          if (messageObj[formulaId]) {
            extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[formulaId])
          }
        }
        if (this.showFormulaLoading) {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.styleError'), exception)
        return false
      }
    },

    // 动态样式执行主方法
    // triggerInfo={top:开始行,left:开始列,length:影响行数}
    async ExcuteFormatFormula(formulaId, triggerInfo) {
      var fieldId
      console.time('====================执行动态样式：' + formulaId + '===================')
      const execFormulaInfo = this.formatFormulaInfos[formulaId]
      // 整理param对象，tableId=>fieldId
      var execAction = 0 // 0=收缩，1=展开
      if (execFormulaInfo.expression) {
        // 获取参数
        var query = 'SELECT 1 ' + (execFormulaInfo.triggerList.length > 0 ? 'FROM ' : '')
        var param = {}
        for (fieldId of execFormulaInfo.triggerList) {
          if (!param[this.id2DataSheets[fieldId]]) {
            param[this.id2DataSheets[fieldId]] = []
          }
          param[this.id2DataSheets[fieldId]].push(fieldId)
        }
        // 触发字段所在tableId取trigger行，其他取整表
        var paramData = []
        for (var tableId in param) {
          var tableJson = {}
          tableJson[tableId] = param[tableId]
          query += `? [${tableId}],`
          paramData.push([this.GetParamWithFieldId(tableJson[tableId], tableId === this.id2DataSheets[execFormulaInfo.targetFieldId] ? triggerInfo : null, undefined, 1)])
        }
        console.log(paramData)
        // 组合查询语句
        if (execFormulaInfo.triggerList.length > 0) {
          query = query.substring(0, query.length - 1)
        }
        query += (' WHERE ' + execFormulaInfo.expression)
        // 根据计算结果进行扩展收缩处理
        var result = alasql(query, paramData)
        if (result.length === 0) {
          execAction = execFormulaInfo.action ? 0 : 1
        } else {
          execAction = execFormulaInfo.action
        }
      } else {
        execAction = execFormulaInfo.action
        execFormulaInfo.action = execFormulaInfo.action ? 0 : 1
      }
      console.log(execAction)
      var i
      // 获取操作行列信息
      var objRange = this.GetNameRangeJson(this.id2Info[execFormulaInfo.originField].areaAlias)
      var handleSheet = this.id2Info[execFormulaInfo.originField].sheetName
      var handleRange = []
      var that = this
      this.spreadSheet.sheetByName(handleSheet).batch(() => {
        if (execFormulaInfo.direction) {
          // 横向
          handleRange.push(objRange.topLeft.row - execFormulaInfo.headOffset)
          handleRange.push(objRange.bottomRight.row + execFormulaInfo.tailOffset)
          console.log(handleRange)
          if (execAction) {
            // 展开
            for (i = handleRange[0]; i <= handleRange[1]; i++) {
              if (i - 1 >= 0) {
                that.spreadSheet.sheetByName(handleSheet).unhideRow(i - 1)
              }
            }
          } else {
            // 收缩
            for (i = handleRange[0]; i <= handleRange[1]; i++) {
              if (i - 1 >= 0) {
                that.spreadSheet.sheetByName(handleSheet).hideRow(i - 1)
              }
            }
          }
        } else {
          // 纵向
          handleRange.push(objRange.topLeft.col - execFormulaInfo.headOffset)
          handleRange.push(objRange.bottomRight.col + execFormulaInfo.tailOffset)
          if (execAction) {
            // 展开
            for (i = handleRange[0]; i <= handleRange[1]; i++) {
              if (i - 1 >= 0) {
                that.spreadSheet.sheetByName(handleSheet).unhideColumn(i - 1)
              }
            }
          } else {
            // 收缩
            for (i = handleRange[0]; i <= handleRange[1]; i++) {
              if (i - 1 >= 0) {
                that.spreadSheet.sheetByName(handleSheet).hideColumn(i - 1)
              }
            }
          }
        }
        console.timeEnd('====================执行动态样式：' + formulaId + '===================')
      })
    },

    // *********************
    // *******别名处理*******
    // *********************
    // 根据别名给出区域，返回Json格式
    GetNameRangeJson: function(name, raw) {
      var range = this.spreadSheet._workbook._names[name.toLowerCase()]
      if (range === undefined) {
        range = this.spreadSheet._workbook._names["'" + name.toLowerCase() + "'"]
        if (range === undefined) {
          return {}
        }
      }
      return raw ? range.value : formatConverter.ConvertAllFormat2Json(range.value, this)
    },

    // 执行前不进行强制排序
    // 相同值合并
    // break=true则是移除合并
    MergeSameField: function(tableId, breakUp) {
      console.time(breakUp ? '解除合并' : '相同值合并')
      var that = this
      var tableUsedRangeJson, thisSheet
      if (this.dataSheets[tableId]) {
        if (this.mergeFields[tableId] && this.mergeFields[tableId].length > 0) {
          // var tableExtType = this.dataSheets[tableId].extType
          // 对查找的内容根据大小顺序进行排序
          this.mergeFields[tableId].sort(extendFunctions.sortBy('autoMerge'))
          // 只对range内的字段进行合并处理
          switch (this.dataSheets[tableId].type) {
            case 0:
              break
            case 1:
              // 找出扩展表中所有需要进行合并的字段
              if (breakUp) {
                thisSheet = this.spreadSheet.sheetByName(this.dataSheets[tableId].sheetName)
                // 解除合并
                thisSheet.batch(() => {
                  // var dealRange
                  this.mergeFields[tableId].forEach(mergeItem => {
                    if (mergeItem.owner !== +tableId) {
                      console.timeEnd(breakUp ? '解除合并' : '相同值合并')
                      return
                    } else {
                      that.unmergeCells(mergeItem, this.dataSheets[tableId].extType, thisSheet)
                    }
                  })
                })
              } else {
                if (this.dataSheets[tableId].extType === 1) {
                  tableUsedRangeJson = this.GetDataSheetUsedRowInfo(tableId)
                  tableUsedRangeJson.usedRangeJson.bottomRight.row = tableUsedRangeJson.usedRangeJson.topLeft.row + tableUsedRangeJson.usedRowColumnCount - 1
                } else {
                  tableUsedRangeJson = this.GetDataSheetUsedColumnInfo(tableId)
                  tableUsedRangeJson.usedRangeJson.bottomRight.col = tableUsedRangeJson.usedRangeJson.topLeft.col + tableUsedRangeJson.usedRowColumnCount - 1
                }
                if (tableUsedRangeJson.usedRowColumnCount > 0) {
                  this.mergeCells(extendFunctions.deepCopy(this.mergeFields[tableId]), tableUsedRangeJson.usedRangeJson)
                }
              }
              break
            case 2:
              // 交叉表
              tableUsedRangeJson = this.GetMatrixUsedInfo(tableId)
              if (breakUp) {
                thisSheet = this.spreadSheet.sheetByName(this.dataSheets[tableId].sheetName)
                // 解除合并
                thisSheet.batch(() => {
                  this.mergeFields[tableId].forEach(mergeItem => {
                    if (mergeItem.owner !== +tableId) {
                      console.timeEnd(breakUp ? '解除合并' : '相同值合并')
                      return
                    }
                    that.unmergeCells(mergeItem, undefined, thisSheet)
                  })
                })
              } else {
                if (tableUsedRangeJson.usedRowColumnCount.row > 0) {
                  this.mergeCells(extendFunctions.deepCopy(this.mergeFields[tableId]).filter(fieldInfo => {
                    return fieldInfo.extType === 1
                  }))
                }
                if (tableUsedRangeJson.usedRowColumnCount.col > 0) {
                  this.mergeCells(extendFunctions.deepCopy(this.mergeFields[tableId]).filter(fieldInfo => {
                    return fieldInfo.extType === 2
                  }))
                }
              }
              break
          }
        }
      } else {
        console.error('参数错误')
      }
      console.timeEnd(breakUp ? '解除合并' : '相同值合并')
    },

    mergeCells: function(fieldList, range) {
      if (!fieldList || fieldList.length === 0) {
        return
      }
      var fieldInfo = fieldList.shift()
      var fieldType = fieldInfo.extType || this.dataSheets[fieldInfo.owner].extType || 1
      var fieldRange = this.GetNameRangeJson(fieldInfo.areaAlias)
      var cellValue, mergeRangeJson, rowIndex, colIndex
      var tempValue = '$unset'
      var startRow = -1
      var startCol = -1
      var lastRow = false
      var lastCol = false
      var that = this
      var thisSheet = this.spreadSheet.sheetByName(this.dataSheets[fieldInfo.owner].sheetName)
      switch (fieldType) {
        case 1:
          // 向下扩展
          if (range) {
            fieldRange.topLeft.row = range.topLeft.row
            fieldRange.bottomRight.row = range.bottomRight.row
            range = fieldRange
          } else {
            range = fieldRange
          }
          rowIndex = range.topLeft.row
          thisSheet.batch(() => {
            for (rowIndex = range.topLeft.row; rowIndex <= range.bottomRight.row; rowIndex++) {
              lastRow = (rowIndex === range.bottomRight.row)
              cellValue = thisSheet.range(formatConverter.ConvertJsonToA1({ row: rowIndex, col: range.topLeft.col })).value()
              if (tempValue === '$unset') {
                startRow = rowIndex
                if (cellValue === undefined) {
                  continue
                }
                tempValue = cellValue
              } else {
                if (tempValue !== cellValue || lastRow) {
                  // 找到不同了，则进行合并
                  var mergeRow = (lastRow && tempValue === cellValue) ? rowIndex : rowIndex - 1
                  if (mergeRow - startRow > 0) {
                    // 只有相同行大于1时才进行合并操作
                    mergeRangeJson = {
                      topLeft: {
                        row: startRow,
                        col: range.topLeft.col
                      },
                      bottomRight: {
                        row: mergeRow,
                        col: range.bottomRight.col
                      }
                    }
                    thisSheet.range(formatConverter.ConvertJsonToRange(mergeRangeJson)).merge()
                    // 递归找下一个需要合并的字段
                    if (fieldList.length > 0) {
                      that.mergeCells(extendFunctions.deepCopy(fieldList), mergeRangeJson)
                    }
                  }
                  tempValue = (cellValue === undefined) ? '$unset' : cellValue
                  startRow = rowIndex
                } else {
                  continue
                }
              }
            }
          })
          break
        case 2:
          if (range) {
            fieldRange.topLeft.col = range.topLeft.col
            fieldRange.bottomRight.col = range.bottomRight.col
            range = fieldRange
          } else {
            range = fieldRange
          }
          colIndex = range.topLeft.col
          thisSheet.batch(() => {
            for (colIndex = range.topLeft.col; colIndex <= range.bottomRight.col; colIndex++) {
              lastCol = (colIndex === range.bottomRight.col)
              cellValue = thisSheet.range(formatConverter.ConvertJsonToA1({ row: range.topLeft.row, col: colIndex })).value()
              if (tempValue === '$unset') {
                startCol = colIndex
                if (cellValue === undefined) {
                  continue
                }
                tempValue = cellValue
              } else {
                // debugger
                if (tempValue !== cellValue || lastCol) {
                  // 找到不同了，则进行合并
                  var mergeCol = (lastCol && tempValue === cellValue) ? colIndex : colIndex - 1
                  if (mergeCol - startCol > 0) {
                    // 只有相同行大于1时才进行合并操作
                    mergeRangeJson = {
                      topLeft: {
                        row: range.topLeft.row,
                        col: startCol
                      },
                      bottomRight: {
                        row: range.bottomRight.row,
                        col: mergeCol
                      }
                    }
                    thisSheet.range(formatConverter.ConvertJsonToRange(mergeRangeJson)).merge()
                    // 递归找下一个需要合并的字段
                    if (fieldList.length > 0) {
                      that.mergeCells(extendFunctions.deepCopy(fieldList), mergeRangeJson)
                    }
                  }
                  tempValue = (cellValue === undefined) ? '$unset' : cellValue
                  startCol = colIndex
                } else {
                  continue
                }
              }
            }
          })
          break
      }
    },

    unmergeCells: function(fieldInfo, extType, thisSheet) {
      var dealRange = this.GetNameRangeJson(fieldInfo.areaAlias)
      var mergedInfo, item, cellValue, col, row
      switch (extType || fieldInfo.extType) {
        case 1:
          mergedInfo = thisSheet._getMergedCells(new kendo.spreadsheet.RangeRef(
            { row: dealRange.topLeft.row - 1, col: dealRange.topLeft.col - 1 },
            { row: dealRange.bottomRight.row - 1, col: dealRange.bottomRight.col - 1 })
          )
          if (mergedInfo.hasMerged) {
            thisSheet.range(formatConverter.ConvertJsonToRange(dealRange)).unmerge()
            for (item in mergedInfo.primary) {
              cellValue = thisSheet.range(new kendo.spreadsheet.CellRef(mergedInfo.primary[item].topLeft.row,
                mergedInfo.primary[item].topLeft.col)).value()
              for (row = mergedInfo.primary[item].topLeft.row + 1; row <= mergedInfo.primary[item].bottomRight.row; row++) {
                thisSheet.range(new kendo.spreadsheet.CellRef(row, mergedInfo.primary[item].topLeft.col)).value(cellValue)
              }
              if (mergedInfo.primary[item].topLeft.col !== mergedInfo.primary[item].bottomRight.col) {
                for (row = mergedInfo.primary[item].topLeft.row; row <= mergedInfo.primary[item].bottomRight.row; row++) {
                  thisSheet.range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: row + 1,
                      col: mergedInfo.primary[item].topLeft.col + 1
                    },
                    bottomRight: {
                      row: row + 1,
                      col: mergedInfo.primary[item].bottomRight.col + 1
                    }
                  })).merge()
                }
              }
            }
          }
          break
        case 2:
          mergedInfo = thisSheet._getMergedCells(new kendo.spreadsheet.RangeRef(
            { row: dealRange.topLeft.row - 1, col: dealRange.topLeft.col - 1 },
            { row: dealRange.bottomRight.row - 1, col: dealRange.bottomRight.col - 1 })
          )
          if (mergedInfo.hasMerged) {
            thisSheet.range(formatConverter.ConvertJsonToRange(dealRange)).unmerge()
            for (item in mergedInfo.primary) {
              cellValue = thisSheet.range(new kendo.spreadsheet.CellRef(mergedInfo.primary[item].topLeft.row,
                mergedInfo.primary[item].topLeft.col)).value()
              for (col = mergedInfo.primary[item].topLeft.col + 1; col <= mergedInfo.primary[item].bottomRight.col; col++) {
                thisSheet.range(new kendo.spreadsheet.CellRef(mergedInfo.primary[item].topLeft.row, col)).value(cellValue)
              }
              if (mergedInfo.primary[item].topLeft.row !== mergedInfo.primary[item].bottomRight.row) {
                for (col = mergedInfo.primary[item].topLeft.col; col <= mergedInfo.primary[item].bottomRight.col; col++) {
                  thisSheet.range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: mergedInfo.primary[item].topLeft.row + 1,
                      col: col + 1
                    },
                    bottomRight: {
                      row: mergedInfo.primary[item].bottomRight.row + 1,
                      col: col + 1
                    }
                  })).merge()
                }
              }
            }
          }
          break
        default:
          break
      }
    },

    // 根据选择区域Json获取别名区域和名称，区域完全在别名范围内才会返回（排除数据表的别名）
    GetRangeInNameRange(Json, sheetName, onlyField) {
      var tempNameRange
      for (var nameRange in this.spreadSheet._workbook._names) {
        if (nameRange.substring(0, 1) !== '_') {
          continue
        }
        tempNameRange = this.spreadSheet._workbook._names[nameRange].value
        if (sheetName !== undefined && sheetName !== null) {
          if (sheetName !== tempNameRange.sheet) {
            continue
          }
        }
        tempNameRange = formatConverter.ConvertAllFormat2Json(tempNameRange, this)
        if (tempNameRange === undefined) {
          continue
        }
        Json.workSheet = sheetName
        if (this.RangeInclude(Json, tempNameRange)) {
          tempNameRange.name = nameRange
          if (onlyField) {
            if (tempNameRange.name.substring(0, 3) === '_mt' || tempNameRange.name.substring(0, 3) === '_ct') {
              continue
            }
          }
          return tempNameRange
        }
      }
      return undefined
    },

    // 根据选择区域Json获取别名区域和名称，区域完全在数据表的别名范围内才会返回（排除普通区域）
    GetRangeInSelectableRange(Json, sheetName, onlyField) {
      var tempNameRange
      for (var nameRange in this.spreadSheet._workbook._names) {
        if (nameRange.substring(0, 1) !== '_') {
          continue
        }
        tempNameRange = this.spreadSheet._workbook._names[nameRange].value
        if (sheetName !== undefined && sheetName !== null) {
          if (sheetName !== tempNameRange.sheet) {
            continue
          }
        }
        tempNameRange = formatConverter.ConvertAllFormat2Json(tempNameRange, this)
        if (tempNameRange === undefined) {
          continue
        }
        Json.workSheet = sheetName
        if (this.RangeInclude(Json, tempNameRange)) {
          tempNameRange.name = nameRange
          if (onlyField) {
            if (tempNameRange.name.substring(0, 3) === '_mf') {
              continue
            }
          }
          return tempNameRange
        }
      }
      return undefined
    },

    // *********************
    // *******条件格式*******
    // *********************
    // 初始化条件格式
    InitCondition: async function(systemVariables) {
      var fieldId
      try {
        // 整理取数公式自动执行触发字典
        console.time('构建字段的条件格式列表')
        // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
        this.conditionDictionary = {}
        for (fieldId in this.conditionInfos) {
          this.conditionInfos[fieldId].forEach((info, index) => {
            if (!info.e) {
              return
            }
            info.tableId = this.id2DataSheets[fieldId]
            info.index = fieldId + '' + index
            for (var tableId in info.p) {
              info.p[tableId].forEach(triggerFieldId => {
                if (this.conditionDictionary[triggerFieldId] === undefined) {
                  this.conditionDictionary[triggerFieldId] = []
                }
                if (this.conditionDictionary[triggerFieldId].indexOf(fieldId) === -1) {
                  this.conditionDictionary[triggerFieldId].push(fieldId)
                }
              })
            }
          })
        }
        console.timeEnd('构建字段的条件格式列表')
        console.log(this.conditionDictionary)
        // 所有条件格式执行一次
        for (fieldId in this.conditionInfos) {
          await this.ConditionHelper([fieldId], undefined, undefined, systemVariables, true)
        }
        if (this.conditionTriggerInfo) {
          switch (this.conditionTriggerInfo.alertType) {
            case 1:
              extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
              break
            case 2:
              extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
              break
          }
          this.conditionTriggerInfo = null
        }
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(this.$t('report.formatError'), exception)
        this.conditionInfos = undefined
      }
    },

    async ConditionHelper(conditionList, triggerInfo, messageObj, systemVariables, silent) {
      if (this.conditionPause) {
        return
      }
      this.conditionTriggerInfo = null
      try {
        if (!(conditionList instanceof Array) || conditionList.length === 0) {
          return
        }
        conditionList = extendFunctions.ArrayDistinct(conditionList)
        if (!messageObj) {
          messageObj = {}
        }
        // 提交处理
        var loadingInstance
        if (this.showFormulaLoading) {
          loadingInstance = Loading.service({
            background: 'transparent',
            text: this.$t('report.waiting')
          })
          setTimeout(() => {
            if (loadingInstance) {
              loadingInstance.close()
            }
          }, 3000)
        }
        for (var fieldId of conditionList) {
          if (!this.conditionInfos[fieldId]) {
            continue
          }
          var tableTrueType = this.dataSheets[this.id2DataSheets[fieldId]].type + this.dataSheets[this.id2DataSheets[fieldId]].extType
          if (tableTrueType > 1 && !triggerInfo) {
            var fieldRange = this.GetDataFromExtendTable(this.id2DataSheets[fieldId], null, [+fieldId], true, false, 1)
            // for (var i = 0; i < fieldRange.length; i++) {
            //   if (fieldRange[i]) {
            //     await this.ExcuteCondition(fieldId, {
            //       top: i,
            //       length: 1
            //     }, systemVariables)
            //   }
            // }
            await this.ExcuteCondition(fieldId, {
              top: 0,
              length: fieldRange.length
            }, systemVariables, silent)
          } else {
            if (triggerInfo) {
              for (var k = 0; k < triggerInfo.length; k++) {
                await this.ExcuteCondition(fieldId, {
                  top: (triggerInfo.top || 0) + k,
                  left: (triggerInfo.left || 0) + k,
                  length: 1
                }, systemVariables, silent)
              }
            } else {
              await this.ExcuteCondition(fieldId, undefined, systemVariables, silent)
            }
          }
          if (messageObj[fieldId] && !silent) {
            extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[fieldId])
          }
        }
        if (this.showFormulaLoading) {
          this.$nextTick(() => { // 以服务的���式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
      } catch (exception) {
        extendFunctions.errorMessage('条件格式执行失败！', exception)
      }
    },

    async ExcuteCondition(fieldId, triggerInfo, systemVariables, silent) {
      console.time('====================执行条件格式：' + fieldId + '===================')
      for (var i = 0; i < this.conditionInfos[fieldId].length; i++) {
        var execConditionInfo = this.conditionInfos[fieldId][i]
        const detailBatch = triggerInfo && triggerInfo.length > 1
        // debugger
        // 整理param对象，tableId=>fieldId
        // 获取参数
        var that = this
        var param = {}
        var fieldInfo = this.id2Info[fieldId]
        var fieldRow
        var fieldRangeJson = this.GetNameRangeJson(fieldInfo.areaAlias)
        const dataSheetInfo = this.dataSheets[this.id2DataSheets[fieldId]]
        var tableId, triggerFieldId, tagTable
        if (execConditionInfo.p[dataSheetInfo.id]) {
          tagTable = dataSheetInfo.id
        }
        for (tableId in execConditionInfo.p) {
          for (triggerFieldId of execConditionInfo.p[tableId]) {
            if (!param[tableId]) {
              param[tableId] = []
            }
            param[tableId].push(triggerFieldId)
          }
          if (!tagTable) {
            tagTable = tableId
          }
        }
        var query = detailBatch && dataSheetInfo.extType ? `SELECT [${tagTable}].[tag] ` : 'SELECT 1 '
        var fieldJson = extendFunctions.deepCopy(fieldRangeJson)
        if (triggerInfo) {
          switch (this.dataSheets[dataSheetInfo.id].extType) {
            case 1:
              // 向下扩展
              fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length - 1
              fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
              break
            case 2:
              // 向右扩展
              fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.top + triggerInfo.length - 1
              fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.top
              break
            case 3:
              // 交叉扩展
              switch (fieldInfo.extType) {
                case 1:
                  fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                  fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                  break
                case 2:
                  fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                  fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                  break
                case 3:
                  fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
                  fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
                  fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
                  fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
                  break
              }
              break
          }
        }
        // 触发字段所在tableId取trigger行，其他取整表
        var paramData = []
        var fromInserted = false
        for (tableId in param) {
          if (!fromInserted) {
            query += ' FROM '
            fromInserted = true
          }
          var tableJson = {}
          tableJson[tableId] = param[tableId]
          query += `? [${tableId}],`
          const detailRange = +tableId === +execConditionInfo.tableId ? (dataSheetInfo.type !== 0 ? fieldJson : null) : null
          const dataParam = this.GetParamWithFieldId(tableJson[tableId], detailBatch ? null : detailRange, undefined, 1, detailBatch ? true : dataSheetInfo.type === 0, 1, false, detailBatch)
          if (detailBatch) {
            paramData.push(dataParam)
          } else {
            paramData.push([dataParam])
          }
        }
        console.log(paramData)
        // 组合查询语句
        query = query.substring(0, query.length - 1)
        if (execConditionInfo.e.indexOf('@s') >= 0) {
          var variables = systemVariables || (await getSystemVariables()).data
          execConditionInfo.e = this.ReplaceVariables(execConditionInfo.e, variables)
        }
        query += (' WHERE ' + execConditionInfo.e)
        if (query.toLowerCase().indexOf('having') >= 0 && query.toLowerCase().indexOf('group by') < 0) {
          // having特殊处理
          paramData.forEach(table => {
            table.forEach(row => {
              row.tempCol = 1
            })
          })
          var havingPosition = query.toLowerCase().indexOf('having')
          var left = query.substring(0, havingPosition)
          var right = query.substring(havingPosition, query.length)
          query = left + ' group by [tempCol] ' + right
        }
        var result = alasql(query, paramData)
        const excuteStep = (index, endIndex, execAction) => {
          // TODO:连续区域处理
          var fieldCell = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(fieldRangeJson))
          switch (this.dataSheets[fieldInfo.owner].type + this.dataSheets[fieldInfo.owner].extType) {
            case 2:
              fieldCell._ref.bottomRight.row = fieldCell._ref.topLeft.row + triggerInfo.top + endIndex
              fieldCell._ref.topLeft.row += triggerInfo.top + index
              if (execConditionInfo.operation) {
                fieldRow = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dataSheetInfo.areaAlias)))
                fieldRow._ref.topLeft.row = fieldCell._ref.topLeft.row
                fieldRow._ref.bottomRight.row = fieldCell._ref.bottomRight.row
              }
              break
            case 3:
              fieldCell._ref.bottomRight.col = fieldCell._ref.topLeft.col + triggerInfo.left + endIndex
              fieldCell._ref.topLeft.col += triggerInfo.left + index
              if (execConditionInfo.operation) {
                fieldRow = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dataSheetInfo.areaAlias)))
                fieldRow._ref.topLeft.col = fieldCell._ref.topLeft.col
                fieldRow._ref.bottomRight.col = fieldCell._ref.bottomRight.col
              }
              break
            case 4:
              break
          }
          var sheet = this.spreadSheet.sheetByName(fieldInfo.sheetName)
          if (execAction) {
            // 满足条件
            fieldCell.conditionStyle({
              index: execConditionInfo.index,
              bold: execConditionInfo.b > 0,
              italic: execConditionInfo.i > 0,
              underline: execConditionInfo.u > 0,
              color: execConditionInfo.fc,
              background: execConditionInfo.bc
            })
            // 影响整行
            if (that.dataSheets[fieldInfo.owner].type + that.dataSheets[fieldInfo.owner].extType > 1 && execConditionInfo.operation) {
              fieldRow.forEachCell((row, col) => {
                var style = sheet.range(row, col).conditionStyle()
                if (!style || style.level === 'low') {
                  sheet.range(row, col).conditionStyle({
                    index: execConditionInfo.index,
                    bold: execConditionInfo.b > 0,
                    italic: execConditionInfo.i > 0,
                    underline: execConditionInfo.u > 0,
                    color: execConditionInfo.fc,
                    background: execConditionInfo.bc,
                    level: 'low'
                  })
                }
              })
            }
            // 触发自定义按钮
            this.$emit('actionButtonClick', execConditionInfo.actionId)
            // 触发数据验证
            this.conditionTriggerInfo = this.conditionTriggerInfo ? this.conditionTriggerInfo : execConditionInfo
            var alertMessage = this.conditionTriggerInfo.alertMessage
            if (this.conditionTriggerInfo && !silent) {
              switch (this.conditionTriggerInfo.alertType) {
                case 2:
                  if (this.handleChangeEvent) {
                    this.handleChangeEvent.range.values(this.handleChangeEvent.originValues || null)
                    extendFunctions.errorMessage(alertMessage)
                    this.handleChangeEvent = null
                  }
                  break
                case 1:
                  extendFunctions.warningMessage(alertMessage)
                  break
              }
            }
          } else {
            // 不满足条件
            if (fieldCell.conditionStyle() && fieldCell.conditionStyle().index === execConditionInfo.index) {
              fieldCell.conditionStyle(null)
              // 影响整行
              if (that.dataSheets[fieldInfo.owner].type + that.dataSheets[fieldInfo.owner].extType > 1 && execConditionInfo.operation) {
                fieldRow.forEachCell((row, col) => {
                  var style = sheet.range(row, col).conditionStyle()
                  if (style && style.level === 'low' && style.index === execConditionInfo.index) {
                    sheet.range(row, col).conditionStyle(null)
                  }
                })
              }
            }
          }
        }
        if (detailBatch) {
          // 判断是不是主表影响扩展表
          this.spreadSheet.sheetByName(dataSheetInfo.sheetName).batch(() => {
            if (dataSheetInfo.type === 1 && !param[dataSheetInfo.id]) {
              // 来源为扩展表并且没有出现在参数中
              excuteStep(0, triggerInfo.length, result.find(item => item.tag === 0))
            } else {
              for (var i = 0; i < triggerInfo.length; i++) {
                excuteStep(i, i, result.find(item => item.tag === i))
              }
            }
          })
        } else {
          excuteStep(0, 0, result.length > 0)
        }
      }
      console.timeEnd('====================执行条件格式：' + fieldId + '===================')
    },

    // *********************
    // *****单元格处理*******
    // *********************
    // 判断range是否重叠
    RangeOverlaped: function(range, compareRanges) {
      console.error('废弃方法')
      if (compareRanges.length === 0) { return false }
      var compareResult = false
      compareRanges.forEach(function(compareRange) {
        if (JSON.stringify(compareRange) !== '{}' && JSON.stringify(range) !== '{}') {
          if (compareRange.workSheet === range.workSheet && !compareResult) {
            var squares = {
              xa1: compareRange.topLeft.col,
              ya1: compareRange.topLeft.row,
              xa2: compareRange.bottomRight.col,
              ya2: compareRange.bottomRight.row,
              xb1: range.topLeft.col,
              yb1: range.topLeft.row,
              xb2: range.bottomRight.col,
              yb2: range.bottomRight.row
            }
            if (Math.min(squares.xa2, squares.xb2) >= Math.max(squares.xa1, squares.xb1) &&
              Math.min(squares.ya2, squares.yb2) >= Math.max(squares.ya1, squares.yb1)) {
              compareResult = true
            } else {
              if ((squares.xa1 <= squares.xb1 && squares.ya1 <= squares.yb1 &&
                squares.xa2 >= squares.xb2 && squares.ya2 >= squares.yb2) ||
                (squares.xa1 > squares.xb1 && squares.ya1 > squares.yb1 &&
                  squares.xa2 < squares.xb2 && squares.ya2 < squares.yb2)) {
                compareRange = true
              }
            }
          }
        } else {
          console.error(new Date() + ' 重叠对比参数为空')
        }
      })
      return compareResult
    },

    // 判断range是否包含关系
    RangeInclude: function(range, biggerRange) {
      if (biggerRange.topLeft.row <= range.topLeft.row &&
        biggerRange.topLeft.col <= range.topLeft.col &&
        biggerRange.bottomRight.row >= range.bottomRight.row &&
        biggerRange.bottomRight.col >= range.bottomRight.col) {
        return true
      }
      return false
    },

    // 获取合并单元格列表
    GetMergedCellsList: function(sheetName) {
      var i
      var j
      var tempMergedCells
      var mergedCells = []
      for (i = 0; i < this.spreadSheet._workbook._sheets.length; i++) {
        if (sheetName !== undefined && sheetName !== null) {
          if (sheetName !== this.spreadSheet._workbook._sheets[i].name()) {
            continue
          }
        }
        tempMergedCells = extendFunctions.deepCopy(this.spreadSheet._workbook._sheets[i]._mergedCells)
        for (j = 0; j < tempMergedCells.length; j++) {
          tempMergedCells[j] = {
            topLeft: {
              row: tempMergedCells[j].topLeft.row + 1,
              col: tempMergedCells[j].topLeft.col + 1
            },
            bottomRight: {
              row: tempMergedCells[j].bottomRight.row + 1,
              col: tempMergedCells[j].bottomRight.col + 1
            },
            workSheet: this.spreadSheet._workbook._sheets[i]._sheetName
          }
        }
        mergedCells = mergedCells.concat(tempMergedCells)
      }
      for (i = mergedCells.length - 1; i >= 0; i--) {
        if (mergedCells[i].topLeft.row === mergedCells[i].bottomRight.row &&
          mergedCells[i].topLeft.col === mergedCells[i].bottomRight.col) {
          mergedCells.splice(i, 1)
        }
      }
      return mergedCells
    },

    // *********************
    // ****AlaSQLHelper*****
    // *********************
    // Note:只有取数公式需要按行列匹配时，才需要使用AlaSQL辅助进行左关联操作
    // 根据数据表ID创建SQL表结构
    CreateDataTable: function(dataSheetId) {
      const dataSheetInfo = this.dataSheets[dataSheetId]
      if (dataSheetInfo === undefined) {
        return false
      }
      console.time('新建表结构')
      try {
        // 判断表ID对应的数据表是否存在
        // const arr = alasql('show tables')
        // for (var i = 0; i < arr.length; i++) {
        //   if (parseInt(arr[i]['tableid']) === dataSheetId) {
        //     // 如果数据表已存在，则重新创建
        //     alasql('DROP TABLE IF EXISTS [' + dataSheetId + '];')
        //   }
        // }
        // 构建创建数据表的SQL语句
        var createSQL = 'CREATE TABLE IF NOT EXISTS [' + dataSheetId + '] ('
        for (var fieldId in dataSheetInfo.fields) {
          // 循环每��字段进行类型判断
          createSQL += '[' + fieldId + '] '
          switch (dataSheetInfo.fields[fieldId].baseType) {
            case 1:
              // 字符串
              createSQL += 'string,'
              break
            case 3:
              // 数值
              createSQL += 'number,'
              break
            case 4:
              // 日期
              createSQL += 'datetime,'
              break
            case 5:
              // 图片
              createSQL += 'string,'
              break
            case 6:
              // 附件
              createSQL += 'string,'
              break
            default:
              createSQL += 'string,'
              break
          }
        }
        if (this.dataSheets[dataSheetId].type === 2) {
          createSQL += '[index] number,[row] number,[col] number'
        } else {
          createSQL = createSQL.substring(0, createSQL.length - 1)
        }
        // 如果数据表存在，则drop
        alasql('DROP TABLE IF EXISTS [' + dataSheetId + '];')
        // 执行创建数据表的SQLdataSheetId语句
        // console.log(createSQL + ');')
        alasql(createSQL + ');')
        console.timeEnd('新建表结构')
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.alasqlError'), exception)
        console.error(createSQL)
        return false
      }
    },

    // 将this.spreadSheet中所有内容写入到创建的数据表中
    InsertDataIntoDataTable: function(dataSheetId, triggerInfo) {
      const dataSheetInfo = this.dataSheets[dataSheetId]
      if (dataSheetInfo === undefined) {
        return
      }
      console.time('将原表内容插入到数据表中')
      try {
        var tableData
        // debugger
        tableData = this.GetDataFromExtendTable(dataSheetId, triggerInfo, undefined, false, true)
        // 将ISO日期转换为标准日期
        if (tableData.length > 0) {
          for (var fieldId in tableData[0]) {
            if (this.id2Info[fieldId] && this.id2Info[fieldId].baseType === 4) {
              tableData.forEach(rowData => {
                if (rowData[fieldId]) {
                  rowData[fieldId] = formatConverter.ConvertDateTime('yyyy/MM/dd hh:mm:ss', formatConverter.StringNumToDate(rowData[fieldId]))
                }
              })
            }
          }
        }
        console.log(tableData)
        alasql.tables['' + dataSheetId].data = tableData
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.fieldFailLegal'), exception)
        console.error(this.insertSQL)
      }
      console.timeEnd('将原表内容插入到数据表中')
    },

    // 将查询结果写入临时数据表中
    InsertDataIntoTempDataTable: function(queryData, targetDataSheetId) {
      console.time('临时表创建表结构并插入数据')
      if (queryData.length > 0) {
        // 生成临时表名称
        const tempDataTableName = 'TEMP' + Math.floor(Math.random() * 1000)
        // 创建临时表
        var createSQL = 'CREATE TABLE IF NOT EXISTS [' + tempDataTableName + '] ('
        const dataSheetInfo = this.dataSheets[targetDataSheetId]
        for (var fieldId in queryData[0]) {
          createSQL += '[' + fieldId + ']'
          if (fieldId.indexOf('_') === -1) {
            switch (dataSheetInfo.fields[fieldId].baseType) {
              case 1:
                // 字符串
                createSQL += ' string,'
                break
              case 3:
                // 数值
                createSQL += ' number,'
                break
              case 4:
                // 日期
                createSQL += ' datetime,'
                break
              case 5:
              case 6:
                // 附件图片
                createSQL += ' string,'
                break
            }
          } else {
            createSQL += ' number,'
          }
        }
        createSQL = createSQL.substring(0, createSQL.length - 1) + ')'
        // 执行创建SQL
        alasql(createSQL)
        // 往临时表里写值
        alasql.tables[tempDataTableName].data = queryData
        console.timeEnd('临时表创建表结构并插入数据')
        return tempDataTableName
      }
      console.timeEnd('临时表创建表结构并插入数据')
    },

    // 通用执行查询方法
    // 适用于条件格式和自定义按钮
    async QuerySQLExpression(paramJson, expression, data, detailRowIndex, tempTableName) {
      if (!expression) {
        return [1]
      }
      if (expression.indexOf('@s') >= 0) {
        var variables = (await getSystemVariables()).data
        expression = this.ReplaceVariables(expression, variables)
      }
      var createTables = {}
      var tableId, fieldId
      for (tableId in paramJson) {
        for (fieldId of paramJson[tableId]) {
          // 循环每个参数字段，开始进行建表和插值处理
          if (!createTables[this.id2DataSheets[fieldId]]) {
            createTables[this.id2DataSheets[fieldId]] = []
          }
          createTables[this.id2DataSheets[fieldId]].push(fieldId)
        }
      }
      // 预先先创建整个datasheets的数据表，然后进行插值删值的操作
      console.time('编写SQL')
      var tempDataTableName = tempTableName || 'TEMP' + Math.floor(Math.random() * 1000)
      var sqlCommand = `DROP TABLE IF EXISTS [${tempDataTableName}];`
      alasql(sqlCommand)
      sqlCommand = `CREATE TABLE IF NOT EXISTS [${tempDataTableName}] (`
      var insertDataCommand = `INSERT INTO [${tempDataTableName}] VALUES (`
      for (tableId in createTables) {
        expression = expression.replace(new RegExp(tableId, 'g'), tempDataTableName)
        for (fieldId of createTables[tableId]) {
          sqlCommand += `[${fieldId}]`
          switch (this.dataSheets[tableId].fields[fieldId].baseType) {
            case 1:
            case 5:
            case 6:
              // 字符串
              // 附件图片
              sqlCommand += 'string,'
              insertDataCommand += `'${data[tableId][detailRowIndex || 0][fieldId]}',`
              break
            case 3:
              // 数值
              sqlCommand += 'number,'
              insertDataCommand += `${data[tableId][detailRowIndex || 0][fieldId]},`
              break
            case 4:
              // 日期
              sqlCommand += 'datetime,'
              insertDataCommand += `'${data[tableId][detailRowIndex || 0][fieldId]}',`
              break
          }
        }
      }
      console.timeEnd('编写SQL')
      console.time('创建表结构、插入数据')
      alasql(sqlCommand.substring(0, sqlCommand.length - 2) + ');')
      alasql(insertDataCommand.substring(0, insertDataCommand.length - 1) + ');')
      console.timeEnd('创建表结构、插入数据')
      console.time('计算')
      sqlCommand = `SELECT 1 FROM [${tempDataTableName}] WHERE ${expression}`
      console.log(sqlCommand)
      var queryResult = alasql(sqlCommand)
      console.timeEnd('计算')
      return queryResult
    },

    // *********************
    // *******打印辅助*******
    // *********************
    // PreviewPdfFile(pdfViewerProperty) {
    //   print.owner = this
    //   print.PreviewPdfFile(pdfViewerProperty)
    // },

    ExportPdfFile() {
      print.ExportPdfFile(this)
    },

    OutputPdfFile() {
      print.reportEditor = this
      print.OutputPdfFile()
    },

    OutputXlsxFile() {
      // print.OutputXlsxFile(this)
      console.time('生成excel文件')
      const loadingInstance = Loading.service({
        lock: true,
        text: '正在生成Excel文件，请稍候...',
        body: true
      })
      setTimeout(async() => {
        var exportContent = {
          file: null,
          images: []
        }
        var ConvertPosition2Cell = position => {
          var col = parseInt(position / this.maxControlRow) + 1
          var row = position % this.maxControlRow + 1
          return { row, col }
        }
        var data = this.spreadSheet._workbook.toJSON({maxUsedRow: this.maxUsedRow, maxUsedColumn: this.maxUsedColumn})
        var fileURL = (new kendo.ooxml.Workbook(data)).toDataURL()
        var arr = fileURL.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var that = this
        const fileName = this.templateAttribute.name + (this.recordId > 0 ? ('-' + this.recordId) : '') + '.xlsx'
        exportContent.file = new File([u8arr], fileName, { type: mime, lastModified: Date.now() })
        this.spreadSheet.sheets().forEach(sheet => {
          const images = extendFunctions.deepCopy(sheet._properties.get('image').values())
          images.forEach(item => {
            var obj = {
              sheetName: sheet.name(),
              id: item.value.id
            }
            if (obj.id <= 0) {
              return
            }
            obj.cell = formatConverter.ConvertJsonToA1(ConvertPosition2Cell(item.start))
            exportContent.images.push(obj)
          })
          const imageGroups = extendFunctions.deepCopy(sheet._properties.get('imageGroup').values())
          imageGroups.forEach(item => {
            if (item.value.data.length === 0) {
              return
            }
            var obj = {
              sheetName: sheet.name(),
              id: item.value.data[0].id
            }
            obj.cell = formatConverter.ConvertJsonToA1(ConvertPosition2Cell(item.start))
            // 检查图片是否已上传
            const uploadCheck = that.uploadFileList.find(item => item.id === obj.id)
            if (uploadCheck && uploadCheck.status === 'ready') {
              obj.file = uploadCheck.obj
            }
            exportContent.images.push(obj)
          })
          const barCodes = extendFunctions.deepCopy(sheet._properties.get('barCode').values())
          var barCodeId = 1
          barCodes.forEach(item => {
            if (!item.value || !item.value.file) {
              return
            }
            console.log(item)
            console.log(barCode.barCodeList)
            const file = barCode.barCodeList[item.value.file]
            var obj = {
              sheetName: sheet.name(),
              id: barCodeId++,
              cell: formatConverter.ConvertJsonToA1(ConvertPosition2Cell(item.start)),
              file: new window.File([file], 'barcode', { type: file.type })
            }
            exportContent.images.push(obj)
          })
        })
        console.log(exportContent)
        const uploadForm = new FormData()
        uploadForm.append('file', exportContent.file)
        const images = []
        exportContent.images.forEach(image => {
          const obj = {
            sheet: image.sheetName,
            cell: image.cell
          }
          if (image.file) {
            obj.upload = [image.id]
            uploadForm.append(image.id, image.file)
          } else {
            obj.file = [image.id]
          }
          images.push(obj)
        })
        uploadForm.append('images', JSON.stringify(images))
        console.log(uploadForm)
        try {
          const downloadResponse = await exportReport(this.templateId, uploadForm)
          if (downloadResponse.status >= 200 && downloadResponse.status < 300) {
            downloadExcel(downloadResponse.data, 'ReportExport.xlsx')
          } else {
            extendFunctions.errorMessage(this.$t('attach.donwloadFail') + downloadResponse.data)
            console.error(downloadResponse)
          }
        } catch (ex) {
          console.error(ex)
          extendFunctions.errorMessage('导出失败！')
        } finally {
          console.timeEnd('生成excel文件')
          loadingInstance.close()
        }
      }, 200)
    },

    PrintPdfFile() {
      print.reportEditor = this
      print.PrintPdfFile()
    },

    // 切换loading状态
    ChangeLoadingStatus(status) {
      this.$emit('ChangeLoadingStatus', status)
    },

    // 切换右上角loading状态
    ChangeFunctionLoadingStatus(status) {
      this.$emit('ChangeFunctionLoadingStatus', status)
    },
    getFocus() {
      $('.k-spreadsheet-clipboard').focus()
    },

    // *********************
    // *******邮件辅助*******
    // *********************
    async PrepareMailByHandle(time) {
      this.mailContent = {}
      this.mailSendList = []
      if (this.workFlowModel && !time) {
        return
      }
      for (var i = 0; i < this.mailInfo.length; i++) {
        var info = this.mailInfo[i]
        if ((info.applyTime & (time || 4)) === (time || 4)) {
          var data = (await getTemplateMailContent(info.id, this.recordId, this.workFlowModel ? this.workflowTaskId : undefined)).data
          var content = data.data
          var address = data.user
          if (!content.length) {
            continue
          }
          var sendContent = {
            id: info.id,
            address: address || info.address,
            copy: info.copy,
            subject: content[0].subject,
            body: content[0].body,
            attach: []
          }
          this.mailSendList.push(sendContent)
        }
      }
      if (this.mailSendList.length > 0) {
        // 发送邮件
        this.SendMailByStep()
      }
    },
    SendMailByStep() {
      if (this.mailSendList.length > 0) {
        var sendInfo = this.mailSendList.shift()
        this.$refs.mail.handleMail(this.mailInfo.find(info => info.id === sendInfo.id), sendInfo)
      }
    },
    // 获取模板邮件信息
    GetEmailInfo() {
      if (this.workFlowModel) {
        for (var i = this.mailInfo.length - 1; i >= 0; i--) {
          if (this.mailInfo[i].workFlowTiming) {
            if (!this.mailInfo[i].activities.find(val => val === this.workFlowActivityId)) {
              this.mailInfo.splice(i, 1)
            }
          }
        }
      }
      this.$emit('buildMailButtons', this.mailInfo)
      this.mailInfo.forEach(mail => {
        if ((mail.applyTime & 128) === 128) {
          mail.applyTime -= 128
          mail.silence = true
        } else {
          mail.silence = false
        }
        if (mail.inputParam) {
          try {
            mail.inputParam = JSON.parse(mail.inputParam)
          } catch (ex) {
            console.log('重复格式化')
          }
        }
      })
    },
    // 获取Excel文件
    ExportExcelFile(content, mailObj) {
      var data = this.spreadSheet._workbook.toJSON()
      var fileURL = (new kendo.ooxml.Workbook(data)).toDataURL()
      var arr = fileURL.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      this.$set(content.attach, content.attach.length, new File([u8arr], this.templateAttribute.name + (this.recordId > 0 ? ('-' + this.recordId) : '') + '.xlsx', { type: mime, lastModified: Date.now() }))
      if (mailObj && mailObj.mailInfo.silence) {
        mailObj.sendMail()
      }
    },
    async ExportPDFFile(info, content, mailObj) {
      var sheetInfo = this.spreadSheet.sheetByGuid(info.contentArea)
      if (sheetInfo) {
        await print.handlePrintReport(this, sheetInfo.guid, 'createAttach', content)
      }
      if (mailObj && mailObj.mailInfo.silence) {
        mailObj.sendMail()
      }
    },
    async getWorkFlowInfo(templateId) {
      console.time('获取流程信息')
      this.workFlowInfo = []
      var targetList = await getWorkFlowTargets(this.$store.getters.userId, templateId)
      console.timeEnd('获取流程信息')
      return targetList.data
    },
    cellDisabledMessage(fieldInfo) {
      extendFunctions.errorMessage(this.id2Info[fieldInfo].editInfo || '当前字段不允许编辑！')
    },
    refreshParent() {
      this.$emit('recalc')
    }
  }
}
</script>
<style lang="scss">
#data-selector {
  .el-dialog__body {
    position: relative;
  }
  .line {
    position: absolute;
    right: 0px;
    bottom: 0px;
    cursor: se-resize;
    width: 0px;
    height: 0px;
    border-color: #e8eaec transparent;
    border-width: 0 0 15px 15px;
    border-style: solid;
    z-index: 999;
  }
}
.report-editor {
  height: 100%;
  .float-button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 999;
    .el-button {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      margin: 0 1px;
      overflow: visible !important;
      filter: opacity(0.6);
    }
  }
  .spreadSheetEditor {
    height: 100%;
    /*整体大小*/
    .spreadsheet {
      width: 100%;
      height: 100%;
      border-color: #eff3f6;
      .k-tabstrip-wrapper {
        display: none;
      }
      .k-spreadsheet-pane {
        border-width: 0px;
      }

      .k-spreadsheet-pane.k-left:not(.k-top) {
        width: 100% !important;
      }
      .k-spreadsheet-pane.k-top:not(.k-left) {
        height: 100% !important;
      }
      .k-spreadsheet-pane.k-top.k-left {
        height: 100% !important;
      }

      .k-selection-blur {
        border-color: rgba(220, 220, 220, 0.5);
        background-color: rgba(220, 220, 220, 0.5);
        box-shadow: inset 0 0 0 1px rgba(220, 220, 220, 0.5);
      }

      .direct-link {
        color: #0000cc;
        cursor: pointer;
        text-decoration: underline;
      }

      .k-spreadsheet-active-cell {
        background-color: transparent;
      }
      .k-spreadsheet-merged-cell {
        background-color: transparent;
      }
      .k-spreadsheet-selection {
        pointer-events: none;
        // background: transparent;
        // border-width: 0px 0px 1px;
        // -webkit-box-shadow:unset;
        // box-shadow:unset;
      }
      .k-spreadsheet-selection::after {
        pointer-events: all;
      }
      /*隐藏菜单tab、列头行标、tab新增删除按钮*/
      div.k-spreadsheet-action-bar,
      div.k-spreadsheet-top-corner,
      .k-spreadsheet-sheets-remove,
      .k-spreadsheet-quick-access-toolbar,
      .k-spreadsheet-tabstrip .k-tabstrip-items,
      .k-spreadsheet-sheets-bar-add {
        display: none !important;
      }
      div.k-spreadsheet-row-header {
        color: transparent;
        background-color: white;
        .k-selection-partial {
          background-color: rgba(4, 126, 240, 0.1);
        }
        // .k-selection-none{
        //   border-top: 1px solid rgb(215, 215, 215)
        // }
      }
      div.k-spreadsheet-column-header {
        color: transparent;
        background-color: white;
        .k-selection-partial {
          background-color: rgba(4, 126, 240, 0.1);
        }
        // .k-selection-none{
        //   border-left: 1px solid rgb(215, 215, 215)
        // }
      }
      div.k-resize-handle.k-vertical-resize {
        cursor: n-resize;
      }
      div.k-resize-handle.k-horizontal-resize {
        cursor: e-resize;
      }
      /*下拉列表按钮*/
      .k-button.k-spreadsheet-editor-button {
        background: #dedede;
        border-color: #dedede;
      }
      /*下拉框最小宽度*/
      .k-animation-container {
        min-width: 100px;
      }

      .k-popup.k-group.k-reset.k-state-border-up {
        width: 100%;
      }

      .custom-button {
        margin: 3px 3px;
      }

      .k-spreadsheet-classify {
        font-size: 12px;
        color: #359cfc;
        margin-right: 3px;
      }

      /*默认显示白色*/
      .k-spreadsheet-view {
        background: white;
        .k-spreadsheet-scroller {
          overflow-y: hidden;
          overflow-x: hidden;
        }

        .data-spec-icon {
          color: #359cfc;
          padding: 6px;
        }
        .image-sign {
          .workfine-sign-tool {
            visibility: hidden;
            top: 0px;
            .sign-icon {
              font-size: 20px;
              color: #409eff;
              cursor: pointer;
            }
          }
          &:hover {
            .workfine-sign-tool {
              visibility: visible;
            }
            // background: lightgray;
          }
        }

        .image-group {
          .image-tool-div {
            position: absolute;
            top: 0px;
            visibility: hidden;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.75);
            div {
              width: 70px;
              height: 25px;
              position: absolute;
              top: 46%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            .image-icon {
              height: 25px;
              width: 25px;
              font-size: 25px;
              line-height: 25px;
              color: white;
              margin: 0 5px;
              &:hover {
                color: #dddddd;
              }
            }
            .icon-workfine-add {
              font-size: 20px;
              // position: absolute;
            }
          }

          &:hover {
            .image-tool-div {
              visibility: visible;
            }
          }

          .image-count-point {
            position: absolute;
            top: 0px;
            right: 0px;
            border: 1px solid;
            border-color: red;
            border-radius: 100%;
            background-color: red;
            color: white;
            height: 16px;
            width: 16px;
            text-align: center;
            line-height: 14px;
            transform: scale(0.8);
          }
        }

        // .image-tool-div{
        //   height: 8px;
        //   width: 16px;
        //   right: 4px;
        //   top:0;
        //   -webkit-transform-origin-x: 0;
        //   -webkit-transform: scale(0.5);
        //   position: absolute;
        //   .image-icon{
        //     height: 16px;
        //     width: 16px;
        //     color: #359CFC;
        //     font-size: 12px;
        //     text-align: center;
        //     margin-left:4px;
        //   }
        //   .image-icon:hover{
        //     background: #359cfc;
        //     color: white !important;
        //     border-radius: 10px;
        //     border: #359cfc 4px solid;
        //     margin-left:0px;
        //   }
        // }
        // .image-tool-div:hover{
        //   height: 16px;
        //   width: 38px;
        //   top: 2px;
        //   -webkit-transform: scale(0.9);
        //   transition-property: width,height,-webkit-transform;
        //   transition-duration: 0.3s;
        //   transition-timing-function: ease-in;
        // }
        // .workfine-attachment{
        //   top: 50%;
        //   width: 100%;
        //   position: absolute;
        //   transform: translate(0%, -50%);
        // }
        .attachment-tool-div {
          height: 8px;
          width: 24px;
          right: 4px;
          top: 0;
          -webkit-transform-origin-x: 0;
          transform: scale(0.5);
          -webkit-transform: scale(0.5);
          position: absolute;
          .attachment-icon {
            height: 16px;
            width: 16px;
            color: #359cfc;
            font-size: 12px;
            text-align: center;
            margin-left: 4px;
          }
          .attachment-icon:hover {
            background: #359cfc;
            color: white !important;
            border-radius: 10px;
            border: #359cfc 4px solid;
            margin-left: 0px;
          }
        }
        .attachment-tool-div:hover {
          height: 16px;
          width: 54px;
          top: 2px;
          transform: scale(0.9);
          -webkit-transform: scale(0.9);
          transition-property: width, height, -webkit-transform;
          transition-duration: 0.3s;
          transition-timing-function: ease-in;
        }

        .attachment-readonly-tool-div {
          height: 8px;
          width: 8px;
          right: 4px;
          top: 0;
          -webkit-transform-origin-x: 0;
          transform: scale(0.5);
          -webkit-transform: scale(0.5);
          position: absolute;
          .attachment-readonly-icon {
            height: 16px;
            width: 16px;
            color: #359cfc;
            font-size: 12px;
            text-align: center;
            margin-left: 4px;
          }
          .attachment-readonly-icon:hover {
            background: #359cfc;
            color: white !important;
            border-radius: 10px;
            border: #359cfc 4px solid;
            margin-left: 0px;
          }
        }
        .attachment-readonly-tool-div:hover {
          height: 16px;
          width: 18px;
          top: 2px;
          transform: scale(0.9);
          -webkit-transform: scale(0.9);
          transition-property: width, height, -webkit-transform;
          transition-duration: 0.3s;
          transition-timing-function: ease-in;
        }

        // .k-filter-range,.k-spreadsheet-link{
        //   // pointer-events:none;
        // }

        .k-filter-range {
          pointer-events: none;
          border-width: 0px;
          .k-spreadsheet-filter {
            pointer-events: unset;
          }
        }

        .cascader-no-data {
          top: 50%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          color: #999;
        }

        .last-selector {
          margin-right: 0px !important;
        }
      }

      .k-spreadSheet-cell-spec {
        margin-left: 20px;
        overflow: hidden;
      }

      /*工具栏多余披锋隐藏*/
      // .k-spreadsheet .k-tabstrip-wrapper {
      //     display: none !important;
      // }

      /*工作表标签区域左侧披锋*/
      .k-spreadsheet-sheets-items .k-tabstrip-items {
        margin-left: 0px !important;
      }

      /*工作表标签栏白底，区域边框*/
      .k-spreadsheet-sheets-bar.k-widget.k-header {
        background-color: white;
      }

      /*激活的工作表标签*/
      .k-reset.k-tabstrip-items .k-spreadsheet-sheets-bar-active {
        background-color: white !important;
      }

      /*未激活的工作表标签文字颜色*/
      .k-spreadsheet-sheets-bar-inactive .k-link {
        color: black !important;
        font-size: 12px;
      }

      /*激活的工作表标签文字颜色*/
      .k-spreadsheet-sheets-bar-active .k-link {
        color: #359cfc !important;
        font-size: 12px;
      }

      .k-popup {
        background: white;
        border-color: #e4e8ed;
        width: auto !important;
        .k-list {
          background: white;
          .k-item {
            height: 34px;
            padding: 0 20px;
            margin: 0px;
            font-size: 14px;
            line-height: 34px;
          }
          .k-state-hover {
            background: #f5f7fb !important;
          }
        }
        .k-calendar {
          background: white;
          .k-header {
            background: transparent;
          }
          .k-content {
            background: transparent;
          }
          .k-footer {
            background: transparent;
          }
        }
      }
      .el-button--text {
        padding: 9px 15px !important;
      }
    }
  }

  .listViewDialog {
    width: 100%;
    height: calc(100vh - 200px);
    border: none;
  }

  .el-dialog__body {
    padding-top: 10px;
  }

  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .auto-hide {
    .el-switch {
      visibility: hidden;
    }
  }
  .auto-hide:hover {
    .el-switch {
      visibility: unset;
    }
  }
  .data-spec-switch-theme_1 {
    .el-switch.is-checked .el-switch__core {
      border-color: #13ce66;
      background-color: #13ce66;
    }
    .el-switch .el-switch__core {
      border-color: #ff4949;
      background-color: #ff4949;
    }
  }
  .data-spec-switch-theme_2 {
    .el-switch.is-checked .el-switch__core {
      border-color: #409eff;
      background-color: #409eff;
    }
    .el-switch .el-switch__core {
      border-color: #13ce66;
      background-color: #13ce66;
    }
  }
  .hide-scroller {
    overflow: hidden !important;
  }
}
</style>
